// edit trip not present
// import React, { useState, useEffect, useRef } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import {
//     getAllRoutes,
//     getRouteById,
//     createRoute,
//     updateRoute,
//     deleteRoute,
//     toggleRouteStatus,
//     getAllMasterRoutes,
//     getMasterRouteByName,
//     searchRouteIntermediateStops,
//     getMasterRouteById,
//     searchMasterRoutesByCities,
//     getBusById,  // Add this
//     activateBusWithPlatformFee  // Add this
// } from '../../Services/Operations/ProductAPI';
// import { toast } from 'react-toastify';
// import '../../Styles/RouteManage.css';
// import { useNavigate } from 'react-router-dom';
// import { getPlacePredictions, getPlaceDetails, getDistanceMatrix } from '../../utilis/mapUtils';
// import PlatformFeeModal from './PlatformFeeModal';
// import TimeSlotManager from './TimeSlotManager';
// import StopTimingManager from './StopTimingManager';
// import {
//     toTitleCase,
//     toTitleCaseLive,
//     normalizeAndDeduplicateSuggestions,
// } from '../../utilis/normalizeUtils';

// // Skeleton Components
// const SkeletonStatsCard = () => (
//     <div className="stat-card skeleton">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-value"></div>
//         <div className="skeleton-subtitle"></div>
//     </div>
// );

// const SkeletonTableRow = () => (
//     <tr className="skeleton-row">
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-cell"></div></td>
//         <td><div className="skeleton-badge"></div></td>
//         <td><div className="skeleton-badge"></div></td>
//         <td><div className="skeleton-actions"></div></td>
//     </tr>
// );

// const SkeletonTable = () => (
//     <div className="table-container skeleton">
//         <table className="data-table">
//             <thead>
//                 <tr>
//                     <th>No.</th>
//                     <th>Route Name</th>
//                     <th>Route No.</th>
//                     <th>Origin</th>
//                     <th>Destination</th>
//                     <th>Distance</th>
//                     <th>Stops</th>
//                     <th>Type</th>
//                     <th>Status</th>
//                     <th>Actions</th>
//                 </tr>
//             </thead>
//             <tbody>
//                 {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//                     <SkeletonTableRow key={i} />
//                 ))}
//             </tbody>
//         </table>
//     </div>
// );

// const SkeletonModal = () => (
//     <div className="modal-overlay">
//         <div className="modal-content add-route-content skeleton">
//             <div className="modal-header">
//                 <div className="skeleton-title"></div>
//                 <div className="skeleton-close"></div>
//             </div>
//             <div className="modal-body">
//                 <div className="skeleton-toggle"></div>
//                 <div className="skeleton-tabs"></div>
//                 <div className="form-sections">
//                     {[1, 2, 3].map((i) => (
//                         <div key={i} className="form-section">
//                             <div className="skeleton-section-title"></div>
//                             <div className="form-row">
//                                 <div className="form-group"><div className="skeleton-input"></div></div>
//                                 <div className="form-group"><div className="skeleton-input"></div></div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//             <div className="modal-footer">
//                 <div className="skeleton-button"></div>
//                 <div className="skeleton-button"></div>
//             </div>
//         </div>
//     </div>
// );


// const LocationInput = ({ value, onChange, placeholder, onLocationSelect, type = 'origin' }) => {
//     const [searchQuery, setSearchQuery] = useState(value || '');
//     const [suggestions, setSuggestions] = useState([]);
//     const [showSuggestions, setShowSuggestions] = useState(false);
//     const [isLoading, setIsLoading] = useState(false);
//     const timeoutRef = useRef(null);

//     useEffect(() => {
//         setSearchQuery(value || '');
//     }, [value]);

//     const searchLocations = async (query) => {
//         if (!query || query.trim().length < 2) {
//             setSuggestions([]);
//             return;
//         }

//         setIsLoading(true);
//         try {
//             const predictions = await getPlacePredictions(query);
//             setSuggestions(predictions);
//             setShowSuggestions(predictions.length > 0);
//         } catch (error) {
//             console.error('Search error:', error);
//             setSuggestions([]);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleSelect = async (prediction) => {
//         setIsLoading(true);
//         try {
//             const placeDetails = await getPlaceDetails(prediction.place_id);

//             if (placeDetails) {
//                 setSearchQuery(placeDetails.name || placeDetails.address);
//                 setShowSuggestions(false);

//                 if (onLocationSelect) {
//                     onLocationSelect({
//                         name: placeDetails.name,
//                         address: placeDetails.address,
//                         city: placeDetails.city || prediction.structured_formatting?.secondary_text?.split(',')[0] || '',
//                         state: placeDetails.state || prediction.structured_formatting?.secondary_text?.split(',')[1]?.trim() || '',
//                         coordinates: placeDetails.coordinates || { lat: 0, lng: 0 },
//                         placeId: prediction.place_id
//                     });
//                 }
//             }
//         } catch (error) {
//             console.error('Error getting place details:', error);
//             toast.error('Failed to get location details');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleTextChange = (e) => {
//         const newValue = e.target.value;
//         setSearchQuery(newValue);
//         onChange(newValue);

//         if (timeoutRef.current) {
//             clearTimeout(timeoutRef.current);
//         }

//         timeoutRef.current = setTimeout(() => {
//             searchLocations(newValue);
//         }, 500);
//     };

//     useEffect(() => {
//         return () => {
//             if (timeoutRef.current) {
//                 clearTimeout(timeoutRef.current);
//             }
//         };
//     }, []);

//     return (
//         <div className="location-input-container">
//             <div className="location-input-wrapper">
//                 <input
//                     type="text"
//                     value={searchQuery}
//                     onChange={handleTextChange}
//                     onFocus={() => {
//                         if (suggestions.length > 0) {
//                             setShowSuggestions(true);
//                         }
//                     }}
//                     onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
//                     className="edit-input"
//                     placeholder={placeholder}
//                 />
//                 {isLoading && (
//                     <div className="location-loading">
//                         <div className="spinner"></div>
//                     </div>
//                 )}
//             </div>
//             {showSuggestions && suggestions.length > 0 && (
//                 <div className="location-suggestions">
//                     <div className="suggestions-header">
//                         <span>Search Results</span>
//                     </div>
//                     {suggestions.map((prediction, index) => (
//                         <div
//                             key={prediction.place_id || index}
//                             className="suggestion-item"
//                             onClick={() => handleSelect(prediction)}
//                         >
//                             <div className="suggestion-main">
//                                 {prediction.structured_formatting?.main_text || prediction.description}
//                             </div>
//                             <div className="suggestion-secondary">
//                                 {prediction.structured_formatting?.secondary_text}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// const TimePicker = ({ value, onChange, placeholder }) => {
//     return (
//         <div className="time-picker">
//             <input
//                 type="time"
//                 value={value || ''}
//                 onChange={(e) => onChange(e.target.value)}
//                 className="edit-input"
//                 placeholder={placeholder}
//             />
//         </div>
//     );
// };

// const Checkbox = ({ label, checked, onChange }) => (
//     <label className="checkbox-container">
//         <input
//             type="checkbox"
//             checked={checked}
//             onChange={onChange}
//             className="checkbox-input"
//         />
//         <span className="checkbox-label">{label}</span>
//     </label>
// );

// const MasterRouteSelector = ({ value, onChange, onRouteNameChange, token, disabled }) => {
//     const [masterRoutes, setMasterRoutes] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [source, setSource] = useState('');
//     const [destination, setDestination] = useState('');
//     const [isManualEntry, setIsManualEntry] = useState(false);
//     const [routeNameValue, setRouteNameValue] = useState('');
//     const [selectedRouteValue, setSelectedRouteValue] = useState(null);
//     const [selectedRouteDetails, setSelectedRouteDetails] = useState(null);

//     // City suggestions states
//     const [sourceSuggestions, setSourceSuggestions] = useState([]);
//     const [destSuggestions, setDestSuggestions] = useState([]);
//     const [showSourceSuggestions, setShowSourceSuggestions] = useState(false);
//     const [showDestSuggestions, setShowDestSuggestions] = useState(false);
//     const [isLoadingSource, setIsLoadingSource] = useState(false);
//     const [isLoadingDest, setIsLoadingDest] = useState(false);

//     // Debounce timeouts
//     const sourceTimeoutRef = useRef(null);
//     const destTimeoutRef = useRef(null);
//     const searchTimeoutRef = useRef(null);

//     useEffect(() => {
//         if (value && value.masterRouteName) {
//             setRouteNameValue(value.masterRouteName);
//             setSelectedRouteValue(value);
//             if (value.origin?.city) setSource(value.origin.city);
//             if (value.destination?.city) setDestination(value.destination.city);
//         } else {
//             setRouteNameValue('');
//             setSelectedRouteValue(null);
//             setSource('');
//             setDestination('');
//             setMasterRoutes([]);
//             setShowDropdown(false);
//             setIsManualEntry(false);
//         }
//     }, [value]);

//     const toTitleCase = (str) =>
//         str
//             ? str.trim().replace(/\s+/g, ' ').replace(/[^\s-]+/g, (w) =>
//                 w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
//             )
//             : str;

//     // Search cities for suggestions
//     const searchCities = async (query, type) => {
//         if (!query || query.length < 2) {
//             if (type === 'source') {
//                 setSourceSuggestions([]);
//                 setShowSourceSuggestions(false);
//             } else {
//                 setDestSuggestions([]);
//                 setShowDestSuggestions(false);
//             }
//             return;
//         }

//         try {
//             if (type === 'source') {
//                 setIsLoadingSource(true);
//             } else {
//                 setIsLoadingDest(true);
//             }

//             // Use searchRouteIntermediateStops API for city suggestions
//             const response = await searchRouteIntermediateStops(token, query);
//             console.log(`City suggestions for ${type}:`, response);

//             if (response.success && response.cities) {
//                 const deduped = normalizeAndDeduplicateSuggestions(response.cities); // ← deduplicate + normalise
//                 if (type === 'source') {
//                     setSourceSuggestions(deduped);
//                     setShowSourceSuggestions(deduped.length > 0);
//                 } else {
//                     setDestSuggestions(deduped);
//                     setShowDestSuggestions(deduped.length > 0);
//                 }
//             }
//         } catch (error) {
//             console.error('Error fetching city suggestions:', error);
//         } finally {
//             if (type === 'source') {
//                 setIsLoadingSource(false);
//             } else {
//                 setIsLoadingDest(false);
//             }
//         }
//     };

//     // Search master routes by source and destination
//     const searchMasterRoutes = async (sourceCity, destCity) => {
//         if (!sourceCity && !destCity) {
//             setMasterRoutes([]);
//             setShowDropdown(false);
//             return;
//         }

//         setIsLoading(true);
//         try {
//             console.log('Searching routes with:', { sourceCity, destCity });

//             // Call the API to search master routes
//             const response = await searchMasterRoutesByCities(token, sourceCity, destCity);
//             console.log('API Response:', response);

//             if (response.success && response.data) {
//                 const routesData = response.data.routes || (Array.isArray(response.data) ? response.data : []);
//                 const mappedRoutes = routesData.map(route => ({
//                     _id: route._id,
//                     originCity: toTitleCase(route.origin?.city || ''),      // ← ADD
//                     destinationCity: toTitleCase(route.destination?.city || ''), // ← ADD
//                     masterRouteName: toTitleCase(route.masterRouteName || ''),   // ← ADD (optional)
//                     // masterRouteName: route.masterRouteName,
//                     description: route.description || '',
//                     // originCity: route.origin?.city || '',
//                     originState: route.origin?.state || '',
//                     originAddress: route.origin?.address || '',
//                     originTerminal: route.origin?.terminal || '',
//                     originCoords: route.origin?.coordinates || null,
//                     // destinationCity: route.destination?.city || '',
//                     destinationState: route.destination?.state || '',
//                     destinationAddress: route.destination?.address || '',
//                     destinationTerminal: route.destination?.terminal || '',
//                     destinationCoords: route.destination?.coordinates || null,
//                     totalDistance: route.routeDetails?.totalDistance || 0,
//                     durationHours: route.routeDetails?.estimatedDuration?.hours || 0,
//                     durationMinutes: route.routeDetails?.estimatedDuration?.minutes || 0,
//                     intermediateStops: route.intermediateStops || [],
//                     isRoundTrip: route.isRoundTrip || false,
//                     returnJourney: route.returnJourney || null
//                 }));

//                 setMasterRoutes(mappedRoutes);
//                 setShowDropdown(mappedRoutes.length > 0);

//                 if (response.data.sourceSuggestions) {
//                     setSourceSuggestions(
//                         normalizeAndDeduplicateSuggestions(response.data.sourceSuggestions)
//                     );
//                 }
//                 if (response.data.destinationSuggestions) {
//                     setDestSuggestions(
//                         normalizeAndDeduplicateSuggestions(response.data.destinationSuggestions)
//                     );
//                 }
//             } else {
//                 setMasterRoutes([]);
//                 setShowDropdown(true);
//             }
//         } catch (error) {
//             console.error('Error fetching routes:', error);
//             setMasterRoutes([]);
//             setShowDropdown(true);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Handle source input change with debounce
//     const handleSourceInputChange = (e) => {
//         const value = toTitleCaseLive(e.target.value);   // ← safe on every keystroke
//         setSource(value);
//         setShowDropdown(false);
//         setShowSourceSuggestions(false);

//         if (selectedRouteValue) {
//             setSelectedRouteValue(null);
//             onChange(null);
//         }

//         // Clear previous timeout
//         if (sourceTimeoutRef.current) {
//             clearTimeout(sourceTimeoutRef.current);
//         }

//         // Search for city suggestions
//         sourceTimeoutRef.current = setTimeout(() => {
//             searchCities(value, 'source');
//         }, 300);

//         // Search for routes
//         if (searchTimeoutRef.current) {
//             clearTimeout(searchTimeoutRef.current);
//         }
//         searchTimeoutRef.current = setTimeout(() => {
//             if (value.length >= 2 || destination.length >= 2) {
//                 searchMasterRoutes(value, destination);
//             } else {
//                 setMasterRoutes([]);
//             }
//         }, 500);
//     };

//     // Handle destination input change with debounce
//     const handleDestinationInputChange = (e) => {
//         const value = toTitleCaseLive(e.target.value);   // ← safe on every keystroke
//         setDestination(value);
//         setShowDropdown(false);
//         setShowDestSuggestions(false);

//         if (selectedRouteValue) {
//             setSelectedRouteValue(null);
//             onChange(null);
//         }

//         // Clear previous timeout
//         if (destTimeoutRef.current) {
//             clearTimeout(destTimeoutRef.current);
//         }

//         // Search for city suggestions
//         destTimeoutRef.current = setTimeout(() => {
//             searchCities(value, 'destination');
//         }, 300);

//         // Search for routes
//         if (searchTimeoutRef.current) {
//             clearTimeout(searchTimeoutRef.current);
//         }
//         searchTimeoutRef.current = setTimeout(() => {
//             if (source.length >= 2 || value.length >= 2) {
//                 searchMasterRoutes(source, value);
//             } else {
//                 setMasterRoutes([]);
//             }
//         }, 500);
//     };

//     const handleSourceSelect = (selectedCity) => {
//         if (!selectedCity) return;
//         // Get city name - handle different response formats
//         // const cityName = typeof selectedCity === 'object'
//         //     ? (selectedCity.city || selectedCity.name || selectedCity)
//         //     : selectedCity;
//         // setSource(cityName);
//         const cityName = toTitleCase(           // ← full normalise on select = correct
//             typeof selectedCity === 'object'
//                 ? (selectedCity.city || selectedCity.name || '')
//                 : selectedCity
//         );
//         setSource(cityName);
//         setShowSourceSuggestions(false);
//         setSourceSuggestions([]);

//         if (selectedRouteValue) {
//             setSelectedRouteValue(null);
//             onChange(null);
//         }

//         if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
//         searchTimeoutRef.current = setTimeout(() => {
//             searchMasterRoutes(cityName, destination);
//         }, 100);
//     };

//     // Fix for handleDestinationSelect (around line 277)
//     const handleDestinationSelect = (selectedCity) => {
//         if (!selectedCity) return;
//         // Get city name - handle different response formats
//         // const cityName = typeof selectedCity === 'object'
//         //     ? (selectedCity.city || selectedCity.name || selectedCity)
//         //     : selectedCity;
//         // setDestination(cityName);
//         const cityName = toTitleCase(                               // ← WRAP
//             typeof selectedCity === 'object'
//                 ? (selectedCity.city || selectedCity.name || '')
//                 : selectedCity
//         );
//         setDestination(cityName);
//         setShowDestSuggestions(false);
//         setDestSuggestions([]);

//         if (selectedRouteValue) {
//             setSelectedRouteValue(null);
//             onChange(null);
//         }

//         if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
//         searchTimeoutRef.current = setTimeout(() => {
//             searchMasterRoutes(source, cityName);
//         }, 100);
//     };

//     const handleRouteSelect = async (route) => {
//         console.log('Route selected:', route);
//         setSelectedRouteDetails(route);
//         setShowDropdown(false);

//         try {
//             setIsLoading(true);
//             const response = await getMasterRouteById(route._id, token);
//             console.log('Complete route details:', response);

//             if (response.success && response.data) {
//                 const fullRoute = response.data;
//                 setSource(fullRoute.origin?.city || '');
//                 setDestination(fullRoute.destination?.city || '');
//                 setRouteNameValue(fullRoute.masterRouteName);

//                 const selectedRouteObj = {
//                     _id: fullRoute._id,
//                     masterRouteName: fullRoute.masterRouteName,
//                     description: fullRoute.description || '',
//                     isManual: false,
//                     // CRITICAL: ADD VIA ARRAY HERE
//                     via: fullRoute.via || [],
//                     origin: {
//                         city: fullRoute.origin?.city || '',
//                         state: fullRoute.origin?.state || '',
//                         address: fullRoute.origin?.address || '',
//                         terminal: fullRoute.origin?.terminal || '',
//                         coordinates: fullRoute.origin?.coordinates || null
//                     },
//                     destination: {
//                         city: fullRoute.destination?.city || '',
//                         state: fullRoute.destination?.state || '',
//                         address: fullRoute.destination?.address || '',
//                         terminal: fullRoute.destination?.terminal || '',
//                         coordinates: fullRoute.destination?.coordinates || null
//                     },
//                     intermediateStops: fullRoute.intermediateStops || [],
//                     routeDetails: {
//                         totalDistance: fullRoute.routeDetails?.totalDistance || 0,
//                         estimatedDuration: {
//                             hours: fullRoute.routeDetails?.estimatedDuration?.hours || 0,
//                             minutes: fullRoute.routeDetails?.estimatedDuration?.minutes || 0
//                         }
//                     },
//                     isRoundTrip: fullRoute.isRoundTrip || false,
//                     returnJourney: fullRoute.returnJourney || null
//                 };

//                 onChange(selectedRouteObj);
//                 if (onRouteNameChange) onRouteNameChange(fullRoute.masterRouteName);
//             } else {
//                 toast.error('Failed to load complete route details');
//             }
//         } catch (error) {
//             console.error('Error fetching full route details:', error);
//             toast.error('Failed to load route details. Please try again.');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     const handleRouteNameChange = (e) => {
//         const newName = e.target.value;
//         setRouteNameValue(newName);
//         if (onRouteNameChange) onRouteNameChange(newName);
//         if (selectedRouteValue) onChange({ ...selectedRouteValue, masterRouteName: newName });
//     };

//     const handleClearSelection = () => {
//         setSelectedRouteValue(null);
//         setSelectedRouteDetails(null);
//         setRouteNameValue('');
//         setSource('');
//         setDestination('');
//         setMasterRoutes([]);
//         setShowDropdown(false);
//         setIsManualEntry(false);
//         onChange(null);
//         if (onRouteNameChange) onRouteNameChange('');
//     };

//     const handleOpenManualEntry = () => {
//         setIsManualEntry(true);
//         setShowDropdown(false);
//     };

//     const handleManualEntrySubmit = () => {
//         if (!routeNameValue.trim()) {
//             toast.error('Please enter a route name');
//             return;
//         }

//         const emptyRoute = {
//             _id: null,
//             masterRouteName: routeNameValue.trim(),
//             isManual: true,
//             origin: { city: source || '', state: '' },
//             destination: { city: destination || '', state: '' },
//             routeDetails: { totalDistance: 0 },
//             isRoundTrip: false
//         };

//         setIsManualEntry(false);
//         setSelectedRouteValue(emptyRoute);
//         onChange(emptyRoute);
//     };

//     const handleCancelManualEntry = () => {
//         setIsManualEntry(false);
//         setRouteNameValue('');
//     };

//     const showSearchFields = !selectedRouteValue && !isManualEntry;

//     // Cleanup timeouts
//     useEffect(() => {
//         return () => {
//             if (sourceTimeoutRef.current) clearTimeout(sourceTimeoutRef.current);
//             if (destTimeoutRef.current) clearTimeout(destTimeoutRef.current);
//             if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
//         };
//     }, []);

//     // Dropdown styles
//     const suggestionsDropdownStyle = {
//         position: 'absolute',
//         top: '100%',
//         left: 0,
//         right: 0,
//         backgroundColor: 'white',
//         border: '1px solid #ddd',
//         borderRadius: '4px',
//         maxHeight: '200px',
//         overflowY: 'auto',
//         zIndex: 10000,
//         boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//         marginTop: '2px'
//     };

//     const suggestionItemStyle = {
//         padding: '10px 12px',
//         cursor: 'pointer',
//         borderBottom: '1px solid #f0f0f0',
//         transition: 'background-color 0.2s'
//     };

//     return (
//         <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
//             {showSearchFields && (
//                 <>
//                     <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
//                         {/* Source City Input with Suggestions */}
//                         <div className="form-group" style={{ flex: 1, position: 'relative' }}>
//                             <label>Source City</label>
//                             <div style={{ position: 'relative' }}>
//                                 <input
//                                     type="text"
//                                     value={source}
//                                     onChange={handleSourceInputChange}
//                                     onFocus={() => {
//                                         if (sourceSuggestions.length > 0) {
//                                             setShowSourceSuggestions(true);
//                                         }
//                                     }}
//                                     onBlur={() => setTimeout(() => setShowSourceSuggestions(false), 200)}
//                                     placeholder="Enter source city (min 2 chars)..."
//                                     className="form-input"
//                                     disabled={disabled}
//                                 />
//                                 {isLoadingSource && (
//                                     <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//                                         <div className="spinner-small"></div>
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Source City Suggestions Dropdown */}
//                             {showSourceSuggestions && sourceSuggestions.length > 0 && (
//                                 <div style={suggestionsDropdownStyle}>

//                                     {sourceSuggestions.map((city, idx) => (
//                                         <div
//                                             key={city.id || idx}
//                                             style={suggestionItemStyle}
//                                             onMouseDown={() => handleSourceSelect(city)}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                         >
//                                             <div style={{ fontWeight: '500' }}>
//                                                 {city.city || city.name || city}
//                                             </div>
//                                             <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                 {city.state}
//                                                 {city.terminal && ` • ${city.terminal}`}
//                                             </div>
//                                             {city.address && city.address !== (city.city || city.name) && (
//                                                 <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{city.address}</div>
//                                             )}
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>

//                         {/* Destination City Input with Suggestions */}
//                         <div className="form-group" style={{ flex: 1, position: 'relative' }}>
//                             <label>Destination City</label>
//                             <div style={{ position: 'relative' }}>
//                                 <input
//                                     type="text"
//                                     value={destination}
//                                     onChange={handleDestinationInputChange}
//                                     onFocus={() => {
//                                         if (destSuggestions.length > 0) {
//                                             setShowDestSuggestions(true);
//                                         }
//                                     }}
//                                     onBlur={() => setTimeout(() => setShowDestSuggestions(false), 200)}
//                                     placeholder="Enter destination city (min 2 chars)..."
//                                     className="form-input"
//                                     disabled={disabled}
//                                 />
//                                 {isLoadingDest && (
//                                     <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
//                                         <div className="spinner-small"></div>
//                                     </div>
//                                 )}
//                             </div>

//                             {destSuggestions.map((city, idx) => (
//                                 <div
//                                     key={city.id || idx}
//                                     style={suggestionItemStyle}
//                                     onMouseDown={() => handleDestinationSelect(city)}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                 >
//                                     <div style={{ fontWeight: '500' }}>
//                                         {city.city || city.name || city}
//                                     </div>
//                                     <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                         {city.state}
//                                         {city.terminal && ` • ${city.terminal}`}
//                                     </div>
//                                     {city.address && city.address !== (city.city || city.name) && (
//                                         <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{city.address}</div>
//                                     )}
//                                 </div>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Display matching routes */}
//                     {(showDropdown || isLoading) && (source || destination) && (
//                         <div style={{
//                             border: '1px solid #ddd',
//                             borderRadius: '4px',
//                             boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//                             backgroundColor: 'white',
//                             maxHeight: '300px',
//                             overflowY: 'auto',
//                             marginBottom: '10px',
//                             zIndex: 1000,
//                             position: 'relative'
//                         }}>
//                             {isLoading ? (
//                                 <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
//                                     <div className="spinner-small"></div> Searching routes...
//                                 </div>
//                             ) : masterRoutes.length > 0 ? (
//                                 <>
//                                     <div style={{ padding: '8px 12px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee', fontSize: '12px', color: '#666' }}>
//                                         Found {masterRoutes.length} matching route(s)
//                                     </div>
//                                     {masterRoutes.map((route) => (
//                                         <div
//                                             key={route._id}
//                                             onClick={() => handleRouteSelect(route)}
//                                             style={{
//                                                 padding: '10px 12px',
//                                                 cursor: 'pointer',
//                                                 borderBottom: '1px solid #f0f0f0',
//                                                 transition: 'background-color 0.2s'
//                                             }}
//                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                         >
//                                             <div style={{ fontWeight: '500', marginBottom: '3px' }}>{route.masterRouteName}</div>
//                                             <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                 {route.originCity || route.origin?.city || 'N/A'} → {route.destinationCity || route.destination?.city || 'N/A'} &nbsp;•&nbsp;
//                                                 {route.isRoundTrip ? 'Round Trip' : 'One Way'} &nbsp;•&nbsp;
//                                                 {route.totalDistance || route.routeDetails?.totalDistance || 0} km
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </>
//                             ) : (
//                                 <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
//                                     No routes found for this route.
//                                     <button
//                                         type="button"
//                                         onClick={handleOpenManualEntry}
//                                         style={{ color: '#007bff', background: 'none', border: 'none', cursor: 'pointer', padding: '0 0 0 5px' }}
//                                     >
//                                         Create new route instead
//                                     </button>
//                                 </div>
//                             )}
//                         </div>
//                     )}

//                     <div style={{ textAlign: 'right' }}>
//                         <button
//                             type="button"
//                             className="btn btn-secondary btn-sm"
//                             onClick={handleOpenManualEntry}
//                             style={{ padding: '5px 12px', fontSize: '12px' }}
//                         >
//                             + Create New Route (skip search)
//                         </button>
//                     </div>
//                 </>
//             )}

//             {isManualEntry && (
//                 <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexDirection: 'column' }}>
//                     <div style={{ width: '100%' }}>
//                         <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//                             <input
//                                 type="text"
//                                 value={routeNameValue}
//                                 onChange={handleRouteNameChange}
//                                 placeholder="Enter new master route name..."
//                                 className="form-input"
//                                 style={{ flex: 1 }}
//                                 disabled={disabled}
//                             />
//                             <button
//                                 type="button"
//                                 className="btn btn-primary"
//                                 onClick={handleManualEntrySubmit}
//                                 style={{ padding: '8px 16px', whiteSpace: 'nowrap' }}
//                             >
//                                 Save Manual
//                             </button>
//                             <button
//                                 type="button"
//                                 className="btn btn-secondary"
//                                 onClick={handleCancelManualEntry}
//                                 style={{ padding: '8px 16px' }}
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </div>
//                     <small className="helper-text" style={{ color: '#666' }}>
//                         You're creating a new master route. Fill in the details below.
//                     </small>
//                 </div>
//             )}

//             {selectedRouteValue && selectedRouteValue.masterRouteName && !isManualEntry && (
//                 <div style={{ marginBottom: '5px' }}>
//                     <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
//                         <input
//                             type="text"
//                             value={routeNameValue}
//                             onChange={handleRouteNameChange}
//                             placeholder="Enter master route name..."
//                             className="form-input"
//                             style={{ flex: 1 }}
//                             disabled={disabled}
//                         />
//                         <button
//                             type="button"
//                             className="btn btn-secondary btn-sm"
//                             onClick={handleClearSelection}
//                             style={{ padding: '8px 14px', whiteSpace: 'nowrap' }}
//                             title="Clear and search again"
//                         >
//                             ✕ Change
//                         </button>
//                     </div>
//                     <small style={{ color: selectedRouteValue.isManual ? '#007bff' : '#28a745', display: 'block', marginTop: '4px' }}>
//                         {selectedRouteValue.isManual
//                             ? 'ℹ️ New route — fill in details below'
//                             : `✓ Auto-filled from "${selectedRouteValue.masterRouteName}" — edit name above if needed`}
//                     </small>
//                 </div>
//             )}
//         </div>
//     );
// };

// const RouteManage = () => {
//     const { token } = useSelector(state => state.user);
//     const [routes, setRoutes] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [editingRoute, setEditingRoute] = useState(null);
//     const [editForm, setEditForm] = useState({});
//     const [viewingRoute, setViewingRoute] = useState(null);
//     const [showAddModal, setShowAddModal] = useState(false);
//     const [isRoundTrip, setIsRoundTrip] = useState(false);
//     const [activeRouteTab, setActiveRouteTab] = useState('UP');
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [isUpdatingRoute, setIsUpdatingRoute] = useState(false);
//     const [editUpIndex, setEditUpIndex] = useState(null);
//     const [editDownIndex, setEditDownIndex] = useState(null);
//     const [isManualStop, setIsManualStop] = useState(true);
//     const [isManualDistance, setIsManualDistance] = useState(false);
//     // Add these state variables if they don't exist
//     const [isOriginManual, setIsOriginManual] = useState(false);
//     const [isDestinationManual, setIsDestinationManual] = useState(false);

//     // Add these with your other state variables
//     const [destinationTimeSlots, setDestinationTimeSlots] = useState([]);
//     const [destinationNumberOfTrips, setDestinationNumberOfTrips] = useState(1);

//     const [returnOriginTimeSlots, setReturnOriginTimeSlots] = useState([]);
//     const [returnDestTimeSlots, setReturnDestTimeSlots] = useState([]);

//     // Master Route Search States
//     const [masterRouteSuggestions, setMasterRouteSuggestions] = useState([]);
//     const [showMasterRouteSuggestions, setShowMasterRouteSuggestions] = useState(false);
//     const [isLoadingMasterRoutes, setIsLoadingMasterRoutes] = useState(false);
//     const [masterRouteSearchTimeout, setMasterRouteSearchTimeout] = useState(null);
//     const [selectedMasterRoute, setSelectedMasterRoute] = useState(null);

//     // Add these state variables near the other state declarations (around line 200)
//     const [filterOrigin, setFilterOrigin] = useState('');
//     const [filterDestination, setFilterDestination] = useState('');
//     const [originSuggestions, setOriginSuggestions] = useState([]);
//     const [destSuggestions, setDestSuggestions] = useState([]);
//     const [showOriginSuggestions, setShowOriginSuggestions] = useState(false);
//     const [showDestSuggestions, setShowDestSuggestions] = useState(false);

//     // Add these state variables with your other useState declarations
//     const [citySuggestions, setCitySuggestions] = useState([]);
//     const [showCityDropdown, setShowCityDropdown] = useState(false);
//     const [editCitySuggestions, setEditCitySuggestions] = useState([]);
//     const [showEditCityDropdown, setShowEditCityDropdown] = useState(false);

//     const [showStopInsertModal, setShowStopInsertModal] = useState(false);
//     const [insertStopForm, setInsertStopForm] = useState({
//         city: '', state: '', address: '', terminal: '',
//         arrivalTime: '', departureTime: '',
//         isBoarding: false, isDropping: false,
//         manualDistFromPrev: '', manualDistToNext: '',
//         isManualStop: true
//     });
//     const [insertCitySuggestions, setInsertCitySuggestions] = useState([]);
//     const [showInsertCityDropdown, setShowInsertCityDropdown] = useState(false);
//     const [pendingInsertIndex, setPendingInsertIndex] = useState(null);

//     // Multi-trip state variables
//     const [timeSlots, setTimeSlots] = useState([]);
//     const [numberOfTrips, setNumberOfTrips] = useState(1);
//     const [isMultiTrip, setIsMultiTrip] = useState(false);

//     // New Route Form State
//     const [newRoute, setNewRoute] = useState({
//         routeName: '',
//         localRouteName: '',
//         upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
//         upOriginCoords: null, upOriginDepTime: '',
//         upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
//         upDestCoords: null, upDestArrTime: '',
//         upTotalDistance: '', upDurationHours: '', upDurationMinutes: '',
//         downOriginDepTime: '',
//         downDestArrTime: '',
//         downTotalDistance: '', downDurationHours: '', downDurationMinutes: '',
//         upManualFinalLeg: '',
//         downManualFinalLeg: '',
//         stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//         stopCoords: null, stopArrivalTime: '', stopDepartureTime: '',
//         stopDistFromPrev: '', stopDistToNext: '',
//         isBoarding: false, isDropping: false
//     });

//     const [upStops, setUpStops] = useState([]);
//     const [downStops, setDownStops] = useState([]);
//     const [editingStopIndex, setEditingStopIndex] = useState(null);
//     const [insertIndex, setInsertIndex] = useState(null);
//     const [isCreatingRoute, setIsCreatingRoute] = useState(false);
//     const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
//     const [isDistanceCalculated, setIsDistanceCalculated] = useState({ up: false, down: false });
//     const [activeTab, setActiveTab] = useState('basic');


//     // Pagination
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalRoutes, setTotalRoutes] = useState(0);
//     const [pageSize] = useState(10);

//     const [showStopEditModal, setShowStopEditModal] = useState(false);
//     const [stopBeingEdited, setStopBeingEdited] = useState(null);
//     // Update the stopEditForm state initialization (around line 300)
//     const [stopEditForm, setStopEditForm] = useState({
//         city: '',
//         state: '',
//         address: '',
//         terminal: '',
//         arrivalTime: '',
//         departureTime: '',
//         timings: [],  // Add this for multi-trip support
//         stopType: 'none',
//         isBoarding: false,
//         isDropping: false,
//         manualDistFromPrev: '',
//         manualDistToNext: '',
//         isManualStop: true
//     });

//     const [inlineInsertIndex, setInlineInsertIndex] = useState(null);
//     const [inlineInsertForm, setInlineInsertForm] = useState({
//         city: '', state: '', address: '', terminal: '',
//         arrivalTime: '', departureTime: '',
//         isBoarding: false, isDropping: false,
//         manualDistFromPrev: '', manualDistToNext: '',
//         isManual: true
//     });
//     const [inlineInsertCitySuggestions, setInlineInsertCitySuggestions] = useState([]);
//     const [showInlineInsertDropdown, setShowInlineInsertDropdown] = useState(false);

//     // Add this function to clear the current route
//     const clearCurrentRoute = () => {
//         // Confirm before clearing
//         if (!window.confirm(`Are you sure you want to clear all data for the ${activeRouteTab} route? This will remove origin, destination, and all intermediate stops.`)) {
//             return;
//         }

//         if (activeRouteTab === 'UP') {
//             // Clear UP route
//             setNewRoute(prev => ({
//                 ...prev,
//                 upOriginCity: '',
//                 upOriginState: '',
//                 upOriginAddress: '',
//                 upOriginTerminal: '',
//                 upOriginCoords: null,
//                 upOriginDepTime: '',
//                 upDestCity: '',
//                 upDestState: '',
//                 upDestAddress: '',
//                 upDestTerminal: '',
//                 upDestCoords: null,
//                 upDestArrTime: '',
//                 upTotalDistance: '',
//                 upDurationHours: '',
//                 upDurationMinutes: '',
//                 upManualFinalLeg: '',
//                 upManualFirstLeg: ''
//             }));
//             setUpStops([]);
//             setIsDistanceCalculated(prev => ({ ...prev, up: false }));

//             // Clear time slots for UP
//             if (isMultiTrip) {
//                 setTimeSlots([]);
//                 setDestinationTimeSlots([]);
//                 setNumberOfTrips(1);
//             }

//             toast.info('UP route cleared successfully');
//         } else {
//             // Clear DOWN route
//             setNewRoute(prev => ({
//                 ...prev,
//                 downOriginDepTime: '',
//                 downDestArrTime: '',
//                 downTotalDistance: '',
//                 downDurationHours: '',
//                 downDurationMinutes: '',
//                 downManualFinalLeg: '',
//                 downManualFirstLeg: ''
//             }));
//             setDownStops([]);
//             setIsDistanceCalculated(prev => ({ ...prev, down: false }));

//             // Clear return time slots
//             if (isMultiTrip) {
//                 setReturnOriginTimeSlots([]);
//                 setReturnDestTimeSlots([]);
//             }

//             toast.info('DOWN route cleared successfully');
//         }
//     };

//     // Add copy function
//     const copyScheduleToDestination = (slots) => {
//         setDestinationTimeSlots(slots.map(slot => ({
//             ...slot,
//             arrivalTime: slot.arrivalTime || '',  // Destination only needs arrival time
//             departureTime: ''  // Clear departure time for destination
//         })));
//         setDestinationNumberOfTrips(slots.length);
//     };

//     // Update the search effect
//     useEffect(() => {
//         setCurrentPage(1);
//         const timer = setTimeout(() => {
//             fetchRoutes();
//         }, 500);
//         return () => clearTimeout(timer);
//     }, [searchTerm, filterOrigin, filterDestination]); // Add filter dependencies

//     // Keep the page change effect
//     useEffect(() => {
//         fetchRoutes();
//     }, [currentPage]);

//     useEffect(() => {
//         const savedData = localStorage.getItem('pendingRouteFormData');
//         if (savedData) {
//             const formData = JSON.parse(savedData);
//             if (window.confirm('You have unsaved route data. Would you like to restore it?')) {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     routeName: formData.routeName || '',
//                     upOriginCity: formData.upOriginCity || '',
//                     upOriginState: formData.upOriginState || '',
//                     upOriginAddress: formData.upOriginAddress || '',
//                     upOriginTerminal: formData.upOriginTerminal || '',
//                     upOriginCoords: formData.upOriginCoords || null,
//                     upOriginDepTime: formData.upOriginDepTime || '',
//                     upDestCity: formData.upDestCity || '',
//                     upDestState: formData.upDestState || '',
//                     upDestAddress: formData.upDestAddress || '',
//                     upDestTerminal: formData.upDestTerminal || '',
//                     upDestCoords: formData.upDestCoords || null,
//                     upDestArrTime: formData.upDestArrTime || '',
//                 }));
//                 setIsRoundTrip(formData.isRoundTrip || false);
//                 if (formData.upStops) setUpStops(formData.upStops);
//                 if (formData.downStops) setDownStops(formData.downStops);
//                 localStorage.removeItem('pendingRouteFormData');
//             } else {
//                 localStorage.removeItem('pendingRouteFormData');
//             }
//         }
//     }, []);

//     // Add this effect to ensure DOWN route distances are properly maintained
//     useEffect(() => {
//         if (isRoundTrip && activeRouteTab === 'DOWN' && downStops.length > 0) {
//             // Check if any DOWN stop is missing distance
//             const missingDistances = downStops.some(stop =>
//                 stop.distanceFromOrigin === undefined || stop.distanceFromOrigin === 0
//             );

//             if (missingDistances && upStops.length > 0 && isDistanceCalculated.up) {
//                 // Attempt to recalculate if distances are missing
//                 const upTotalDist = parseFloat(newRoute.upTotalDistance) || 0;
//                 const downTotalDist = parseFloat(newRoute.downTotalDistance) || 0;

//                 if (downTotalDist === 0 && upTotalDist > 0) {
//                     syncDownStopsWithUpStops(false);
//                 }
//             }
//         }
//     }, [downStops, upStops, isRoundTrip, activeRouteTab, isDistanceCalculated.up]);

//     const navigate = useNavigate();
//     const [selectedMasterRouteFromDropdown, setSelectedMasterRouteFromDropdown] = useState(null);
//     // Add these state variables
//     const [showPlatformFeeModal, setShowPlatformFeeModal] = useState(false);
//     const [selectedBusForActivation, setSelectedBusForActivation] = useState(null);


//     // Update the handleActivateBusFromRoute function
//     const handleActivateBusFromRoute = (route) => {
//         console.log("Route for activation:", route);

//         // Find all pending buses on this route
//         const pendingBuses = route.associatedBuses?.filter(bus => !bus.isActive && (bus.approvalStatus === 'pending' || !bus.approvalStatus));

//         console.log("Pending buses found:", pendingBuses);

//         if (pendingBuses && pendingBuses.length > 0) {
//             // If there's only one pending bus, activate it directly
//             if (pendingBuses.length === 1) {
//                 handleActivateSingleBus(pendingBuses[0]);
//             } else {
//                 // If multiple, let the user choose
//                 const busList = pendingBuses.map((bus, idx) =>
//                     `${idx + 1}. ${bus.busName} (${bus.busNumber})`
//                 ).join('\n');

//                 const selectedIndex = window.prompt(
//                     `Multiple pending buses found on this route:\n${busList}\n\nEnter the number of the bus to activate (1-${pendingBuses.length}):`
//                 );

//                 const index = parseInt(selectedIndex) - 1;
//                 if (index >= 0 && index < pendingBuses.length) {
//                     handleActivateSingleBus(pendingBuses[index]);
//                 } else {
//                     toast.error('Invalid selection');
//                 }
//             }
//         } else {
//             toast.info('No pending buses found on this route');
//         }
//     };

//     // Update the fetchBusDetails function to use API
//     const fetchBusDetails = async (busId) => {
//         try {
//             const response = await getBusById(busId, token);
//             console.log('Bus details response:', response);

//             if (response.success) {
//                 setSelectedBusForActivation(response.data);
//                 setShowPlatformFeeModal(true);
//             } else {
//                 toast.error('Failed to fetch bus details');
//             }
//         } catch (error) {
//             console.error('Error fetching bus details:', error);
//             toast.error(error.response?.data?.message || 'Failed to fetch bus details');
//         }
//     };

//     // Update the handleActivateSingleBus function
//     const handleActivateSingleBus = async (bus) => {
//         console.log("Activating bus:", bus);

//         // Get the correct bus ID
//         const busId = bus._id || bus.busId;

//         if (!busId) {
//             toast.error('Invalid bus ID');
//             return;
//         }

//         try {
//             // First, try to fetch complete bus details
//             const response = await getBusById(busId, token);
//             console.log('Bus details from API:', response);

//             if (response && response.success) {
//                 // Check if response has data or bus property
//                 const busData = response.data || response.bus;
//                 if (busData) {
//                     setSelectedBusForActivation(busData);
//                     setShowPlatformFeeModal(true);
//                     return;
//                 }
//             }

//             // If API fails or doesn't return proper data, use the bus data we already have
//             // But ensure it has _id
//             const busWithId = {
//                 ...bus,
//                 _id: busId
//             };
//             setSelectedBusForActivation(busWithId);
//             setShowPlatformFeeModal(true);
//             toast.info('Using existing bus data for activation');

//         } catch (error) {
//             console.error('Error fetching bus details:', error);

//             // Fallback: use the bus data we already have
//             const busWithId = {
//                 ...bus,
//                 _id: busId
//             };
//             setSelectedBusForActivation(busWithId);
//             setShowPlatformFeeModal(true);
//             toast.info('Using existing bus data for activation');
//         }
//     };

//     // Helper function to get default state for new stops in RouteManage
//     const getDefaultStateForStop = (activeRouteTab, upStops, downStops, newRoute) => {
//         // For UP route: check last stop, then origin, then destination
//         if (activeRouteTab === 'UP') {
//             if (upStops.length > 0) {
//                 const lastStop = upStops[upStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     return lastStop.state;
//                 }
//             }
//             // If no stops with state, try origin state
//             if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 return newRoute.upOriginState;
//             }
//             // Fallback to destination state
//             if (newRoute.upDestState && newRoute.upDestState.trim()) {
//                 return newRoute.upDestState;
//             }
//         }
//         // For DOWN route: check last stop in downStops, then destination (which is UP origin), then origin (which is UP destination)
//         else if (activeRouteTab === 'DOWN') {
//             if (downStops.length > 0) {
//                 const lastStop = downStops[downStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     return lastStop.state;
//                 }
//             }
//             // Try UP origin (which becomes destination in DOWN route)
//             if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 return newRoute.upOriginState;
//             }
//             // Try UP destination (which becomes origin in DOWN route)
//             if (newRoute.upDestState && newRoute.upDestState.trim()) {
//                 return newRoute.upDestState;
//             }
//         }
//         return '';
//     };

//     // Add the renderInlineInsertPanel function
//     const renderInlineInsertPanel = (idx) => {
//         const stops = getActiveStops();
//         const prevStop = idx > 0 ? stops[idx - 1] : null;
//         const nextStop = stops[idx] || null;
//         const nextHasGPS = nextStop?.coordinates?.lat && nextStop.coordinates.lat !== 0;
//         const cityOk = inlineInsertForm.city.trim().length > 0;
//         const timeOk = inlineInsertForm.arrivalTime.trim().length > 0;
//         const distOk = parseFloat(inlineInsertForm.manualDistFromPrev) > 0;
//         const canInsert = cityOk && timeOk && (!inlineInsertForm.isManual || distOk);

//         const fieldStyle = {
//             display: 'flex', flexDirection: 'column', gap: 5
//         };
//         const labelStyle = {
//             fontSize: 11, fontWeight: 500,
//             color: 'var(--color-text-secondary, #777)', letterSpacing: '.2px'
//         };
//         const inputStyle = (hasErr = false) => ({
//             width: '100%', height: 38, padding: '0 12px',
//             border: `1px solid ${hasErr ? '#e24b4a' : 'var(--color-border-secondary, rgba(0,0,0,.2))'}`,
//             borderRadius: 8, fontSize: 13,
//             background: hasErr ? 'rgba(252,235,235,.05)' : 'var(--color-background-primary, #fff)',
//             color: 'var(--color-text-primary, #333)', outline: 'none',
//             boxSizing: 'border-box'
//         });
//         const sectionHead = (label) => (
//             <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '18px 0 12px' }}>
//                 <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--color-text-secondary, #888)', letterSpacing: '.4px', whiteSpace: 'nowrap' }}>{label}</span>
//                 <div style={{ flex: 1, height: 1, background: 'var(--color-border-tertiary, rgba(0,0,0,.1))' }} />
//             </div>
//         );

//         return (
//             <div style={{
//                 width: '100%', background: 'var(--color-background-primary, #fff)',
//                 border: '1.5px solid #378add', borderRadius: 14,
//                 overflow: 'hidden', margin: '6px 0', alignSelf: 'stretch'
//             }}>
//                 {/* Header band */}
//                 <div style={{
//                     background: 'linear-gradient(135deg, #185fa5 0%, #378add 100%)',
//                     padding: '14px 18px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'
//                 }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//                         <div style={{
//                             width: 34, height: 34, borderRadius: 8,
//                             background: 'rgba(255,255,255,.18)', display: 'flex',
//                             alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0
//                         }}>📍</div>
//                         <div>
//                             <div style={{ fontSize: 14, fontWeight: 500, color: '#fff' }}>
//                                 Insert stop at position {idx + 1}
//                             </div>

//                         </div>
//                     </div>
//                     <button onClick={() => { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }}
//                         style={{ width: 26, height: 26, borderRadius: 6, border: '1px solid rgba(255,255,255,.3)', background: 'transparent', color: '#fff', cursor: 'pointer', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
//                         ×
//                     </button>
//                 </div>

//                 {/* Body */}
//                 <div style={{ padding: 18 }}>
//                     {/* Manual toggle */}
//                     <label style={{
//                         display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
//                         background: 'var(--color-background-secondary, #f7f7f5)',
//                         border: '0.5px solid var(--color-border-tertiary, rgba(0,0,0,.1))',
//                         borderRadius: 8, cursor: 'pointer', userSelect: 'none'
//                     }}>
//                         <input type="checkbox" checked={inlineInsertForm.isManual}
//                             onChange={() => setInlineInsertForm(prev => ({
//                                 ...prev, isManual: !prev.isManual,
//                                 city: '', address: '', state: '', terminal: '', manualDistFromPrev: '', manualDistToNext: ''
//                             }))}
//                             style={{ width: 16, height: 16, accentColor: '#378add', cursor: 'pointer' }} />
//                         <span style={{ fontSize: 13, color: 'var(--color-text-primary, #333)' }}>
//                             Manually typed stop (no map suggestions)
//                         </span>
//                     </label>

//                     {/* Stop details */}
//                     {sectionHead('Stop details')}

//                     {/* City */}
//                     <div style={{ marginBottom: 12 }}>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>City / stop name <span style={{ color: '#e24b4a' }}>*</span></label>
//                             {!inlineInsertForm.isManual ? (
//                                 <LocationInput
//                                     value={inlineInsertForm.city}
//                                     onChange={(v) => setInlineInsertForm(prev => ({ ...prev, city: v }))}
//                                     onLocationSelect={(loc) => setInlineInsertForm(prev => ({
//                                         ...prev,
//                                         city: loc.city || loc.name || '',
//                                         state: loc.state || prev.state,
//                                         address: loc.address || ''
//                                     }))}
//                                     placeholder="Search stop city or address…"
//                                 />
//                             ) : (
//                                 <div style={{ position: 'relative' }}>
//                                     <input
//                                         type="text"
//                                         value={inlineInsertForm.city}
//                                         onChange={async (e) => {
//                                             const value = toTitleCase(e.target.value);
//                                             setInlineInsertForm(prev => ({ ...prev, city: value, address: '', state: '', terminal: '' }));
//                                             if (value.length >= 2) {
//                                                 try {
//                                                     const response = await searchRouteIntermediateStops(token, value);
//                                                     if (response.success && response.cities?.length > 0) {
//                                                         // setInlineInsertCitySuggestions(response.cities);
//                                                         normalizeAndDeduplicateSuggestions(response.cities);
//                                                         setShowInlineInsertDropdown(true);
//                                                     } else {
//                                                         setInlineInsertCitySuggestions([]);
//                                                         setShowInlineInsertDropdown(false);
//                                                     }
//                                                 } catch {
//                                                     setInlineInsertCitySuggestions([]);
//                                                     setShowInlineInsertDropdown(false);
//                                                 }
//                                             } else {
//                                                 setInlineInsertCitySuggestions([]);
//                                                 setShowInlineInsertDropdown(false);
//                                             }
//                                         }}
//                                         onFocus={() => inlineInsertCitySuggestions.length > 0 && setShowInlineInsertDropdown(true)}
//                                         onBlur={() => setTimeout(() => setShowInlineInsertDropdown(false), 200)}
//                                         placeholder="Type city name (min 2 chars)…"
//                                         style={inputStyle()}
//                                     />
//                                     {showInlineInsertDropdown && inlineInsertCitySuggestions.length > 0 && (
//                                         <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #ddd', borderRadius: 8, maxHeight: 200, overflowY: 'auto', zIndex: 10000, boxShadow: '0 4px 12px rgba(0,0,0,.12)' }}>
//                                             {inlineInsertCitySuggestions.map((city, i) => (
//                                                 <div key={city.id || i}
//                                                     onMouseDown={() => {
//                                                         setInlineInsertForm(prev => ({
//                                                             ...prev,
//                                                             city: city.name,
//                                                             address: city.address || city.name,
//                                                             state: city.state || '',
//                                                             terminal: city.terminal || `${city.name} Bus Stand`
//                                                         }));
//                                                         setShowInlineInsertDropdown(false);
//                                                         setInlineInsertCitySuggestions([]);
//                                                     }}
//                                                     style={{ padding: '9px 12px', cursor: 'pointer', borderBottom: '0.5px solid #f0f0f0' }}
//                                                     onMouseEnter={e => e.currentTarget.style.background = '#f0f7ff'}
//                                                     onMouseLeave={e => e.currentTarget.style.background = 'white'}>
//                                                     <div style={{ fontWeight: 500, fontSize: 13 }}>{city.name}</div>
//                                                     <div style={{ fontSize: 11, color: '#888' }}>{city.state}{city.terminal ? ` · ${city.terminal}` : ''}</div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </div>

//                     {/* Address */}
//                     <div style={{ marginBottom: 12 }}>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>Address</label>
//                             <input type="text" value={inlineInsertForm.address}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, address: e.target.value }))}
//                                 placeholder="e.g. NH-19, Near Bus Stand" style={inputStyle()} />
//                         </div>
//                     </div>

//                     {/* State + Terminal */}
//                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 4 }}>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>State</label>
//                             <input type="text" value={inlineInsertForm.state}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, state: e.target.value }))}
//                                 placeholder="State" style={inputStyle()} />
//                         </div>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>Terminal</label>
//                             <input type="text" value={inlineInsertForm.terminal}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, terminal: e.target.value }))}
//                                 placeholder="Terminal name" style={inputStyle()} />
//                         </div>
//                     </div>

//                     {/* Times */}
//                     {sectionHead('Schedule')}

//                     <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 4 }}>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>Arrival Time <span style={{ color: '#e24b4a' }}>*</span></label>
//                             <TimePicker
//                                 value={inlineInsertForm.arrivalTime}
//                                 onChange={(value) => setInlineInsertForm(prev => ({ ...prev, arrivalTime: value }))}
//                                 placeholder="Select time"
//                             />
//                         </div>
//                         <div style={fieldStyle}>
//                             <label style={labelStyle}>Departure Time (Opt)</label>
//                             <TimePicker
//                                 value={inlineInsertForm.departureTime}
//                                 onChange={(value) => setInlineInsertForm(prev => ({ ...prev, departureTime: value }))}
//                                 placeholder="Select time"
//                             />
//                         </div>
//                     </div>

//                     {/* Distance */}
//                     {sectionHead('Distance')}

//                     <div style={{ display: 'grid', gridTemplateColumns: nextHasGPS ? '1fr 1fr' : '1fr', gap: 12, marginBottom: 4 }}>
//                         {/* from prev */}
//                         <div style={{ border: '1px solid rgba(226,75,74,.4)', borderRadius: 10, padding: 14, background: 'rgba(252,235,235,.04)' }}>
//                             <div style={{ fontSize: 11, fontWeight: 500, color: '#a32d2d', marginBottom: 6 }}>
//                                 From previous stop <span style={{ color: '#e24b4a' }}>*</span>
//                             </div>
//                             <input type="number" value={inlineInsertForm.manualDistFromPrev}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
//                                 placeholder="0" min="0" step="0.1"
//                                 style={{ ...inputStyle(true), border: '1px solid #e24b4a' }} />
//                             <div style={{ fontSize: 11, color: '#a32d2d', marginTop: 5, display: 'flex', alignItems: 'center', gap: 4 }}>
//                                 ⚠ Required for manual stops
//                             </div>
//                             <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #888)', marginTop: 2 }}>km</div>
//                         </div>

//                         {/* to next — only if GPS */}
//                         {nextHasGPS && (
//                             <div style={{ border: '1px solid rgba(55,138,221,.3)', borderRadius: 10, padding: 14, background: 'rgba(230,241,251,.04)' }}>
//                                 <div style={{ fontSize: 11, fontWeight: 500, color: '#185fa5', marginBottom: 6 }}>
//                                     To next stop — {nextStop.city}
//                                 </div>
//                                 <input type="number" value={inlineInsertForm.manualDistToNext}
//                                     onChange={e => setInlineInsertForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
//                                     placeholder="0" min="0" step="0.1"
//                                     style={{ ...inputStyle(), border: '1px solid rgba(55,138,221,.5)' }} />
//                                 <div style={{ fontSize: 11, color: '#185fa5', marginTop: 5, display: 'flex', alignItems: 'center', gap: 4 }}>
//                                     ℹ Next stop has GPS — helps accuracy
//                                 </div>
//                                 <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #888)', marginTop: 2 }}>km</div>
//                             </div>
//                         )}
//                     </div>

//                     {/* Stop type */}
//                     {sectionHead('Stop type')}

//                     <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
//                         {[
//                             { val: 'none', label: 'Pass-through', bg: '#f1efe8', color: '#5f5e5a', border: '#888' },
//                             { val: 'boarding', label: 'Boarding only', bg: '#eaf3de', color: '#3b6d11', border: '#3b6d11' },
//                             { val: 'dropping', label: 'Dropping only', bg: '#fcebeb', color: '#a32d2d', border: '#a32d2d' },
//                             { val: 'both', label: 'Both boarding & dropping', bg: '#e6f1fb', color: '#185fa5', border: '#378add' },
//                         ].map(opt => {
//                             const sel = inlineInsertForm.stopType === opt.val;
//                             return (
//                                 <button key={opt.val}
//                                     type="button"
//                                     onClick={() => setInlineInsertForm(prev => ({ ...prev, stopType: opt.val }))}
//                                     style={{
//                                         padding: '6px 14px', borderRadius: 999, fontSize: 12, cursor: 'pointer',
//                                         border: `1px solid ${sel ? opt.border : 'rgba(0,0,0,.2)'}`,
//                                         background: sel ? opt.bg : 'transparent',
//                                         color: sel ? opt.color : 'var(--color-text-secondary, #666)',
//                                         fontWeight: sel ? 500 : 400, transition: 'all .12s'
//                                     }}>
//                                     {opt.label}
//                                 </button>
//                             );
//                         })}
//                     </div>

//                     {/* Checkboxes for boarding/dropping (if not set via stop type) */}
//                     <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
//                         <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
//                             <input type="checkbox" checked={inlineInsertForm.isBoarding}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, isBoarding: e.target.checked }))} />
//                             Boarding Point
//                         </label>
//                         <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
//                             <input type="checkbox" checked={inlineInsertForm.isDropping}
//                                 onChange={e => setInlineInsertForm(prev => ({ ...prev, isDropping: e.target.checked }))} />
//                             Dropping Point
//                         </label>
//                     </div>
//                 </div>

//                 {/* Footer */}
//                 <div style={{
//                     display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8,
//                     padding: '12px 18px',
//                     borderTop: '1px solid var(--color-border-tertiary, rgba(0,0,0,.08))',
//                     background: 'var(--color-background-secondary, #fafafa)'
//                 }}>
//                     <button type="button"
//                         onClick={() => { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }}
//                         style={{ padding: '8px 18px', fontSize: 13, borderRadius: 8, border: '1px solid var(--color-border-secondary, rgba(0,0,0,.2))', background: 'transparent', cursor: 'pointer', color: 'var(--color-text-secondary, #666)' }}>
//                         Cancel
//                     </button>
//                     <button type="button"
//                         onClick={saveInlineInsert}
//                         disabled={!canInsert}
//                         style={{ padding: '8px 22px', fontSize: 13, borderRadius: 8, border: 'none', background: '#378add', color: '#fff', fontWeight: 500, cursor: canInsert ? 'pointer' : 'not-allowed', opacity: canInsert ? 1 : 0.45, display: 'flex', alignItems: 'center', gap: 6 }}>
//                         ✓ Insert stop
//                     </button>
//                 </div>
//             </div>
//         );
//     };

//     // Add the saveInlineInsert function
//     const saveInlineInsert = () => {
//         if (!inlineInsertForm.city) {
//             toast.error('City is required');
//             return;
//         }
//         if (!inlineInsertForm.arrivalTime) {
//             toast.error('Arrival time is required');
//             return;
//         }
//         if (inlineInsertForm.isManual && (!inlineInsertForm.manualDistFromPrev || parseFloat(inlineInsertForm.manualDistFromPrev) <= 0)) {
//             toast.error('For manual stops, please provide distance from previous stop');
//             return;
//         }

//         const type = activeRouteTab === 'UP' ? 'up' : 'down';
//         let currentStops = type === 'up' ? [...upStops] : [...downStops];

//         let coordinates = null;
//         let manualDistFromPrev = null;
//         let manualDistToNext = null;
//         let distanceFromOrigin = 0;

//         if (inlineInsertForm.isManual) {
//             coordinates = { lat: 0, lng: 0 };
//             manualDistFromPrev = parseFloat(inlineInsertForm.manualDistFromPrev);
//             manualDistToNext = inlineInsertForm.manualDistToNext ? parseFloat(inlineInsertForm.manualDistToNext) : null;

//             // Calculate distance from origin
//             if (inlineInsertIndex > 0 && currentStops[inlineInsertIndex - 1]) {
//                 distanceFromOrigin = parseFloat(((currentStops[inlineInsertIndex - 1].distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
//             } else {
//                 distanceFromOrigin = manualDistFromPrev || 0;
//             }
//         }

//         // Determine stop type
//         let stopType = inlineInsertForm.stopType || 'none';
//         if (stopType === 'none') {
//             if (inlineInsertForm.isBoarding && inlineInsertForm.isDropping) stopType = 'both';
//             else if (inlineInsertForm.isBoarding) stopType = 'boarding';
//             else if (inlineInsertForm.isDropping) stopType = 'dropping';
//         }

//         const newStop = {
//             city: inlineInsertForm.city,
//             state: inlineInsertForm.state || '',
//             address: inlineInsertForm.address || `${inlineInsertForm.city}, ${inlineInsertForm.state || 'India'}`,
//             terminal: inlineInsertForm.terminal || `${inlineInsertForm.city} Bus Stand`,
//             arrivalTime: inlineInsertForm.arrivalTime,
//             departureTime: inlineInsertForm.departureTime || inlineInsertForm.arrivalTime,
//             stopType: stopType,
//             coordinates: coordinates,
//             manualDistFromPrev: manualDistFromPrev,
//             manualDistToNext: manualDistToNext,
//             distanceFromOrigin: distanceFromOrigin,
//             isManualStop: inlineInsertForm.isManual
//         };

//         // Insert the stop
//         currentStops.splice(inlineInsertIndex, 0, newStop);
//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//         // Update stops with new sequences
//         if (type === 'up') {
//             setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         } else {
//             setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         }

//         toast.success(`Stop "${inlineInsertForm.city}" inserted at position ${inlineInsertIndex + 1}`);

//         // Close the insert panel
//         setInlineInsertIndex(null);
//         setInlineInsertCitySuggestions([]);
//         setShowInlineInsertDropdown(false);
//     };


//     // Add this function to search for city suggestions
//     const searchCitySuggestions = async (query, type) => {
//         if (!query || query.trim().length < 2) {
//             if (type === 'origin') {
//                 setOriginSuggestions([]);
//             } else {
//                 setDestSuggestions([]);
//             }
//             return;
//         }

//         try {
//             // You can either use your existing getPlacePredictions or create a new API endpoint
//             // For now, we'll filter from existing routes
//             const allRoutes = await getAllRoutes(token, 1, 100, '');
//             if (allRoutes.success && allRoutes.data?.routes) {
//                 const cities = new Set();
//                 allRoutes.data.routes.forEach(route => {
//                     if (type === 'origin' && route.origin?.city) {
//                         if (route.origin.city.toLowerCase().includes(query.toLowerCase())) {
//                             cities.add(route.origin.city);
//                         }
//                     } else if (type === 'destination' && route.destination?.city) {
//                         if (route.destination.city.toLowerCase().includes(query.toLowerCase())) {
//                             cities.add(route.destination.city);
//                         }
//                     }
//                 });

//                 const suggestions = Array.from(cities).map(city => ({ city }));
//                 if (type === 'origin') {
//                     setOriginSuggestions(suggestions);
//                     setShowOriginSuggestions(true);
//                 } else {
//                     setDestSuggestions(suggestions);
//                     setShowDestSuggestions(true);
//                 }
//             }
//         } catch (error) {
//             console.error('Error fetching city suggestions:', error);
//         }
//     };

//     // Helper Functions
//     const formatTime = (time) => {
//         if (!time) return 'N/A';
//         if (time.includes(':')) {
//             const [hours, minutes] = time.split(':');
//             const hour = parseInt(hours);
//             const ampm = hour >= 12 ? 'pm' : 'am';
//             const displayHour = hour % 12 || 12;
//             return `${displayHour}:${minutes} ${ampm}`;
//         }
//         return time;
//     };

//     const formatDuration = (hours, minutes) => {
//         if (!hours && !minutes) return 'N/A';
//         const parts = [];
//         if (hours) parts.push(`${hours}h`);
//         if (minutes) parts.push(`${minutes}m`);
//         return parts.join(' ');
//     };

//     const getDuration = (start, end) => {
//         if (!start || !end) return { hours: '0', minutes: '0' };
//         const [sh, sm] = start.split(':').map(Number);
//         const [eh, em] = end.split(':').map(Number);
//         let sMins = sh * 60 + sm;
//         let eMins = eh * 60 + em;
//         if (eMins < sMins) eMins += 24 * 60;
//         const diff = eMins - sMins;
//         return { hours: String(Math.floor(diff / 60)), minutes: String(diff % 60) };
//     };

//     const isLastStopManual = () => {
//         const stops = activeRouteTab === 'UP' ? upStops : downStops;

//         if (stops.length === 0) return false;

//         const lastStop = stops[stops.length - 1];

//         // Check if last stop is manual based on multiple criteria
//         const isManual =
//             lastStop.isManualStop === true ||
//             (lastStop.manualDistFromPrev !== null && lastStop.manualDistFromPrev !== undefined && lastStop.manualDistFromPrev > 0) ||
//             (lastStop.manualDistToNext !== null && lastStop.manualDistToNext !== undefined && lastStop.manualDistToNext > 0) ||
//             !lastStop.coordinates ||
//             (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0);

//         console.log('isLastStopManual check:', {
//             city: lastStop.city,
//             isManualStop: lastStop.isManualStop,
//             manualDistFromPrev: lastStop.manualDistFromPrev,
//             manualDistToNext: lastStop.manualDistToNext,
//             hasCoordinates: !!lastStop.coordinates,
//             coordinates: lastStop.coordinates,
//             isManual: isManual
//         });

//         return isManual;
//     };

//     const isNextStopAuto = (currentIndex) => {
//         const stops = getActiveStops();
//         const nextStop = stops[currentIndex + 1];
//         return nextStop && nextStop.coordinates &&
//             (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
//     };

//     // Location Handlers
//     const handleSelectOrigin = (location) => {
//         setNewRoute(prev => ({
//             ...prev,
//             upOriginCity: location.city || location.name || '',
//             upOriginState: location.state || '',
//             upOriginAddress: location.address || '',
//             upOriginCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsDistanceCalculated(prev => ({ ...prev, up: false }));
//     };

//     const handleSelectDest = (location) => {
//         setNewRoute(prev => ({
//             ...prev,
//             upDestCity: location.city || location.name || '',
//             upDestState: location.state || '',
//             upDestAddress: location.address || '',
//             upDestCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsDistanceCalculated(prev => ({ ...prev, up: false }));
//     };

//     //   const handleSelectStop = (location) => {
//     //     setNewRoute(prev => ({
//     //       ...prev,
//     //       stopCity: location.city || location.name || '',
//     //       stopState: location.state || '',
//     //       stopAddress: location.address || '',
//     //       stopCoords: location.coordinates || { lat: 0, lng: 0 }
//     //     }));
//     //     setIsManualStop(false);
//     //     setIsManualDistance(false);
//     //   };

//     const handleSelectStop = (location) => {
//         // If location has state, use it; otherwise try to auto-fill from previous stop or origin
//         let autoState = location.state || '';

//         if (!autoState && activeRouteTab === 'UP') {
//             if (upStops.length > 0) {
//                 const lastStop = upStops[upStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     autoState = lastStop.state;
//                 }
//             }
//             if (!autoState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 autoState = newRoute.upOriginState;
//             }
//         } else if (!autoState && activeRouteTab === 'DOWN') {
//             if (downStops.length > 0) {
//                 const lastStop = downStops[downStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     autoState = lastStop.state;
//                 }
//             }
//             if (!autoState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 autoState = newRoute.upOriginState;
//             }
//         }

//         setNewRoute(prev => ({
//             ...prev,
//             stopCity: location.city || location.name || '',
//             stopState: autoState,
//             stopAddress: location.address || '',
//             stopCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//         setIsManualStop(false);
//         setIsManualDistance(false);
//     };

//     // const syncDownStopsWithUpStops = (forcePrompt = false) => {
//     //     const hasManualStops = upStops.some(s => s.manualDistFromPrev !== null || !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0));

//     //     if (forcePrompt && !isDistanceCalculated.up && hasManualStops) {
//     //         toast.warning("Please click 'Auto-Calculate Distances (UP)' before syncing the return route.");
//     //         return;
//     //     }

//     //     const doSync = () => {
//     //         const upTotalDist = parseFloat(newRoute.upTotalDistance) || 0;

//     //         //   const reversed = [...upStops].reverse().map((s, idx) => {
//     //         //     let newStopType = s.stopType;
//     //         //     if (s.stopType === 'boarding') {
//     //         //       newStopType = 'dropping';
//     //         //     } else if (s.stopType === 'dropping') {
//     //         //       newStopType = 'boarding';
//     //         //     }
//     //         const reversed = [...upStops].reverse().map((s, idx) => {
//     //             let newStopType = s.stopType;
//     //             if (s.stopType === 'boarding') {
//     //                 newStopType = 'dropping';
//     //             } else if (s.stopType === 'dropping') {
//     //                 newStopType = 'boarding';
//     //             }

//     //             const origIndex = upStops.length - 1 - idx;
//     //             const nextOrigIndex = origIndex + 1;
//     //             let mappedManualDist = null;

//     //             const isManual = !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0);

//     //             if (isManual) {
//     //                 if (nextOrigIndex < upStops.length) {
//     //                     const nextUpStop = upStops[nextOrigIndex];
//     //                     if (nextUpStop.manualDistFromPrev !== null && nextUpStop.manualDistFromPrev !== undefined) {
//     //                         mappedManualDist = nextUpStop.manualDistFromPrev;
//     //                     } else {
//     //                         const currDist = s.distanceFromOrigin || 0;
//     //                         const nextDist = nextUpStop.distanceFromOrigin || 0;
//     //                         const diff = nextDist - currDist;
//     //                         mappedManualDist = diff > 0 ? parseFloat(diff.toFixed(1)) : null;
//     //                     }
//     //                 } else {
//     //                     const lastUpStopDist = s.distanceFromOrigin || 0;
//     //                     let inferredFirstSegment = upTotalDist - lastUpStopDist;
//     //                     if (inferredFirstSegment < 0) inferredFirstSegment = 0;
//     //                     mappedManualDist = parseFloat(inferredFirstSegment.toFixed(1));
//     //                 }
//     //             } else {
//     //                 if (origIndex === upStops.length - 1) {
//     //                     const lastUpStopDist = s.distanceFromOrigin || 0;
//     //                     mappedManualDist = parseFloat((upTotalDist - lastUpStopDist).toFixed(1));
//     //                 } else {
//     //                     const prevUpStop = upStops[origIndex + 1];
//     //                     if (prevUpStop) {
//     //                         const currDist = s.distanceFromOrigin || 0;
//     //                         const prevDist = prevUpStop.distanceFromOrigin || 0;
//     //                         const diff = currDist - prevDist;
//     //                         mappedManualDist = diff > 0 ? parseFloat(diff.toFixed(1)) : null;
//     //                     }
//     //                 }
//     //             }

//     //             return {
//     //                 ...s,
//     //                 sequence: idx + 1,
//     //                 stopType: newStopType,
//     //                 manualDistFromPrev: mappedManualDist,
//     //                 manualDistToNext: s.manualDistFromPrev,
//     //                 distanceFromOrigin: 0,
//     //                 isManualStop: isManual,
//     //                 state: s.state || '' // Preserve state
//     //             };
//     //         });

//     //         setDownStops(reversed);
//     //         setIsDistanceCalculated(prev => ({ ...prev, down: false }));
//     //         setEditDownIndex(null);
//     //         setEditingStopIndex(null);
//     //     };

//     //     if (forcePrompt && downStops.length > 0) {
//     //         if (window.confirm("This will update your Return Route stops based on your Main Route. Proceed?")) {
//     //             doSync();
//     //         }
//     //     } else {
//     //         doSync();
//     //     }
//     // };
//     // const syncDownStopsWithUpStops = (forcePrompt = false) => {
//     //     if (upStops.length === 0) {
//     //         toast.warning("No UP route stops to sync from.");
//     //         return;
//     //     }

//     //     // Get total distances
//     //     const upTotalDist = parseFloat(editForm.totalDistance || newRoute.upTotalDistance || 0);
//     //     let downTotalDist = parseFloat(editForm.returnTotalDistance || newRoute.downTotalDistance || 0);

//     //     if (downTotalDist === 0 && upTotalDist > 0) {
//     //         downTotalDist = upTotalDist;
//     //     }

//     //     const doSync = () => {
//     //         // Build segment distances from UP route
//     //         const upSegmentDistances = [];
//     //         let prevDist = 0;

//     //         for (let i = 0; i < upStops.length; i++) {
//     //             const stop = upStops[i];
//     //             let segmentDist = stop.manualDistFromPrev;

//     //             if (!segmentDist || segmentDist <= 0) {
//     //                 const currentDist = stop.distanceFromOrigin || 0;
//     //                 segmentDist = currentDist - prevDist;
//     //                 if (segmentDist <= 0) segmentDist = upTotalDist / (upStops.length + 1);
//     //             }
//     //             if (segmentDist <= 0) segmentDist = 5;

//     //             upSegmentDistances.push(segmentDist);
//     //             prevDist = stop.distanceFromOrigin || (prevDist + segmentDist);
//     //         }

//     //         // Last segment from last UP stop to destination
//     //         const lastUpStopDist = upStops.length > 0 ? (upStops[upStops.length - 1].distanceFromOrigin || 0) : 0;
//     //         let finalUpSegment = upTotalDist - lastUpStopDist;
//     //         if (finalUpSegment <= 0 && editForm.upManualFinalLeg) {
//     //             finalUpSegment = parseFloat(editForm.upManualFinalLeg);
//     //         }
//     //         if (finalUpSegment <= 0) finalUpSegment = upTotalDist / (upStops.length + 1);

//     //         // First leg from origin to first UP stop
//     //         let firstUpLeg = upStops[0]?.manualDistFromPrev || upStops[0]?.distanceFromOrigin || upTotalDist / (upStops.length + 1);
//     //         if (firstUpLeg <= 0) firstUpLeg = 5;

//     //         // Build DOWN segment distances (reversed order)
//     //         const reversedSegments = [...upSegmentDistances].reverse();
//     //         const downSegmentDistances = [finalUpSegment, ...reversedSegments];

//     //         // Calculate DOWN stops with cumulative distances
//     //         let cumulativeDist = 0;
//     //         const newDownStops = [];

//     //         for (let i = 0; i < upStops.length; i++) {
//     //             const originalIndex = upStops.length - 1 - i;
//     //             const originalStop = upStops[originalIndex];

//     //             let segmentDist = downSegmentDistances[i] || 5;

//     //             // Prefer manual values from original stop
//     //             if (originalStop.manualDistFromPrev && originalStop.manualDistFromPrev > 0) {
//     //                 segmentDist = parseFloat(originalStop.manualDistFromPrev);
//     //             } else if (originalStop.manualDistToNext && originalStop.manualDistToNext > 0) {
//     //                 segmentDist = parseFloat(originalStop.manualDistToNext);
//     //             }

//     //             cumulativeDist += segmentDist;

//     //             let newStopType = originalStop.stopType;
//     //             if (originalStop.stopType === 'boarding') newStopType = 'dropping';
//     //             else if (originalStop.stopType === 'dropping') newStopType = 'boarding';

//     //             newDownStops.push({
//     //                 ...originalStop,
//     //                 sequence: i + 1,
//     //                 stopType: newStopType,
//     //                 distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//     //                 manualDistFromPrev: parseFloat(segmentDist.toFixed(1)),
//     //                 manualDistToNext: originalStop.manualDistFromPrev || null,
//     //                 arrivalTime: originalStop.arrivalTime || '',
//     //                 departureTime: originalStop.departureTime || '',
//     //                 timings: originalStop.timings ? [...originalStop.timings] : []
//     //             });
//     //         }

//     //         // Calculate final segment
//     //         let finalSegment = downTotalDist - cumulativeDist;
//     //         if (finalSegment <= 0) {
//     //             finalSegment = firstUpLeg;
//     //         }

//     //         // Update last stop's manualDistToNext
//     //         if (newDownStops.length > 0 && finalSegment > 0) {
//     //             newDownStops[newDownStops.length - 1] = {
//     //                 ...newDownStops[newDownStops.length - 1],
//     //                 manualDistToNext: parseFloat(finalSegment.toFixed(1))
//     //             };
//     //         }

//     //         // Recalculate total distance
//     //         const calculatedTotal = cumulativeDist + finalSegment;

//     //         // Update down stops
//     //         setDownStops(newDownStops);

//     //         // Update editForm
//     //         setEditForm(prev => ({
//     //             ...prev,
//     //             returnTotalDistance: calculatedTotal.toFixed(1),
//     //             returnDurationHours: prev.durationHours,
//     //             returnDurationMinutes: prev.durationMinutes,
//     //             returnManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.returnManualFinalLeg
//     //         }));

//     //         // CRITICAL: Also update newRoute state for the DOWN summary distance field
//     //         setNewRoute(prev => ({
//     //             ...prev,
//     //             downTotalDistance: calculatedTotal.toFixed(1),
//     //             downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.downManualFinalLeg,
//     //             downDurationHours: prev.downDurationHours || String(editForm.durationHours || ''),
//     //             downDurationMinutes: prev.downDurationMinutes || String(editForm.durationMinutes || '')
//     //         }));

//     //         setIsDistanceCalculated(prev => ({ ...prev, down: false }));
//     //         toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${calculatedTotal.toFixed(1)} km`);
//     //     };

//     //     if (forcePrompt && downStops.length > 0) {
//     //         if (window.confirm("This will update your Return Route stops based on your Main Route. Any existing DOWN route data will be replaced. Proceed?")) {
//     //             doSync();
//     //         }
//     //     } else {
//     //         doSync();
//     //     }
//     // };

//     const syncDownStopsWithUpStops = (forcePrompt = false) => {
//         if (upStops.length === 0) {
//             toast.warning("No UP route stops to sync from.");
//             return;
//         }

//         // Get total distances from actual data
//         const upTotalDist = parseFloat(editForm.totalDistance || newRoute.upTotalDistance || 0);
//         let downTotalDist = parseFloat(editForm.returnTotalDistance || newRoute.downTotalDistance || 0);

//         if (downTotalDist === 0 && upTotalDist > 0) {
//             downTotalDist = upTotalDist;
//         }

//         const doSync = () => {
//             // Build DOWN stops by reversing UP stops and PRESERVING actual distances
//             const newDownStops = [];

//             // Get the actual distances from UP stops
//             const upDistances = upStops.map(stop => stop.distanceFromOrigin || 0);
//             const maxUpDistance = upDistances[upDistances.length - 1] || 0;

//             for (let i = 0; i < upStops.length; i++) {
//                 const originalIndex = upStops.length - 1 - i;
//                 const originalStop = upStops[originalIndex];

//                 // Calculate DOWN distance (reverse of UP distance)
//                 const upDistance = originalStop.distanceFromOrigin || 0;
//                 let downDistance = downTotalDist - upDistance;

//                 // Adjust if negative or zero
//                 if (downDistance <= 0 && i === 0) {
//                     downDistance = downTotalDist - maxUpDistance;
//                 }
//                 if (downDistance <= 0) downDistance = (downTotalDist / (upStops.length + 1)) * (i + 1);

//                 // Get manual distance from previous in DOWN direction
//                 let manualDistFromPrev = null;
//                 if (i === 0) {
//                     manualDistFromPrev = downDistance;
//                 } else {
//                     const prevDownDist = newDownStops[i - 1]?.distanceFromOrigin || 0;
//                     manualDistFromPrev = downDistance - prevDownDist;
//                 }
//                 if (manualDistFromPrev <= 0) manualDistFromPrev = originalStop.manualDistFromPrev || downDistance / (i + 1);

//                 // Determine stop type for return journey
//                 let newStopType = originalStop.stopType;
//                 if (originalStop.stopType === 'boarding') newStopType = 'dropping';
//                 else if (originalStop.stopType === 'dropping') newStopType = 'boarding';

//                 newDownStops.push({
//                     ...originalStop,
//                     sequence: i + 1,
//                     stopType: newStopType,
//                     distanceFromOrigin: parseFloat(downDistance.toFixed(1)),
//                     manualDistFromPrev: parseFloat(manualDistFromPrev.toFixed(1)),
//                     manualDistToNext: originalStop.manualDistFromPrev || null,
//                     // arrivalTime: originalStop.arrivalTime || '',
//                     // departureTime: originalStop.departureTime || '',
//                     // timings: originalStop.timings ? [...originalStop.timings] : []
//                     arrivalTime: '',    // DOWN fills independently
//                     departureTime: '',
//                     timings: []
//                 });
//             }

//             // Update last stop's manualDistToNext
//             if (newDownStops.length > 0) {
//                 const lastDownDist = newDownStops[newDownStops.length - 1].distanceFromOrigin || 0;
//                 const finalSegment = downTotalDist - lastDownDist;
//                 if (finalSegment > 0) {
//                     newDownStops[newDownStops.length - 1] = {
//                         ...newDownStops[newDownStops.length - 1],
//                         manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                     };
//                 }
//             }

//             setDownStops(newDownStops);
//             setEditForm(prev => ({
//                 ...prev,
//                 returnTotalDistance: downTotalDist.toFixed(1),
//                 returnDurationHours: prev.durationHours,
//                 returnDurationMinutes: prev.durationMinutes
//             }));
//             setNewRoute(prev => ({
//                 ...prev,
//                 downTotalDistance: downTotalDist.toFixed(1)
//             }));

//             setIsDistanceCalculated(prev => ({ ...prev, down: false }));
//             toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${downTotalDist.toFixed(1)} km`);
//         };

//         if (forcePrompt && downStops.length > 0) {
//             if (window.confirm("This will update your Return Route stops based on your Main Route. Any existing DOWN route data will be replaced. Proceed?")) {
//                 doSync();
//             }
//         } else {
//             doSync();
//         }
//     };

//     // const toggleRoundTrip = () => {
//     //     const newVal = !isRoundTrip;
//     //     setIsRoundTrip(newVal);

//     //     if (newVal) {
//     //         if (downStops.length === 0 && upStops.length > 0) {
//     //             const reversed = [...upStops].reverse().map((s, idx) => {
//     //                 let newStopType = s.stopType;
//     //                 if (s.stopType === 'boarding') {
//     //                     newStopType = 'dropping';
//     //                 } else if (s.stopType === 'dropping') {
//     //                     newStopType = 'boarding';
//     //                 }

//     //                 return {
//     //                     city: s.city,
//     //                     state: s.state || '',
//     //                     address: s.address || '',
//     //                     terminal: s.terminal || '',
//     //                     arrivalTime: s.arrivalTime,
//     //                     departureTime: s.departureTime,
//     //                     stopType: newStopType,
//     //                     coordinates: s.coordinates || { lat: 0, lng: 0 },
//     //                     sequence: idx + 1,
//     //                     manualDistFromPrev: s.manualDistToNext || null,
//     //                     manualDistToNext: s.manualDistFromPrev || null,
//     //                     distanceFromOrigin: 0
//     //                 };
//     //             });
//     //             setDownStops(reversed);
//     //         }
//     //         setActiveRouteTab('DOWN');
//     //     } else {
//     //         setActiveRouteTab('UP');
//     //     }
//     //     clearStopForm();
//     // };

// const toggleRoundTrip = () => {
//     const newVal = !isRoundTrip;
//     setIsRoundTrip(newVal);

//     if (newVal) {
//         // When enabling round trip, initialize return time slots from forward times
//         if (isMultiTrip) {
//             // Initialize return origin time slots from destination time slots
//             if (destinationTimeSlots && destinationTimeSlots.length > 0) {
//                 setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
//                     sequence: slot.sequence,
//                     departureTime: slot.arrivalTime || '',
//                     arrivalTime: '',
//                     fareMultiplier: slot.fareMultiplier || 1.0,
//                     isActive: true
//                 })));
//             } else if (timeSlots && timeSlots.length > 0) {
//                 // Fallback to time slots
//                 setReturnOriginTimeSlots(timeSlots.map(slot => ({
//                     sequence: slot.sequence,
//                     departureTime: slot.departureTime || '',
//                     arrivalTime: '',
//                     fareMultiplier: slot.fareMultiplier || 1.0,
//                     isActive: true
//                 })));
//             }

//             // Initialize return destination time slots from forward origin time slots
//             if (timeSlots && timeSlots.length > 0) {
//                 setReturnDestTimeSlots(timeSlots.map(slot => ({
//                     sequence: slot.sequence,
//                     arrivalTime: slot.departureTime || '',
//                     departureTime: '',
//                     fareMultiplier: slot.fareMultiplier || 1.0,
//                     isActive: true
//                 })));
//             }
//         }

//         // Sync down stops if we have up stops
//         if (upStops.length > 0) {
//             if (downStops.length === 0) {
//                 syncDownStopsWithUpStops(false);
//             } else if (downStops.length > 0) {
//                 if (window.confirm("Enable round trip and sync DOWN route with UP route? Existing DOWN route data will be replaced.")) {
//                     syncDownStopsWithUpStops(false);
//                 }
//             }
//         }
//         setActiveRouteTab('DOWN');
//     } else {
//         setActiveRouteTab('UP');
//         // Clear return time slots when disabling round trip
//         setReturnOriginTimeSlots([]);
//         setReturnDestTimeSlots([]);
//     }
//     clearStopForm();
// };

//     // const handleTabSwitch = (tab) => {
//     //     if (tab === 'DOWN' && downStops.length === 0 && upStops.length > 0) {
//     //         syncDownStopsWithUpStops(false);
//     //     }
//     //     setActiveRouteTab(tab);
//     //     clearStopForm();
//     // };

// const handleTabSwitch = (tab) => {
//     if (tab === 'DOWN' && upStops.length > 0 && isRoundTrip) {
//         // When switching to DOWN, initialize return time slots if needed
//         if (isMultiTrip) {
//             if (returnOriginTimeSlots.length === 0 && destinationTimeSlots.length > 0) {
//                 setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
//                     sequence: slot.sequence,
//                     departureTime: slot.arrivalTime || '',
//                     arrivalTime: '',
//                     fareMultiplier: slot.fareMultiplier || 1.0,
//                     isActive: true
//                 })));
//             }
//             if (returnDestTimeSlots.length === 0 && timeSlots.length > 0) {
//                 setReturnDestTimeSlots(timeSlots.map(slot => ({
//                     sequence: slot.sequence,
//                     arrivalTime: slot.departureTime || '',
//                     departureTime: '',
//                     fareMultiplier: slot.fareMultiplier || 1.0,
//                     isActive: true
//                 })));
//             }
//         }

//         if (downStops.length === 0) {
//             syncDownStopsWithUpStops(false);
//         } else if (downStops.length > 0) {
//             // Check if we need to update return stops
//             const hasStaleData = downStops.some(stop => {
//                 if (isMultiTrip) {
//                     return !stop.timings || stop.timings.length === 0;
//                 }
//                 return !stop.arrivalTime;
//             });

//             if (hasStaleData && window.confirm("Return route stops are missing timing information. Would you like to sync with UP route?")) {
//                 syncDownStopsWithUpStops(false);
//             }
//         }
//     }
//     setActiveRouteTab(tab);
//     clearStopForm();
// };

//     const getActiveStops = () => activeRouteTab === 'UP' ? upStops : downStops;
//     const setActiveStops = (stops) => {
//         if (activeRouteTab === 'UP') {
//             setUpStops(stops);
//         } else {
//             setDownStops(stops);
//         }
//     };

//     //   const clearStopForm = () => {
//     //     setNewRoute(prev => ({
//     //       ...prev,
//     //       stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//     //       stopArrivalTime: '', stopDepartureTime: '', stopCoords: null,
//     //       stopDistFromPrev: '', stopDistToNext: '',
//     //       isBoarding: false, isDropping: false
//     //     }));
//     //     setIsManualDistance(false);
//     //     setEditingStopIndex(null);
//     //     setInsertIndex(null);
//     //   };

//     // const clearStopForm = () => {
//     //     // Get default state based on existing stops
//     //     let defaultState = '';

//     //     if (activeRouteTab === 'UP') {
//     //         if (upStops.length > 0) {
//     //             const lastStop = upStops[upStops.length - 1];
//     //             if (lastStop.state && lastStop.state.trim()) {
//     //                 defaultState = lastStop.state;
//     //             }
//     //         }
//     //         if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//     //             defaultState = newRoute.upOriginState;
//     //         }
//     //         if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) {
//     //             defaultState = newRoute.upDestState;
//     //         }
//     //     } else if (activeRouteTab === 'DOWN') {
//     //         if (downStops.length > 0) {
//     //             const lastStop = downStops[downStops.length - 1];
//     //             if (lastStop.state && lastStop.state.trim()) {
//     //                 defaultState = lastStop.state;
//     //             }
//     //         }
//     //         if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//     //             defaultState = newRoute.upOriginState;
//     //         }
//     //         if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) {
//     //             defaultState = newRoute.upDestState;
//     //         }
//     //     }

//     //     setNewRoute(prev => ({
//     //         ...prev,
//     //         stopCity: '',
//     //         stopState: defaultState, // Auto-fill with default state
//     //         stopAddress: '',
//     //         stopTerminal: '',
//     //         stopArrivalTime: '',
//     //         stopDepartureTime: '',
//     //         stopCoords: null,
//     //         stopDistFromPrev: '',
//     //         stopDistToNext: '',
//     //         isBoarding: false,
//     //         isDropping: false
//     //     }));
//     //     setIsManualDistance(false);
//     //     setEditingStopIndex(null);
//     //     setInsertIndex(null);
//     //     setIsManualStop(true);
//     // };

//     const clearStopForm = () => {
//         let defaultState = '';

//         if (activeRouteTab === 'UP') {
//             if (upStops.length > 0) {
//                 const lastStop = upStops[upStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     defaultState = lastStop.state;
//                 }
//             }
//             if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 defaultState = newRoute.upOriginState;
//             }
//             if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) {
//                 defaultState = newRoute.upDestState;
//             }
//         } else if (activeRouteTab === 'DOWN') {
//             if (downStops.length > 0) {
//                 const lastStop = downStops[downStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) {
//                     defaultState = lastStop.state;
//                 }
//             }
//             if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
//                 defaultState = newRoute.upOriginState;
//             }
//             if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) {
//                 defaultState = newRoute.upDestState;
//             }
//         }

//         setNewRoute(prev => ({
//             ...prev,
//             stopCity: '',
//             stopState: defaultState,
//             stopAddress: '',
//             stopTerminal: '',
//             stopArrivalTime: '',
//             stopDepartureTime: '',
//             stopCoords: null,
//             stopDistFromPrev: '',
//             stopDistToNext: '',
//             isBoarding: false,
//             isDropping: false,
//             stopTimings: []  // Reset timings
//         }));
//         setIsManualDistance(false);
//         setEditingStopIndex(null);
//         setInsertIndex(null);
//         setIsManualStop(true);
//     };

//     // const addIntermediateStop = (type = 'up') => {
//     //     if (!newRoute.stopCity || !newRoute.stopArrivalTime) {
//     //         toast.error('City and Arrival Time are required.');
//     //         return;
//     //     }

//     //     let coordinates = newRoute.stopCoords;
//     //     let manualDistFromPrev = null;
//     //     let manualDistToNext = null;
//     //     let distanceFromOrigin = 0;

//     //     const stops = getActiveStops();
//     //     const isManualLocation = isManualStop || !newRoute.stopCoords || (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

//     //     if (isManualLocation) {
//     //         if (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0) {
//     //             toast.error('For manual stops, please provide distance from previous stop');
//     //             return;
//     //         }
//     //         coordinates = { lat: 0, lng: 0 };
//     //         manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);

//     //         // Calculate cumulative distance from origin
//     //         if (stops.length > 0) {
//     //             const lastStop = stops[stops.length - 1];
//     //             distanceFromOrigin = (lastStop.distanceFromOrigin || 0) + manualDistFromPrev;
//     //         } else {
//     //             distanceFromOrigin = manualDistFromPrev;
//     //         }

//     //         const currentIndex = editingStopIndex !== null ? editingStopIndex :
//     //             (insertIndex !== null ? insertIndex : stops.length);
//     //         const nextStop = stops[currentIndex];
//     //         const isNextAuto = nextStop && nextStop.coordinates &&
//     //             (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);

//     //         if (isNextAuto && newRoute.stopDistToNext && parseFloat(newRoute.stopDistToNext) > 0) {
//     //             manualDistToNext = parseFloat(newRoute.stopDistToNext);
//     //         }
//     //     } else if (newRoute.stopCoords && (newRoute.stopCoords.lat !== 0 || newRoute.stopCoords.lng !== 0)) {
//     //         // For Google stop, we'll calculate distance during auto-calculation
//     //         distanceFromOrigin = 0; // Will be calculated later
//     //     }

//     //     let stopType = 'none';
//     //     if (newRoute.isBoarding && newRoute.isDropping) stopType = 'both';
//     //     else if (newRoute.isBoarding) stopType = 'boarding';
//     //     else if (newRoute.isDropping) stopType = 'dropping';

//     //     // Auto-fill state if empty
//     //     let autoState = newRoute.stopState;
//     //     if (!autoState || !autoState.trim()) {
//     //         if (type === 'up' && upStops.length > 0) {
//     //             const lastStop = upStops[upStops.length - 1];
//     //             if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state;
//     //         } else if (type === 'down' && downStops.length > 0) {
//     //             const lastStop = downStops[downStops.length - 1];
//     //             if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state;
//     //         }
//     //         if (!autoState && newRoute.upOriginState) autoState = newRoute.upOriginState;
//     //         if (!autoState && newRoute.upDestState) autoState = newRoute.upDestState;
//     //     }

//     //     const newStop = {
//     //         city: newRoute.stopCity,
//     //         state: autoState || newRoute.stopState || '',
//     //         address: newRoute.stopAddress || `${newRoute.stopCity}, ${autoState || 'India'}`,
//     //         terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
//     //         arrivalTime: newRoute.stopArrivalTime,
//     //         departureTime: newRoute.stopDepartureTime || newRoute.stopArrivalTime,
//     //         stopType: stopType,
//     //         coordinates: coordinates,
//     //         manualDistFromPrev: manualDistFromPrev,
//     //         manualDistToNext: manualDistToNext,
//     //         distanceFromOrigin: distanceFromOrigin,
//     //         isManualStop: isManualLocation
//     //     };

//     //     setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//     //     let currentStops = type === 'up' ? [...upStops] : [...downStops];
//     //     let editingIndex = null;

//     //     if (type === 'up' && editUpIndex !== null) {
//     //         editingIndex = editUpIndex;
//     //     } else if (type === 'down' && editDownIndex !== null) {
//     //         editingIndex = editDownIndex;
//     //     }

//     //     if (editingIndex !== null) {
//     //         currentStops[editingIndex] = { ...currentStops[editingIndex], ...newStop, sequence: editingIndex + 1 };
//     //         if (type === 'up') setEditUpIndex(null);
//     //         else setEditDownIndex(null);
//     //         setEditingStopIndex(null);
//     //         toast.success(`Stop "${newRoute.stopCity}" updated successfully`);
//     //     } else if (insertIndex !== null) {
//     //         currentStops.splice(insertIndex, 0, newStop);
//     //         setInsertIndex(null);
//     //         toast.success(`Stop inserted at position ${insertIndex + 1}`);
//     //     } else {
//     //         currentStops.push(newStop);
//     //         toast.success(`Stop "${newRoute.stopCity}" added successfully`);
//     //     }

//     //     if (type === 'up') {
//     //         setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     //     } else {
//     //         setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//     //     }

//     //     clearStopForm();
//     // };

//     const addIntermediateStop = (type = 'up') => {
//         if (!newRoute.stopCity) {
//             toast.error('City is required.');
//             return;
//         }

//         // For multi-trip mode, check if at least one timing is set
//         if (isMultiTrip && (!newRoute.stopTimings || newRoute.stopTimings.length === 0)) {
//             toast.warning('Please add at least one trip timing for this stop');
//             return;
//         }

//         // For single trip mode, arrival time is required
//         if (!isMultiTrip && !newRoute.stopArrivalTime) {
//             toast.error('Arrival Time is required.');
//             return;
//         }

//         let coordinates = newRoute.stopCoords;
//         let manualDistFromPrev = null;
//         let manualDistToNext = null;
//         let distanceFromOrigin = 0;

//         const stops = getActiveStops();
//         const isManualLocation = isManualStop || !newRoute.stopCoords || (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

//         if (isManualLocation) {
//             if (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0) {
//                 toast.error('For manual stops, please provide distance from previous stop');
//                 return;
//             }
//             coordinates = { lat: 0, lng: 0 };
//             manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);

//             if (stops.length > 0) {
//                 const lastStop = stops[stops.length - 1];
//                 distanceFromOrigin = parseFloat(((lastStop.distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
//             } else {
//                 distanceFromOrigin = manualDistFromPrev;
//             }

//             const currentIndex = editingStopIndex !== null ? editingStopIndex :
//                 (insertIndex !== null ? insertIndex : stops.length);
//             const nextStop = stops[currentIndex];
//             const isNextAuto = nextStop && nextStop.coordinates &&
//                 (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);

//             if (isNextAuto && newRoute.stopDistToNext && parseFloat(newRoute.stopDistToNext) > 0) {
//                 manualDistToNext = parseFloat(newRoute.stopDistToNext);
//             }
//         } else if (newRoute.stopCoords && (newRoute.stopCoords.lat !== 0 || newRoute.stopCoords.lng !== 0)) {
//             distanceFromOrigin = 0;
//         }

//         let stopType = 'none';
//         if (newRoute.isBoarding && newRoute.isDropping) stopType = 'both';
//         else if (newRoute.isBoarding) stopType = 'boarding';
//         else if (newRoute.isDropping) stopType = 'dropping';

//         let autoState = newRoute.stopState;
//         if (!autoState || !autoState.trim()) {
//             if (type === 'up' && upStops.length > 0) {
//                 const lastStop = upStops[upStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state;
//             } else if (type === 'down' && downStops.length > 0) {
//                 const lastStop = downStops[downStops.length - 1];
//                 if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state;
//             }
//             if (!autoState && newRoute.upOriginState) autoState = newRoute.upOriginState;
//             if (!autoState && newRoute.upDestState) autoState = newRoute.upDestState;
//         }

//         // In addIntermediateStop function, make sure timings are saved
//         const newStop = {
//             city: newRoute.stopCity,
//             state: autoState || newRoute.stopState || '',
//             address: newRoute.stopAddress || `${newRoute.stopCity}, ${autoState || 'India'}`,
//             terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
//             // For multi-trip, store timings array; for single trip, store single times
//             arrivalTime: isMultiTrip ? '' : newRoute.stopArrivalTime,
//             departureTime: isMultiTrip ? '' : (newRoute.stopDepartureTime || newRoute.stopArrivalTime),
//             timings: isMultiTrip ? (newRoute.stopTimings || []).map(t => ({
//                 timeSlotSequence: t.timeSlotSequence,
//                 arrivalTime: t.arrivalTime,
//                 departureTime: t.departureTime || t.arrivalTime
//             })) : [],
//             stopType: stopType,
//             coordinates: coordinates,
//             manualDistFromPrev: manualDistFromPrev,
//             manualDistToNext: manualDistToNext,
//             distanceFromOrigin: distanceFromOrigin,
//             isManualStop: isManualLocation
//         };

//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//         let currentStops = type === 'up' ? [...upStops] : [...downStops];
//         let editingIndex = null;

//         if (type === 'up' && editUpIndex !== null) {
//             editingIndex = editUpIndex;
//         } else if (type === 'down' && editDownIndex !== null) {
//             editingIndex = editDownIndex;
//         }

//         if (editingIndex !== null) {
//             currentStops[editingIndex] = { ...currentStops[editingIndex], ...newStop, sequence: editingIndex + 1 };
//             if (type === 'up') setEditUpIndex(null);
//             else setEditDownIndex(null);
//             setEditingStopIndex(null);
//             toast.success(`Stop "${newRoute.stopCity}" updated successfully`);
//         } else if (insertIndex !== null) {
//             currentStops.splice(insertIndex, 0, newStop);
//             setInsertIndex(null);
//             toast.success(`Stop inserted at position ${insertIndex + 1}`);
//         } else {
//             currentStops.push(newStop);
//             toast.success(`Stop "${newRoute.stopCity}" added successfully`);
//         }

//         if (type === 'up') {
//             setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         } else {
//             setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         }

//         // Clear stop form
//         clearStopForm();
//     };

//     //   const handleEditStop = (index, type = 'up') => {
//     //     setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//     //     const stop = type === 'up' ? upStops[index] : downStops[index];

//     //     const isManual = !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);
//     //     const hasManualDist = stop.manualDistFromPrev !== null && stop.manualDistFromPrev !== undefined;

//     //     setIsManualStop(isManual || hasManualDist);
//     //     setIsManualDistance(isManual || hasManualDist);

//     //     setNewRoute(prev => ({
//     //       ...prev,
//     //       stopCity: stop.city,
//     //       stopState: stop.state || '',
//     //       stopAddress: stop.address || '',
//     //       stopTerminal: stop.terminal || '',
//     //       stopArrivalTime: stop.arrivalTime,
//     //       stopDepartureTime: stop.departureTime || '',
//     //       stopCoords: stop.coordinates || { lat: 0, lng: 0 },
//     //       stopDistFromPrev: stop.manualDistFromPrev ? String(stop.manualDistFromPrev) : '',
//     //       stopDistToNext: stop.manualDistToNext ? String(stop.manualDistToNext) : '',
//     //       isBoarding: stop.stopType === 'boarding' || stop.stopType === 'both',
//     //       isDropping: stop.stopType === 'dropping' || stop.stopType === 'both',
//     //     }));

//     //     setEditingStopIndex(index);
//     //     setInsertIndex(null);

//     //     if (type === 'up') {
//     //       setEditUpIndex(index);
//     //       setEditDownIndex(null);
//     //     } else {
//     //       setEditDownIndex(index);
//     //       setEditUpIndex(null);
//     //     }
//     //   };

//     // const handleEditStop = (index, type = 'up') => {
//     //   setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//     //   const stop = type === 'up' ? upStops[index] : downStops[index];

//     //   const isManual = !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);
//     //   const hasManualDist = stop.manualDistFromPrev !== null && stop.manualDistFromPrev !== undefined;

//     //   setIsManualStop(isManual || hasManualDist);
//     //   setIsManualDistance(isManual || hasManualDist);

//     //   setNewRoute(prev => ({
//     //     ...prev,
//     //     stopCity: stop.city,
//     //     stopState: stop.state || '', // Ensure state is loaded
//     //     stopAddress: stop.address || '',
//     //     stopTerminal: stop.terminal || '',
//     //     stopArrivalTime: stop.arrivalTime,
//     //     stopDepartureTime: stop.departureTime || '',
//     //     stopCoords: stop.coordinates || { lat: 0, lng: 0 },
//     //     stopDistFromPrev: stop.manualDistFromPrev ? String(stop.manualDistFromPrev) : '',
//     //     stopDistToNext: stop.manualDistToNext ? String(stop.manualDistToNext) : '',
//     //     isBoarding: stop.stopType === 'boarding' || stop.stopType === 'both',
//     //     isDropping: stop.stopType === 'dropping' || stop.stopType === 'both',
//     //   }));

//     //   setEditingStopIndex(index);
//     //   setInsertIndex(null);

//     //   if (type === 'up') {
//     //     setEditUpIndex(index);
//     //     setEditDownIndex(null);
//     //   } else {
//     //     setEditDownIndex(index);
//     //     setEditUpIndex(null);
//     //   }
//     // };

//     const handleEditStop = (index, type = 'up') => {
//         const stop = type === 'up' ? upStops[index] : downStops[index];
//         const stops = type === 'up' ? upStops : downStops;

//         const isManual = !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);

//         // AUTO-CALCULATE manualDistFromPrev from distanceFromOrigin if missing
//         let manualDistValue = stop.manualDistFromPrev ? String(stop.manualDistFromPrev) : '';

//         // If manualDistFromPrev is empty but we have distanceFromOrigin, calculate it
//         if (!manualDistValue && stop.distanceFromOrigin > 0) {
//             // Calculate distance from previous stop
//             let calculatedDist = stop.distanceFromOrigin;
//             if (index > 0) {
//                 const prevStop = stops[index - 1];
//                 if (prevStop && prevStop.distanceFromOrigin > 0) {
//                     calculatedDist = stop.distanceFromOrigin - prevStop.distanceFromOrigin;
//                 }
//             }
//             if (calculatedDist > 0) {
//                 manualDistValue = calculatedDist.toFixed(1);
//                 console.log(`Auto-calculated manualDistFromPrev for ${stop.city}: ${manualDistValue} km`);
//             }
//         }

//         // Also auto-calculate manualDistToNext if missing
//         let manualDistToNextValue = stop.manualDistToNext ? String(stop.manualDistToNext) : '';
//         if (!manualDistToNextValue && stop.distanceFromOrigin > 0 && index < stops.length - 1) {
//             const nextStop = stops[index + 1];
//             if (nextStop && nextStop.distanceFromOrigin > 0) {
//                 const calculatedNextDist = nextStop.distanceFromOrigin - stop.distanceFromOrigin;
//                 if (calculatedNextDist > 0) {
//                     manualDistToNextValue = calculatedNextDist.toFixed(1);
//                     console.log(`Auto-calculated manualDistToNext for ${stop.city}: ${manualDistToNextValue} km`);
//                 }
//             }
//         }

//         setStopBeingEdited({ index, type, originalStop: stop });

//         setStopEditForm({
//             city: stop.city || '',
//             state: stop.state || '',
//             address: stop.address || '',
//             terminal: stop.terminal || '',
//             arrivalTime: stop.arrivalTime || '',
//             departureTime: stop.departureTime || '',
//             timings: stop.timings || [],
//             isBoarding: stop.stopType === 'boarding' || stop.stopType === 'both',
//             isDropping: stop.stopType === 'dropping' || stop.stopType === 'both',
//             manualDistFromPrev: manualDistValue,  // Now populated from calculation
//             manualDistToNext: manualDistToNextValue,  // Now populated from calculation
//             isManualStop: isManual || stop.manualDistFromPrev !== null || manualDistValue !== ''
//         });

//         setShowStopEditModal(true);
//     };

//     // Update the saveEditedStop function to properly save times
//     const saveEditedStop = () => {
//         if (!stopEditForm.city) {
//             toast.error('City is required');
//             return;
//         }

//         // For multi-trip mode, check timing requirements
//         if (isMultiTrip) {
//             if (!stopEditForm.timings || stopEditForm.timings.length === 0) {
//                 toast.error('Please add timing information for this stop');
//                 return;
//             }
//             const missingArrival = stopEditForm.timings.some(t => !t.arrivalTime);
//             if (missingArrival) {
//                 toast.error('Please provide arrival time for all trips');
//                 return;
//             }
//         } else if (!stopEditForm.arrivalTime) {
//             toast.error('Arrival time is required');
//             return;
//         }

//         const isManualLocation = stopEditForm.isManualStop;

//         // Parse manual distances
//         let manualDistFromPrev = null;
//         let manualDistToNext = null;

//         if (stopEditForm.manualDistFromPrev && parseFloat(stopEditForm.manualDistFromPrev) > 0) {
//             manualDistFromPrev = parseFloat(stopEditForm.manualDistFromPrev);
//         }

//         if (stopEditForm.manualDistToNext && parseFloat(stopEditForm.manualDistToNext) > 0) {
//             manualDistToNext = parseFloat(stopEditForm.manualDistToNext);
//         }

//         // Calculate distanceFromOrigin from manualDistFromPrev if available
//         let distanceFromOrigin = stopBeingEdited.originalStop.distanceFromOrigin || 0;

//         if (manualDistFromPrev && manualDistFromPrev > 0) {
//             const stops = stopBeingEdited.type === 'up' ? upStops : downStops;
//             if (stopBeingEdited.index === 0) {
//                 distanceFromOrigin = manualDistFromPrev;
//             } else {
//                 const prevStop = stops[stopBeingEdited.index - 1];
//                 const prevDistance = prevStop?.distanceFromOrigin || 0;
//                 distanceFromOrigin = parseFloat((prevDistance + manualDistFromPrev).toFixed(2));
//             }
//         }

//         let stopType = 'none';
//         if (stopEditForm.isBoarding && stopEditForm.isDropping) stopType = 'both';
//         else if (stopEditForm.isBoarding) stopType = 'boarding';
//         else if (stopEditForm.isDropping) stopType = 'dropping';

//         const updatedStop = {
//             ...stopBeingEdited.originalStop,
//             city: stopEditForm.city,
//             state: stopEditForm.state || '',
//             address: stopEditForm.address || `${stopEditForm.city}, ${stopEditForm.state || 'India'}`,
//             terminal: stopEditForm.terminal || `${stopEditForm.city} Bus Stand`,
//             arrivalTime: isMultiTrip ? '' : stopEditForm.arrivalTime,
//             departureTime: isMultiTrip ? '' : (stopEditForm.departureTime || stopEditForm.arrivalTime),
//             timings: isMultiTrip ? stopEditForm.timings : [],
//             stopType,
//             coordinates: isManualLocation ? { lat: 0, lng: 0 } : stopBeingEdited.originalStop.coordinates,
//             manualDistFromPrev: manualDistFromPrev,
//             manualDistToNext: manualDistToNext,
//             distanceFromOrigin: distanceFromOrigin,
//             isManualStop: isManualLocation
//         };

//         const { index, type } = stopBeingEdited;
//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//         if (type === 'up') {
//             const updated = [...upStops];
//             updated[index] = { ...updatedStop, sequence: index + 1 };
//             setUpStops(updated);
//             if (isRoundTrip) {
//                 toast.info('UP route updated. Use "Auto-Fill / Sync Reversed Stops" to update DOWN route if needed.');
//             }
//         } else {
//             const updated = [...downStops];
//             updated[index] = { ...updatedStop, sequence: index + 1 };
//             setDownStops(updated);
//         }

//         setShowStopEditModal(false);
//         setStopBeingEdited(null);
//         toast.success('Stop updated successfully');
//     };
//     const handleDeleteStop = (index) => {
//         const isUp = activeRouteTab === 'UP';
//         setIsDistanceCalculated(prev => ({ ...prev, [isUp ? 'up' : 'down']: false }));

//         if (isUp) {
//             const updated = upStops.filter((_, i) => i !== index);
//             setUpStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
//             if (editingStopIndex === index && editUpIndex === index) clearStopForm();
//         } else {
//             const updated = downStops.filter((_, i) => i !== index);
//             setDownStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
//             if (editingStopIndex === index && editDownIndex === index) clearStopForm();
//         }
//     };

//     // const handleCalculateDistances = async () => {
//     //     const isUp = activeRouteTab === 'UP';
//     //     const stops = isUp ? upStops : downStops;

//     //     if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//     //         toast.error("Main Route Origin and Destination required.");
//     //         return;
//     //     }

//     //     if (!newRoute.upOriginCoords) {
//     //         toast.error('Please select Origin from suggestions to get coordinates');
//     //         return;
//     //     }

//     //     if (!newRoute.upDestCoords) {
//     //         toast.error('Please select Destination from suggestions to get coordinates');
//     //         return;
//     //     }

//     //     let originNode, destNode;
//     //     if (isUp) {
//     //         originNode = {
//     //             id: 'origin',
//     //             name: newRoute.upOriginCity,
//     //             lat: newRoute.upOriginCoords?.lat || 0,
//     //             lng: newRoute.upOriginCoords?.lng || 0
//     //         };
//     //         destNode = {
//     //             id: 'destination',
//     //             name: newRoute.upDestCity,
//     //             lat: newRoute.upDestCoords?.lat || 0,
//     //             lng: newRoute.upDestCoords?.lng || 0
//     //         };
//     //     } else {
//     //         originNode = {
//     //             id: 'origin',
//     //             name: newRoute.upDestCity,
//     //             lat: newRoute.upDestCoords?.lat || 0,
//     //             lng: newRoute.upDestCoords?.lng || 0
//     //         };
//     //         destNode = {
//     //             id: 'destination',
//     //             name: newRoute.upOriginCity,
//     //             lat: newRoute.upOriginCoords?.lat || 0,
//     //             lng: newRoute.upOriginCoords?.lng || 0
//     //         };
//     //     }

//     //     setIsCalculatingDistances(true);
//     //     toast.info(`Calculating ${activeRouteTab} route distances...`);

//     //     try {
//     //         const stopNodes = stops.map((s, i) => ({
//     //             id: `stop_${i}`,
//     //             name: s.city,
//     //             lat: s.coordinates?.lat,
//     //             lng: s.coordinates?.lng,
//     //             manualFromPrev: s.manualDistFromPrev,
//     //             manualToNext: s.manualDistToNext,
//     //             isManual: !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0) || s.manualDistFromPrev !== null
//     //         }));

//     //         const fullPath = [originNode, ...stopNodes, destNode];
//     //         const validNodes = fullPath.filter(s => s.lat && s.lng);

//     //         let matrixResponse = null;
//     //         if (validNodes.length >= 2) {
//     //             matrixResponse = await getDistanceMatrix(validNodes, validNodes);
//     //         }

//     //         let cumulativeDist = 0;
//     //         let lastAutoNodeIndex = 0;
//     //         let sumManualSinceLastAuto = 0;
//     //         const updatedStops = [];
//     //         let validNodeCounter = 0;

//     //         for (let i = 0; i < stopNodes.length; i++) {
//     //             const currNode = stopNodes[i];
//     //             const isManual = currNode.isManual;

//     //             if (isManual) {
//     //                 if (currNode.manualFromPrev === null || currNode.manualFromPrev === undefined || currNode.manualFromPrev === '') {
//     //                     toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }

//     //                 const segment = parseFloat(currNode.manualFromPrev) || 0;
//     //                 cumulativeDist += segment;
//     //                 sumManualSinceLastAuto += segment;

//     //                 updatedStops.push({
//     //                     ...stops[i],
//     //                     distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//     //                     manualDistFromPrev: segment,
//     //                     manualDistToNext: currNode.manualToNext
//     //                 });

//     //                 if (currNode.manualToNext && currNode.manualToNext > 0) {
//     //                     sumManualSinceLastAuto = currNode.manualToNext;
//     //                 }
//     //             } else {
//     //                 validNodeCounter++;
//     //                 let apiDistance = 0;

//     //                 if (matrixResponse) {
//     //                     const element = matrixResponse.rows[lastAutoNodeIndex]?.elements[validNodeCounter];
//     //                     if (element?.status === 'OK') {
//     //                         apiDistance = element.distance.value / 1000;
//     //                     }
//     //                 }

//     //                 let segment = 0;
//     //                 if (i > 0 && stopNodes[i - 1].manualToNext && stopNodes[i - 1].manualToNext > 0) {
//     //                     segment = stopNodes[i - 1].manualToNext;
//     //                     sumManualSinceLastAuto = 0;
//     //                 } else {
//     //                     segment = apiDistance - sumManualSinceLastAuto;
//     //                     if (segment < 0) segment = 0;
//     //                     sumManualSinceLastAuto = 0;
//     //                 }

//     //                 cumulativeDist += segment;
//     //                 lastAutoNodeIndex = validNodeCounter;

//     //                 updatedStops.push({
//     //                     ...stops[i],
//     //                     distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1))
//     //                 });
//     //             }
//     //         }

//     //         validNodeCounter++;
//     //         let finalSegment = 0;
//     //         let apiDistance = 0;

//     //         const lastStop = stopNodes[stopNodes.length - 1];

//     //         if (lastStop && lastStop.isManual) {
//     //             const manualFinalLeg = isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg;
//     //             if (manualFinalLeg && parseFloat(manualFinalLeg) > 0) {
//     //                 finalSegment = parseFloat(manualFinalLeg);
//     //             } else if (lastStop.manualToNext && lastStop.manualToNext > 0) {
//     //                 finalSegment = lastStop.manualToNext;
//     //             } else {
//     //                 toast.error(`Last stop '${lastStop.name}' is manual. Please provide distance to destination.`);
//     //                 setIsCalculatingDistances(false);
//     //                 return;
//     //             }
//     //         } else if (matrixResponse) {
//     //             const element = matrixResponse.rows[lastAutoNodeIndex]?.elements[validNodeCounter];
//     //             if (element?.status === 'OK') {
//     //                 apiDistance = element.distance.value / 1000;
//     //             }
//     //             finalSegment = apiDistance - sumManualSinceLastAuto;
//     //             if (finalSegment < 0) finalSegment = 0;
//     //         }

//     //         cumulativeDist += finalSegment;

//     //         setActiveStops(updatedStops);
//     //         setNewRoute(prev => ({
//     //             ...prev,
//     //             [isUp ? 'upTotalDistance' : 'downTotalDistance']: cumulativeDist.toFixed(1)
//     //         }));

//     //         setIsDistanceCalculated(prev => ({ ...prev, [activeRouteTab.toLowerCase()]: true }));
//     //         toast.success(`${activeRouteTab} route distances calculated!`);

//     //     } catch (error) {
//     //         console.error('Distance calculation error:', error);
//     //         toast.error("Calculation failed. Please enter distances manually.");
//     //     } finally {
//     //         setIsCalculatingDistances(false);
//     //     }
//     // };

//     const checkOriginManual = () => {
//         return isOriginManual || !newRoute.upOriginCoords || (newRoute.upOriginCoords.lat === 0 && newRoute.upOriginCoords.lng === 0);
//     };

//     const checkDestinationManual = () => {
//         return isDestinationManual || !newRoute.upDestCoords || (newRoute.upDestCoords.lat === 0 && newRoute.upDestCoords.lng === 0);
//     };
//     // const handleCalculateDistances = async () => {
//     //     const isUp = activeRouteTab === 'UP';
//     //     const stops = isUp ? upStops : downStops;

//     //     if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//     //         toast.error("Main Route Origin and Destination required.");
//     //         return;
//     //     }

//     //     if (!newRoute.upOriginCoords) {
//     //         toast.error('Please select Origin from suggestions to get coordinates');
//     //         return;
//     //     }

//     //     if (!newRoute.upDestCoords) {
//     //         toast.error('Please select Destination from suggestions to get coordinates');
//     //         return;
//     //     }

//     //     let originNode, destNode;
//     //     if (isUp) {
//     //         originNode = {
//     //             id: 'origin',
//     //             name: newRoute.upOriginCity,
//     //             lat: newRoute.upOriginCoords?.lat || 0,
//     //             lng: newRoute.upOriginCoords?.lng || 0
//     //         };
//     //         destNode = {
//     //             id: 'destination',
//     //             name: newRoute.upDestCity,
//     //             lat: newRoute.upDestCoords?.lat || 0,
//     //             lng: newRoute.upDestCoords?.lng || 0
//     //         };
//     //     } else {
//     //         originNode = {
//     //             id: 'origin',
//     //             name: newRoute.upDestCity,
//     //             lat: newRoute.upDestCoords?.lat || 0,
//     //             lng: newRoute.upDestCoords?.lng || 0
//     //         };
//     //         destNode = {
//     //             id: 'destination',
//     //             name: newRoute.upOriginCity,
//     //             lat: newRoute.upOriginCoords?.lat || 0,
//     //             lng: newRoute.upOriginCoords?.lng || 0
//     //         };
//     //     }

//     //     setIsCalculatingDistances(true);
//     //     toast.info(`Calculating ${activeRouteTab} route distances...`);

//     //     try {
//     //         // Build stop nodes with their coordinates and manual distances
//     //         const stopNodes = stops.map((s, i) => ({
//     //             id: `stop_${i}`,
//     //             name: s.city,
//     //             lat: s.coordinates?.lat,
//     //             lng: s.coordinates?.lng,
//     //             manualFromPrev: s.manualDistFromPrev,
//     //             manualToNext: s.manualDistToNext,
//     //             isManual: s.isManualStop === true || !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0),
//     //             originalStop: s
//     //         }));

//     //         const fullPath = [originNode, ...stopNodes, destNode];
//     //         const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);

//     //         let matrixResponse = null;
//     //         if (validNodes.length >= 2) {
//     //             matrixResponse = await getDistanceMatrix(validNodes, validNodes);
//     //             console.log('Matrix Response received');
//     //         }

//     //         let cumulativeDist = 0;
//     //         let lastAutoNodeIndex = -1;
//     //         let sumManualSinceLastAuto = 0;
//     //         const updatedStops = [];
//     //         let validNodeCounter = -1;
//     //         let prevCumulativeDist = 0;

//     //         // Process origin to first stop
//     //         if (stops.length > 0 && stops[0]) {
//     //             const isFirstStopManual = stopNodes[0].isManual;

//     //             // Check if first stop already has manual distance from origin
//     //             if (isFirstStopManual && stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
//     //                 // First stop already has distance from origin
//     //                 const firstLeg = parseFloat(stopNodes[0].manualFromPrev);
//     //                 cumulativeDist = firstLeg;
//     //                 sumManualSinceLastAuto = firstLeg;
//     //                 prevCumulativeDist = cumulativeDist;
//     //                 console.log(`First manual stop has distance: ${firstLeg} km`);
//     //             }
//     //             else if ((checkOriginManual() && !isFirstStopManual) || (!checkOriginManual() && isFirstStopManual)) {
//     //                 const firstLeg = parseFloat(isUp ? newRoute.upManualFirstLeg : newRoute.downManualFirstLeg);
//     //                 if (!firstLeg || parseFloat(firstLeg) <= 0) {
//     //                     toast.error('Please provide distance from origin to first stop.');
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }
//     //                 cumulativeDist = parseFloat(firstLeg);
//     //                 sumManualSinceLastAuto = cumulativeDist;
//     //                 prevCumulativeDist = cumulativeDist;
//     //                 console.log(`Mixed types - first leg: ${firstLeg} km`);
//     //             }
//     //             else if (!checkOriginManual() && !isFirstStopManual) {
//     //                 // Both have coordinates - will use API
//     //                 lastAutoNodeIndex = 0;
//     //                 validNodeCounter = 0;
//     //                 console.log('Both origin and first stop have coordinates');
//     //             }
//     //             else if (checkOriginManual() && isFirstStopManual) {
//     //                 // Both manual - use first stop's manualDistFromPrev
//     //                 if (stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
//     //                     cumulativeDist = parseFloat(stopNodes[0].manualFromPrev);
//     //                     prevCumulativeDist = cumulativeDist;
//     //                 } else {
//     //                     cumulativeDist = 0;
//     //                     prevCumulativeDist = 0;
//     //                 }
//     //                 console.log('Both manual - waiting for manual distances');
//     //             }
//     //         }

//     //         // Process each stop
//     //         for (let i = 0; i < stopNodes.length; i++) {
//     //             const currNode = stopNodes[i];
//     //             const isManual = currNode.isManual;
//     //             let segment = 0;

//     //             if (isManual) {
//     //                 // Manual stop - use manualDistFromPrev
//     //                 if (currNode.manualFromPrev === null || currNode.manualFromPrev === undefined || currNode.manualFromPrev === '') {
//     //                     toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }

//     //                 segment = parseFloat(currNode.manualFromPrev) || 0;
//     //                 if (segment <= 0 && i > 0) {
//     //                     toast.warning(`Manual stop '${currNode.name}' has distance 0 from previous stop.`);
//     //                 }

//     //                 cumulativeDist += segment;
//     //                 sumManualSinceLastAuto += segment;

//     //                 const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//     //                 prevCumulativeDist = cumulativeDist;

//     //                 updatedStops.push({
//     //                     ...stops[i],
//     //                     distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//     //                     manualDistFromPrev: parseFloat(segment.toFixed(1)),
//     //                     manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
//     //                 });

//     //                 console.log(`Manual stop ${currNode.name}: +${segment} km = ${cumulativeDist.toFixed(1)} km`);

//     //                 if (currNode.manualToNext && parseFloat(currNode.manualToNext) > 0) {
//     //                     sumManualSinceLastAuto = parseFloat(currNode.manualToNext);
//     //                 }
//     //             } else {
//     //                 // Google stop - calculate from API
//     //                 validNodeCounter++;
//     //                 let apiDistance = 0;

//     //                 let matrixOriginIndex = lastAutoNodeIndex;
//     //                 let matrixDestIndex = validNodeCounter;

//     //                 // Adjust indices for manual origin
//     //                 if (checkOriginManual() && lastAutoNodeIndex === -1 && i === 0) {
//     //                     matrixOriginIndex = 0;
//     //                     matrixDestIndex = validNodeCounter;
//     //                 } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
//     //                     matrixOriginIndex = lastAutoNodeIndex;
//     //                     matrixDestIndex = validNodeCounter;
//     //                 } else if (!checkOriginManual() && lastAutoNodeIndex === -1) {
//     //                     matrixOriginIndex = 0;
//     //                     matrixDestIndex = validNodeCounter;
//     //                 }

//     //                 if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//     //                     const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//     //                     if (element?.status === 'OK') {
//     //                         apiDistance = element.distance.value / 1000;
//     //                     }
//     //                 }

//     //                 // Calculate segment distance
//     //                 if (i > 0 && stopNodes[i - 1]?.manualToNext && parseFloat(stopNodes[i - 1].manualToNext) > 0) {
//     //                     segment = parseFloat(stopNodes[i - 1].manualToNext);
//     //                     sumManualSinceLastAuto = 0;
//     //                 } else {
//     //                     segment = apiDistance - sumManualSinceLastAuto;
//     //                     if (segment < 0) segment = 0;
//     //                     sumManualSinceLastAuto = 0;
//     //                 }

//     //                 cumulativeDist += segment;

//     //                 if (lastAutoNodeIndex === -1) {
//     //                     lastAutoNodeIndex = validNodeCounter;
//     //                 }

//     //                 if (matrixOriginIndex >= 0) {
//     //                     lastAutoNodeIndex = validNodeCounter;
//     //                 }

//     //                 const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//     //                 prevCumulativeDist = cumulativeDist;

//     //                 updatedStops.push({
//     //                     ...stops[i],
//     //                     distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//     //                     manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)),
//     //                     manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
//     //                 });

//     //                 console.log(`Google stop ${currNode.name}: +${segment.toFixed(1)} km = ${cumulativeDist.toFixed(1)} km`);
//     //             }
//     //         }

//     //         // Process final segment to destination
//     //         validNodeCounter++;
//     //         let finalSegment = 0;
//     //         const lastStop = stopNodes[stopNodes.length - 1];
//     //         const isLastStopManualFlag = lastStop && lastStop.isManual;

//     //         if (checkDestinationManual()) {
//     //             // Destination is manual - use upManualFinalLeg / downManualFinalLeg
//     //             const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
//     //             if (isNaN(finalLeg) || finalLeg <= 0) {
//     //                 toast.error(`Destination is manual. Please provide distance from last stop to destination.`);
//     //                 setIsCalculatingDistances(false);
//     //                 return;
//     //             }
//     //             finalSegment = finalLeg;
//     //             console.log(`Destination manual - final leg: ${finalSegment} km`);
//     //         }
//     //         else if (!checkDestinationManual() && isLastStopManualFlag) {
//     //             // Destination has GPS, last stop is manual - use destManualDistFromLastStop
//     //             const finalLeg = parseFloat(isUp ? newRoute.destManualDistFromLastStop : newRoute.downManualFinalLeg);
//     //             if (isNaN(finalLeg) || finalLeg <= 0) {
//     //                 toast.error(`Last stop is manual, destination has GPS. Please provide distance to destination.`);
//     //                 setIsCalculatingDistances(false);
//     //                 return;
//     //             }
//     //             finalSegment = finalLeg;
//     //             console.log(`Last stop manual, destination GPS - final leg: ${finalSegment} km`);
//     //         }
//     //         else if (!checkDestinationManual() && !isLastStopManualFlag && stopNodes.length > 0) {
//     //             // Both have coordinates - use API for final leg
//     //             let apiDistance = 0;
//     //             let matrixOriginIndex = lastAutoNodeIndex;
//     //             let matrixDestIndex = validNodeCounter;

//     //             if (checkOriginManual() && lastAutoNodeIndex === -1) {
//     //                 matrixOriginIndex = 0;
//     //                 matrixDestIndex = validNodeCounter;
//     //             } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
//     //                 matrixOriginIndex = lastAutoNodeIndex;
//     //                 matrixDestIndex = validNodeCounter;
//     //             }

//     //             if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//     //                 const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//     //                 if (element?.status === 'OK') {
//     //                     apiDistance = element.distance.value / 1000;
//     //                 }
//     //             }
//     //             finalSegment = apiDistance - sumManualSinceLastAuto;
//     //             if (finalSegment < 0) finalSegment = 0;
//     //             console.log(`Both GPS - final leg: ${finalSegment} km`);
//     //         }
//     //         else if (stopNodes.length === 0) {
//     //             // No stops - direct origin to destination
//     //             if (checkOriginManual() && checkDestinationManual()) {
//     //                 const totalDistance = parseFloat(newRoute.upTotalDistance);
//     //                 if (isNaN(totalDistance) || totalDistance <= 0) {
//     //                     toast.error('Both origin and destination are manual. Please provide total distance.');
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }
//     //                 finalSegment = totalDistance;
//     //                 console.log(`No stops, both manual - total: ${finalSegment} km`);
//     //             }
//     //             else if (!checkOriginManual() && !checkDestinationManual() && matrixResponse) {
//     //                 const element = matrixResponse.rows[0]?.elements[1];
//     //                 if (element?.status === 'OK') {
//     //                     finalSegment = element.distance.value / 1000;
//     //                     console.log(`No stops, both GPS - direct distance: ${finalSegment} km`);
//     //                 } else {
//     //                     toast.error('Could not calculate distance between origin and destination. Please check addresses or enter manually.');
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }
//     //             }
//     //             else {
//     //                 toast.error('Cannot calculate distance. Please ensure both origin and destination have coordinates or provide manual total distance.');
//     //                 setIsCalculatingDistances(false);
//     //                 return;
//     //             }
//     //         }

//     //         cumulativeDist += finalSegment;

//     //         // Update last stop's manualDistToNext if this is the final segment
//     //         if (updatedStops.length > 0 && finalSegment > 0) {
//     //             const lastIndex = updatedStops.length - 1;
//     //             updatedStops[lastIndex] = {
//     //                 ...updatedStops[lastIndex],
//     //                 manualDistToNext: parseFloat(finalSegment.toFixed(1))
//     //             };
//     //         }

//     //         // Update the state with calculated distances
//     //         setActiveStops(updatedStops);
//     //         setNewRoute(prev => ({
//     //             ...prev,
//     //             [isUp ? 'upTotalDistance' : 'downTotalDistance']: cumulativeDist.toFixed(1),
//     //             [isUp ? 'upManualFinalLeg' : 'downManualFinalLeg']: finalSegment > 0 ? finalSegment.toFixed(1) : ''
//     //         }));

//     //         // Sync back to editForm if in edit mode
//     //         if (editingRoute) {
//     //             if (isUp) {
//     //                 setEditForm(prev => ({
//     //                     ...prev,
//     //                     totalDistance: cumulativeDist.toFixed(1)
//     //                 }));
//     //             } else {
//     //                 setEditForm(prev => ({
//     //                     ...prev,
//     //                     returnTotalDistance: cumulativeDist.toFixed(1)
//     //                 }));
//     //             }
//     //         }

//     //         setIsDistanceCalculated(prev => ({ ...prev, [activeRouteTab.toLowerCase()]: true }));

//     //         console.log(`${activeRouteTab} route distances calculated successfully!`);
//     //         console.log(`Total distance: ${cumulativeDist.toFixed(1)} km`);
//     //         console.log(`Final segment: ${finalSegment.toFixed(1)} km`);

//     //         toast.success(`${activeRouteTab} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km`);

//     //     } catch (error) {
//     //         console.error('Distance calculation error:', error);
//     //         toast.error("Calculation failed. Please enter distances manually.");
//     //     } finally {
//     //         setIsCalculatingDistances(false);
//     //     }
//     // };

//     // problem for reverse route error for manual
//     // const handleCalculateDistances = async () => {
//     //     const isUp = activeRouteTab === 'UP';
//     //     const stops = isUp ? upStops : downStops;

//     //     if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//     //         toast.error("Main Route Origin and Destination required.");
//     //         return;
//     //     }

//     //     if (!newRoute.upOriginCoords) {
//     //         toast.error('Please select Origin from suggestions to get coordinates');
//     //         return;
//     //     }

//     //     if (!newRoute.upDestCoords) {
//     //         toast.error('Please select Destination from suggestions to get coordinates');
//     //         return;
//     //     }

//     //     let originNode, destNode;
//     //     if (isUp) {
//     //         originNode = {
//     //             id: 'origin',
//     //             name: newRoute.upOriginCity,
//     //             lat: newRoute.upOriginCoords?.lat || 0,
//     //             lng: newRoute.upOriginCoords?.lng || 0
//     //         };
//     //         destNode = {
//     //             id: 'destination',
//     //             name: newRoute.upDestCity,
//     //             lat: newRoute.upDestCoords?.lat || 0,
//     //             lng: newRoute.upDestCoords?.lng || 0
//     //         };
//     //     } else {
//     //         originNode = {
//     //             id: 'origin',
//     //             name: newRoute.upDestCity,
//     //             lat: newRoute.upDestCoords?.lat || 0,
//     //             lng: newRoute.upDestCoords?.lng || 0
//     //         };
//     //         destNode = {
//     //             id: 'destination',
//     //             name: newRoute.upOriginCity,
//     //             lat: newRoute.upOriginCoords?.lat || 0,
//     //             lng: newRoute.upOriginCoords?.lng || 0
//     //         };
//     //     }

//     //     setIsCalculatingDistances(true);
//     //     toast.info(`Calculating ${activeRouteTab} route distances...`);

//     //     // ============ GET DEPARTURE AND ARRIVAL TIMES ============
//     //     let departureTimeForDuration = '';
//     //     let arrivalTimeForDuration = '';

//     //     if (isUp) {
//     //         if (isMultiTrip) {
//     //             // For multi-trip: get times from timeSlots and destinationTimeSlots
//     //             if (timeSlots && timeSlots.length > 0) {
//     //                 departureTimeForDuration = timeSlots[0]?.departureTime || '';
//     //                 console.log(`Multi-trip departure time from timeSlots[0]: "${departureTimeForDuration}"`);
//     //             }
//     //             if (destinationTimeSlots && destinationTimeSlots.length > 0) {
//     //                 arrivalTimeForDuration = destinationTimeSlots[0]?.arrivalTime || '';
//     //                 console.log(`Multi-trip arrival time from destinationTimeSlots[0]: "${arrivalTimeForDuration}"`);
//     //             }
//     //         } else {
//     //             // For single trip: use direct fields
//     //             departureTimeForDuration = newRoute.upOriginDepTime;
//     //             arrivalTimeForDuration = newRoute.upDestArrTime;
//     //         }
//     //         console.log(`UP ROUTE - DEPARTURE TIME: "${departureTimeForDuration}"`);
//     //         console.log(`UP ROUTE - ARRIVAL TIME: "${arrivalTimeForDuration}"`);
//     //         console.log(`isMultiTrip: ${isMultiTrip}`);
//     //     } else {
//     //         if (isMultiTrip) {
//     //             // For return route multi-trip
//     //             if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) {
//     //                 departureTimeForDuration = returnOriginTimeSlots[0]?.departureTime || '';
//     //                 console.log(`Return multi-trip departure time: "${departureTimeForDuration}"`);
//     //             }
//     //             if (returnDestTimeSlots && returnDestTimeSlots.length > 0) {
//     //                 arrivalTimeForDuration = returnDestTimeSlots[0]?.arrivalTime || '';
//     //                 console.log(`Return multi-trip arrival time: "${arrivalTimeForDuration}"`);
//     //             }
//     //         } else {
//     //             departureTimeForDuration = newRoute.downOriginDepTime;
//     //             arrivalTimeForDuration = newRoute.downDestArrTime;
//     //         }
//     //         console.log(`DOWN ROUTE - DEPARTURE TIME: "${departureTimeForDuration}"`);
//     //         console.log(`DOWN ROUTE - ARRIVAL TIME: "${arrivalTimeForDuration}"`);
//     //     }

//     //     try {
//     //         const stopNodes = stops.map((s, i) => ({
//     //             id: `stop_${i}`,
//     //             name: s.city,
//     //             lat: s.coordinates?.lat,
//     //             lng: s.coordinates?.lng,
//     //             manualFromPrev: s.manualDistFromPrev,
//     //             manualToNext: s.manualDistToNext,
//     //             isManual: s.isManualStop === true || !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0),
//     //             originalStop: s
//     //         }));

//     //         const fullPath = [originNode, ...stopNodes, destNode];
//     //         const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);

//     //         let matrixResponse = null;
//     //         if (validNodes.length >= 2) {
//     //             matrixResponse = await getDistanceMatrix(validNodes, validNodes);
//     //             console.log('Matrix Response received');
//     //         }

//     //         let cumulativeDist = 0;
//     //         let lastAutoNodeIndex = -1;
//     //         let sumManualSinceLastAuto = 0;
//     //         const updatedStops = [];
//     //         let validNodeCounter = -1;
//     //         let prevCumulativeDist = 0;
//     //         let firstStopAlreadyCounted = false;

//     //         // Process origin to first stop
//     //         if (stops.length > 0 && stops[0]) {
//     //             const isFirstStopManual = stopNodes[0].isManual;

//     //             if (isFirstStopManual && stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
//     //                 const firstLeg = parseFloat(stopNodes[0].manualFromPrev);
//     //                 cumulativeDist = firstLeg;
//     //                 sumManualSinceLastAuto = firstLeg;
//     //                 prevCumulativeDist = cumulativeDist;
//     //                 firstStopAlreadyCounted = true;
//     //                 console.log(`First manual stop has distance: ${firstLeg} km`);
//     //             }
//     //             else if ((checkOriginManual() && !isFirstStopManual) || (!checkOriginManual() && isFirstStopManual)) {
//     //                 const firstLeg = parseFloat(isUp ? newRoute.upManualFirstLeg : newRoute.downManualFirstLeg);
//     //                 if (!firstLeg || parseFloat(firstLeg) <= 0) {
//     //                     toast.error('Please provide distance from origin to first stop.');
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }
//     //                 cumulativeDist = parseFloat(firstLeg);
//     //                 sumManualSinceLastAuto = cumulativeDist;
//     //                 prevCumulativeDist = cumulativeDist;
//     //                 firstStopAlreadyCounted = true;
//     //                 console.log(`Mixed types - first leg: ${firstLeg} km`);
//     //             }
//     //             else if (!checkOriginManual() && !isFirstStopManual) {
//     //                 lastAutoNodeIndex = 0;
//     //                 validNodeCounter = 0;
//     //                 console.log('Both origin and first stop have coordinates');
//     //             }
//     //             else if (checkOriginManual() && isFirstStopManual) {
//     //                 if (stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
//     //                     cumulativeDist = parseFloat(stopNodes[0].manualFromPrev);
//     //                     prevCumulativeDist = cumulativeDist;
//     //                     firstStopAlreadyCounted = true;
//     //                 } else {
//     //                     cumulativeDist = 0;
//     //                     prevCumulativeDist = 0;
//     //                 }
//     //                 console.log('Both manual - using manual distances');
//     //             }
//     //         }

//     //         // Process each stop
//     //         for (let i = 0; i < stopNodes.length; i++) {
//     //             const currNode = stopNodes[i];
//     //             const isManual = currNode.isManual;
//     //             let segment = 0;

//     //             if (isManual) {
//     //                 if (currNode.manualFromPrev === null || currNode.manualFromPrev === undefined || currNode.manualFromPrev === '') {
//     //                     toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }

//     //                 segment = parseFloat(currNode.manualFromPrev) || 0;

//     //                 if (i === 0 && firstStopAlreadyCounted) {
//     //                     console.log(`First manual stop ${currNode.name}: already counted, dist = ${cumulativeDist.toFixed(1)} km`);
//     //                 } else {
//     //                     if (segment <= 0 && i > 0) {
//     //                         toast.warning(`Manual stop '${currNode.name}' has distance 0 from previous stop.`);
//     //                     }
//     //                     cumulativeDist += segment;
//     //                     sumManualSinceLastAuto += segment;
//     //                     console.log(`Manual stop ${currNode.name}: +${segment} km = ${cumulativeDist.toFixed(1)} km`);
//     //                 }

//     //                 prevCumulativeDist = i === 0 && firstStopAlreadyCounted ? segment : cumulativeDist;

//     //                 updatedStops.push({
//     //                     ...stops[i],
//     //                     distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//     //                     manualDistFromPrev: parseFloat(segment.toFixed(1)),
//     //                     manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
//     //                 });

//     //                 if (currNode.manualToNext && parseFloat(currNode.manualToNext) > 0) {
//     //                     sumManualSinceLastAuto = parseFloat(currNode.manualToNext);
//     //                 }

//     //             } else {
//     //                 validNodeCounter++;
//     //                 let apiDistance = 0;

//     //                 let matrixOriginIndex = lastAutoNodeIndex;
//     //                 let matrixDestIndex = validNodeCounter;

//     //                 if (checkOriginManual() && lastAutoNodeIndex === -1 && i === 0) {
//     //                     matrixOriginIndex = 0;
//     //                     matrixDestIndex = validNodeCounter;
//     //                 } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
//     //                     matrixOriginIndex = lastAutoNodeIndex;
//     //                     matrixDestIndex = validNodeCounter;
//     //                 } else if (!checkOriginManual() && lastAutoNodeIndex === -1) {
//     //                     matrixOriginIndex = 0;
//     //                     matrixDestIndex = validNodeCounter;
//     //                 }

//     //                 if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//     //                     const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//     //                     if (element?.status === 'OK') {
//     //                         apiDistance = element.distance.value / 1000;
//     //                     }
//     //                 }

//     //                 if (i > 0 && stopNodes[i - 1]?.manualToNext && parseFloat(stopNodes[i - 1].manualToNext) > 0) {
//     //                     segment = parseFloat(stopNodes[i - 1].manualToNext);
//     //                     sumManualSinceLastAuto = 0;
//     //                 } else {
//     //                     segment = apiDistance - sumManualSinceLastAuto;
//     //                     if (segment < 0) segment = 0;
//     //                     sumManualSinceLastAuto = 0;
//     //                 }

//     //                 cumulativeDist += segment;

//     //                 if (lastAutoNodeIndex === -1) {
//     //                     lastAutoNodeIndex = validNodeCounter;
//     //                 }
//     //                 if (matrixOriginIndex >= 0) {
//     //                     lastAutoNodeIndex = validNodeCounter;
//     //                 }

//     //                 const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//     //                 prevCumulativeDist = cumulativeDist;

//     //                 updatedStops.push({
//     //                     ...stops[i],
//     //                     distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//     //                     manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)),
//     //                     manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
//     //                 });

//     //                 console.log(`Google stop ${currNode.name}: +${segment.toFixed(1)} km = ${cumulativeDist.toFixed(1)} km`);
//     //             }
//     //         }

//     //         // Process final segment to destination
//     //         validNodeCounter++;
//     //         let finalSegment = 0;
//     //         const lastStop = stopNodes[stopNodes.length - 1];
//     //         const isLastStopManualFlag = lastStop && lastStop.isManual;

//     //         if (checkDestinationManual()) {
//     //             const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
//     //             if (isNaN(finalLeg) || finalLeg <= 0) {
//     //                 toast.error(`Destination is manual. Please provide distance from last stop to destination.`);
//     //                 setIsCalculatingDistances(false);
//     //                 return;
//     //             }
//     //             finalSegment = finalLeg;
//     //             console.log(`Destination manual - final leg: ${finalSegment} km`);
//     //         }
//     //         else if (!checkDestinationManual() && isLastStopManualFlag) {
//     //             const finalLeg = parseFloat(isUp ? newRoute.destManualDistFromLastStop : newRoute.downManualFinalLeg);
//     //             if (isNaN(finalLeg) || finalLeg <= 0) {
//     //                 toast.error(`Last stop is manual, destination has GPS. Please provide distance to destination.`);
//     //                 setIsCalculatingDistances(false);
//     //                 return;
//     //             }
//     //             finalSegment = finalLeg;
//     //             console.log(`Last stop manual, destination GPS - final leg: ${finalSegment} km`);
//     //         }
//     //         else if (!checkDestinationManual() && !isLastStopManualFlag && stopNodes.length > 0) {
//     //             let apiDistance = 0;
//     //             let matrixOriginIndex = lastAutoNodeIndex;
//     //             let matrixDestIndex = validNodeCounter;

//     //             if (checkOriginManual() && lastAutoNodeIndex === -1) {
//     //                 matrixOriginIndex = 0;
//     //                 matrixDestIndex = validNodeCounter;
//     //             } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
//     //                 matrixOriginIndex = lastAutoNodeIndex;
//     //                 matrixDestIndex = validNodeCounter;
//     //             }

//     //             if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//     //                 const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//     //                 if (element?.status === 'OK') {
//     //                     apiDistance = element.distance.value / 1000;
//     //                 }
//     //             }
//     //             finalSegment = apiDistance - sumManualSinceLastAuto;
//     //             if (finalSegment < 0) finalSegment = 0;
//     //             console.log(`Both GPS - final leg: ${finalSegment} km`);
//     //         }
//     //         else if (stopNodes.length === 0) {
//     //             if (checkOriginManual() && checkDestinationManual()) {
//     //                 const totalDistance = parseFloat(newRoute.upTotalDistance);
//     //                 if (isNaN(totalDistance) || totalDistance <= 0) {
//     //                     toast.error('Both origin and destination are manual. Please provide total distance.');
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }
//     //                 finalSegment = totalDistance;
//     //                 console.log(`No stops, both manual - total: ${finalSegment} km`);
//     //             }
//     //             else if (!checkOriginManual() && !checkDestinationManual() && matrixResponse) {
//     //                 const element = matrixResponse.rows[0]?.elements[1];
//     //                 if (element?.status === 'OK') {
//     //                     finalSegment = element.distance.value / 1000;
//     //                     console.log(`No stops, both GPS - direct distance: ${finalSegment} km`);
//     //                 } else {
//     //                     toast.error('Could not calculate distance. Please check addresses or enter manually.');
//     //                     setIsCalculatingDistances(false);
//     //                     return;
//     //                 }
//     //             }
//     //             else {
//     //                 toast.error('Cannot calculate distance. Please ensure both origin and destination have coordinates or provide manual total distance.');
//     //                 setIsCalculatingDistances(false);
//     //                 return;
//     //             }
//     //         }

//     //         cumulativeDist += finalSegment;

//     //         // Update last stop's manualDistToNext
//     //         if (updatedStops.length > 0 && finalSegment > 0) {
//     //             const lastIndex = updatedStops.length - 1;
//     //             updatedStops[lastIndex] = {
//     //                 ...updatedStops[lastIndex],
//     //                 manualDistToNext: parseFloat(finalSegment.toFixed(1))
//     //             };
//     //         }

//     //         setActiveStops(updatedStops);

//     //         // ============ CALCULATE ESTIMATED DURATION ============
//     //         let calculatedHours = 0;
//     //         let calculatedMinutes = 0;

//     //         if (departureTimeForDuration && departureTimeForDuration.trim() !== '' && 
//     //             arrivalTimeForDuration && arrivalTimeForDuration.trim() !== '') {

//     //             const [depHour, depMin] = departureTimeForDuration.split(':').map(Number);
//     //             const [arrHour, arrMin] = arrivalTimeForDuration.split(':').map(Number);

//     //             let depTotalMins = depHour * 60 + depMin;
//     //             let arrTotalMins = arrHour * 60 + arrMin;

//     //             // If arrival time is next day
//     //             if (arrTotalMins < depTotalMins) {
//     //                 arrTotalMins += 24 * 60;
//     //             }

//     //             const durationMins = arrTotalMins - depTotalMins;
//     //             calculatedHours = Math.floor(durationMins / 60);
//     //             calculatedMinutes = durationMins % 60;

//     //             console.log(`Duration calculated from times: ${calculatedHours}h ${calculatedMinutes}m (${durationMins} minutes)`);
//     //         } else {
//     //             // Fallback to distance-based estimate (40 km/h average speed)
//     //             const avgSpeed = 40;
//     //             const durationMins = Math.round((cumulativeDist / avgSpeed) * 60);
//     //             calculatedHours = Math.floor(durationMins / 60);
//     //             calculatedMinutes = durationMins % 60;
//     //             console.log(`Duration estimated from distance (${cumulativeDist}km at ${avgSpeed}km/h): ${calculatedHours}h ${calculatedMinutes}m`);
//     //         }

//     //         // Update the route with calculated distance and duration
//     //         if (isUp) {
//     //             setNewRoute(prev => ({
//     //                 ...prev,
//     //                 upTotalDistance: cumulativeDist.toFixed(1),
//     //                 upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : '',
//     //                 upDurationHours: calculatedHours.toString(),
//     //                 upDurationMinutes: calculatedMinutes.toString()
//     //             }));

//     //             if (editingRoute) {
//     //                 setEditForm(prev => ({ 
//     //                     ...prev, 
//     //                     totalDistance: cumulativeDist.toFixed(1),
//     //                     durationHours: calculatedHours.toString(),
//     //                     durationMinutes: calculatedMinutes.toString()
//     //                 }));
//     //             }
//     //         } else {
//     //             setNewRoute(prev => ({
//     //                 ...prev,
//     //                 downTotalDistance: cumulativeDist.toFixed(1),
//     //                 downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : '',
//     //                 downDurationHours: calculatedHours.toString(),
//     //                 downDurationMinutes: calculatedMinutes.toString()
//     //             }));

//     //             if (editingRoute) {
//     //                 setEditForm(prev => ({ 
//     //                     ...prev, 
//     //                     returnTotalDistance: cumulativeDist.toFixed(1),
//     //                     returnDurationHours: calculatedHours.toString(),
//     //                     returnDurationMinutes: calculatedMinutes.toString()
//     //                 }));
//     //             }
//     //         }

//     //         setIsDistanceCalculated(prev => ({ ...prev, [activeRouteTab.toLowerCase()]: true }));

//     //         console.log(`${activeRouteTab} route distances calculated successfully!`);
//     //         console.log(`Total distance: ${cumulativeDist.toFixed(1)} km`);
//     //         console.log(`Estimated duration: ${calculatedHours}h ${calculatedMinutes}m`);

//     //         toast.success(`${activeRouteTab} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km, Duration: ${calculatedHours}h ${calculatedMinutes}m`);

//     //     } catch (error) {
//     //         console.error('Distance calculation error:', error);
//     //         toast.error("Calculation failed. Please enter distances manually.");
//     //     } finally {
//     //         setIsCalculatingDistances(false);
//     //     }
//     // };

//     const handleCalculateDistances = async () => {
//         const isUp = activeRouteTab === 'UP';
//         const stops = isUp ? upStops : downStops;

//         if (!newRoute.upOriginCity || !newRoute.upDestCity) {
//             toast.error("Main Route Origin and Destination required.");
//             return;
//         }

//         if (!newRoute.upOriginCoords) {
//             toast.error('Please select Origin from suggestions to get coordinates');
//             return;
//         }

//         if (!newRoute.upDestCoords) {
//             toast.error('Please select Destination from suggestions to get coordinates');
//             return;
//         }

//         let originNode, destNode;
//         if (isUp) {
//             originNode = {
//                 id: 'origin',
//                 name: newRoute.upOriginCity,
//                 lat: newRoute.upOriginCoords?.lat || 0,
//                 lng: newRoute.upOriginCoords?.lng || 0
//             };
//             destNode = {
//                 id: 'destination',
//                 name: newRoute.upDestCity,
//                 lat: newRoute.upDestCoords?.lat || 0,
//                 lng: newRoute.upDestCoords?.lng || 0
//             };
//         } else {
//             originNode = {
//                 id: 'origin',
//                 name: newRoute.upDestCity,
//                 lat: newRoute.upDestCoords?.lat || 0,
//                 lng: newRoute.upDestCoords?.lng || 0
//             };
//             destNode = {
//                 id: 'destination',
//                 name: newRoute.upOriginCity,
//                 lat: newRoute.upOriginCoords?.lat || 0,
//                 lng: newRoute.upOriginCoords?.lng || 0
//             };
//         }

//         setIsCalculatingDistances(true);
//         toast.info(`Calculating ${activeRouteTab} route distances...`);

//         // ============ GET DEPARTURE AND ARRIVAL TIMES ============
//         let departureTimeForDuration = '';
//         let arrivalTimeForDuration = '';

//         if (isUp) {
//             if (isMultiTrip) {
//                 if (timeSlots && timeSlots.length > 0) {
//                     departureTimeForDuration = timeSlots[0]?.departureTime || '';
//                 }
//                 if (destinationTimeSlots && destinationTimeSlots.length > 0) {
//                     arrivalTimeForDuration = destinationTimeSlots[0]?.arrivalTime || '';
//                 }
//             } else {
//                 departureTimeForDuration = newRoute.upOriginDepTime;
//                 arrivalTimeForDuration = newRoute.upDestArrTime;
//             }
//         } else {
//             if (isMultiTrip) {
//                 if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) {
//                     departureTimeForDuration = returnOriginTimeSlots[0]?.departureTime || '';
//                 }
//                 if (returnDestTimeSlots && returnDestTimeSlots.length > 0) {
//                     arrivalTimeForDuration = returnDestTimeSlots[0]?.arrivalTime || '';
//                 }
//             } else {
//                 departureTimeForDuration = newRoute.downOriginDepTime;
//                 arrivalTimeForDuration = newRoute.downDestArrTime;
//             }
//         }

//         try {
//             const stopNodes = stops.map((s, i) => ({
//                 id: `stop_${i}`,
//                 name: s.city,
//                 lat: s.coordinates?.lat,
//                 lng: s.coordinates?.lng,
//                 manualFromPrev: s.manualDistFromPrev,
//                 manualToNext: s.manualDistToNext,
//                 isManual: s.isManualStop === true || !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0),
//                 originalStop: s
//             }));

//             const fullPath = [originNode, ...stopNodes, destNode];
//             const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);

//             let matrixResponse = null;
//             if (validNodes.length >= 2) {
//                 matrixResponse = await getDistanceMatrix(validNodes, validNodes);
//                 console.log('Matrix Response received');
//             }

//             let cumulativeDist = 0;
//             let lastAutoNodeIndex = -1;
//             let sumManualSinceLastAuto = 0;
//             const updatedStops = [];
//             let validNodeCounter = -1;
//             let prevCumulativeDist = 0;
//             let firstStopAlreadyCounted = false;

//             // ============ PROCESS ORIGIN TO FIRST STOP ============
//             if (stops.length > 0 && stops[0]) {
//                 const isFirstStopManual = stopNodes[0].isManual;

//                 if (isFirstStopManual && stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
//                     const firstLeg = parseFloat(stopNodes[0].manualFromPrev);
//                     cumulativeDist = firstLeg;
//                     sumManualSinceLastAuto = firstLeg;
//                     prevCumulativeDist = cumulativeDist;
//                     firstStopAlreadyCounted = true;
//                     console.log(`First manual stop has distance: ${firstLeg} km`);
//                 }
//                 else if ((checkOriginManual() && !isFirstStopManual) || (!checkOriginManual() && isFirstStopManual)) {
//                     const firstLeg = parseFloat(isUp ? newRoute.upManualFirstLeg : newRoute.downManualFirstLeg);
//                     if (!firstLeg || parseFloat(firstLeg) <= 0) {
//                         toast.error('Please provide distance from origin to first stop.');
//                         setIsCalculatingDistances(false);
//                         return;
//                     }
//                     cumulativeDist = parseFloat(firstLeg);
//                     sumManualSinceLastAuto = cumulativeDist;
//                     prevCumulativeDist = cumulativeDist;
//                     firstStopAlreadyCounted = true;
//                     console.log(`Mixed types - first leg: ${firstLeg} km`);
//                 }
//                 else if (!checkOriginManual() && !isFirstStopManual) {
//                     lastAutoNodeIndex = 0;
//                     validNodeCounter = 0;
//                     console.log('Both origin and first stop have coordinates');
//                 }
//                 else if (checkOriginManual() && isFirstStopManual) {
//                     if (stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
//                         cumulativeDist = parseFloat(stopNodes[0].manualFromPrev);
//                         prevCumulativeDist = cumulativeDist;
//                         firstStopAlreadyCounted = true;
//                     } else {
//                         cumulativeDist = 0;
//                         prevCumulativeDist = 0;
//                     }
//                     console.log('Both manual - using manual distances');
//                 }
//             }

//             // ============ PROCESS EACH STOP ============
//             for (let i = 0; i < stopNodes.length; i++) {
//                 const currNode = stopNodes[i];
//                 const isManual = currNode.isManual;
//                 let segment = 0;

//                 if (isManual) {
//                     if (currNode.manualFromPrev === null || currNode.manualFromPrev === undefined || currNode.manualFromPrev === '') {
//                         toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
//                         setIsCalculatingDistances(false);
//                         return;
//                     }

//                     segment = parseFloat(currNode.manualFromPrev) || 0;

//                     if (i === 0 && firstStopAlreadyCounted) {
//                         console.log(`First manual stop ${currNode.name}: already counted, dist = ${cumulativeDist.toFixed(1)} km`);
//                     } else {
//                         if (segment <= 0 && i > 0) {
//                             toast.warning(`Manual stop '${currNode.name}' has distance 0 from previous stop.`);
//                         }
//                         cumulativeDist += segment;
//                         sumManualSinceLastAuto += segment;
//                         console.log(`Manual stop ${currNode.name}: +${segment} km = ${cumulativeDist.toFixed(1)} km`);
//                     }

//                     prevCumulativeDist = i === 0 && firstStopAlreadyCounted ? segment : cumulativeDist;

//                     updatedStops.push({
//                         ...stops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: parseFloat(segment.toFixed(1)),
//                         manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
//                     });

//                     if (currNode.manualToNext && parseFloat(currNode.manualToNext) > 0) {
//                         sumManualSinceLastAuto = parseFloat(currNode.manualToNext);
//                     }

//                 } else {
//                     validNodeCounter++;
//                     let apiDistance = 0;

//                     let matrixOriginIndex = lastAutoNodeIndex;
//                     let matrixDestIndex = validNodeCounter;

//                     if (checkOriginManual() && lastAutoNodeIndex === -1 && i === 0) {
//                         matrixOriginIndex = 0;
//                         matrixDestIndex = validNodeCounter;
//                     } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
//                         matrixOriginIndex = lastAutoNodeIndex;
//                         matrixDestIndex = validNodeCounter;
//                     } else if (!checkOriginManual() && lastAutoNodeIndex === -1) {
//                         matrixOriginIndex = 0;
//                         matrixDestIndex = validNodeCounter;
//                     }

//                     if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//                         const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//                         if (element?.status === 'OK') {
//                             apiDistance = element.distance.value / 1000;
//                         }
//                     }

//                     if (i > 0 && stopNodes[i - 1]?.manualToNext && parseFloat(stopNodes[i - 1].manualToNext) > 0) {
//                         segment = parseFloat(stopNodes[i - 1].manualToNext);
//                         sumManualSinceLastAuto = 0;
//                     } else {
//                         segment = apiDistance - sumManualSinceLastAuto;
//                         if (segment < 0) segment = 0;
//                         sumManualSinceLastAuto = 0;
//                     }

//                     cumulativeDist += segment;

//                     if (lastAutoNodeIndex === -1) {
//                         lastAutoNodeIndex = validNodeCounter;
//                     }
//                     if (matrixOriginIndex >= 0) {
//                         lastAutoNodeIndex = validNodeCounter;
//                     }

//                     const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//                     prevCumulativeDist = cumulativeDist;

//                     updatedStops.push({
//                         ...stops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)),
//                         manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
//                     });

//                     console.log(`Google stop ${currNode.name}: +${segment.toFixed(1)} km = ${cumulativeDist.toFixed(1)} km`);
//                 }
//             }

//             // ============ PROCESS FINAL SEGMENT TO DESTINATION ============
//             validNodeCounter++;
//             let finalSegment = 0;
//             const lastStop = stopNodes[stopNodes.length - 1];
//             const isLastStopManualFlag = lastStop && lastStop.isManual;

//             const isDestManual = checkDestinationManual();

//             if (isDestManual) {
//                 // Destination is manual — read from upManualFinalLeg / downManualFinalLeg
//                 const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
//                 if (isNaN(finalLeg) || finalLeg <= 0) {
//                     toast.error(`Destination is manual. Please provide distance from last stop to destination in the Summary section.`);
//                     setIsCalculatingDistances(false);
//                     return;
//                 }
//                 finalSegment = finalLeg;
//                 console.log(`Destination manual - final leg: ${finalSegment} km`);

//             } else if (!isDestManual && isLastStopManualFlag) {
//                 // ✅ FIX: Last stop is manual, destination has GPS
//                 // Priority 1: last stop's own manualDistToNext field
//                 if (lastStop.manualToNext && parseFloat(lastStop.manualToNext) > 0) {
//                     finalSegment = parseFloat(lastStop.manualToNext);
//                     console.log(`Last stop manual → dest GPS, using stop's manualToNext: ${finalSegment} km`);
//                 }
//                 // Priority 2: the Summary field (upManualFinalLeg / downManualFinalLeg) — same field the UI shows
//                 else {
//                     const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
//                     if (!isNaN(finalLeg) && finalLeg > 0) {
//                         finalSegment = finalLeg;
//                         console.log(`Last stop manual → dest GPS, using upManualFinalLeg: ${finalSegment} km`);
//                     }
//                     // Priority 3: auto-derive from totalDistance - lastStopDistanceFromOrigin
//                     else {
//                         const totalDist = parseFloat(isUp ? newRoute.upTotalDistance : newRoute.downTotalDistance) || 0;
//                         const lastStopDist = updatedStops.length > 0
//                             ? (updatedStops[updatedStops.length - 1].distanceFromOrigin || 0)
//                             : 0;
//                         const derived = parseFloat((totalDist - lastStopDist).toFixed(1));
//                         if (derived > 0) {
//                             finalSegment = derived;
//                             console.log(`Last stop manual → dest GPS, auto-derived: ${totalDist} - ${lastStopDist} = ${finalSegment} km`);
//                         } else {
//                             toast.error(`Last stop is manual and destination has GPS. Please enter the distance to destination in the Summary section, or set "Distance to Next Stop" on the last stop.`);
//                             setIsCalculatingDistances(false);
//                             return;
//                         }
//                     }
//                 }

//             } else if (!isDestManual && !isLastStopManualFlag && stopNodes.length > 0) {
//                 // Both last stop and destination have GPS — use API
//                 let apiDistance = 0;
//                 let matrixOriginIndex = lastAutoNodeIndex;
//                 let matrixDestIndex = validNodeCounter;

//                 if (checkOriginManual() && lastAutoNodeIndex === -1) {
//                     matrixOriginIndex = 0;
//                     matrixDestIndex = validNodeCounter;
//                 } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
//                     matrixOriginIndex = lastAutoNodeIndex;
//                     matrixDestIndex = validNodeCounter;
//                 }

//                 if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//                     const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//                     if (element?.status === 'OK') {
//                         apiDistance = element.distance.value / 1000;
//                     }
//                 }
//                 finalSegment = apiDistance - sumManualSinceLastAuto;
//                 if (finalSegment < 0) finalSegment = 0;
//                 console.log(`Both GPS - final leg: ${finalSegment} km`);

//             } else if (stopNodes.length === 0) {
//                 // No intermediate stops — direct origin to destination
//                 if (checkOriginManual() && isDestManual) {
//                     const totalDistance = parseFloat(newRoute.upTotalDistance);
//                     if (isNaN(totalDistance) || totalDistance <= 0) {
//                         toast.error('Both origin and destination are manual. Please provide total distance.');
//                         setIsCalculatingDistances(false);
//                         return;
//                     }
//                     finalSegment = totalDistance;
//                     console.log(`No stops, both manual - total: ${finalSegment} km`);
//                 }
//                 else if (!checkOriginManual() && !isDestManual && matrixResponse) {
//                     const element = matrixResponse.rows[0]?.elements[1];
//                     if (element?.status === 'OK') {
//                         finalSegment = element.distance.value / 1000;
//                         console.log(`No stops, both GPS - direct distance: ${finalSegment} km`);
//                     } else {
//                         toast.error('Could not calculate distance. Please check addresses or enter manually.');
//                         setIsCalculatingDistances(false);
//                         return;
//                     }
//                 }
//                 else {
//                     toast.error('Cannot calculate distance. Please ensure both origin and destination have coordinates or provide manual total distance.');
//                     setIsCalculatingDistances(false);
//                     return;
//                 }
//             }

//             cumulativeDist += finalSegment;

//             // Update last stop's manualDistToNext with the final segment
//             if (updatedStops.length > 0 && finalSegment > 0) {
//                 const lastIndex = updatedStops.length - 1;
//                 updatedStops[lastIndex] = {
//                     ...updatedStops[lastIndex],
//                     manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                 };
//             }

//             setActiveStops(updatedStops);

//             // ============ CALCULATE ESTIMATED DURATION ============
//             let calculatedHours = 0;
//             let calculatedMinutes = 0;

//             if (departureTimeForDuration && departureTimeForDuration.trim() !== '' &&
//                 arrivalTimeForDuration && arrivalTimeForDuration.trim() !== '') {

//                 const [depHour, depMin] = departureTimeForDuration.split(':').map(Number);
//                 const [arrHour, arrMin] = arrivalTimeForDuration.split(':').map(Number);

//                 let depTotalMins = depHour * 60 + depMin;
//                 let arrTotalMins = arrHour * 60 + arrMin;

//                 // Handle overnight routes
//                 if (arrTotalMins < depTotalMins) {
//                     arrTotalMins += 24 * 60;
//                 }

//                 const durationMins = arrTotalMins - depTotalMins;
//                 calculatedHours = Math.floor(durationMins / 60);
//                 calculatedMinutes = durationMins % 60;

//                 console.log(`Duration from times: ${calculatedHours}h ${calculatedMinutes}m`);
//             } else {
//                 // Fallback: estimate from distance at 40 km/h average
//                 const avgSpeed = 40;
//                 const durationMins = Math.round((cumulativeDist / avgSpeed) * 60);
//                 calculatedHours = Math.floor(durationMins / 60);
//                 calculatedMinutes = durationMins % 60;
//                 console.log(`Duration estimated from distance: ${calculatedHours}h ${calculatedMinutes}m`);
//             }

//             // ============ UPDATE STATE ============
//             if (isUp) {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     upTotalDistance: cumulativeDist.toFixed(1),
//                     upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.upManualFinalLeg,
//                     upDurationHours: calculatedHours.toString(),
//                     upDurationMinutes: calculatedMinutes.toString()
//                 }));

//                 if (editingRoute) {
//                     setEditForm(prev => ({
//                         ...prev,
//                         totalDistance: cumulativeDist.toFixed(1),
//                         durationHours: calculatedHours.toString(),
//                         durationMinutes: calculatedMinutes.toString()
//                     }));
//                 }
//             } else {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     downTotalDistance: cumulativeDist.toFixed(1),
//                     downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.downManualFinalLeg,
//                     downDurationHours: calculatedHours.toString(),
//                     downDurationMinutes: calculatedMinutes.toString()
//                 }));

//                 if (editingRoute) {
//                     setEditForm(prev => ({
//                         ...prev,
//                         returnTotalDistance: cumulativeDist.toFixed(1),
//                         returnDurationHours: calculatedHours.toString(),
//                         returnDurationMinutes: calculatedMinutes.toString()
//                     }));
//                 }
//             }

//             setIsDistanceCalculated(prev => ({ ...prev, [activeRouteTab.toLowerCase()]: true }));

//             console.log(`${activeRouteTab} distances calculated! Total: ${cumulativeDist.toFixed(1)} km, Duration: ${calculatedHours}h ${calculatedMinutes}m`);
//             toast.success(`${activeRouteTab} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km, Duration: ${calculatedHours}h ${calculatedMinutes}m`);

//         } catch (error) {
//             console.error('Distance calculation error:', error);
//             toast.error("Calculation failed. Please enter distances manually.");
//         } finally {
//             setIsCalculatingDistances(false);
//         }
//     };

//     const handleEditCalculateDistances = async (type = 'up') => {
//         const isUp = type === 'up';
//         const stops = isUp ? upStops : downStops;

//         if (isUp) {
//             if (!editForm.originCity || !editForm.destCity) {
//                 toast.error("Origin and Destination required for UP route.");
//                 return;
//             }
//             if (!editForm.originCoords) {
//                 toast.error('Please select Origin from suggestions');
//                 return;
//             }
//             if (!editForm.destCoords) {
//                 toast.error('Please select Destination from suggestions');
//                 return;
//             }
//         } else {
//             if (!editForm.returnOriginCity || !editForm.returnDestCity) {
//                 toast.error("Return Origin and Destination required for DOWN route.");
//                 return;
//             }
//             if (!editForm.returnOriginCoords) {
//                 toast.error('Please select Return Origin from suggestions');
//                 return;
//             }
//             if (!editForm.returnDestCoords) {
//                 toast.error('Please select Return Destination from suggestions');
//                 return;
//             }
//         }

//         let originNode, destNode;
//         if (isUp) {
//             originNode = {
//                 id: 'origin',
//                 name: editForm.originCity,
//                 lat: editForm.originCoords?.lat || 0,
//                 lng: editForm.originCoords?.lng || 0,
//                 isManual: !editForm.originCoords?.lat || editForm.originCoords.lat === 0
//             };
//             destNode = {
//                 id: 'destination',
//                 name: editForm.destCity,
//                 lat: editForm.destCoords?.lat || 0,
//                 lng: editForm.destCoords?.lng || 0,
//                 isManual: !editForm.destCoords?.lat || editForm.destCoords.lat === 0
//             };
//         } else {
//             originNode = {
//                 id: 'origin',
//                 name: editForm.returnOriginCity,
//                 lat: editForm.returnOriginCoords?.lat || 0,
//                 lng: editForm.returnOriginCoords?.lng || 0,
//                 isManual: !editForm.returnOriginCoords?.lat || editForm.returnOriginCoords.lat === 0
//             };
//             destNode = {
//                 id: 'destination',
//                 name: editForm.returnDestCity,
//                 lat: editForm.returnDestCoords?.lat || 0,
//                 lng: editForm.returnDestCoords?.lng || 0,
//                 isManual: !editForm.returnDestCoords?.lat || editForm.returnDestCoords.lat === 0
//             };
//         }

//         setIsCalculatingDistances(true);
//         toast.info(`Calculating ${type === 'up' ? 'UP' : 'DOWN'} route distances...`);

//         try {
//             // First, auto-calculate missing manual distances from existing distanceFromOrigin
//             const enrichedStops = [...stops];

//             for (let i = 0; i < enrichedStops.length; i++) {
//                 const stop = enrichedStops[i];
//                 const isManual = stop.isManualStop === true || !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);

//                 // If it's a manual stop and missing manualDistFromPrev, try to calculate from distanceFromOrigin
//                 if (isManual && (!stop.manualDistFromPrev || stop.manualDistFromPrev === 0) && stop.distanceFromOrigin > 0) {
//                     // Calculate distance from previous stop
//                     const prevStop = i > 0 ? enrichedStops[i - 1] : null;
//                     const prevDistance = prevStop?.distanceFromOrigin || 0;
//                     const calculatedDist = stop.distanceFromOrigin - prevDistance;

//                     if (calculatedDist > 0) {
//                         enrichedStops[i] = {
//                             ...stop,
//                             manualDistFromPrev: parseFloat(calculatedDist.toFixed(1))
//                         };
//                         console.log(`Auto-calculated manualDistFromPrev for ${stop.city}: ${calculatedDist.toFixed(1)} km`);
//                     }
//                 }
//             }

//             // Build stop nodes with enriched data
//             const stopNodes = enrichedStops.map((s, i) => {
//                 const hasValidCoords = s.coordinates?.lat && s.coordinates.lat !== 0;
//                 const hasManualDist = s.manualDistFromPrev && s.manualDistFromPrev > 0;
//                 const hasDistanceFromOrigin = s.distanceFromOrigin && s.distanceFromOrigin > 0;

//                 const isManual = s.isManualStop === true || !hasValidCoords || hasManualDist;

//                 return {
//                     id: `stop_${i}`,
//                     name: s.city,
//                     lat: s.coordinates?.lat,
//                     lng: s.coordinates?.lng,
//                     manualFromPrev: s.manualDistFromPrev ? parseFloat(s.manualDistFromPrev) : null,
//                     manualToNext: s.manualDistToNext ? parseFloat(s.manualDistToNext) : null,
//                     existingDistance: s.distanceFromOrigin || 0,
//                     isManual: isManual,
//                     originalStop: s
//                 };
//             });

//             const fullPath = [originNode, ...stopNodes, destNode];
//             const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);

//             let matrixResponse = null;
//             if (validNodes.length >= 2) {
//                 matrixResponse = await getDistanceMatrix(fullPath, fullPath);
//             }

//             let cumulativeDist = 0;
//             let prevCumulativeDist = 0;
//             const updatedStops = [];
//             let lastAutoNodeIndex = 0;
//             let sumManualSinceLastAuto = 0;
//             let validNodeCounter = -1;

//             // ============ HANDLE ORIGIN TO FIRST STOP ============
//             if (stops.length > 0) {
//                 const firstStop = stopNodes[0];
//                 const hasFirstStopDistance = firstStop && (firstStop.existingDistance > 0 || (firstStop.manualFromPrev && firstStop.manualFromPrev > 0));

//                 if (hasFirstStopDistance) {
//                     cumulativeDist = firstStop.existingDistance > 0 ? firstStop.existingDistance : firstStop.manualFromPrev;
//                     sumManualSinceLastAuto = cumulativeDist;
//                     prevCumulativeDist = cumulativeDist;
//                     console.log(`First stop already has distance: ${cumulativeDist} km - using existing value`);
//                 }
//                 else if (originNode.isManual) {
//                     const firstLeg = isUp ? editForm.upManualFirstLeg : editForm.returnManualFirstLeg;
//                     if (!firstLeg || parseFloat(firstLeg) <= 0) {
//                         toast.error('Please provide distance from origin to first stop in the Summary section.');
//                         setIsCalculatingDistances(false);
//                         return;
//                     }
//                     cumulativeDist = parseFloat(firstLeg);
//                     sumManualSinceLastAuto = cumulativeDist;
//                     prevCumulativeDist = cumulativeDist;
//                     console.log(`Manual origin to first stop: ${cumulativeDist} km`);
//                 }
//                 else {
//                     lastAutoNodeIndex = 0;
//                     validNodeCounter = 0;
//                     console.log('Both origin and first stop have coordinates - will use API');
//                 }
//             }

//             // ============ PROCESS EACH STOP ============
//             for (let i = 0; i < stopNodes.length; i++) {
//                 const currNode = stopNodes[i];
//                 const isManual = currNode.isManual;
//                 let segment = 0;

//                 // SKIP if this is first stop and we already used its distance
//                 if (i === 0 && cumulativeDist > 0 && (currNode.existingDistance > 0 || currNode.manualFromPrev > 0)) {
//                     updatedStops.push({
//                         ...enrichedStops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: currNode.manualFromPrev || cumulativeDist,
//                         manualDistToNext: currNode.manualToNext || null
//                     });
//                     console.log(`First stop ${currNode.name}: using existing distance ${cumulativeDist.toFixed(1)} km`);
//                     continue;
//                 }

//                 if (isManual) {
//                     // Manual stop - check if we have manualDistFromPrev
//                     let manualDist = currNode.manualFromPrev;

//                     // If manualDist is missing but we have existingDistance, calculate it
//                     if ((!manualDist || manualDist === 0) && currNode.existingDistance > 0) {
//                         const prevDistance = i > 0 ? updatedStops[i - 1]?.distanceFromOrigin || 0 : cumulativeDist;
//                         manualDist = currNode.existingDistance - prevDistance;
//                         if (manualDist > 0) {
//                             console.log(`Auto-calculated missing manualDist for ${currNode.name}: ${manualDist.toFixed(1)} km`);
//                         }
//                     }

//                     if (!manualDist || manualDist === 0) {
//                         toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
//                         setIsCalculatingDistances(false);
//                         return;
//                     }

//                     segment = manualDist;
//                     cumulativeDist += segment;
//                     sumManualSinceLastAuto += segment;

//                     const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//                     prevCumulativeDist = cumulativeDist;

//                     updatedStops.push({
//                         ...enrichedStops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: segment,
//                         manualDistToNext: currNode.manualToNext || null
//                     });

//                     console.log(`Manual stop ${currNode.name}: +${segment} km = ${cumulativeDist.toFixed(1)} km`);
//                 } else {
//                     // GPS stop - calculate from API
//                     validNodeCounter++;
//                     let apiDistance = 0;

//                     let matrixOriginIndex = lastAutoNodeIndex;
//                     let matrixDestIndex = validNodeCounter;

//                     if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
//                         const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//                         if (element?.status === 'OK') {
//                             apiDistance = element.distance.value / 1000;
//                         }
//                     }

//                     // Check if previous stop has manualToNext
//                     if (i > 0 && stopNodes[i - 1].manualToNext && stopNodes[i - 1].manualToNext > 0) {
//                         segment = stopNodes[i - 1].manualToNext;
//                         sumManualSinceLastAuto = 0;
//                     } else {
//                         segment = apiDistance - sumManualSinceLastAuto;
//                         if (segment < 0) segment = 0;
//                         sumManualSinceLastAuto = 0;
//                     }

//                     cumulativeDist += segment;

//                     if (lastAutoNodeIndex === -1 || matrixOriginIndex >= 0) {
//                         lastAutoNodeIndex = validNodeCounter;
//                     }

//                     const distanceFromPrev = cumulativeDist - prevCumulativeDist;
//                     prevCumulativeDist = cumulativeDist;

//                     updatedStops.push({
//                         ...enrichedStops[i],
//                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                         manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)),
//                         manualDistToNext: currNode.manualToNext || null
//                     });

//                     console.log(`GPS stop ${currNode.name}: +${segment.toFixed(1)} km = ${cumulativeDist.toFixed(1)} km`);
//                 }
//             }

//             // ============ PROCESS FINAL SEGMENT TO DESTINATION ============
//             let finalSegment = 0;
//             const lastStop = stopNodes[stopNodes.length - 1];
//             const isLastStopManual = lastStop && lastStop.isManual;
//             const hasLastStopDistanceToDest = lastStop && lastStop.manualToNext && lastStop.manualToNext > 0;

//             // Get total distance from destination (either from editForm or calculated from stops)
//             const totalDistance = isUp ? parseFloat(editForm.totalDistance) : parseFloat(editForm.returnTotalDistance);
//             const lastStopDistance = updatedStops.length > 0 ? updatedStops[updatedStops.length - 1].distanceFromOrigin : 0;

//             // AUTO-CALCULATE final segment from total distance if available
//             if (totalDistance > 0 && lastStopDistance > 0 && !hasLastStopDistanceToDest) {
//                 const calculatedFinalSegment = totalDistance - lastStopDistance;
//                 if (calculatedFinalSegment > 0) {
//                     finalSegment = parseFloat(calculatedFinalSegment.toFixed(1));
//                     console.log(`Auto-calculated final segment from total distance: ${finalSegment} km`);

//                     // Update the manual final leg field
//                     if (isUp) {
//                         setEditForm(prev => ({ ...prev, upManualFinalLeg: finalSegment.toString() }));
//                     } else {
//                         setEditForm(prev => ({ ...prev, returnManualFinalLeg: finalSegment.toString() }));
//                     }
//                 }
//             }

//             // If not auto-calculated, check other conditions
//             if (finalSegment === 0) {
//                 if (hasLastStopDistanceToDest) {
//                     finalSegment = lastStop.manualToNext;
//                     console.log(`Last stop has manual distance to destination: ${finalSegment} km`);
//                 }
//                 else if (destNode.isManual) {
//                     const finalLeg = isUp ? editForm.upManualFinalLeg : editForm.returnManualFinalLeg;
//                     if (!finalLeg || parseFloat(finalLeg) <= 0) {
//                         // Try to auto-calculate from total distance one more time
//                         if (totalDistance > 0 && lastStopDistance > 0) {
//                             finalSegment = totalDistance - lastStopDistance;
//                             if (finalSegment > 0) {
//                                 console.log(`Auto-calculated final segment (fallback): ${finalSegment} km`);
//                                 if (isUp) {
//                                     setEditForm(prev => ({ ...prev, upManualFinalLeg: finalSegment.toString() }));
//                                 } else {
//                                     setEditForm(prev => ({ ...prev, returnManualFinalLeg: finalSegment.toString() }));
//                                 }
//                             } else {
//                                 toast.error('Destination is manual. Please provide distance from last stop to destination in Summary section.');
//                                 setIsCalculatingDistances(false);
//                                 return;
//                             }
//                         } else {
//                             toast.error('Destination is manual. Please provide distance from last stop to destination in Summary section.');
//                             setIsCalculatingDistances(false);
//                             return;
//                         }
//                     } else {
//                         finalSegment = parseFloat(finalLeg);
//                     }
//                     console.log(`Manual destination - final leg: ${finalSegment} km`);
//                 }
//                 else if (!destNode.isManual && isLastStopManual) {
//                     const finalLeg = isUp ? editForm.destManualDistFromLastStop : editForm.returnDestManualDistFromLastStop;
//                     if (!finalLeg || parseFloat(finalLeg) <= 0) {
//                         // Try to auto-calculate from total distance
//                         if (totalDistance > 0 && lastStopDistance > 0) {
//                             finalSegment = totalDistance - lastStopDistance;
//                             if (finalSegment > 0) {
//                                 console.log(`Auto-calculated final segment (last stop manual): ${finalSegment} km`);
//                             } else {
//                                 toast.error('Last stop is manual. Please provide distance to destination in Summary section.');
//                                 setIsCalculatingDistances(false);
//                                 return;
//                             }
//                         } else {
//                             toast.error('Last stop is manual. Please provide distance to destination in Summary section.');
//                             setIsCalculatingDistances(false);
//                             return;
//                         }
//                     } else {
//                         finalSegment = parseFloat(finalLeg);
//                     }
//                     console.log(`Last stop manual, destination GPS - final leg: ${finalSegment} km`);
//                 }
//                 else if (!destNode.isManual && !isLastStopManual && matrixResponse) {
//                     validNodeCounter++;
//                     let matrixOriginIndex = lastAutoNodeIndex;
//                     let matrixDestIndex = validNodeCounter;

//                     const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
//                     if (element?.status === 'OK') {
//                         finalSegment = element.distance.value / 1000 - sumManualSinceLastAuto;
//                         if (finalSegment < 0) finalSegment = 0;
//                     }
//                     console.log(`Both GPS - final leg: ${finalSegment} km`);
//                 }
//                 else if (stopNodes.length === 0) {
//                     if (originNode.isManual && destNode.isManual) {
//                         const totalDist = isUp ? editForm.totalDistance : editForm.returnTotalDistance;
//                         if (!totalDist || parseFloat(totalDist) <= 0) {
//                             toast.error('Both origin and destination are manual. Please provide total distance.');
//                             setIsCalculatingDistances(false);
//                             return;
//                         }
//                         finalSegment = parseFloat(totalDist);
//                     } else if (matrixResponse) {
//                         const element = matrixResponse.rows[0]?.elements[1];
//                         if (element?.status === 'OK') {
//                             finalSegment = element.distance.value / 1000;
//                         }
//                     }
//                 }
//             }

//             cumulativeDist += finalSegment;

//             // Update last stop's manualDistToNext
//             if (updatedStops.length > 0 && finalSegment > 0) {
//                 const lastIndex = updatedStops.length - 1;
//                 updatedStops[lastIndex] = {
//                     ...updatedStops[lastIndex],
//                     manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                 };
//             }

//             // Update state with calculated distances
//             if (type === 'up') {
//                 setUpStops(updatedStops);
//                 setEditForm(prev => ({
//                     ...prev,
//                     totalDistance: cumulativeDist.toFixed(1),
//                     upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.upManualFinalLeg
//                 }));
//             } else {
//                 setDownStops(updatedStops);
//                 setEditForm(prev => ({
//                     ...prev,
//                     returnTotalDistance: cumulativeDist.toFixed(1),
//                     returnManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.returnManualFinalLeg
//                 }));
//             }

//             setIsDistanceCalculated(prev => ({ ...prev, [type]: true }));
//             toast.success(`${type === 'up' ? 'UP' : 'DOWN'} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km`);

//         } catch (error) {
//             console.error('Distance calculation error:', error);
//             toast.error("Calculation failed. Please enter distances manually.");
//         } finally {
//             setIsCalculatingDistances(false);
//         }
//     };

//     // Fetch Routes
//     //   const fetchRoutes = async () => {
//     //     try {
//     //       setLoading(true);
//     //       const response = await getAllRoutes(token, currentPage, pageSize, searchTerm);
//     // console.log("getAllRoutes : ",response)
//     //       if (response && response.success) {
//     //         const routesData = response.data?.routes || [];

//     //         const transformedRoutes = routesData.map((route, index) => ({
//     //           id: route._id || route.id,
//     //           serialNo: (currentPage - 1) * pageSize + index + 1,
//     //           routeNumber: route.routeNumber || 'N/A',
//     //           routeName: route.routeName || 'N/A',
//     //           originCity: route.origin?.city || 'N/A',
//     //           destinationCity: route.destination?.city || 'N/A',
//     //           distance: route.routeDetails?.totalDistance || 0,
//     //           duration: formatDuration(
//     //             route.routeDetails?.estimatedDuration?.hours,
//     //             route.routeDetails?.estimatedDuration?.minutes
//     //           ),
//     //           stops: route.intermediateStops?.length || 0,
//     //           status: route.isActive ? 'Active' : 'Inactive',
//     //           departureTime: formatTime(route.origin?.departureTime),
//     //           arrivalTime: formatTime(route.destination?.arrivalTime),
//     //           isActive: route.isActive,
//     //           createdAt: route.createdAt,
//     //           updatedAt: route.updatedAt,
//     //           creatorType: route.creatorType || 'Admin',
//     //           creatorName: route.creatorName || 'Admin',
//     //           isRoundTrip: route.isRoundTrip || false,
//     //           fullData: route
//     //         }));

//     //         setRoutes(transformedRoutes);

//     //         if (response.data?.pagination) {
//     //           setTotalPages(response.data.pagination.totalPages || 1);
//     //           setTotalRoutes(response.data.pagination.total || 0);
//     //         }
//     //       }
//     //     } catch (err) {
//     //       console.error('Error fetching routes:', err);
//     //       toast.error('Failed to fetch routes');
//     //     } finally {
//     //       setLoading(false);
//     //     }
//     //   };

//     // const fetchRoutes = async () => {
//     //     try {
//     //         setLoading(true);
//     //         const response = await getAllRoutes(
//     //             token,
//     //             currentPage,
//     //             pageSize,
//     //             searchTerm,
//     //             filterOrigin,
//     //             filterDestination
//     //         );
//     //         console.log("getAllRoutes : ", response);

//     //         if (response && response.success) {
//     //             const routesData = response.data?.routes || [];

//     //             const transformedRoutes = routesData.map((route, index) => ({
//     //                 id: route._id || route.id,
//     //                 serialNo: (currentPage - 1) * pageSize + index + 1,
//     //                 routeNumber: route.routeNumber || 'N/A',
//     //                 routeName: route.routeName || 'N/A',
//     //                 localRouteName: route.localRouteName || null,
//     //                 originCity: route.origin?.city || 'N/A',
//     //                 destinationCity: route.destination?.city || 'N/A',
//     //                 distance: route.routeDetails?.totalDistance || 0,
//     //                 duration: formatDuration(
//     //                     route.routeDetails?.estimatedDuration?.hours,
//     //                     route.routeDetails?.estimatedDuration?.minutes
//     //                 ),
//     //                 stops: route.intermediateStops?.length || 0,
//     //                 status: route.isActive ? 'Active' : 'Inactive',
//     //                 departureTime: formatTime(route.origin?.departureTime),
//     //                 arrivalTime: formatTime(route.destination?.arrivalTime),
//     //                 isActive: route.isActive,
//     //                 createdAt: route.createdAt,
//     //                 updatedAt: route.updatedAt,
//     //                 creatorType: route.creatorType || 'Admin',
//     //                 creatorName: route.creatorName || 'Admin',
//     //                 isRoundTrip: route.isRoundTrip || false,
//     //                 associatedBuses: (route.associatedBuses || []).map(bus => ({
//     //                     ...bus,
//     //                     _id: bus.busId || bus._id, // Ensure _id exists
//     //                     busId: bus.busId || bus._id,
//     //                     approvalStatus: bus.approvalStatus || (bus.isActive ? 'approved' : 'pending')
//     //                 })),
//     //                 busCount: route.busCount || 0,
//     //                 activeBusCount: route.activeBusCount || 0,
//     //                 hasActiveBuses: route.hasActiveBuses || false,
//     //                 hasPendingBuses: (route.associatedBuses || []).some(bus => !bus.isActive && bus.approvalStatus === 'pending'),
//     //                 fullData: route
//     //             }));

//     //             setRoutes(transformedRoutes);

//     //             if (response.data?.pagination) {
//     //                 setTotalPages(response.data.pagination.totalPages || 1);
//     //                 setTotalRoutes(response.data.pagination.total || 0);
//     //             }
//     //         }
//     //     } catch (err) {
//     //         console.error('Error fetching routes:', err);
//     //         toast.error('Failed to fetch routes');
//     //     } finally {
//     //         setLoading(false);
//     //     }
//     // };

//     const fetchRoutes = async () => {
//         try {
//             setLoading(true);
//             const response = await getAllRoutes(
//                 token,
//                 currentPage,
//                 pageSize,
//                 searchTerm,
//                 filterOrigin,
//                 filterDestination
//             );
//             console.log("getAllRoutes : ", response);

//             if (response && response.success) {
//                 const routesData = response.data?.routes || [];

//                 const transformedRoutes = routesData.map((route, index) => {
//                     // Helper function to get departure time from origin
//                     const getDepartureTime = (origin) => {
//                         // First check if direct departureTime exists
//                         if (origin?.departureTime) return origin.departureTime;

//                         // For multi-trip, check timings array
//                         if (origin?.timings && origin.timings.length > 0) {
//                             // Get first departure time from timings
//                             const firstTiming = origin.timings[0];
//                             if (firstTiming?.departureTime) return firstTiming.departureTime;
//                         }

//                         return 'N/A';
//                     };

//                     // Helper function to get arrival time from destination
//                     const getArrivalTime = (destination) => {
//                         // First check if direct arrivalTime exists
//                         if (destination?.arrivalTime) return destination.arrivalTime;

//                         // For multi-trip, check timings array
//                         if (destination?.timings && destination.timings.length > 0) {
//                             // Get first arrival time from timings
//                             const firstTiming = destination.timings[0];
//                             if (firstTiming?.arrivalTime) return firstTiming.arrivalTime;
//                         }

//                         return 'N/A';
//                     };

//                     // For round trip routes, the display should show from the current route's perspective
//                     // Forward route (FWD) shows origin.departureTime and destination.arrivalTime
//                     // Return route (REV) shows return origin times
//                     let departureTime = getDepartureTime(route.origin);
//                     let arrivalTime = getArrivalTime(route.destination);

//                     // For return routes (REV), the times come from returnJourney if available
//                     if (route.routeNumber?.includes('REV') && route.returnJourney) {
//                         departureTime = getDepartureTime(route.returnJourney.origin);
//                         arrivalTime = getArrivalTime(route.returnJourney.destination);
//                     }

//                     // Format the times for display
//                     const formatDisplayTime = (timeStr) => {
//                         if (!timeStr || timeStr === 'N/A') return 'N/A';
//                         if (timeStr.includes(':')) {
//                             const [hours, minutes] = timeStr.split(':');
//                             const hour = parseInt(hours);
//                             const ampm = hour >= 12 ? 'pm' : 'am';
//                             const displayHour = hour % 12 || 12;
//                             return `${displayHour}:${minutes} ${ampm}`;
//                         }
//                         return timeStr;
//                     };

//                     return {
//                         id: route._id || route.id,
//                         serialNo: (currentPage - 1) * pageSize + index + 1,
//                         routeNumber: route.routeNumber || 'N/A',
//                         routeName: route.routeName || 'N/A',
//                         localRouteName: route.localRouteName || null,
//                         originCity: route.origin?.city || 'N/A',
//                         destinationCity: route.destination?.city || 'N/A',
//                         distance: route.routeDetails?.totalDistance || 0,
//                         duration: formatDuration(
//                             route.routeDetails?.estimatedDuration?.hours,
//                             route.routeDetails?.estimatedDuration?.minutes
//                         ),
//                         stops: route.intermediateStops?.length || 0,
//                         status: route.isActive ? 'Active' : 'Inactive',
//                         departureTime: formatDisplayTime(departureTime),
//                         arrivalTime: formatDisplayTime(arrivalTime),
//                         isActive: route.isActive,
//                         createdAt: route.createdAt,
//                         updatedAt: route.updatedAt,
//                         creatorType: route.creatorType || 'Admin',
//                         creatorName: route.creatorName || 'Admin',
//                         isRoundTrip: route.isRoundTrip || false,
//                         associatedBuses: (route.associatedBuses || []).map(bus => ({
//                             ...bus,
//                             _id: bus.busId || bus._id,
//                             busId: bus.busId || bus._id,
//                             approvalStatus: bus.approvalStatus || (bus.isActive ? 'approved' : 'pending')
//                         })),
//                         busCount: route.busCount || 0,
//                         activeBusCount: route.activeBusCount || 0,
//                         hasActiveBuses: route.hasActiveBuses || false,
//                         hasPendingBuses: (route.associatedBuses || []).some(bus => !bus.isActive && bus.approvalStatus === 'pending'),
//                         fullData: route
//                     };
//                 });

//                 setRoutes(transformedRoutes);

//                 if (response.data?.pagination) {
//                     setTotalPages(response.data.pagination.totalPages || 1);
//                     setTotalRoutes(response.data.pagination.total || 0);
//                 }
//             }
//         } catch (err) {
//             console.error('Error fetching routes:', err);
//             toast.error('Failed to fetch routes');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // useEffect(() => {
//     //     setCurrentPage(1);
//     //     const timer = setTimeout(() => {
//     //         fetchRoutes();
//     //     }, 500);
//     //     return () => clearTimeout(timer);
//     // }, [searchTerm]);

//     // useEffect(() => {
//     //     fetchRoutes();
//     // }, [currentPage]);

// const handleSaveRoute = async () => {
//     // Validate master route is selected
//     if (!selectedMasterRouteFromDropdown) {
//         toast.error('Please select a Master Route first');
//         return;
//     }

//     if (!newRoute.routeName) {
//         toast.error('Route Name is required. Please select a Master Route.');
//         return;
//     }

//     if (!newRoute.upOriginCoords) {
//         toast.error('Please select Origin from suggestions to get coordinates');
//         return;
//     }

//     if (!newRoute.upDestCoords) {
//         toast.error('Please select Destination from suggestions to get coordinates');
//         return;
//     }

//     // Update the invalidStops validation around line 1150
//     const invalidStops = upStops.filter(stop => {
//         const missingFields = [];
//         if (!stop.city?.trim()) missingFields.push('city');
//         if (!stop.coordinates) missingFields.push('coordinates');

//         if (isMultiTrip) {
//             // For multi-trip, check if timings exist
//             if (!stop.timings || stop.timings.length === 0) {
//                 missingFields.push('timings');
//             } else {
//                 // Check each timing has arrival time
//                 const missingTimings = stop.timings.filter(t => !t.arrivalTime);
//                 if (missingTimings.length > 0) {
//                     missingFields.push(`timings for ${missingTimings.length} trip(s)`);
//                 }
//             }
//         } else if (!stop.arrivalTime) {
//             missingFields.push('arrivalTime');
//         }

//         if (missingFields.length > 0) {
//             console.warn(`Stop missing: ${missingFields.join(', ')}`, stop);
//             return true;
//         }
//         return false;
//     });

//     if (invalidStops.length > 0) {
//         toast.error(`Stop(s) missing required fields: ${invalidStops.map(s => s.city || 'Unknown').join(', ')}`);
//         return;
//     }

//     if (!isDistanceCalculated.up) {
//         toast.error('Please calculate UP route distances first');
//         return;
//     }

//     if (isRoundTrip && !isDistanceCalculated.down) {
//         toast.error('Please calculate DOWN route distances first');
//         return;
//     }

//     if (isRoundTrip && !isMultiTrip && (!newRoute.downOriginDepTime || !newRoute.downDestArrTime)) {
//         toast.error("Please provide Departure and Arrival times for the Return Route");
//         return;
//     }

//     setIsCreatingRoute(true);

//     try {
//         // Update originData for multi-trip support
//         const originData = {
//             city: newRoute.upOriginCity,
//             state: newRoute.upOriginState || '',
//             address: newRoute.upOriginAddress || '',
//             terminal: newRoute.upOriginTerminal || newRoute.upOriginCity + ' Terminal',
//             coordinates: newRoute.upOriginCoords || { lat: 0, lng: 0 }
//         };

//         // Add timings for multi-trip, otherwise departureTime
//         if (isMultiTrip) {
//             originData.timings = timeSlots.map(slot => ({
//                 timeSlotSequence: slot.sequence,
//                 departureTime: slot.departureTime,
//                 arrivalTime: ''  // No arrival time for origin
//             }));
//         } else {
//             originData.departureTime = newRoute.upOriginDepTime;
//         }

//         // Update destData for multi-trip support
//         const destData = {
//             city: newRoute.upDestCity,
//             state: newRoute.upDestState || '',
//             address: newRoute.upDestAddress || '',
//             terminal: newRoute.upDestTerminal || newRoute.upDestCity + ' Terminal',
//             coordinates: newRoute.upDestCoords || { lat: 0, lng: 0 },
//             distanceFromOrigin: parseFloat(newRoute.upTotalDistance || 0)
//         };

//         if (isMultiTrip) {
//             destData.timings = destinationTimeSlots.map(slot => ({
//                 timeSlotSequence: slot.sequence,
//                 arrivalTime: slot.arrivalTime,
//                 departureTime: ''  // No departure time for destination
//             }));
//         } else {
//             destData.arrivalTime = newRoute.upDestArrTime;
//         }

//         // Update the cleanStops function in handleSaveRoute
//         const cleanStops = (list) => list.map((s, index) => {
//             const stopCoords = s.coordinates || { lat: 0, lng: 0 };
//             const city = s.city?.trim();
//             if (!city) {
//                 throw new Error(`Stop ${index + 1} is missing city name`);
//             }

//             const state = s.state?.trim() || 'West Bengal';
//             const address = s.address?.trim() || `${city}, ${state}, India`;
//             const terminal = s.terminal?.trim() || `${city} Terminal`;

//             const stopPayload = {
//                 sequence: index + 1,
//                 city: city,
//                 state: state,
//                 address: address,
//                 terminal: terminal,
//                 stopType: s.stopType || 'none',
//                 coordinates: stopCoords,
//                 distanceFromOrigin: s.distanceFromOrigin || 0
//             };

//             // Handle multi-trip vs single trip
//             if (isMultiTrip) {
//                 // For multi-trip, use timings array
//                 if (s.timings && s.timings.length > 0) {
//                     stopPayload.timings = s.timings.map(timing => ({
//                         timeSlotSequence: timing.timeSlotSequence,
//                         arrivalTime: timing.arrivalTime,
//                         departureTime: timing.departureTime || timing.arrivalTime
//                     }));
//                 } else {
//                     // If no timings, create empty timings array for number of trips
//                     stopPayload.timings = timeSlots.map(slot => ({
//                         timeSlotSequence: slot.sequence,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                 }
//             } else {
//                 // For single trip, use arrivalTime/departureTime
//                 if (!s.arrivalTime) {
//                     throw new Error(`Stop ${index + 1} (${city}) is missing arrival time`);
//                 }
//                 stopPayload.arrivalTime = s.arrivalTime;
//                 stopPayload.departureTime = s.departureTime?.trim() || s.arrivalTime;
//             }

//             if (s.manualDistFromPrev) stopPayload.manualDistFromPrev = s.manualDistFromPrev;
//             if (s.manualDistToNext) stopPayload.manualDistToNext = s.manualDistToNext;
//             if (s.isManualStop) stopPayload.isManualStop = s.isManualStop;

//             return stopPayload;
//         });

//         const generateNullPoints = (stops, origin, destination) => {
//             const nullPoints = [];
//             nullPoints.push({
//                 name: origin.terminal,
//                 address: origin.address,
//                 city: origin.city,
//                 state: origin.state,
//                 landmark: origin.terminal,
//                 referenceTime: origin.departureTime
//             });
//             nullPoints.push({
//                 name: destination.terminal,
//                 address: destination.address,
//                 city: destination.city,
//                 state: destination.state,
//                 landmark: destination.terminal,
//                 referenceTime: destination.arrivalTime
//             });
//             stops.forEach(stop => {
//                 if (stop.stopType === 'none') {
//                     nullPoints.push({
//                         name: stop.terminal,
//                         address: stop.address,
//                         city: stop.city,
//                         state: stop.state,
//                         landmark: stop.terminal,
//                         referenceTime: stop.arrivalTime
//                     });
//                 }
//             });
//             return nullPoints;
//         };

//         const generateBoardingPoints = (stops, origin) => {
//             const boardingPoints = [];
//             boardingPoints.push({
//                 name: origin.terminal,
//                 address: origin.address,
//                 city: origin.city,
//                 state: origin.state,
//                 landmark: origin.terminal,
//                 pickupTime: origin.departureTime
//             });
//             stops.forEach(stop => {
//                 if (stop.stopType === 'boarding' || stop.stopType === 'both') {
//                     boardingPoints.push({
//                         name: stop.terminal,
//                         address: stop.address,
//                         city: stop.city,
//                         state: stop.state,
//                         landmark: stop.terminal,
//                         pickupTime: stop.departureTime || stop.arrivalTime
//                     });
//                 }
//             });
//             return boardingPoints;
//         };

//         const generateDroppingPoints = (stops, destination) => {
//             const droppingPoints = [];
//             droppingPoints.push({
//                 name: destination.terminal,
//                 address: destination.address,
//                 city: destination.city,
//                 state: destination.state,
//                 landmark: destination.terminal,
//                 dropTime: destination.arrivalTime
//             });
//             stops.forEach(stop => {
//                 if (stop.stopType === 'dropping' || stop.stopType === 'both') {
//                     droppingPoints.push({
//                         name: stop.terminal,
//                         address: stop.address,
//                         city: stop.city,
//                         state: stop.state,
//                         landmark: stop.terminal,
//                         dropTime: stop.arrivalTime
//                     });
//                 }
//             });
//             return droppingPoints;
//         };

//         const boardingPoints = generateBoardingPoints(upStops, originData);
//         const droppingPoints = generateDroppingPoints(upStops, destData);
//         const nullPoints = generateNullPoints(upStops, originData, destData);

//         // In handleSaveRoute function, update the finalPayload to include multi-trip flags
//         const finalPayload = {
//             routeName: newRoute.routeName.trim(),
//             via: selectedMasterRouteFromDropdown?.via || [],
//             localRouteName: newRoute.localRouteName?.trim() || null,
//             isMultiTrip: isMultiTrip,
//             numberOfTrips: isMultiTrip ? numberOfTrips : 1,
//             timeSlots: isMultiTrip ? timeSlots : [],
//             origin: originData,
//             destination: destData,
//             intermediateStops: cleanStops(upStops),
//             additionalBoardingPoints: boardingPoints,
//             additionalDroppingPoints: droppingPoints,
//             additionalNullPoints: nullPoints,
//             routeDetails: {
//                 totalDistance: parseFloat(newRoute.upTotalDistance || 0),
//                 estimatedDuration: {
//                     hours: parseInt(newRoute.upDurationHours || 0, 10),
//                     minutes: parseInt(newRoute.upDurationMinutes || 0, 10)
//                 }
//             },
//             isRoundTrip: isRoundTrip
//         };

//         if (isRoundTrip) {
//             const invalidReturnStops = downStops.filter(stop => !stop.coordinates);

//             if (invalidReturnStops.length > 0) {
//                 toast.error('All return stops must have coordinates. Please select from suggestions or add manually with distances.');
//                 setIsCreatingRoute(false);
//                 return;
//             }

//             // ========== FIXED: Return Origin Data ==========
//             const returnOriginData = {
//                 city: destData.city,
//                 state: destData.state,
//                 address: destData.address,
//                 terminal: destData.terminal,
//                 coordinates: destData.coordinates
//             };

//             // CORRECTED: Use returnOriginTimeSlots for departure times
//             if (isMultiTrip) {
//                 // Check if returnOriginTimeSlots has values
//                 if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) {
//                     returnOriginData.timings = returnOriginTimeSlots.map(slot => ({
//                         timeSlotSequence: slot.sequence,
//                         departureTime: slot.departureTime || slot.arrivalTime || '',
//                         arrivalTime: ''
//                     }));
//                 } else if (destinationTimeSlots && destinationTimeSlots.length > 0) {
//                     // Fallback: Use destination arrival times as return departure times
//                     returnOriginData.timings = destinationTimeSlots.map(slot => ({
//                         timeSlotSequence: slot.sequence,
//                         departureTime: slot.arrivalTime || '',
//                         arrivalTime: ''
//                     }));
//                 } else {
//                     // Last resort: Use timeSlots
//                     returnOriginData.timings = timeSlots.map(slot => ({
//                         timeSlotSequence: slot.sequence,
//                         departureTime: slot.departureTime || '',
//                         arrivalTime: ''
//                     }));
//                 }
//             } else {
//                 returnOriginData.departureTime = newRoute.downOriginDepTime;
//             }

//             // ========== FIXED: Return Destination Data ==========
//             const returnDestData = {
//                 city: originData.city,
//                 state: originData.state,
//                 address: originData.address,
//                 terminal: originData.terminal,
//                 coordinates: originData.coordinates,
//                 distanceFromOrigin: parseFloat(newRoute.downTotalDistance || 0)
//             };

//             // CORRECTED: Use returnDestTimeSlots for arrival times
//             if (isMultiTrip) {
//                 if (returnDestTimeSlots && returnDestTimeSlots.length > 0) {
//                     returnDestData.timings = returnDestTimeSlots.map(slot => ({
//                         timeSlotSequence: slot.sequence,
//                         arrivalTime: slot.arrivalTime || slot.departureTime || '',
//                         departureTime: ''
//                     }));
//                 } else if (timeSlots && timeSlots.length > 0) {
//                     // Fallback: Use forward departure times as return arrival times
//                     returnDestData.timings = timeSlots.map(slot => ({
//                         timeSlotSequence: slot.sequence,
//                         arrivalTime: slot.departureTime || '',
//                         departureTime: ''
//                     }));
//                 } else {
//                     // Last resort: Create empty timings
//                     returnDestData.timings = Array.from({ length: numberOfTrips || 1 }, (_, i) => ({
//                         timeSlotSequence: i + 1,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                 }
//             } else {
//                 returnDestData.arrivalTime = newRoute.downDestArrTime;
//             }

//             // Validate return origin timings
//             if (isMultiTrip && returnOriginData.timings) {
//                 const missingDepartures = returnOriginData.timings.filter(t => !t.departureTime);
//                 if (missingDepartures.length > 0) {
//                     toast.error(`Return origin is missing departure times for ${missingDepartures.length} trip(s). Please set them in the DOWN route section.`);
//                     setIsCreatingRoute(false);
//                     return;
//                 }
//             }

//             // Validate return destination timings
//             if (isMultiTrip && returnDestData.timings) {
//                 const missingArrivals = returnDestData.timings.filter(t => !t.arrivalTime);
//                 if (missingArrivals.length > 0) {
//                     toast.error(`Return destination is missing arrival times for ${missingArrivals.length} trip(s). Please set them in the DOWN route section.`);
//                     setIsCreatingRoute(false);
//                     return;
//                 }
//             }

//             // Clean return stops preserving their timings
//             const cleanedReturnStops = downStops.map((stop, index) => {
//                 const stopCoords = stop.coordinates || { lat: 0, lng: 0 };
//                 const city = stop.city?.trim();
//                 if (!city) {
//                     throw new Error(`Return stop ${index + 1} is missing city name`);
//                 }

//                 const state = stop.state?.trim() || 'West Bengal';
//                 const address = stop.address?.trim() || `${city}, ${state}, India`;
//                 const terminal = stop.terminal?.trim() || `${city} Terminal`;

//                 const stopPayload = {
//                     sequence: index + 1,
//                     city: city,
//                     state: state,
//                     address: address,
//                     terminal: terminal,
//                     stopType: stop.stopType || 'none',
//                     coordinates: stopCoords,
//                     distanceFromOrigin: stop.distanceFromOrigin || 0
//                 };

//                 // Handle multi-trip vs single trip for return stops
//                 if (isMultiTrip) {
//                     // Preserve existing timings from return stops
//                     if (stop.timings && stop.timings.length > 0) {
//                         stopPayload.timings = stop.timings.map(timing => ({
//                             timeSlotSequence: timing.timeSlotSequence,
//                             arrivalTime: timing.arrivalTime || '',
//                             departureTime: timing.departureTime || timing.arrivalTime || ''
//                         }));
//                     } else {
//                         // Create timings from return time slots
//                         const numTrips = returnOriginTimeSlots.length || numberOfTrips || 1;
//                         stopPayload.timings = Array.from({ length: numTrips }, (_, i) => ({
//                             timeSlotSequence: i + 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     }
//                 } else {
//                     if (!stop.arrivalTime) {
//                         throw new Error(`Return stop ${index + 1} (${city}) is missing arrival time`);
//                     }
//                     stopPayload.arrivalTime = stop.arrivalTime;
//                     stopPayload.departureTime = stop.departureTime?.trim() || stop.arrivalTime;
//                 }

//                 if (stop.manualDistFromPrev) stopPayload.manualDistFromPrev = stop.manualDistFromPrev;
//                 if (stop.manualDistToNext) stopPayload.manualDistToNext = stop.manualDistToNext;
//                 if (stop.isManualStop) stopPayload.isManualStop = stop.isManualStop;

//                 return stopPayload;
//             });

//             const returnBoardingPoints = generateBoardingPoints(downStops, returnOriginData);
//             const returnDroppingPoints = generateDroppingPoints(downStops, returnDestData);
//             const returnNullPoints = generateNullPoints(downStops, returnOriginData, returnDestData);

//             finalPayload.returnOrigin = returnOriginData;
//             finalPayload.returnDestination = returnDestData;
//             finalPayload.returnIntermediateStops = cleanedReturnStops;
//             finalPayload.returnAdditionalBoardingPoints = returnBoardingPoints;
//             finalPayload.returnAdditionalDroppingPoints = returnDroppingPoints;
//             finalPayload.returnAdditionalNullPoints = returnNullPoints;
//             finalPayload.returnRouteDetails = {
//                 totalDistance: parseFloat(newRoute.downTotalDistance || 0),
//                 estimatedDuration: {
//                     hours: parseInt(newRoute.downDurationHours || 0, 10),
//                     minutes: parseInt(newRoute.downDurationMinutes || 0, 10)
//                 }
//             };
//         }

//         console.log("Final Payload:", JSON.stringify(finalPayload, null, 2));

//         const response = await createRoute(finalPayload, token);
//         if (response.success) {
//             toast.success(isRoundTrip ? 'Round trip route created successfully!' : 'Route created successfully!');
//             setShowAddModal(false);
//             resetNewRouteForm();
//             fetchRoutes();
//         } else {
//             toast.error(response.message || 'Failed to create route');
//         }
//     } catch (err) {
//         console.error('Error creating route:', err);
//         if (err.response) {
//             const serverError = err.response.data?.message || err.response.data || err.message;
//             toast.error(serverError);
//             console.error('Server response data:', err.response.data);
//         } else if (err.request) {
//             toast.error('No response from server. Please check your connection.');
//         } else {
//             toast.error(err.message || 'Failed to create route');
//         }
//     } finally {
//         setIsCreatingRoute(false);
//     }
// };

//     const resetNewRouteForm = () => {
//         setNewRoute({
//             routeName: '',
//             localRouteName: '',  // ADD THIS
//             upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
//             upOriginCoords: null, upOriginDepTime: '',
//             upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
//             upDestCoords: null, upDestArrTime: '',
//             upTotalDistance: '', upDurationHours: '', upDurationMinutes: '',
//             downOriginDepTime: '', downDestArrTime: '',
//             downTotalDistance: '', downDurationHours: '', downDurationMinutes: '',
//             upManualFinalLeg: '',
//             downManualFinalLeg: '',
//             stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
//             stopCoords: null, stopArrivalTime: '', stopDepartureTime: '',
//             stopDistFromPrev: '', stopDistToNext: '',
//             isBoarding: false, isDropping: false
//         });
//         setUpStops([]);
//         setDownStops([]);
//         setIsRoundTrip(false);
//         setActiveRouteTab('UP');
//         setIsDistanceCalculated({ up: false, down: false });
//         setActiveTab('basic');
//         setSelectedMasterRoute(null);
//         setSelectedMasterRouteFromDropdown(null);
//         setMasterRouteSuggestions([]);
//     };

//     const handleViewRoute = async (route) => {
//         try {
//             const routeData = await getRouteById(route.id, token);
//             setViewingRoute(routeData.data || routeData);
//         } catch (err) {
//             setViewingRoute(route.fullData);
//             toast.warning('Could not fetch latest route details. Showing cached data.');
//         }
//     };

//     const handleAddNewMasterRoute = () => {
//         const currentFormData = {
//             routeName: newRoute.routeName,
//             upOriginCity: newRoute.upOriginCity,
//             upOriginState: newRoute.upOriginState,
//             upOriginAddress: newRoute.upOriginAddress,
//             upOriginTerminal: newRoute.upOriginTerminal,
//             upOriginCoords: newRoute.upOriginCoords,
//             upOriginDepTime: newRoute.upOriginDepTime,
//             upDestCity: newRoute.upDestCity,
//             upDestState: newRoute.upDestState,
//             upDestAddress: newRoute.upDestAddress,
//             upDestTerminal: newRoute.upDestTerminal,
//             upDestCoords: newRoute.upDestCoords,
//             upDestArrTime: newRoute.upDestArrTime,
//             isRoundTrip: isRoundTrip,
//             upStops: upStops,
//             downStops: downStops,
//             // CRITICAL: Also save via points if they exist as stops
//             via: upStops.map(stop => ({
//                 city: stop.city,
//                 state: stop.state,
//                 sequence: stop.sequence
//             }))
//         };
//         localStorage.setItem('pendingRouteFormData', JSON.stringify(currentFormData));

//         toast.info('Redirecting to create master route. Your current form data has been saved.');

//         navigate('/masterroutes', {
//             state: {
//                 returnTo: 'routes',
//                 formData: currentFormData
//             }
//         });
//     };

//     //     const autoFillFromMasterRoute = (masterRoute) => {
//     //         if (!masterRoute) return;

//     //         setSelectedMasterRouteFromDropdown(masterRoute);

//     //         // Auto-fill Route Name from master route
//     //         setNewRoute(prev => ({
//     //             ...prev,
//     //             routeName: masterRoute.masterRouteName
//     //         }));

//     //         // Auto-fill UP Route Origin
//     //         if (masterRoute.origin) {
//     //             setNewRoute(prev => ({
//     //                 ...prev,
//     //                 upOriginCity: masterRoute.origin.city || '',
//     //                 upOriginState: masterRoute.origin.state || '',
//     //                 upOriginAddress: masterRoute.origin.address || `${masterRoute.origin.city || ''}, ${masterRoute.origin.state || 'India'}`,
//     //                 upOriginTerminal: masterRoute.origin.terminal || `${masterRoute.origin.city || ''} Terminal`,
//     //                 upOriginCoords: masterRoute.origin.coordinates || null
//     //             }));
//     //         }

//     //         // Auto-fill UP Route Destination
//     //         if (masterRoute.destination) {
//     //             setNewRoute(prev => ({
//     //                 ...prev,
//     //                 upDestCity: masterRoute.destination.city || '',
//     //                 upDestState: masterRoute.destination.state || '',
//     //                 upDestAddress: masterRoute.destination.address || `${masterRoute.destination.city || ''}, ${masterRoute.destination.state || 'India'}`,
//     //                 upDestTerminal: masterRoute.destination.terminal || `${masterRoute.destination.city || ''} Terminal`,
//     //                 upDestCoords: masterRoute.destination.coordinates || null,
//     //                 upTotalDistance: masterRoute.routeDetails?.totalDistance || '',
//     //                 upDurationHours: masterRoute.routeDetails?.estimatedDuration?.hours || '',
//     //                 upDurationMinutes: masterRoute.routeDetails?.estimatedDuration?.minutes || ''
//     //             }));
//     //         }

//     //         // Auto-fill UP Intermediate Stops and calculate manual distances
//     //         if (masterRoute.intermediateStops && masterRoute.intermediateStops.length > 0) {
//     //             const upTotalDist = parseFloat(masterRoute.routeDetails?.totalDistance) || 0;
//     //             let firstLegDistance = 0;

//     //            // In autoFillFromMasterRoute function, when creating transformedUpStops
//     // const transformedUpStops = masterRoute.intermediateStops.map((stop, index, array) => {
//     //   const currentDist = stop.distanceFromOrigin || 0;
//     //   const prevDist = index === 0 ? 0 : (array[index - 1].distanceFromOrigin || 0);
//     //   let segmentDist = parseFloat((currentDist - prevDist).toFixed(1));

//     //   if (segmentDist <= 0 && stop.manualDistFromPrev) {
//     //     segmentDist = parseFloat(stop.manualDistFromPrev);
//     //   }

//     //   if (index === 0 && segmentDist > 0) {
//     //     firstLegDistance = segmentDist;
//     //   }

//     //   const baseStop = {
//     //     sequence: index + 1,
//     //     city: stop.city || '',
//     //     state: stop.state || '',
//     //     address: stop.address || `${stop.city || ''}, ${stop.state || 'India'}`,
//     //     terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
//     //     stopType: stop.stopType || 'none',
//     //     coordinates: stop.coordinates || { lat: 0, lng: 0 },
//     //     distanceFromOrigin: currentDist,
//     //     manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
//     //     manualDistToNext: stop.manualDistToNext || null,
//     //     isManualStop: !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)
//     //   };

//     //   // Handle multi-trip or single trip
//     //   if (isMultiTrip) {
//     //     // If master route has timings, use them, otherwise initialize empty
//     //     baseStop.timings = stop.timings || [];
//     //     baseStop.arrivalTime = '';
//     //     baseStop.departureTime = '';
//     //   } else {
//     //     baseStop.arrivalTime = stop.arrivalTime || '';
//     //     baseStop.departureTime = stop.departureTime || '';
//     //     baseStop.timings = [];
//     //   }

//     //   return baseStop;
//     // });

//     //             setUpStops(transformedUpStops);
//     //             setIsDistanceCalculated(prev => ({ ...prev, up: true }));

//     //             // Set upManualFirstLeg (distance from origin to first stop)
//     //             if (firstLegDistance > 0) {
//     //                 setNewRoute(prev => ({ ...prev, upManualFirstLeg: String(firstLegDistance) }));
//     //             } else if (masterRoute.intermediateStops[0]?.manualDistFromPrev) {
//     //                 setNewRoute(prev => ({ ...prev, upManualFirstLeg: String(masterRoute.intermediateStops[0].manualDistFromPrev) }));
//     //             }

//     //             // Set upManualFinalLeg (distance from last stop to destination)
//     //             if (transformedUpStops.length > 0) {
//     //                 const lastStopDist = transformedUpStops[transformedUpStops.length - 1].distanceFromOrigin || 0;
//     //                 const finalLeg = parseFloat((upTotalDist - lastStopDist).toFixed(1));
//     //                 if (finalLeg > 0) {
//     //                     setNewRoute(prev => ({ ...prev, upManualFinalLeg: String(finalLeg) }));
//     //                 }
//     //             } else if (upTotalDist > 0) {
//     //                 setNewRoute(prev => ({ ...prev, upManualFinalLeg: String(upTotalDist) }));
//     //             }
//     //         } else {
//     //             setUpStops([]);
//     //         }

//     //         // Auto-fill Round Trip Information
//     //         if (masterRoute.isRoundTrip && masterRoute.returnJourney) {
//     //             setIsRoundTrip(true);

//     //             const returnJourney = masterRoute.returnJourney;
//     //             const returnTotalDist = parseFloat(returnJourney.routeDetails?.totalDistance) || 0;

//     //             // Set Return Journey total distance and duration
//     //             setNewRoute(prev => ({
//     //                 ...prev,
//     //                 downTotalDistance: returnTotalDist,
//     //                 downDurationHours: returnJourney.routeDetails?.estimatedDuration?.hours || '',
//     //                 downDurationMinutes: returnJourney.routeDetails?.estimatedDuration?.minutes || ''
//     //             }));

//     //             // Auto-fill Return Origin (this is the destination from UP route)
//     //             if (returnJourney.origin) {
//     //                 setNewRoute(prev => ({
//     //                     ...prev,
//     //                     downOriginCity: returnJourney.origin.city || masterRoute.destination?.city || '',
//     //                     downOriginState: returnJourney.origin.state || masterRoute.destination?.state || '',
//     //                     downOriginAddress: returnJourney.origin.address || `${masterRoute.destination?.city || ''}, ${masterRoute.destination?.state || 'India'}`,
//     //                     downOriginTerminal: returnJourney.origin.terminal || `${masterRoute.destination?.city || ''} Terminal`,
//     //                     downOriginCoords: returnJourney.origin.coordinates || masterRoute.destination?.coordinates || null
//     //                 }));
//     //             }

//     //             // Auto-fill Return Destination (this is the origin from UP route)
//     //             if (returnJourney.destination) {
//     //                 setNewRoute(prev => ({
//     //                     ...prev,
//     //                     downDestCity: returnJourney.destination.city || masterRoute.origin?.city || '',
//     //                     downDestState: returnJourney.destination.state || masterRoute.origin?.state || '',
//     //                     downDestAddress: returnJourney.destination.address || `${masterRoute.origin?.city || ''}, ${masterRoute.origin?.state || 'India'}`,
//     //                     downDestTerminal: returnJourney.destination.terminal || `${masterRoute.origin?.city || ''} Terminal`,
//     //                     downDestCoords: returnJourney.destination.coordinates || masterRoute.origin?.coordinates || null
//     //                 }));
//     //             }

//     //             // Auto-fill Return Intermediate Stops
//     //             if (returnJourney.intermediateStops && returnJourney.intermediateStops.length > 0) {
//     //                 // For return journey, we need to preserve the distances but they will be recalculated
//     //                 const transformedDownStops = returnJourney.intermediateStops.map((stop, index, array) => {
//     //                     const currentDist = stop.distanceFromOrigin || 0;
//     //                     const prevDist = index === 0 ? 0 : (array[index - 1].distanceFromOrigin || 0);
//     //                     let segmentDist = parseFloat((currentDist - prevDist).toFixed(1));

//     //                     if (segmentDist <= 0 && stop.manualDistFromPrev) {
//     //                         segmentDist = parseFloat(stop.manualDistFromPrev);
//     //                     }

//     //                     return {
//     //                         sequence: index + 1,
//     //                         city: stop.city || '',
//     //                         state: stop.state || '',
//     //                         address: stop.address || `${stop.city || ''}, ${stop.state || 'India'}`,
//     //                         terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
//     //                         arrivalTime: '',
//     //                         departureTime: '',
//     //                         stopType: stop.stopType || 'none',
//     //                         coordinates: stop.coordinates || { lat: 0, lng: 0 },
//     //                         distanceFromOrigin: currentDist,
//     //                         manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
//     //                         manualDistToNext: stop.manualDistToNext || null,
//     //                         isManualStop: !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)
//     //                     };
//     //                 });

//     //                 setDownStops(transformedDownStops);
//     //                 setIsDistanceCalculated(prev => ({ ...prev, down: true }));
//     //             } else {
//     //                 setDownStops([]);
//     //             }
//     //         } else {
//     //             setIsRoundTrip(false);
//     //             setDownStops([]);
//     //         }

//     //         toast.success(`Master route "${masterRoute.masterRouteName}" loaded successfully! Please verify and fill in the timings.`);
//     //     };

//     const autoFillFromMasterRoute = (masterRoute) => {
//         if (!masterRoute) return;

//         console.log('=== autoFillFromMasterRoute called ===');
//         console.log('Master route data:', masterRoute);

//         setSelectedMasterRouteFromDropdown(masterRoute);

//         const isMultiTripRoute = masterRoute.isMultiTrip ||
//             (masterRoute.origin?.timings && masterRoute.origin.timings.length > 0) ||
//             (masterRoute.intermediateStops && masterRoute.intermediateStops.some(stop => stop.timings && stop.timings.length > 0));

//         setIsMultiTrip(isMultiTripRoute);

//         setNewRoute(prev => ({
//             ...prev,
//             routeName: masterRoute.masterRouteName,
//             localRouteName: masterRoute.localRouteName || prev.localRouteName
//         }));

//         // ========== HANDLE FORWARD JOURNEY ORIGIN ==========
//         if (masterRoute.origin) {
//             setNewRoute(prev => ({
//                 ...prev,
//                 upOriginCity: masterRoute.origin.city || '',
//                 upOriginState: masterRoute.origin.state || '',
//                 upOriginAddress: masterRoute.origin.address || `${masterRoute.origin.city || ''}, ${masterRoute.origin.state || 'India'}`,
//                 upOriginTerminal: masterRoute.origin.terminal || `${masterRoute.origin.city || ''} Terminal`,
//                 upOriginCoords: masterRoute.origin.coordinates || null,
//                 upOriginDepTime: masterRoute.origin.departureTime || ''
//             }));

//             if (isMultiTripRoute && masterRoute.origin.timings && masterRoute.origin.timings.length > 0) {
//                 const numTrips = masterRoute.numberOfTrips || masterRoute.origin.timings.length;
//                 setNumberOfTrips(numTrips);
//                 setTimeSlots(masterRoute.origin.timings.map(timing => ({
//                     sequence: timing.timeSlotSequence,
//                     departureTime: timing.departureTime,
//                     arrivalTime: '',
//                     fareMultiplier: timing.fareMultiplier || 1.0,
//                     isActive: timing.isActive !== undefined ? timing.isActive : true
//                 })));
//             }
//         }

//         // ========== HANDLE FORWARD JOURNEY DESTINATION ==========
//         if (masterRoute.destination) {
//             setNewRoute(prev => ({
//                 ...prev,
//                 upDestCity: masterRoute.destination.city || '',
//                 upDestState: masterRoute.destination.state || '',
//                 upDestAddress: masterRoute.destination.address || `${masterRoute.destination.city || ''}, ${masterRoute.destination.state || 'India'}`,
//                 upDestTerminal: masterRoute.destination.terminal || `${masterRoute.destination.city || ''} Terminal`,
//                 upDestCoords: masterRoute.destination.coordinates || null,
//                 upDestArrTime: masterRoute.destination.arrivalTime || '',
//                 upTotalDistance: masterRoute.routeDetails?.totalDistance || '',
//                 upDurationHours: masterRoute.routeDetails?.estimatedDuration?.hours || '',
//                 upDurationMinutes: masterRoute.routeDetails?.estimatedDuration?.minutes || ''
//             }));

//             if (isMultiTripRoute && masterRoute.destination.timings && masterRoute.destination.timings.length > 0) {
//                 setDestinationTimeSlots(masterRoute.destination.timings.map(timing => ({
//                     sequence: timing.timeSlotSequence,
//                     arrivalTime: timing.arrivalTime,
//                     departureTime: '',
//                     fareMultiplier: timing.fareMultiplier || 1.0
//                 })));
//                 setDestinationNumberOfTrips(masterRoute.destination.timings.length);
//             }
//         }

//         // ========== HANDLE FORWARD INTERMEDIATE STOPS ==========
//         // CRITICAL FIX: ONLY use intermediateStops, do NOT merge with via array
//         // The via array is for route identification only, not actual stops
//         const existingIntermediateStops = masterRoute.intermediateStops || [];

//         // Sort by sequence
//         const sortedStops = [...existingIntermediateStops].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//         if (sortedStops.length > 0) {
//             const upTotalDist = parseFloat(masterRoute.routeDetails?.totalDistance) || 0;

//             const transformedUpStops = sortedStops.map((stop, index) => {
//                 // USE actual distanceFromOrigin from master route data
//                 const actualDist = stop.distanceFromOrigin || 0;
//                 const prevStop = index > 0 ? sortedStops[index - 1] : null;
//                 const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

//                 // Calculate segment distance
//                 let segmentDist = 0;
//                 if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
//                     segmentDist = parseFloat(stop.manualDistFromPrev);
//                 } else if (actualDist > 0) {
//                     segmentDist = parseFloat((actualDist - prevDist).toFixed(1));
//                 }

//                 // Only fall back to equal segments if we have absolutely no distance data
//                 if (segmentDist <= 0 && upTotalDist > 0 && sortedStops.length > 0) {
//                     segmentDist = parseFloat((upTotalDist / (sortedStops.length + 1)).toFixed(1));
//                 }
//                 if (segmentDist <= 0) segmentDist = 5;

//                 // Handle timings
//                 const existingTimings = stop.timings || [];
//                 let stopTimings = existingTimings;
//                 if (isMultiTripRoute && existingTimings.length === 0) {
//                     const numTrips = masterRoute.numberOfTrips || 1;
//                     stopTimings = Array.from({ length: numTrips }, (_, i) => ({
//                         timeSlotSequence: i + 1,
//                         arrivalTime: '',
//                         departureTime: ''
//                     }));
//                 }

//                 return {
//                     sequence: index + 1,
//                     city: stop.city || '',
//                     state: stop.state || masterRoute.origin?.state || '',
//                     address: stop.address || `${stop.city || ''}, ${stop.state || masterRoute.origin?.state || 'India'}`,
//                     terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
//                     stopType: stop.stopType || 'none',
//                     coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                     distanceFromOrigin: actualDist,
//                     manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
//                     manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
//                     isManualStop: stop.isManualStop !== undefined
//                         ? stop.isManualStop
//                         : (!stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)),
//                     arrivalTime: stop.arrivalTime || '',
//                     departureTime: stop.departureTime || '',
//                     timings: stopTimings
//                 };
//             });

//             setUpStops(transformedUpStops);
//             setIsDistanceCalculated(prev => ({ ...prev, up: true }));

//             // Set first leg (origin → first stop)
//             const firstStopDist = transformedUpStops[0].distanceFromOrigin || 0;
//             const firstSegment = transformedUpStops[0].manualDistFromPrev || firstStopDist;
//             if (firstSegment > 0) {
//                 setNewRoute(prev => ({ ...prev, upManualFirstLeg: String(firstSegment) }));
//             }

//             // Set final leg (last stop → destination)
//             const lastStopDist = transformedUpStops[transformedUpStops.length - 1].distanceFromOrigin || 0;
//             const finalLeg = parseFloat((upTotalDist - lastStopDist).toFixed(1));
//             if (finalLeg > 0) {
//                 setNewRoute(prev => ({ ...prev, upManualFinalLeg: String(finalLeg) }));
//             }
//         } else {
//             setUpStops([]);
//         }

//         // ========== HANDLE RETURN JOURNEY ==========
//         if (masterRoute.isRoundTrip && masterRoute.returnJourney) {
//             setIsRoundTrip(true);

//             const returnJourney = masterRoute.returnJourney;
//             const returnTotalDist = parseFloat(returnJourney.routeDetails?.totalDistance) || 0;

//             if (returnJourney.origin) {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     downOriginCity: returnJourney.origin.city || masterRoute.destination?.city || '',
//                     downOriginState: returnJourney.origin.state || masterRoute.destination?.state || '',
//                     downOriginAddress: returnJourney.origin.address || `${masterRoute.destination?.city || ''}, ${masterRoute.destination?.state || 'India'}`,
//                     downOriginTerminal: returnJourney.origin.terminal || `${masterRoute.destination?.city || ''} Terminal`,
//                     downOriginCoords: returnJourney.origin.coordinates || masterRoute.destination?.coordinates || null,
//                     downOriginDepTime: returnJourney.origin.departureTime || ''
//                 }));

//                 if (isMultiTripRoute && returnJourney.origin.timings && returnJourney.origin.timings.length > 0) {
//                     setReturnOriginTimeSlots(returnJourney.origin.timings.map(timing => ({
//                         sequence: timing.timeSlotSequence,
//                         departureTime: timing.departureTime,
//                         arrivalTime: '',
//                         fareMultiplier: timing.fareMultiplier || 1.0
//                     })));
//                 } else if (isMultiTripRoute && destinationTimeSlots.length > 0) {
//                     setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         departureTime: slot.arrivalTime,
//                         arrivalTime: ''
//                     })));
//                 }
//             }

//             if (returnJourney.destination) {
//                 setNewRoute(prev => ({
//                     ...prev,
//                     downDestCity: returnJourney.destination.city || masterRoute.origin?.city || '',
//                     downDestState: returnJourney.destination.state || masterRoute.origin?.state || '',
//                     downDestAddress: returnJourney.destination.address || `${masterRoute.origin?.city || ''}, ${masterRoute.origin?.state || 'India'}`,
//                     downDestTerminal: returnJourney.destination.terminal || `${masterRoute.origin?.city || ''} Terminal`,
//                     downDestCoords: returnJourney.destination.coordinates || masterRoute.origin?.coordinates || null,
//                     downDestArrTime: returnJourney.destination.arrivalTime || '',
//                     downTotalDistance: returnTotalDist,
//                     downDurationHours: returnJourney.routeDetails?.estimatedDuration?.hours || '',
//                     downDurationMinutes: returnJourney.routeDetails?.estimatedDuration?.minutes || ''
//                 }));

//                 if (isMultiTripRoute && returnJourney.destination.timings && returnJourney.destination.timings.length > 0) {
//                     setReturnDestTimeSlots(returnJourney.destination.timings.map(timing => ({
//                         sequence: timing.timeSlotSequence,
//                         arrivalTime: timing.arrivalTime,
//                         departureTime: '',
//                         fareMultiplier: timing.fareMultiplier || 1.0
//                     })));
//                 } else if (isMultiTripRoute && timeSlots.length > 0) {
//                     setReturnDestTimeSlots(timeSlots.map(slot => ({
//                         sequence: slot.sequence,
//                         arrivalTime: slot.departureTime,
//                         departureTime: ''
//                     })));
//                 }
//             }

//             // ========== HANDLE RETURN INTERMEDIATE STOPS ==========
//             // CRITICAL FIX: ONLY use return intermediateStops, do NOT merge with return via array
//             const returnExistingStops = returnJourney.intermediateStops || [];
//             const sortedReturnStops = [...returnExistingStops].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

//             if (sortedReturnStops.length > 0) {
//                 const transformedDownStops = sortedReturnStops.map((stop, index) => {
//                     // USE actual distanceFromOrigin from return journey data
//                     const actualDist = stop.distanceFromOrigin || 0;
//                     const prevStop = index > 0 ? sortedReturnStops[index - 1] : null;
//                     const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

//                     let segmentDist = 0;
//                     if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
//                         segmentDist = parseFloat(stop.manualDistFromPrev);
//                     } else if (actualDist > 0) {
//                         segmentDist = parseFloat((actualDist - prevDist).toFixed(1));
//                     }

//                     if (segmentDist <= 0 && returnTotalDist > 0 && sortedReturnStops.length > 0) {
//                         segmentDist = parseFloat((returnTotalDist / (sortedReturnStops.length + 1)).toFixed(1));
//                     }
//                     if (segmentDist <= 0) segmentDist = 5;

//                     const existingTimings = stop.timings || [];
//                     let stopTimings = existingTimings;
//                     if (isMultiTripRoute && existingTimings.length === 0) {
//                         const numTrips = masterRoute.numberOfTrips || 1;
//                         stopTimings = Array.from({ length: numTrips }, (_, i) => ({
//                             timeSlotSequence: i + 1,
//                             arrivalTime: '',
//                             departureTime: ''
//                         }));
//                     }

//                     // Determine stop type for return journey (swap boarding/dropping)
//                     let newStopType = stop.stopType || 'none';
//                     if (newStopType === 'boarding') newStopType = 'dropping';
//                     else if (newStopType === 'dropping') newStopType = 'boarding';

//                     return {
//                         sequence: index + 1,
//                         city: stop.city || '',
//                         state: stop.state || masterRoute.destination?.state || '',
//                         address: stop.address || `${stop.city || ''}, ${stop.state || masterRoute.destination?.state || 'India'}`,
//                         terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
//                         arrivalTime: stop.arrivalTime || '',
//                         departureTime: stop.departureTime || '',
//                         stopType: newStopType,
//                         coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                         distanceFromOrigin: actualDist,
//                         manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
//                         manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
//                         isManualStop: stop.isManualStop !== undefined
//                             ? stop.isManualStop
//                             : (!stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)),
//                         timings: stopTimings
//                     };
//                 });

//                 setDownStops(transformedDownStops);
//                 setIsDistanceCalculated(prev => ({ ...prev, down: true }));

//                 // Set return first leg and final leg
//                 const returnFirstSegment = transformedDownStops[0].manualDistFromPrev ||
//                     transformedDownStops[0].distanceFromOrigin || 0;
//                 if (returnFirstSegment > 0) {
//                     setNewRoute(prev => ({ ...prev, downManualFirstLeg: String(returnFirstSegment) }));
//                 }

//                 const returnLastStopDist = transformedDownStops[transformedDownStops.length - 1].distanceFromOrigin || 0;
//                 const returnFinalLeg = parseFloat((returnTotalDist - returnLastStopDist).toFixed(1));
//                 if (returnFinalLeg > 0) {
//                     setNewRoute(prev => ({ ...prev, downManualFinalLeg: String(returnFinalLeg) }));
//                 }
//             } else {
//                 setDownStops([]);
//             }
//         } else {
//             setIsRoundTrip(false);
//             setDownStops([]);
//             setReturnOriginTimeSlots([]);
//             setReturnDestTimeSlots([]);
//         }

//         toast.success(`Master route "${masterRoute.masterRouteName}" loaded successfully! Please verify and fill in the timings.`);

//         console.log('=== autoFillFromMasterRoute completed ===');
//     };

//     // const handleEditRoute = async (route) => {
//     //     try {
//     //         const response = await getRouteById(route.id, token);
//     //         const routeData = response.data || route.fullData;

//     //         setEditingRoute(routeData);

//     //         const origin = routeData.origin || {};
//     //         const destination = routeData.destination || {};
//     //         const routeDetails = routeData.routeDetails || {};
//     //         const estimatedDuration = routeDetails.estimatedDuration || {};

//     //         const transformedStops = (routeData.intermediateStops || []).map(stop => ({
//     //             city: stop.city,
//     //             state: stop.state || '',
//     //             address: stop.address || '',
//     //             terminal: stop.terminal || '',
//     //             arrivalTime: stop.arrivalTime,
//     //             departureTime: stop.departureTime || '',
//     //             stopType: stop.stopType || 'none',
//     //             coordinates: stop.coordinates || { lat: 0, lng: 0 },
//     //             distanceFromOrigin: stop.distanceFromOrigin || 0,
//     //             manualDistFromPrev: stop.manualDistFromPrev || null,
//     //             manualDistToNext: stop.manualDistToNext || null
//     //         }));

//     //         setEditForm({
//     //             routeNumber: routeData.routeNumber || '',
//     //             routeName: routeData.routeName || '',
//     //             localRouteName: routeData.localRouteName || '',  // ADD THIS
//     //             originCity: origin.city || '',
//     //             originState: origin.state || '',
//     //             originAddress: origin.address || '',
//     //             originTerminal: origin.terminal || '',
//     //             originDepTime: origin.departureTime || '',
//     //             originCoords: origin.coordinates || { lat: 0, lng: 0 },
//     //             destCity: destination.city || '',
//     //             destState: destination.state || '',
//     //             destAddress: destination.address || '',
//     //             destTerminal: destination.terminal || '',
//     //             destArrTime: destination.arrivalTime || '',
//     //             destCoords: destination.coordinates || { lat: 0, lng: 0 },
//     //             totalDistance: routeDetails.totalDistance || '',
//     //             durationHours: estimatedDuration.hours || '',
//     //             durationMinutes: estimatedDuration.minutes || '',
//     //             intermediateStops: transformedStops,
//     //             isActive: routeData.isActive,
//     //             isRoundTrip: routeData.isRoundTrip || false,
//     //             returnJourney: routeData.returnJourney || null
//     //         });

//     //         if (routeData.intermediateStops && routeData.intermediateStops.length > 0) {
//     //             setUpStops(transformedStops);
//     //             if (transformedStops.every(stop => stop.distanceFromOrigin > 0)) {
//     //                 setIsDistanceCalculated(prev => ({ ...prev, up: true }));
//     //             }
//     //         }

//     //         if (routeData.isRoundTrip && routeData.returnJourney) {
//     //             const returnJourney = routeData.returnJourney;
//     //             const returnOrigin = returnJourney.origin || {};
//     //             const returnDestination = returnJourney.destination || {};
//     //             const returnRouteDetails = returnJourney.routeDetails || {};
//     //             const returnEstimatedDuration = returnRouteDetails.estimatedDuration || {};

//     //             const transformedReturnStops = (returnJourney.intermediateStops || []).map(stop => ({
//     //                 city: stop.city,
//     //                 state: stop.state || '',
//     //                 address: stop.address || '',
//     //                 terminal: stop.terminal || '',
//     //                 arrivalTime: stop.arrivalTime,
//     //                 departureTime: stop.departureTime || '',
//     //                 stopType: stop.stopType || 'none',
//     //                 coordinates: stop.coordinates || { lat: 0, lng: 0 },
//     //                 distanceFromOrigin: stop.distanceFromOrigin || 0,
//     //                 manualDistFromPrev: stop.manualDistFromPrev || null,
//     //                 manualDistToNext: stop.manualDistToNext || null
//     //             }));

//     //             setEditForm(prev => ({
//     //                 ...prev,
//     //                 returnOriginCity: returnOrigin.city || '',
//     //                 returnOriginState: returnOrigin.state || '',
//     //                 returnOriginAddress: returnOrigin.address || '',
//     //                 returnOriginTerminal: returnOrigin.terminal || '',
//     //                 returnOriginDepTime: returnOrigin.departureTime || '',
//     //                 returnOriginCoords: returnOrigin.coordinates || { lat: 0, lng: 0 },
//     //                 returnDestCity: returnDestination.city || '',
//     //                 returnDestState: returnDestination.state || '',
//     //                 returnDestAddress: returnDestination.address || '',
//     //                 returnDestTerminal: returnDestination.terminal || '',
//     //                 returnDestArrTime: returnDestination.arrivalTime || '',
//     //                 returnDestCoords: returnDestination.coordinates || { lat: 0, lng: 0 },
//     //                 returnTotalDistance: returnRouteDetails.totalDistance || '',
//     //                 returnDurationHours: returnEstimatedDuration.hours || '',
//     //                 returnDurationMinutes: returnEstimatedDuration.minutes || '',
//     //                 returnIntermediateStops: transformedReturnStops
//     //             }));

//     //             if (transformedReturnStops.length > 0) {
//     //                 setDownStops(transformedReturnStops);
//     //                 if (transformedReturnStops.every(stop => stop.distanceFromOrigin > 0)) {
//     //                     setIsDistanceCalculated(prev => ({ ...prev, down: true }));
//     //                 }
//     //             }
//     //         }

//     //         if (routeData.isRoundTrip) {
//     //             setIsRoundTrip(true);
//     //             setActiveRouteTab('UP');
//     //         }

//     //         setShowEditModal(true);

//     //     } catch (err) {
//     //         console.error('Error fetching route for edit:', err);
//     //         toast.error('Failed to load route for editing');
//     //     }
//     // };

//     const handleEditRoute = async (route) => {
//         try {
//             const response = await getRouteById(route.id, token);
//             const routeData = response.data || route.fullData;

//             setEditingRoute(routeData);

//             const resolvedIsMultiTrip = routeData.isMultiTrip ||
//                 (routeData.origin?.timings && routeData.origin.timings.length > 0) ||
//                 (routeData.intermediateStops && routeData.intermediateStops.some(
//                     stop => stop.timings && stop.timings.length > 0
//                 ));

//             setIsMultiTrip(resolvedIsMultiTrip);

//             // Helper: sort timings by timeSlotSequence ascending — Trip 1 always first
//             const sortTimings = (timings) => {
//                 if (!timings || !Array.isArray(timings)) return [];
//                 return [...timings].sort((a, b) =>
//                     (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0)
//                 );
//             };

//             if (resolvedIsMultiTrip) {
//                 const resolvedNumberOfTrips = routeData.numberOfTrips ||
//                     routeData.origin?.timings?.length || 1;
//                 setNumberOfTrips(resolvedNumberOfTrips);

//                 const resolvedTimeSlots = sortTimings(routeData.origin?.timings || []).map(t => ({
//                     sequence: t.timeSlotSequence,
//                     departureTime: t.departureTime || '',
//                     arrivalTime: '',
//                     fareMultiplier: t.fareMultiplier || 1.0,
//                     isActive: t.isActive !== undefined ? t.isActive : true
//                 }));
//                 setTimeSlots(resolvedTimeSlots);

//                 if (routeData.destination?.timings?.length > 0) {
//                     setDestinationTimeSlots(
//                         sortTimings(routeData.destination.timings).map(t => ({
//                             sequence: t.timeSlotSequence,
//                             arrivalTime: t.arrivalTime || '',
//                             departureTime: ''
//                         }))
//                     );
//                     setDestinationNumberOfTrips(routeData.destination.timings.length);
//                 }
//             } else {
//                 setNumberOfTrips(1);
//                 setTimeSlots([]);
//             }

//             const origin = routeData.origin || {};
//             const destination = routeData.destination || {};
//             const routeDetails = routeData.routeDetails || {};
//             const estimatedDuration = routeDetails.estimatedDuration || {};

//             // Helper: transform stops preserving actual distances + sorted timings
//             const transformStops = (stops, isReturn = false) => {
//                 return (stops || []).map((stop, index, array) => {
//                     const actualDist = stop.distanceFromOrigin || 0;
//                     const prevStop = index > 0 ? array[index - 1] : null;
//                     const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

//                     let manualDistFromPrev = stop.manualDistFromPrev
//                         ? parseFloat(stop.manualDistFromPrev)
//                         : null;

//                     if (!manualDistFromPrev && actualDist > 0) {
//                         const calculated = parseFloat((actualDist - prevDist).toFixed(1));
//                         if (calculated > 0) manualDistFromPrev = calculated;
//                     }

//                     return {
//                         city: stop.city,
//                         state: stop.state || '',
//                         address: stop.address || '',
//                         terminal: stop.terminal || '',
//                         arrivalTime: stop.arrivalTime || '',
//                         departureTime: stop.departureTime || '',
//                         timings: sortTimings(stop.timings || []),
//                         stopType: stop.stopType || 'none',
//                         coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                         distanceFromOrigin: actualDist,
//                         manualDistFromPrev: manualDistFromPrev,
//                         manualDistToNext: stop.manualDistToNext
//                             ? parseFloat(stop.manualDistToNext)
//                             : null,
//                         isManualStop: stop.isManualStop === true ||
//                             !stop.coordinates ||
//                             (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)
//                     };
//                 });
//             };

//             const transformedStops = transformStops(routeData.intermediateStops, false);

//             // Calculate manual final leg for forward route
//             let forwardManualFinalLeg = '';
//             if (routeDetails.totalDistance && transformedStops.length > 0) {
//                 const lastStopDist = transformedStops[transformedStops.length - 1].distanceFromOrigin || 0;
//                 const calculated = routeDetails.totalDistance - lastStopDist;
//                 if (calculated > 0) {
//                     forwardManualFinalLeg = calculated.toFixed(1);
//                 }
//             }

//             setEditForm({
//                 routeNumber: routeData.routeNumber || '',
//                 routeName: routeData.routeName || '',
//                 localRouteName: routeData.localRouteName || '',
//                 isMultiTrip: resolvedIsMultiTrip,
//                 numberOfTrips: routeData.numberOfTrips ||
//                     (routeData.origin?.timings?.length || 1),
//                 timeSlots: routeData.timeSlots || [],
//                 originCity: origin.city || '',
//                 originState: origin.state || '',
//                 originAddress: origin.address || '',
//                 originTerminal: origin.terminal || '',
//                 originDepTime: origin.departureTime || '',
//                 originCoords: origin.coordinates || { lat: 0, lng: 0 },
//                 originTimings: sortTimings(origin.timings || []),
//                 destCity: destination.city || '',
//                 destState: destination.state || '',
//                 destAddress: destination.address || '',
//                 destTerminal: destination.terminal || '',
//                 destArrTime: destination.arrivalTime || '',
//                 destCoords: destination.coordinates || { lat: 0, lng: 0 },
//                 destTimings: sortTimings(destination.timings || []),
//                 totalDistance: routeDetails.totalDistance || '',
//                 durationHours: estimatedDuration.hours || '',
//                 durationMinutes: estimatedDuration.minutes || '',
//                 intermediateStops: transformedStops,
//                 isActive: routeData.isActive !== undefined ? routeData.isActive : true,
//                 isRoundTrip: routeData.isRoundTrip || false,
//                 returnJourney: routeData.returnJourney || null,
//                 // Add manual final leg for forward route
//                 upManualFinalLeg: forwardManualFinalLeg,
//                 // Add manual first leg if needed
//                 upManualFirstLeg: transformedStops.length > 0 && transformedStops[0].manualDistFromPrev
//                     ? String(transformedStops[0].manualDistFromPrev)
//                     : ''
//             });

//             if (transformedStops.length > 0) {
//                 setUpStops(transformedStops);
//                 if (transformedStops.every(stop => stop.distanceFromOrigin > 0)) {
//                     setIsDistanceCalculated(prev => ({ ...prev, up: true }));
//                 }
//             } else {
//                 setUpStops([]);
//             }

//             // Handle return journey
//             if (routeData.isRoundTrip && routeData.returnJourney) {
//                 const returnJourney = routeData.returnJourney;
//                 const returnOrigin = returnJourney.origin || {};
//                 const returnDestination = returnJourney.destination || {};
//                 const returnRouteDetails = returnJourney.routeDetails || {};
//                 const returnEstimatedDuration = returnRouteDetails.estimatedDuration || {};

//                 const transformedReturnStops = transformStops(returnJourney.intermediateStops, true);

//                 // Calculate manual final leg for return route
//                 let returnManualFinalLeg = '';
//                 if (returnRouteDetails.totalDistance && transformedReturnStops.length > 0) {
//                     const lastStopDist = transformedReturnStops[transformedReturnStops.length - 1].distanceFromOrigin || 0;
//                     const calculated = returnRouteDetails.totalDistance - lastStopDist;
//                     if (calculated > 0) {
//                         returnManualFinalLeg = calculated.toFixed(1);
//                     }
//                 }

//                 setEditForm(prev => ({
//                     ...prev,
//                     returnOriginCity: returnOrigin.city || '',
//                     returnOriginState: returnOrigin.state || '',
//                     returnOriginAddress: returnOrigin.address || '',
//                     returnOriginTerminal: returnOrigin.terminal || '',
//                     returnOriginDepTime: returnOrigin.departureTime || '',
//                     returnOriginCoords: returnOrigin.coordinates || { lat: 0, lng: 0 },
//                     returnOriginTimings: sortTimings(returnOrigin.timings || []),
//                     returnDestCity: returnDestination.city || '',
//                     returnDestState: returnDestination.state || '',
//                     returnDestAddress: returnDestination.address || '',
//                     returnDestTerminal: returnDestination.terminal || '',
//                     returnDestArrTime: returnDestination.arrivalTime || '',
//                     returnDestCoords: returnDestination.coordinates || { lat: 0, lng: 0 },
//                     returnDestTimings: sortTimings(returnDestination.timings || []),
//                     returnTotalDistance: returnRouteDetails.totalDistance || '',
//                     returnDurationHours: returnEstimatedDuration.hours || '',
//                     returnDurationMinutes: returnEstimatedDuration.minutes || '',
//                     returnIntermediateStops: transformedReturnStops,
//                     // Add manual final leg for return route
//                     returnManualFinalLeg: returnManualFinalLeg,
//                     // Add manual first leg for return route if needed
//                     returnManualFirstLeg: transformedReturnStops.length > 0 && transformedReturnStops[0].manualDistFromPrev
//                         ? String(transformedReturnStops[0].manualDistFromPrev)
//                         : ''
//                 }));

//                 if (transformedReturnStops.length > 0) {
//                     setDownStops(transformedReturnStops);
//                     if (transformedReturnStops.every(stop => stop.distanceFromOrigin > 0)) {
//                         setIsDistanceCalculated(prev => ({ ...prev, down: true }));
//                     }
//                 } else {
//                     setDownStops([]);
//                 }
//             } else {
//                 setDownStops([]);
//                 setEditForm(prev => ({
//                     ...prev,
//                     returnOriginCity: '',
//                     returnOriginState: '',
//                     returnOriginAddress: '',
//                     returnOriginTerminal: '',
//                     returnOriginDepTime: '',
//                     returnOriginCoords: null,
//                     returnOriginTimings: [],
//                     returnDestCity: '',
//                     returnDestState: '',
//                     returnDestAddress: '',
//                     returnDestTerminal: '',
//                     returnDestArrTime: '',
//                     returnDestCoords: null,
//                     returnDestTimings: [],
//                     returnTotalDistance: '',
//                     returnDurationHours: '',
//                     returnDurationMinutes: '',
//                     returnIntermediateStops: [],
//                     returnManualFinalLeg: '',
//                     returnManualFirstLeg: ''
//                 }));
//             }

//             // Load return timings for multi-trip if they exist in the response
//             if (resolvedIsMultiTrip && routeData.returnJourney) {
//                 if (routeData.returnJourney.origin?.timings) {
//                     setReturnOriginTimeSlots(
//                         sortTimings(routeData.returnJourney.origin.timings).map(t => ({
//                             sequence: t.timeSlotSequence,
//                             departureTime: t.departureTime || '',
//                             arrivalTime: ''
//                         }))
//                     );
//                 }
//                 if (routeData.returnJourney.destination?.timings) {
//                     setReturnDestTimeSlots(
//                         sortTimings(routeData.returnJourney.destination.timings).map(t => ({
//                             sequence: t.timeSlotSequence,
//                             arrivalTime: t.arrivalTime || '',
//                             departureTime: ''
//                         }))
//                     );
//                 }
//             }

//             if (routeData.isRoundTrip) {
//                 setIsRoundTrip(true);
//                 setActiveRouteTab('UP');
//             } else {
//                 setIsRoundTrip(false);
//                 setActiveRouteTab('UP');
//             }

//             setShowEditModal(true);

//         } catch (err) {
//             console.error('Error fetching route for edit:', err);
//             toast.error('Failed to load route for editing');
//         }
//     };

//     const handleUpdateRoute = async () => {
//         if (!editForm.routeName) {
//             toast.error('Route Name is required');
//             return;
//         }

//         setIsUpdatingRoute(true);

//         try {
//             // Determine if this is multi-trip from editForm or component state
//             const isMultiTripMode = editForm.isMultiTrip || isMultiTrip;

//             // Helper to sort timings
//             const sortTimings = (timings) => {
//                 if (!timings || !Array.isArray(timings)) return [];
//                 return [...timings].sort((a, b) =>
//                     (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0)
//                 );
//             };

//             // Helper function to clean stops for API (works for both forward and return)
//             const cleanStops = (list, stopType = 'forward') => {
//                 if (!list || !Array.isArray(list)) return [];

//                 return list.map((s, index) => {
//                     // Validate required fields
//                     if (!s.city) {
//                         throw new Error(`Stop ${index + 1} is missing city name`);
//                     }

//                     const stopObj = {
//                         sequence: index + 1,
//                         city: s.city,
//                         state: s.state || '',
//                         address: s.address || `${s.city}, ${s.state || 'India'}`,
//                         terminal: s.terminal || `${s.city} Bus Stand`,
//                         stopType: s.stopType || 'none',
//                         coordinates: s.coordinates || { lat: 0, lng: 0 },
//                         distanceFromOrigin: s.distanceFromOrigin || 0,
//                     };

//                     // Add manual distance fields if present
//                     if (s.manualDistFromPrev) stopObj.manualDistFromPrev = s.manualDistFromPrev;
//                     if (s.manualDistToNext) stopObj.manualDistToNext = s.manualDistToNext;
//                     if (s.isManualStop) stopObj.isManualStop = s.isManualStop;

//                     // CRITICAL FIX: Handle both single trip and multi-trip formats
//                     if (isMultiTripMode) {
//                         // For multi-trip: send timings array
//                         if (s.timings && s.timings.length > 0) {
//                             // Sort timings by timeSlotSequence before sending
//                             stopObj.timings = sortTimings(s.timings).map(timing => ({
//                                 timeSlotSequence: timing.timeSlotSequence,
//                                 arrivalTime: timing.arrivalTime || '',
//                                 departureTime: timing.departureTime || timing.arrivalTime || ''
//                             }));
//                         } else if (stopType === 'forward' && upStops.length > 0) {
//                             // If no timings, try to get from the stop object's timings property
//                             const existingTimings = s.timings || [];
//                             if (existingTimings.length > 0) {
//                                 stopObj.timings = sortTimings(existingTimings).map(timing => ({
//                                     timeSlotSequence: timing.timeSlotSequence,
//                                     arrivalTime: timing.arrivalTime || '',
//                                     departureTime: timing.departureTime || timing.arrivalTime || ''
//                                 }));
//                             } else {
//                                 // Create empty timings as fallback
//                                 const numTrips = editForm.numberOfTrips || 1;
//                                 stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({
//                                     timeSlotSequence: i + 1,
//                                     arrivalTime: s.arrivalTime || '',
//                                     departureTime: s.departureTime || s.arrivalTime || ''
//                                 }));
//                             }
//                         } else {
//                             const numTrips = editForm.numberOfTrips || 1;
//                             stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({
//                                 timeSlotSequence: i + 1,
//                                 arrivalTime: s.arrivalTime || '',
//                                 departureTime: s.departureTime || s.arrivalTime || ''
//                             }));
//                         }

//                         // Also include single-time fields for backward compatibility
//                         stopObj.arrivalTime = s.arrivalTime || (stopObj.timings[0]?.arrivalTime) || '';
//                         stopObj.departureTime = s.departureTime || (stopObj.timings[0]?.departureTime) || stopObj.arrivalTime;
//                     } else {
//                         // For single trip: use arrivalTime/departureTime
//                         if (!s.arrivalTime) {
//                             throw new Error(`Stop ${index + 1} (${s.city}) is missing arrival time`);
//                         }
//                         stopObj.arrivalTime = s.arrivalTime;
//                         stopObj.departureTime = s.departureTime || s.arrivalTime;
//                         stopObj.timings = [];
//                     }

//                     return stopObj;
//                 });
//             };

//             // Prepare origin data
//             const originData = {
//                 city: editForm.originCity,
//                 state: editForm.originState || '',
//                 address: editForm.originAddress || '',
//                 terminal: editForm.originTerminal || editForm.originCity + ' Terminal',
//                 coordinates: editForm.originCoords || { lat: 0, lng: 0 }
//             };

//             if (isMultiTripMode && editForm.originTimings && editForm.originTimings.length > 0) {
//                 originData.timings = sortTimings(editForm.originTimings).map(t => ({
//                     timeSlotSequence: t.timeSlotSequence,
//                     departureTime: t.departureTime,
//                     arrivalTime: t.arrivalTime || ''
//                 }));
//             } else {
//                 originData.departureTime = editForm.originDepTime;
//                 originData.timings = [];
//             }

//             // Prepare destination data
//             const destData = {
//                 city: editForm.destCity,
//                 state: editForm.destState || '',
//                 address: editForm.destAddress || '',
//                 terminal: editForm.destTerminal || editForm.destCity + ' Terminal',
//                 coordinates: editForm.destCoords || { lat: 0, lng: 0 },
//                 distanceFromOrigin: parseFloat(editForm.totalDistance || 0)
//             };

//             if (isMultiTripMode && editForm.destTimings && editForm.destTimings.length > 0) {
//                 destData.timings = sortTimings(editForm.destTimings).map(t => ({
//                     timeSlotSequence: t.timeSlotSequence,
//                     arrivalTime: t.arrivalTime,
//                     departureTime: t.departureTime || ''
//                 }));
//             } else {
//                 destData.arrivalTime = editForm.destArrTime;
//                 destData.timings = [];
//             }

//             // Build update payload
//             const updatePayload = {
//                 routeName: editForm.routeName.trim(),
//                 localRouteName: editForm.localRouteName?.trim() || null,
//                 isMultiTrip: isMultiTripMode,
//                 numberOfTrips: editForm.numberOfTrips || 1,
//                 timeSlots: editForm.timeSlots || [],
//                 origin: originData,
//                 destination: destData,
//                 intermediateStops: cleanStops(upStops, 'forward'),
//                 routeDetails: {
//                     totalDistance: parseFloat(editForm.totalDistance || 0),
//                     estimatedDuration: {
//                         hours: parseInt(editForm.durationHours || 0, 10),
//                         minutes: parseInt(editForm.durationMinutes || 0, 10)
//                     }
//                 },
//                 isActive: editForm.isActive,
//                 isRoundTrip: editForm.isRoundTrip
//             };

//             // Add return journey data for round trips - CRITICAL FIX: preserve timings
//             if (editForm.isRoundTrip) {
//                 // Prepare return origin data (this is the destination from forward route)
//                 const returnOriginData = {
//                     city: editForm.returnOriginCity || editForm.destCity,
//                     state: editForm.returnOriginState || editForm.destState,
//                     address: editForm.returnOriginAddress || editForm.destAddress,
//                     terminal: editForm.returnOriginTerminal || editForm.destTerminal,
//                     coordinates: editForm.returnOriginCoords || editForm.destCoords || { lat: 0, lng: 0 }
//                 };

//                 // CRITICAL: Preserve return origin timings
//                 if (isMultiTripMode && editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0) {
//                     returnOriginData.timings = sortTimings(editForm.returnOriginTimings).map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         departureTime: t.departureTime,
//                         arrivalTime: t.arrivalTime || ''
//                     }));
//                 } else if (isMultiTripMode && originData.timings && originData.timings.length > 0) {
//                     // If no return origin timings, copy from forward origin (same departure times)
//                     returnOriginData.timings = originData.timings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         departureTime: t.departureTime,
//                         arrivalTime: ''
//                     }));
//                 } else {
//                     returnOriginData.departureTime = editForm.returnOriginDepTime;
//                     returnOriginData.timings = [];
//                 }

//                 // Prepare return destination data (this is the origin from forward route)
//                 const returnDestData = {
//                     city: editForm.returnDestCity || editForm.originCity,
//                     state: editForm.returnDestState || editForm.originState,
//                     address: editForm.returnDestAddress || editForm.originAddress,
//                     terminal: editForm.returnDestTerminal || editForm.originTerminal,
//                     coordinates: editForm.returnDestCoords || editForm.originCoords || { lat: 0, lng: 0 },
//                     distanceFromOrigin: parseFloat(editForm.returnTotalDistance || 0)
//                 };

//                 // CRITICAL: Preserve return destination timings
//                 if (isMultiTripMode && editForm.returnDestTimings && editForm.returnDestTimings.length > 0) {
//                     returnDestData.timings = sortTimings(editForm.returnDestTimings).map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         arrivalTime: t.arrivalTime,
//                         departureTime: t.departureTime || ''
//                     }));
//                 } else if (isMultiTripMode && destData.timings && destData.timings.length > 0) {
//                     // If no return destination timings, copy from forward destination (same arrival times)
//                     returnDestData.timings = destData.timings.map(t => ({
//                         timeSlotSequence: t.timeSlotSequence,
//                         arrivalTime: t.arrivalTime,
//                         departureTime: ''
//                     }));
//                 } else {
//                     returnDestData.arrivalTime = editForm.returnDestArrTime;
//                     returnDestData.timings = [];
//                 }

//                 // CRITICAL FIX: Clean return stops while preserving their timings
//                 // Use downStops directly as they contain the timings from editForm
//                 const cleanedReturnStops = downStops.map((stop, index) => {
//                     const stopObj = {
//                         sequence: index + 1,
//                         city: stop.city,
//                         state: stop.state || '',
//                         address: stop.address || `${stop.city}, ${stop.state || 'India'}`,
//                         terminal: stop.terminal || `${stop.city} Bus Stand`,
//                         stopType: stop.stopType || 'none',
//                         coordinates: stop.coordinates || { lat: 0, lng: 0 },
//                         distanceFromOrigin: stop.distanceFromOrigin || 0,
//                     };

//                     if (stop.manualDistFromPrev) stopObj.manualDistFromPrev = stop.manualDistFromPrev;
//                     if (stop.manualDistToNext) stopObj.manualDistToNext = stop.manualDistToNext;
//                     if (stop.isManualStop) stopObj.isManualStop = stop.isManualStop;

//                     // CRITICAL: Preserve timings exactly as they are for return stops
//                     if (isMultiTripMode) {
//                         // First try to get timings from the stop object
//                         if (stop.timings && stop.timings.length > 0) {
//                             stopObj.timings = sortTimings(stop.timings).map(timing => ({
//                                 timeSlotSequence: timing.timeSlotSequence,
//                                 arrivalTime: timing.arrivalTime || '',
//                                 departureTime: timing.departureTime || timing.arrivalTime || ''
//                             }));
//                         }
//                         // Then try from editForm.returnIntermediateStops
//                         else if (editForm.returnIntermediateStops && editForm.returnIntermediateStops[index]?.timings) {
//                             const savedTimings = editForm.returnIntermediateStops[index].timings;
//                             if (savedTimings && savedTimings.length > 0) {
//                                 stopObj.timings = sortTimings(savedTimings).map(timing => ({
//                                     timeSlotSequence: timing.timeSlotSequence,
//                                     arrivalTime: timing.arrivalTime || '',
//                                     departureTime: timing.departureTime || timing.arrivalTime || ''
//                                 }));
//                             } else {
//                                 const numTrips = editForm.numberOfTrips || 1;
//                                 stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({
//                                     timeSlotSequence: i + 1,
//                                     arrivalTime: stop.arrivalTime || '',
//                                     departureTime: stop.departureTime || stop.arrivalTime || ''
//                                 }));
//                             }
//                         } else {
//                             const numTrips = editForm.numberOfTrips || 1;
//                             stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({
//                                 timeSlotSequence: i + 1,
//                                 arrivalTime: stop.arrivalTime || '',
//                                 departureTime: stop.departureTime || stop.arrivalTime || ''
//                             }));
//                         }

//                         stopObj.arrivalTime = stop.arrivalTime || (stopObj.timings[0]?.arrivalTime) || '';
//                         stopObj.departureTime = stop.departureTime || (stopObj.timings[0]?.departureTime) || stopObj.arrivalTime;
//                     } else {
//                         if (!stop.arrivalTime) {
//                             throw new Error(`Return stop ${index + 1} (${stop.city}) is missing arrival time`);
//                         }
//                         stopObj.arrivalTime = stop.arrivalTime;
//                         stopObj.departureTime = stop.departureTime || stop.arrivalTime;
//                         stopObj.timings = [];
//                     }

//                     return stopObj;
//                 });

//                 updatePayload.returnOrigin = returnOriginData;
//                 updatePayload.returnDestination = returnDestData;
//                 updatePayload.returnIntermediateStops = cleanedReturnStops;
//                 updatePayload.returnRouteDetails = {
//                     totalDistance: parseFloat(editForm.returnTotalDistance || 0),
//                     estimatedDuration: {
//                         hours: parseInt(editForm.returnDurationHours || 0, 10),
//                         minutes: parseInt(editForm.returnDurationMinutes || 0, 10)
//                     }
//                 };
//             }

//             console.log("Update Payload with preserved timings:", JSON.stringify(updatePayload, null, 2));

//             const response = await updateRoute(editingRoute._id, updatePayload, token);

//             if (response.success) {
//                 toast.success('Route updated successfully!');
//                 setShowEditModal(false);
//                 setEditingRoute(null);
//                 setEditForm({});
//                 fetchRoutes();
//             } else {
//                 throw new Error(response.message || 'Failed to update route');
//             }
//         } catch (err) {
//             console.error('Error updating route:', err);
//             toast.error(err.message || 'Failed to update route');
//         } finally {
//             setIsUpdatingRoute(false);
//         }
//     };

//     const handleEditOriginSelect = (location) => {
//         setEditForm(prev => ({
//             ...prev,
//             originCity: location.city || location.name || '',
//             originState: location.state || '',
//             originAddress: location.address || '',
//             originCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//     };

//     const handleEditDestSelect = (location) => {
//         setEditForm(prev => ({
//             ...prev,
//             destCity: location.city || location.name || '',
//             destState: location.state || '',
//             destAddress: location.address || '',
//             destCoords: location.coordinates || { lat: 0, lng: 0 }
//         }));
//     };

//     const handleToggleStatus = async (routeId, currentStatus) => {
//         const newStatus = !currentStatus;
//         const action = newStatus ? 'activate' : 'deactivate';

//         if (window.confirm(`Are you sure you want to ${action} this route?`)) {
//             try {
//                 const response = await toggleRouteStatus(routeId, newStatus, token);

//                 if (response.success) {
//                     setRoutes(prevRoutes =>
//                         prevRoutes.map(route =>
//                             route.id === routeId ? {
//                                 ...route,
//                                 isActive: newStatus,
//                                 status: newStatus ? 'Active' : 'Inactive'
//                             } : route
//                         )
//                     );
//                     toast.success(`Route ${action}d successfully!`);
//                 } else {
//                     throw new Error(response.message || `Failed to ${action} route`);
//                 }
//             } catch (err) {
//                 console.error(`Error ${action}ing route:`, err);
//                 toast.error(`Failed to ${action} route`);
//             }
//         }
//     };

//     const saveInsertedStop = () => {
//         if (!insertStopForm.city) {
//             toast.error('City is required');
//             return;
//         }
//         if (!insertStopForm.arrivalTime) {
//             toast.error('Arrival time is required');
//             return;
//         }
//         const isManualLocation = insertStopForm.isManualStop;
//         if (isManualLocation && (!insertStopForm.manualDistFromPrev || parseFloat(insertStopForm.manualDistFromPrev) <= 0)) {
//             toast.error('For manual stops, please provide distance from previous stop');
//             return;
//         }

//         let stopType = 'none';
//         if (insertStopForm.isBoarding && insertStopForm.isDropping) stopType = 'both';
//         else if (insertStopForm.isBoarding) stopType = 'boarding';
//         else if (insertStopForm.isDropping) stopType = 'dropping';

//         const type = activeRouteTab === 'UP' ? 'up' : 'down';
//         const currentStops = type === 'up' ? [...upStops] : [...downStops];

//         let manualDistFromPrev = isManualLocation ? parseFloat(insertStopForm.manualDistFromPrev) : null;
//         let manualDistToNext = insertStopForm.manualDistToNext ? parseFloat(insertStopForm.manualDistToNext) : null;

//         // Calculate distance from origin
//         let distanceFromOrigin = 0;
//         if (pendingInsertIndex > 0 && currentStops[pendingInsertIndex - 1]) {
//             distanceFromOrigin = (currentStops[pendingInsertIndex - 1].distanceFromOrigin || 0) + (manualDistFromPrev || 0);
//         } else {
//             distanceFromOrigin = manualDistFromPrev || 0;
//         }

//         const newStop = {
//             city: insertStopForm.city,
//             state: insertStopForm.state || '',
//             address: insertStopForm.address || `${insertStopForm.city}, ${insertStopForm.state || 'India'}`,
//             terminal: insertStopForm.terminal || `${insertStopForm.city} Bus Stand`,
//             arrivalTime: insertStopForm.arrivalTime,
//             departureTime: insertStopForm.departureTime || insertStopForm.arrivalTime,
//             stopType,
//             coordinates: isManualLocation ? { lat: 0, lng: 0 } : null,
//             manualDistFromPrev,
//             manualDistToNext,
//             distanceFromOrigin,
//             isManualStop: isManualLocation
//         };

//         currentStops.splice(pendingInsertIndex, 0, newStop);
//         setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

//         if (type === 'up') {
//             setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         } else {
//             setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
//         }

//         toast.success(`Stop "${insertStopForm.city}" inserted at position ${pendingInsertIndex + 1}`);
//         setShowStopInsertModal(false);
//         setPendingInsertIndex(null);
//         setInsertCitySuggestions([]);
//         setShowInsertCityDropdown(false);
//     };

//     const handleDeleteRoute = async (routeId) => {
//         if (window.confirm('Are you sure you want to delete this route?')) {
//             try {
//                 const response = await deleteRoute(routeId, token);

//                 if (response.success) {
//                     setRoutes(prevRoutes => prevRoutes.filter(route => route.id !== routeId));
//                     setTotalRoutes(prev => prev - 1);
//                     toast.success('Route deleted successfully!');
//                 } else {
//                     throw new Error(response.message || 'Failed to delete route');
//                 }
//             } catch (err) {
//                 console.error('Error deleting route:', err);
//                 toast.error('Failed to delete route');
//             }
//         }
//     };

//     const renderInsertButton = (idx, type = 'up') => {
//         const isOpen = inlineInsertIndex === idx;
//         const stops = getActiveStops();

//         return (
//             <div key={`insert-wrap-${idx}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px 0' }}>
//                 <div style={{ width: 2, height: 16, background: 'rgba(0,0,0,.12)', flexShrink: 0 }} />

//                 <button
//                     onClick={() => {
//                         if (isOpen) {
//                             setInlineInsertIndex(null);
//                             setInlineInsertCitySuggestions([]);
//                             setShowInlineInsertDropdown(false);
//                         } else {
//                             // Get default state from previous stop
//                             let defaultState = '';
//                             const currentStops = type === 'up' ? upStops : downStops;
//                             if (idx > 0 && currentStops[idx - 1]?.state) {
//                                 defaultState = currentStops[idx - 1].state;
//                             } else if (newRoute.upOriginState) {
//                                 defaultState = newRoute.upOriginState;
//                             }

//                             setInlineInsertForm({
//                                 city: '', state: defaultState, address: '', terminal: '',
//                                 arrivalTime: '', departureTime: '',
//                                 isBoarding: false, isDropping: false,
//                                 manualDistFromPrev: '', manualDistToNext: '',
//                                 isManual: true,
//                                 stopType: 'none'
//                             });
//                             setInlineInsertCitySuggestions([]);
//                             setShowInlineInsertDropdown(false);
//                             setInlineInsertIndex(idx);
//                         }
//                     }}
//                     style={{
//                         display: 'flex', alignItems: 'center', gap: 6,
//                         padding: '5px 14px', borderRadius: 999,
//                         border: `1.5px ${isOpen ? 'solid' : 'dashed'} ${isOpen ? '#378add' : 'rgba(0,0,0,.25)'}`,
//                         background: isOpen ? '#e6f1fb' : 'var(--color-background-primary, #fff)',
//                         fontSize: 12, fontWeight: 500,
//                         color: isOpen ? '#185fa5' : 'var(--color-text-secondary, #666)',
//                         cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all .15s'
//                     }}
//                 >
//                     <span style={{ fontSize: 15 }}>{isOpen ? '✕' : '+'}</span>
//                     {isOpen ? 'Cancel insert' : 'Insert stop here'}
//                 </button>

//                 <div style={{ width: 2, height: isOpen ? 0 : 16, background: 'rgba(0,0,0,.12)', flexShrink: 0 }} />

//                 {isOpen && renderInlineInsertPanel(idx)}
//             </div>
//         );
//     };

//     // Stats
//     const activeRoutes = routes.filter(r => r.isActive).length;
//     const totalDistance = routes.reduce((sum, route) => sum + (parseInt(route.distance) || 0), 0);
//     const totalStops = routes.reduce((sum, route) => sum + (parseInt(route.stops) || 0), 0);

//     if (loading && routes.length === 0) {
//         return (
//             <div className="management-page">
//                 <div className="page-header">
//                     <div className="skeleton-header-title"></div>
//                     <div className="header-actions">
//                         <div className="skeleton-search"></div>
//                         <div className="skeleton-button"></div>
//                         <div className="skeleton-button"></div>
//                     </div>
//                 </div>

//                 <div className="stats-cards">
//                     {[1, 2, 3, 4].map((i) => (
//                         <SkeletonStatsCard key={i} />
//                     ))}
//                 </div>

//                 <SkeletonTable />

//                 <div className="pagination-container">
//                     <div className="skeleton-pagination-info"></div>
//                     <div className="skeleton-pagination-controls"></div>
//                 </div>
//             </div>
//         );
//     }

//     return (
//         <div className="management-page">
//             <div className="page-header">
//                 <h1>Route Management</h1>
//                 <div className="header-actions">
//                     <div className="filter-group">
//                         <input
//                             type="text"
//                             placeholder="Search routes by name..."
//                             className="search-input"
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                     </div>
//                     <div className="filter-group">
//                         <div className="location-input-container" style={{ minWidth: '200px' }}>
//                             <input
//                                 type="text"
//                                 placeholder="Filter by Origin City"
//                                 className="search-input"
//                                 value={filterOrigin}
//                                 onChange={(e) => {
//                                     setFilterOrigin(e.target.value);
//                                     searchCitySuggestions(e.target.value, 'origin');
//                                 }}
//                                 onFocus={() => filterOrigin && setShowOriginSuggestions(true)}
//                                 onBlur={() => setTimeout(() => setShowOriginSuggestions(false), 200)}
//                             />
//                             {showOriginSuggestions && originSuggestions.length > 0 && (
//                                 <div className="location-suggestions" style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000 }}>
//                                     {originSuggestions.map((suggestion, idx) => (
//                                         <div
//                                             key={idx}
//                                             className="suggestion-item"
//                                             onClick={() => {
//                                                 setFilterOrigin(suggestion.city);
//                                                 setShowOriginSuggestions(false);
//                                                 setCurrentPage(1);
//                                             }}
//                                         >
//                                             {suggestion.city}
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                     <div className="filter-group">
//                         <div className="location-input-container" style={{ minWidth: '200px' }}>
//                             <input
//                                 type="text"
//                                 placeholder="Filter by Destination City"
//                                 className="search-input"
//                                 value={filterDestination}
//                                 onChange={(e) => {
//                                     setFilterDestination(e.target.value);
//                                     searchCitySuggestions(e.target.value, 'destination');
//                                 }}
//                                 onFocus={() => filterDestination && setShowDestSuggestions(true)}
//                                 onBlur={() => setTimeout(() => setShowDestSuggestions(false), 200)}
//                             />
//                             {showDestSuggestions && destSuggestions.length > 0 && (
//                                 <div className="location-suggestions" style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000 }}>
//                                     {destSuggestions.map((suggestion, idx) => (
//                                         <div
//                                             key={idx}
//                                             className="suggestion-item"
//                                             onClick={() => {
//                                                 setFilterDestination(suggestion.city);
//                                                 setShowDestSuggestions(false);
//                                                 setCurrentPage(1);
//                                             }}
//                                         >
//                                             {suggestion.city}
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                     <button className="refresh-btn" onClick={fetchRoutes}>
//                         Refresh
//                     </button>
//                     <button className="add-btn" onClick={() => setShowAddModal(true)}>
//                         + Add Route
//                     </button>
//                 </div>
//             </div>

//             <div className="stats-cards">
//                 <div className="stat-card">
//                     <h3>Total Routes</h3>
//                     <p>{totalRoutes}</p>
//                     <span>All registered routes</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>Active Routes</h3>
//                     <p>{activeRoutes}</p>
//                     <span>Currently active</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>Total Stops</h3>
//                     <p>{totalStops}</p>
//                     <span>Across all routes</span>
//                 </div>
//                 <div className="stat-card">
//                     <h3>Total Distance</h3>
//                     <p>{totalDistance} km</p>
//                     <span>Covered by all routes</span>
//                 </div>
//             </div>

//             <div className="table-container">
//                 <table className="data-table">
//                     <thead>
//                         <tr>
//                             <th>No.</th>
//                             <th>Route Name</th>
//                             <th>Local Route Name</th>
//                             <th>Origin</th>
//                             <th>Destination</th>
//                             <th>Distance</th>
//                             <th>Stops</th>
//                             <th>Assigned Buses</th>
//                             <th>Type</th>
//                             <th>Status</th>
//                             <th>Actions</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {routes.map(route => (
//                             <tr key={route.id}>
//                                 <td>{route.serialNo}</td>
//                                 <td>{route.routeName}</td>
//                                 <td>{route.localRouteName || '—'}</td>
//                                 <td>
//                                     <div>
//                                         <div>{route.originCity}</div>
//                                         <div style={{ fontSize: '12px', color: '#666' }}>
//                                             {route.departureTime}
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>
//                                     <div>
//                                         <div>{route.destinationCity}</div>
//                                         <div style={{ fontSize: '12px', color: '#666' }}>
//                                             {route.arrivalTime}
//                                         </div>
//                                     </div>
//                                 </td>
//                                 <td>{route.distance} km</td>
//                                 <td>{route.stops}</td>
//                                 <td>

//                                     {route.associatedBuses && route.associatedBuses.length > 0 ? (
//                                         <div className="buses-container">
//                                             {route.associatedBuses.map((bus, idx) => {
//                                                 console.log("Rendering bus:", bus);
//                                                 console.log("Bus approval status:", bus.approvalStatus);
//                                                 console.log("Bus isActive:", bus.isActive);

//                                                 const isPending = !bus.isActive && (bus.approvalStatus === 'pending' || !bus.approvalStatus);
//                                                 console.log("Is pending?", isPending);

//                                                 return (
//                                                     <div key={bus.busId || idx} className="bus-item">
//                                                         <div className="bus-info-wrapper">
//                                                             <span className="bus-name">{bus.busName}</span>
//                                                             <span className="bus-number">({bus.busNumber})</span>
//                                                             {bus.localRouteName && (
//                                                                 <span className="bus-local-name"> - {bus.localRouteName}</span>
//                                                             )}
//                                                             <span className={`bus-status-badge ${bus.isActive ? 'active' : (bus.approvalStatus === 'pending' ? 'pending' : 'inactive')}`}>
//                                                                 {bus.isActive ? 'Active' : (bus.approvalStatus === 'pending' ? 'Pending Approval' : 'Inactive')}
//                                                             </span>
//                                                         </div>
//                                                         {isPending && (
//                                                             <button
//                                                                 className="activate-bus-inline"
//                                                                 onClick={() => handleActivateSingleBus(bus)}
//                                                                 style={{
//                                                                     marginLeft: '10px',
//                                                                     padding: '4px 12px',
//                                                                     fontSize: '11px',
//                                                                     backgroundColor: '#20c997',
//                                                                     color: 'white',
//                                                                     border: 'none',
//                                                                     borderRadius: '4px',
//                                                                     cursor: 'pointer'
//                                                                 }}
//                                                             >
//                                                                 Activate
//                                                             </button>
//                                                         )}
//                                                     </div>
//                                                 );
//                                             })}
//                                         </div>
//                                     ) : (
//                                         <span className="no-buses">No buses assigned</span>
//                                     )}
//                                 </td>
//                                 <td>
//                                     <span className={`route-type-badge ${route.isRoundTrip ? 'roundtrip' : 'oneway'}`}>
//                                         {route.isRoundTrip ? 'Round Trip' : 'One Way'}
//                                     </span>
//                                 </td>
//                                 <td>
//                                     <span className={`status-badge ${route.status.toLowerCase()}`}>
//                                         {route.status}
//                                     </span>
//                                 </td>
//                                 <td>
//                                     <div className="action-buttons">
//                                         <button
//                                             className="action-btn view"
//                                             onClick={() => handleViewRoute(route)}
//                                         >
//                                             View
//                                         </button>
//                                         <button
//                                             className="action-btn edit"
//                                             onClick={() => handleEditRoute(route)}
//                                             style={{ backgroundColor: '#17a2b8', color: 'white' }}
//                                         >
//                                             Edit
//                                         </button>
//                                         <button
//                                             className={`action-btn ${route.isActive ? 'deactivate' : 'activate'}`}
//                                             onClick={() => handleToggleStatus(route.id, route.isActive)}
//                                             style={{
//                                                 backgroundColor: route.isActive ? '#ffc107' : '#28a745',
//                                                 color: route.isActive ? '#000' : 'white'
//                                             }}
//                                         >
//                                             {route.isActive ? 'Deactivate' : 'Activate'}
//                                         </button>

//                                         {/* Activate Bus button for routes with pending buses */}
//                                         {route.associatedBuses && route.associatedBuses.some(bus => !bus.isActive && (bus.approvalStatus === 'pending' || !bus.approvalStatus)) && (
//                                             <button
//                                                 className="action-btn activate-bus"
//                                                 onClick={() => handleActivateBusFromRoute(route)}
//                                                 style={{ backgroundColor: '#20c997', color: 'white' }}
//                                                 title="Activate pending buses on this route"
//                                             >
//                                                 Activate Bus
//                                             </button>
//                                         )}

//                                         <button
//                                             className="action-btn delete"
//                                             onClick={() => handleDeleteRoute(route.id)}
//                                         >
//                                             Delete
//                                         </button>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Pagination */}
//             <div className="pagination-container">
//                 <div className="pagination-info">
//                     Showing {Math.min(pageSize, routes.length)} of {totalRoutes} routes
//                     (Page {currentPage} of {totalPages})
//                 </div>
//                 <div className="pagination-controls">
//                     <button
//                         className="pagination-btn"
//                         onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
//                         disabled={currentPage === 1}
//                     >
//                         Previous
//                     </button>

//                     <div className="page-numbers">
//                         {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//                             let pageNumber;
//                             if (totalPages <= 5) {
//                                 pageNumber = i + 1;
//                             } else if (currentPage <= 3) {
//                                 pageNumber = i + 1;
//                             } else if (currentPage >= totalPages - 2) {
//                                 pageNumber = totalPages - 4 + i;
//                             } else {
//                                 pageNumber = currentPage - 2 + i;
//                             }

//                             return (
//                                 <button
//                                     key={pageNumber}
//                                     className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                                     onClick={() => setCurrentPage(pageNumber)}
//                                 >
//                                     {pageNumber}
//                                 </button>
//                             );
//                         })}
//                     </div>

//                     <button
//                         className="pagination-btn"
//                         onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
//                         disabled={currentPage === totalPages || totalPages === 0}
//                     >
//                         Next
//                     </button>
//                 </div>
//             </div>

//             {/* Add Route Modal */}
//             {showAddModal && (
//                 <div className="modal-overlay add-route-modal" onClick={() => setShowAddModal(false)}>
//                     <div className="modal-content add-route-content" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">
//                             <h3>Create New Route</h3>
//                             <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             {/* Round Trip Toggle */}
//                             <div className="round-trip-toggle">
//                                 <label className="checkbox-container">
//                                     <input
//                                         type="checkbox"
//                                         checked={isRoundTrip}
//                                         onChange={toggleRoundTrip}
//                                         className="checkbox-input"
//                                     />
//                                     <span className="checkbox-label">Round Trip (Main + Return Routes)</span>
//                                 </label>
//                             </div>

//                             {/* Tabs for Round Trip */}
//                             {isRoundTrip && (
//                                 <div className="route-tabs">
//                                     <button
//                                         className={`route-tab ${activeRouteTab === 'UP' ? 'active' : ''}`}
//                                         onClick={() => handleTabSwitch('UP')}
//                                     >
//                                         UP (Main) Route
//                                     </button>
//                                     <button
//                                         className={`route-tab ${activeRouteTab === 'DOWN' ? 'active' : ''}`}
//                                         onClick={() => handleTabSwitch('DOWN')}
//                                     >
//                                         DOWN (Return) Route
//                                     </button>
//                                     <button
//                                         className="route-tab clear-tab"
//                                         onClick={clearCurrentRoute}
//                                         style={{
//                                             marginLeft: 'auto',
//                                             backgroundColor: '#dc3545',
//                                             color: 'white',
//                                             border: 'none',
//                                             padding: '6px 16px',
//                                             borderRadius: '4px',
//                                             fontSize: '13px',
//                                             fontWeight: '500',
//                                             cursor: 'pointer',
//                                             transition: 'background-color 0.2s'
//                                         }}
//                                         onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#c82333'}
//                                         onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#dc3545'}
//                                         title={`Clear all data for ${activeRouteTab} route`}
//                                     >
//                                         ✕ Clear {activeRouteTab} Route
//                                     </button>
//                                 </div>
//                             )}

//                             <div className="form-sections">
//                                 {/* Route Identity — Master Route Dropdown ONLY */}
//                                 {/* Route Identity — Master Route Dropdown ONLY */}
//                                 <div className="form-section">
//                                     <h4>Route Identity</h4>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Select Master Route *</label>
//                                             <MasterRouteSelector
//                                                 token={token}
//                                                 value={selectedMasterRouteFromDropdown}
//                                                 onChange={(masterRoute) => {
//                                                     setSelectedMasterRouteFromDropdown(masterRoute);
//                                                     if (masterRoute) {
//                                                         autoFillFromMasterRoute(masterRoute);
//                                                     } else {
//                                                         setNewRoute(prev => ({ ...prev, routeName: '' }));
//                                                     }
//                                                 }}
//                                                 onAddNew={handleAddNewMasterRoute}
//                                             />
//                                             <small className="helper-text">
//                                                 {selectedMasterRouteFromDropdown
//                                                     ? `✓ Route name set to: "${selectedMasterRouteFromDropdown.masterRouteName}"`
//                                                     : 'Select a master route to auto-fill all route details, or click + New Master Route to create one first'}
//                                             </small>
//                                         </div>
//                                     </div>
//                                     {/* ADD LOCAL ROUTE NAME FIELD */}
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Local Route Name</label>
//                                             <input
//                                                 type="text"
//                                                 value={newRoute.localRouteName}
//                                                 onChange={(e) => setNewRoute(prev => ({ ...prev, localRouteName: e.target.value }))}
//                                                 placeholder="Enter local/regional name for this route (e.g., 'City Express', 'Night Special')"
//                                                 className="form-input"
//                                             />
//                                             <small className="helper-text">This name will be displayed to passengers as the local route identifier</small>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Origin Section */}
//                                 <div className="form-section">
//                                     <h4>{activeRouteTab === 'UP' ? 'Origin *' : 'Return Origin (Locked to Main Dest)'}</h4>

//                                     {activeRouteTab === 'UP' ? (
//                                         <>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Search Location</label>
//                                                     <LocationInput
//                                                         value={newRoute.upOriginCity}
//                                                         onChange={(value) => setNewRoute(prev => ({ ...prev, upOriginCity: value }))}
//                                                         onLocationSelect={handleSelectOrigin}
//                                                         placeholder="Search origin city or address..."
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Address</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upOriginAddress}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginAddress: e.target.value }))}
//                                                         placeholder="Full address"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>State</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upOriginState}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginState: e.target.value }))}
//                                                         placeholder="State"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Terminal</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upOriginTerminal}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginTerminal: e.target.value }))}
//                                                         placeholder="Terminal name"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                             </div>
//                                             {/* <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Departure Time *</label>
//                                                     <TimePicker
//                                                         value={newRoute.upOriginDepTime}
//                                                         onChange={(value) => {
//                                                             setNewRoute(prev => ({ ...prev, upOriginDepTime: value }));
//                                                             const dur = getDuration(value, newRoute.upDestArrTime);
//                                                             setNewRoute(prev => ({
//                                                                 ...prev,
//                                                                 upDurationHours: dur.hours,
//                                                                 upDurationMinutes: dur.minutes
//                                                             }));
//                                                         }}
//                                                         placeholder="Select time"
//                                                     />
//                                                 </div>
//                                             </div> */}
//                                             {/* Multi-trip toggle */}
//                                             {/* Multi-trip toggle for Origin - only departure time */}
//                                             <div className="form-row">
//                                                 <Checkbox
//                                                     label="Multi-Trip Route (Multiple departures per day)"
//                                                     checked={isMultiTrip}
//                                                     onChange={() => {
//                                                         setIsMultiTrip(!isMultiTrip);
//                                                         if (!isMultiTrip && timeSlots.length === 0) {
//                                                             // Initialize with one time slot (only departure time for origin)
//                                                             setTimeSlots([{
//                                                                 sequence: 1,
//                                                                 departureTime: newRoute.upOriginDepTime || '',
//                                                                 arrivalTime: '',  // No arrival time for origin
//                                                                 fareMultiplier: 1.0,
//                                                                 isActive: true
//                                                             }]);
//                                                             setNumberOfTrips(1);
//                                                         }
//                                                     }}
//                                                 />
//                                             </div>

//                                             {isMultiTrip ? (
//                                                 <TimeSlotManager
//                                                     timeSlots={timeSlots}
//                                                     onTimeSlotsChange={setTimeSlots}
//                                                     numberOfTrips={numberOfTrips}
//                                                     onNumberOfTripsChange={setNumberOfTrips}
//                                                     disabled={false}
//                                                     showDeparture={true}   // Only show departure time
//                                                     showArrival={false}    // No arrival time for origin
//                                                     labelPrefix="Trip"
//                                                 />
//                                             ) : (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Departure Time *</label>
//                                                         <TimePicker
//                                                             value={newRoute.upOriginDepTime}
//                                                             onChange={(value) => {
//                                                                 setNewRoute(prev => ({ ...prev, upOriginDepTime: value }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </>
//                                     ) : (
//                                         <div className="locked-fields">
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upDestCity || 'Auto-filled from Main Destination'}
//                                                         className="form-input locked"
//                                                         disabled
//                                                     />
//                                                 </div>
//                                             </div>
//                                             {isMultiTrip ? (
//                                                 <TimeSlotManager
//                                                     timeSlots={returnOriginTimeSlots}
//                                                     onTimeSlotsChange={(slots) => {
//                                                         setReturnOriginTimeSlots(slots);
//                                                     }}
//                                                     numberOfTrips={returnOriginTimeSlots.length || numberOfTrips}
//                                                     onNumberOfTripsChange={(count) => {
//                                                         // CRITICAL: Initialize all time slots immediately when count changes
//                                                         const newSlots = Array.from({ length: count }, (_, i) => ({
//                                                             sequence: i + 1,
//                                                             departureTime: returnOriginTimeSlots[i]?.departureTime || '',
//                                                             arrivalTime: '',
//                                                             fareMultiplier: 1.0,
//                                                             isActive: true
//                                                         }));
//                                                         setReturnOriginTimeSlots(newSlots);
//                                                     }}
//                                                     disabled={false}
//                                                     showDeparture={true}
//                                                     showArrival={false}
//                                                     labelPrefix="Return Trip"
//                                                 />
//                                             ) : null}

//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Destination Section */}
//                                 <div className="form-section">
//                                     <h4>{activeRouteTab === 'UP' ? 'Destination *' : 'Return Destination (Locked to Main Origin)'}</h4>

//                                     {activeRouteTab === 'UP' ? (
//                                         <>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Search Location</label>
//                                                     <LocationInput
//                                                         value={newRoute.upDestCity}
//                                                         onChange={(value) => setNewRoute(prev => ({ ...prev, upDestCity: value }))}
//                                                         onLocationSelect={handleSelectDest}
//                                                         placeholder="Search destination city or address..."
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Address</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upDestAddress}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upDestAddress: e.target.value }))}
//                                                         placeholder="Full address"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>State</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upDestState}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upDestState: e.target.value }))}
//                                                         placeholder="State"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Terminal</label>
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upDestTerminal}
//                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, upDestTerminal: e.target.value }))}
//                                                         placeholder="Terminal name"
//                                                         className="form-input"
//                                                     />
//                                                 </div>
//                                             </div>
//                                             {/* <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Arrival Time *</label>
//                                                     <TimePicker
//                                                         value={newRoute.upDestArrTime}
//                                                         onChange={(value) => {
//                                                             setNewRoute(prev => ({ ...prev, upDestArrTime: value }));
//                                                             const dur = getDuration(newRoute.upOriginDepTime, value);
//                                                             setNewRoute(prev => ({
//                                                                 ...prev,
//                                                                 upDurationHours: dur.hours,
//                                                                 upDurationMinutes: dur.minutes
//                                                             }));
//                                                         }}
//                                                         placeholder="Select time"
//                                                     />
//                                                 </div>
//                                             </div> */}
//                                             {isMultiTrip ? (
//                                                 <TimeSlotManager
//                                                     timeSlots={destinationTimeSlots}
//                                                     onTimeSlotsChange={setDestinationTimeSlots}
//                                                     numberOfTrips={destinationNumberOfTrips}
//                                                     onNumberOfTripsChange={setDestinationNumberOfTrips}
//                                                     disabled={false}
//                                                     showDeparture={false}   // No departure time for destination
//                                                     showArrival={true}      // Only show arrival time
//                                                     labelPrefix="Trip"
//                                                 />
//                                             ) : (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Arrival Time *</label>
//                                                         <TimePicker
//                                                             value={newRoute.upDestArrTime}
//                                                             onChange={(value) => {
//                                                                 setNewRoute(prev => ({ ...prev, upDestArrTime: value }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </>
//                                     ) : (
//                                         <div className="locked-fields">
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <input
//                                                         type="text"
//                                                         value={newRoute.upOriginCity || 'Auto-filled from Main Origin'}
//                                                         className="form-input locked"
//                                                         disabled
//                                                     />
//                                                 </div>
//                                             </div>

//                                             {/* <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Return Arrival Time *</label>
//                                                     <TimePicker
//                                                         value={newRoute.downDestArrTime}
//                                                         onChange={(value) => {
//                                                             setNewRoute(prev => ({ ...prev, downDestArrTime: value }));
//                                                             const dur = getDuration(newRoute.downOriginDepTime, value);
//                                                             setNewRoute(prev => ({
//                                                                 ...prev,
//                                                                 downDurationHours: dur.hours,
//                                                                 downDurationMinutes: dur.minutes
//                                                             }));
//                                                         }}
//                                                         placeholder="Select time"
//                                                     />
//                                                 </div>
//                                             </div> */}


//                                             {isMultiTrip ? (
//                                                 <TimeSlotManager
//                                                     timeSlots={returnDestTimeSlots}
//                                                     onTimeSlotsChange={(slots) => {
//                                                         setReturnDestTimeSlots(slots);
//                                                     }}
//                                                     numberOfTrips={returnDestTimeSlots.length || numberOfTrips}
//                                                     onNumberOfTripsChange={(count) => {
//                                                         // CRITICAL: Initialize all time slots immediately when count changes
//                                                         const newSlots = Array.from({ length: count }, (_, i) => ({
//                                                             sequence: i + 1,
//                                                             arrivalTime: returnDestTimeSlots[i]?.arrivalTime || '',
//                                                             departureTime: '',
//                                                             fareMultiplier: 1.0,
//                                                             isActive: true
//                                                         }));
//                                                         setReturnDestTimeSlots(newSlots);
//                                                     }}
//                                                     disabled={false}
//                                                     showDeparture={false}
//                                                     showArrival={true}
//                                                     labelPrefix="Return Trip"
//                                                 />
//                                             ) : null}
//                                         </div>
//                                     )}
//                                 </div>

//                                 {/* Intermediate Stops Section */}
//                                 <div className="form-section stops-section">
//                                     <h4>Intermediate Stops ({activeRouteTab})</h4>

//                                     {/* Show Number of Trips info when multi-trip is enabled */}
//                                     {isMultiTrip && (
//                                         <div style={{
//                                             marginBottom: '16px',
//                                             padding: '12px 16px',
//                                             backgroundColor: '#e3f2fd',
//                                             borderRadius: '8px',
//                                             border: '1px solid #90caf9',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             justifyContent: 'space-between',
//                                             flexWrap: 'wrap',
//                                             gap: '10px'
//                                         }}>
//                                             <div>
//                                                 <span style={{ fontSize: '13px', fontWeight: '500', color: '#0d47a1' }}>
//                                                     🚍 Number of Trips per Day:
//                                                 </span>
//                                                 <span style={{
//                                                     marginLeft: '8px',
//                                                     fontSize: '16px',
//                                                     fontWeight: 'bold',
//                                                     color: '#1565c0',
//                                                     backgroundColor: '#bbdefb',
//                                                     padding: '4px 12px',
//                                                     borderRadius: '20px',
//                                                     display: 'inline-block'
//                                                 }}>
//                                                     {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}
//                                                 </span>
//                                             </div>
//                                             <div style={{ fontSize: '12px', color: '#1565c0' }}>
//                                                 ⏰ Each stop needs timings for all {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}
//                                             </div>
//                                             <button
//                                                 type="button"
//                                                 onClick={() => {
//                                                     if (window.confirm(`This will set default timings (00:00) for all ${numberOfTrips} trips at all stops. Continue?`)) {
//                                                         // Initialize timings for all stops
//                                                         const currentStops = getActiveStops();
//                                                         const updatedStops = currentStops.map(stop => ({
//                                                             ...stop,
//                                                             timings: timeSlots.map(slot => ({
//                                                                 timeSlotSequence: slot.sequence,
//                                                                 sequence: stop.sequence,
//                                                                 arrivalTime: '',
//                                                                 departureTime: ''
//                                                             }))
//                                                         }));
//                                                         setActiveStops(updatedStops);
//                                                         toast.info(`Timings initialized for all ${currentStops.length} stops`);
//                                                     }
//                                                 }}
//                                                 style={{
//                                                     padding: '4px 12px',
//                                                     fontSize: '11px',
//                                                     backgroundColor: '#1565c0',
//                                                     color: 'white',
//                                                     border: 'none',
//                                                     borderRadius: '4px',
//                                                     cursor: 'pointer'
//                                                 }}
//                                             >
//                                                 Initialize All Stops
//                                             </button>
//                                         </div>
//                                     )}

//                                     {activeRouteTab === 'DOWN' && (
//                                         <button
//                                             className="sync-btn"
//                                             onClick={() => syncDownStopsWithUpStops(true)}
//                                         >
//                                             🔄 Auto-Fill / Sync Reversed Stops from UP Route
//                                         </button>
//                                     )}

//                                     <div className="stops-list">
//                                         {getActiveStops().length > 0 && renderInsertButton(0, activeRouteTab === 'UP' ? 'up' : 'down')}

//                                         {getActiveStops().map((stop, index) => (
//                                             <React.Fragment key={index}>
//                                                 <div className={`stop-list-item ${(activeRouteTab === 'UP' ? editUpIndex : editDownIndex) === index ? 'editing-highlight' : ''}`}>
//                                                     <div className="stop-info">
//                                                         <div className="stop-name">
//                                                             {index + 1}. {stop.city}
//                                                             <span className="stop-distance">
//                                                                 ({typeof stop.distanceFromOrigin === 'number'
//                                                                     ? stop.distanceFromOrigin.toFixed(2)
//                                                                     : parseFloat(stop.distanceFromOrigin || 0).toFixed(2)} km)
//                                                             </span>
//                                                         </div>

//                                                         {/* Show multi-trip timings or single trip times */}
//                                                         {/* In the stops list render — BOTH add modal and edit modal */}
//                                                         {isMultiTrip && stop.timings && stop.timings.length > 0 ? (
//                                                             <div className="stop-multi-times" style={{ marginTop: '8px', marginBottom: '8px' }}>
//                                                                 {[...stop.timings]
//                                                                     .sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0))
//                                                                     .map(timing => (
//                                                                         <div key={timing.timeSlotSequence} style={{
//                                                                             display: 'inline-flex', alignItems: 'center', gap: '8px',
//                                                                             backgroundColor: '#e9ecef', padding: '4px 10px',
//                                                                             borderRadius: '16px', margin: '2px 4px', fontSize: '11px'
//                                                                         }}>
//                                                                             <span style={{ fontWeight: '500' }}>Trip {timing.timeSlotSequence}:</span>
//                                                                             <span>Arr {timing.arrivalTime || '--:--'}</span>
//                                                                             <span>→</span>
//                                                                             <span>Dep {timing.departureTime || '--:--'}</span>
//                                                                         </div>
//                                                                     ))}
//                                                                 {/* ADD THIS BADGE INLINE */}
//                                                                 {stop.stopType && stop.stopType !== 'none' && (
//                                                                     <span style={{
//                                                                         display: 'inline-flex', alignItems: 'center',
//                                                                         marginLeft: '8px', fontSize: '11px', fontWeight: '500',
//                                                                         padding: '2px 8px', borderRadius: '12px',
//                                                                         backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
//                                                                             : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
//                                                                         color: stop.stopType === 'boarding' ? '#1565c0'
//                                                                             : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
//                                                                         border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
//                                                                             : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
//                                                                     }}>
//                                                                         {stop.stopType === 'boarding' ? '🟢 Boarding'
//                                                                             : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         ) : (
//                                                             <div className="stop-times" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
//                                                                 <span>Arr: {stop.arrivalTime || 'TBD'} • Dep: {stop.departureTime || 'N/A'}</span>
//                                                                 {/* ADD THIS BADGE INLINE */}
//                                                                 {stop.stopType && stop.stopType !== 'none' && (
//                                                                     <span style={{
//                                                                         fontSize: '11px', fontWeight: '500',
//                                                                         padding: '2px 8px', borderRadius: '12px',
//                                                                         backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
//                                                                             : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
//                                                                         color: stop.stopType === 'boarding' ? '#1565c0'
//                                                                             : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
//                                                                         border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
//                                                                             : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
//                                                                     }}>
//                                                                         {stop.stopType === 'boarding' ? '🟢 Boarding'
//                                                                             : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
//                                                                     </span>
//                                                                 )}
//                                                             </div>
//                                                         )}
//                                                         {/* Rest of the stop info... */}
//                                                     </div>
//                                                     <div className="stop-actions">
//                                                         <button
//                                                             className="stop-action-btn edit"
//                                                             onClick={() => handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down')}
//                                                         >
//                                                             Edit
//                                                         </button>
//                                                         <button
//                                                             className="stop-action-btn delete"
//                                                             onClick={() => handleDeleteStop(index)}
//                                                         >
//                                                             Delete
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                                 {renderInsertButton(index + 1, activeRouteTab === 'UP' ? 'up' : 'down')}
//                                             </React.Fragment>
//                                         ))}
//                                     </div>

//                                     {/* Stop Form */}
//                                     <div className="stop-form">
//                                         <h5>
//                                             {editingStopIndex !== null ? `Edit Stop #${editingStopIndex + 1}` :
//                                                 insertIndex !== null ? `Insert Stop at #${insertIndex + 1}` :
//                                                     'Add Stop at End'}
//                                         </h5>

//                                         {insertIndex !== null && (
//                                             <button className="cancel-insert-btn" onClick={() => setInsertIndex(null)}>
//                                                 Cancel Insert
//                                             </button>
//                                         )}

//                                         {/* Show trip info when editing in multi-trip mode */}
//                                         {isMultiTrip && editingStopIndex !== null && (
//                                             <div style={{
//                                                 marginBottom: '16px',
//                                                 padding: '8px 12px',
//                                                 backgroundColor: '#fff3cd',
//                                                 borderRadius: '6px',
//                                                 fontSize: '12px',
//                                                 color: '#856404'
//                                             }}>
//                                                 💡 This stop has {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}. Set timings for each trip below.
//                                             </div>
//                                         )}

//                                         <div className="form-row">
//                                             <Checkbox
//                                                 label="Manually Typed Stop (No Map Suggestions)"
//                                                 checked={isManualStop}
//                                                 onChange={() => {
//                                                     setIsManualStop(!isManualStop);
//                                                     if (!isManualStop) {
//                                                         setNewRoute(prev => ({
//                                                             ...prev,
//                                                             stopCity: '',
//                                                             stopCoords: null,
//                                                             stopDistFromPrev: '',
//                                                             stopDistToNext: '',
//                                                             stopAddress: '',
//                                                             stopState: '',
//                                                             stopTerminal: ''
//                                                         }));
//                                                         setCitySuggestions([]);
//                                                         setShowCityDropdown(false);
//                                                     }
//                                                 }}
//                                             />
//                                         </div>

//                                         {!isManualStop ? (
//                                             // NON-MANUAL MODE - Google Places Autocomplete
//                                             <>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Search Location</label>
//                                                         <LocationInput
//                                                             value={newRoute.stopCity}
//                                                             onChange={(value) => setNewRoute(prev => ({ ...prev, stopCity: value }))}
//                                                             onLocationSelect={handleSelectStop}
//                                                             placeholder="Search stop city or address..."
//                                                         />
//                                                     </div>
//                                                 </div>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Address</label>
//                                                         <input
//                                                             type="text"
//                                                             value={newRoute.stopAddress}
//                                                             onChange={(e) => setNewRoute(prev => ({ ...prev, stopAddress: e.target.value }))}
//                                                             placeholder="Full address (e.g., NH-19, Near Bus Stand)"
//                                                             className="form-input"
//                                                         />
//                                                         <small className="helper-text">Complete address of the stop location</small>
//                                                     </div>
//                                                 </div>
//                                             </>
//                                         ) : (
//                                             // MANUAL MODE - City Search from API with Auto-fill
//                                             <>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Search City *</label>
//                                                         <div className="city-search-container" style={{ position: 'relative' }}>
//                                                             <input
//                                                                 type="text"
//                                                                 value={newRoute.stopCity}
//                                                                 onChange={async (e) => {
//                                                                     const value = toTitleCase(e.target.value);
//                                                                     setNewRoute(prev => ({ ...prev, stopCity: value }));

//                                                                     if (value !== newRoute.stopCity) {
//                                                                         setNewRoute(prev => ({
//                                                                             ...prev,
//                                                                             stopAddress: '',
//                                                                             stopState: '',
//                                                                             stopTerminal: ''
//                                                                         }));
//                                                                     }

//                                                                     if (value.length >= 2) {
//                                                                         try {
//                                                                             console.log('Searching for city (manual mode):', value);
//                                                                             const response = await searchRouteIntermediateStops(token, value);
//                                                                             console.log('API Response:', response);

//                                                                             if (response.success && response.cities && response.cities.length > 0) {
//                                                                                 setCitySuggestions(response.cities);
//                                                                                 setShowCityDropdown(true);
//                                                                             } else {
//                                                                                 setCitySuggestions([]);
//                                                                                 setShowCityDropdown(false);
//                                                                             }
//                                                                         } catch (error) {
//                                                                             console.error('Error searching cities:', error);
//                                                                             setCitySuggestions([]);
//                                                                             setShowCityDropdown(false);
//                                                                         }
//                                                                     } else {
//                                                                         setCitySuggestions([]);
//                                                                         setShowCityDropdown(false);
//                                                                     }
//                                                                 }}
//                                                                 onFocus={() => {
//                                                                     if (citySuggestions.length > 0) {
//                                                                         setShowCityDropdown(true);
//                                                                     }
//                                                                 }}
//                                                                 onBlur={() => {
//                                                                     setTimeout(() => setShowCityDropdown(false), 200);
//                                                                 }}
//                                                                 placeholder="Type city name (min 2 characters)..."
//                                                                 className="form-input"
//                                                             />
//                                                             {showCityDropdown && citySuggestions.length > 0 && (
//                                                                 <div className="city-suggestions-dropdown" style={{
//                                                                     position: 'absolute',
//                                                                     top: '100%',
//                                                                     left: 0,
//                                                                     right: 0,
//                                                                     backgroundColor: 'white',
//                                                                     border: '1px solid #ddd',
//                                                                     borderRadius: '4px',
//                                                                     maxHeight: '200px',
//                                                                     overflowY: 'auto',
//                                                                     zIndex: 10000,
//                                                                     boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                                                                 }}>
//                                                                     {citySuggestions.map((city, idx) => (
//                                                                         <div
//                                                                             key={city.id || idx}
//                                                                             onClick={() => {
//                                                                                 console.log('Selected city:', city);
//                                                                                 setNewRoute(prev => ({
//                                                                                     ...prev,
//                                                                                     stopCity: toTitleCase(city.name),
//                                                                                     stopAddress: toTitleCase(city.address || city.name),
//                                                                                     stopState: toTitleCase(city.state || ''),
//                                                                                     stopTerminal: toTitleCase(city.terminal || `${city.name} Bus Stand`),
//                                                                                     stopCoords: city.coordinates || null
//                                                                                 }));
//                                                                                 setShowCityDropdown(false);
//                                                                                 toast.success(`Auto-filled details for ${city.name}`);
//                                                                             }}
//                                                                             style={{
//                                                                                 padding: '10px 12px',
//                                                                                 cursor: 'pointer',
//                                                                                 borderBottom: '1px solid #f0f0f0',
//                                                                                 transition: 'background-color 0.2s'
//                                                                             }}
//                                                                             onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                                                             onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                                                         >
//                                                                             <div style={{ fontWeight: '500' }}>{city.name}</div>
//                                                                             <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                                                 {city.state}
//                                                                                 {city.terminal && ` • ${city.terminal}`}
//                                                                             </div>
//                                                                             <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
//                                                                                 {city.address !== city.name ? city.address : ''}
//                                                                             </div>
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>
//                                                             )}
//                                                         </div>
//                                                         <small className="helper-text">Type at least 2 characters to search for cities from existing routes</small>
//                                                     </div>
//                                                 </div>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Address *</label>
//                                                         <input
//                                                             type="text"
//                                                             value={newRoute.stopAddress}
//                                                             onChange={(e) => setNewRoute(prev => ({ ...prev, stopAddress: e.target.value }))}
//                                                             placeholder="Complete address of the stop location"
//                                                             className="form-input"
//                                                         />
//                                                         <small className="helper-text">Complete address of the stop location</small>
//                                                     </div>
//                                                 </div>
//                                             </>
//                                         )}

//                                         {/* Manual distance fields - only show for manual stops */}
//                                         {(stopEditForm.isManualStop || isManualStop) && (
//                                             <>
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Distance from Previous Stop (km) *</label>
//                                                         <input
//                                                             type="number"
//                                                             value={newRoute.stopDistFromPrev}
//                                                             onChange={(e) => setNewRoute(prev => ({ ...prev, stopDistFromPrev: e.target.value }))}
//                                                             placeholder="e.g., 50"
//                                                             className="form-input"
//                                                             min="0"
//                                                             step="0.1"
//                                                         />
//                                                         <small className="helper-text">Required for manual stops</small>
//                                                     </div>
//                                                 </div>

//                                                 {/* Distance to Next Stop - if next stop has GPS */}
//                                                 {(() => {
//                                                     const stops = getActiveStops();
//                                                     const currentIndex = editingStopIndex !== null ? editingStopIndex :
//                                                         (insertIndex !== null ? insertIndex : stops.length);
//                                                     const nextStop = stops[currentIndex];
//                                                     const isNextAuto = nextStop && nextStop.coordinates &&
//                                                         (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
//                                                     if (isNextAuto) {
//                                                         return (
//                                                             <div className="form-row">
//                                                                 <div className="form-group full-width">
//                                                                     <label>Distance to Next Stop ({nextStop.city}) (km)</label>
//                                                                     <input
//                                                                         type="number"
//                                                                         value={newRoute.stopDistToNext}
//                                                                         onChange={(e) => setNewRoute(prev => ({ ...prev, stopDistToNext: e.target.value }))}
//                                                                         placeholder={`Distance to ${nextStop.city}`}
//                                                                         className="form-input"
//                                                                         min="0"
//                                                                         step="0.1"
//                                                                     />
//                                                                     <small className="helper-text">
//                                                                         Optional - helps with distance calculation accuracy
//                                                                     </small>
//                                                                 </div>
//                                                             </div>
//                                                         );
//                                                     }
//                                                     return null;
//                                                 })()}
//                                             </>
//                                         )}

//                                         <div className="form-row">
//                                             <div className="form-group">
//                                                 <label>State</label>
//                                                 <input
//                                                     type="text"
//                                                     value={newRoute.stopState}
//                                                     onChange={(e) => setNewRoute(prev => ({ ...prev, stopState: e.target.value }))}
//                                                     placeholder="State"
//                                                     className="form-input"
//                                                 />
//                                             </div>
//                                             <div className="form-group">
//                                                 <label>Terminal</label>
//                                                 <input
//                                                     type="text"
//                                                     value={newRoute.stopTerminal}
//                                                     onChange={(e) =>
//                                                         setNewRoute(prev => ({
//                                                             ...prev,
//                                                             stopTerminal: toTitleCase(e.target.value),
//                                                         }))
//                                                     }
//                                                     placeholder="Terminal name"
//                                                     className="form-input"
//                                                 />
//                                             </div>
//                                         </div>

//                                         {/* Multi-trip timing manager or single trip time pickers */}
//                                         {isMultiTrip ? (
//                                             <StopTimingManager
//                                                 stop={{
//                                                     sequence: editingStopIndex !== null ? editingStopIndex + 1 :
//                                                         (insertIndex !== null ? insertIndex + 1 : getActiveStops().length + 1),
//                                                     timings: newRoute.stopTimings || []
//                                                 }}
//                                                 timeSlots={timeSlots}
//                                                 onTimingUpdate={(stopSequence, timings) => {
//                                                     setNewRoute(prev => ({ ...prev, stopTimings: timings }));
//                                                 }}
//                                                 disabled={false}
//                                             />
//                                         ) : (
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Arrival Time *</label>
//                                                     <TimePicker
//                                                         value={newRoute.stopArrivalTime}
//                                                         onChange={(value) => setNewRoute(prev => ({ ...prev, stopArrivalTime: value }))}
//                                                         placeholder="Select time"
//                                                     />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Departure Time (Opt)</label>
//                                                     <TimePicker
//                                                         value={newRoute.stopDepartureTime}
//                                                         onChange={(value) => setNewRoute(prev => ({ ...prev, stopDepartureTime: value }))}
//                                                         placeholder="Select time"
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}

//                                         <div className="form-row checkbox-row">
//                                             <Checkbox
//                                                 label="Boarding Point"
//                                                 checked={newRoute.isBoarding}
//                                                 onChange={() => setNewRoute(prev => ({ ...prev, isBoarding: !prev.isBoarding }))}
//                                             />
//                                             <Checkbox
//                                                 label="Dropping Point"
//                                                 checked={newRoute.isDropping}
//                                                 onChange={() => setNewRoute(prev => ({ ...prev, isDropping: !prev.isDropping }))}
//                                             />
//                                         </div>

//                                         <button
//                                             className="btn btn-secondary add-stop-btn"
//                                             onClick={() => addIntermediateStop(activeRouteTab === 'UP' ? 'up' : 'down')}
//                                             disabled={
//                                                 !newRoute.stopCity ||
//                                                 ((!isMultiTrip && !newRoute.stopArrivalTime) ||
//                                                     (isMultiTrip && (!newRoute.stopTimings || newRoute.stopTimings.length === 0))) ||
//                                                 ((isManualStop || !newRoute.stopCoords) && (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0))
//                                             }
//                                         >
//                                             {editingStopIndex !== null ? 'Save Changes' :
//                                                 insertIndex !== null ? 'Confirm Insertion' :
//                                                     '+ Append Stop'}
//                                         </button>
//                                     </div>
//                                 </div>
//                                 {/* Route Summary Section */}
//                                 <div className="form-section">
//                                     <h4>{activeRouteTab} Summary</h4>

//                                     <button
//                                         className="btn btn-success calculate-btn"
//                                         onClick={handleCalculateDistances}
//                                         disabled={isCalculatingDistances}
//                                     >
//                                         {isCalculatingDistances ? 'Calculating...' : `Auto-Calculate Distances (${activeRouteTab})`}
//                                     </button>

//                                     {isLastStopManual() && (
//                                         <div className="form-row" style={{ marginTop: '10px' }}>
//                                             <div className="form-group full-width">
//                                                 <label>Distance from Last Stop to Destination (KM) *</label>
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg}
//                                                     onChange={(e) => setNewRoute(prev => ({
//                                                         ...prev,
//                                                         [activeRouteTab === 'UP' ? 'upManualFinalLeg' : 'downManualFinalLeg']: e.target.value
//                                                     }))}
//                                                     placeholder="Required because last stop is manual"
//                                                     className="form-input"
//                                                     min="0"
//                                                     step="0.1"
//                                                     style={{ borderColor: '#dc3545', backgroundColor: '#fff5f5' }}
//                                                 />
//                                                 <small className="helper-text" style={{ color: '#dc3545' }}>
//                                                     ⚠️ The last stop is manual, so you must provide the distance to destination
//                                                 </small>
//                                             </div>
//                                         </div>
//                                     )}

//                                     <div className="form-row summary-fields">
//                                         <div className="form-group">
//                                             <label>Total Distance (KM)</label>
//                                             <input
//                                                 type="number"
//                                                 value={activeRouteTab === 'UP' ? newRoute.upTotalDistance : newRoute.downTotalDistance}
//                                                 onChange={(e) => setNewRoute(prev => ({
//                                                     ...prev,
//                                                     [activeRouteTab === 'UP' ? 'upTotalDistance' : 'downTotalDistance']: e.target.value
//                                                 }))}
//                                                 className="form-input"
//                                                 min="0"
//                                                 step="0.1"
//                                             />
//                                         </div>
//                                         <div className="form-group">
//                                             <label>Est. Duration</label>
//                                             <div className="duration-inputs">
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? newRoute.upDurationHours : newRoute.downDurationHours}
//                                                     onChange={(e) => {
//                                                         const value = e.target.value;
//                                                         setNewRoute(prev => ({
//                                                             ...prev,
//                                                             [activeRouteTab === 'UP' ? 'upDurationHours' : 'downDurationHours']: value
//                                                         }));
//                                                     }}
//                                                     className="form-input"
//                                                     placeholder="Hours"
//                                                     min="0"
//                                                 />
//                                                 <span>h</span>
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? newRoute.upDurationMinutes : newRoute.downDurationMinutes}
//                                                     onChange={(e) => {
//                                                         const value = e.target.value;
//                                                         // Validate minutes between 0-59
//                                                         let minutes = Math.min(59, Math.max(0, parseInt(value) || 0));
//                                                         setNewRoute(prev => ({
//                                                             ...prev,
//                                                             [activeRouteTab === 'UP' ? 'upDurationMinutes' : 'downDurationMinutes']: minutes.toString()
//                                                         }));
//                                                     }}
//                                                     className="form-input"
//                                                     placeholder="Minutes"
//                                                     min="0"
//                                                     max="59"
//                                                 />
//                                                 <span>m</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Form Actions */}
//                             <div className="form-actions">
//                                 <button
//                                     className="btn btn-primary save-route-btn"
//                                     onClick={handleSaveRoute}
//                                     disabled={
//                                         isCreatingRoute ||
//                                         !selectedMasterRouteFromDropdown ||
//                                         !isDistanceCalculated.up ||
//                                         (isRoundTrip && !isDistanceCalculated.down)
//                                     }
//                                 >
//                                     {isCreatingRoute ? 'Creating Route...' : 'Add Route'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* View Route Modal */}
//             {viewingRoute && (
//                 <div className="modal-overlay" onClick={() => setViewingRoute(null)}>
//                     <div className="modal-content1 view-route-modal" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">
//                             <h3>Route Details: {viewingRoute.routeName}</h3>
//                             <button className="modal-close-btn" onClick={() => setViewingRoute(null)}>×</button>
//                         </div>

//                         <div className="modal-body view-modal-body">
//                             <div className="route-details">
//                                 <div className="detail-row">
//                                     <label>Route Name:</label>
//                                     <span>{viewingRoute.routeName}</span>
//                                 </div>
//                                 <div className="detail-row">
//                                     <label>Local Route Name:</label>
//                                     <span>{viewingRoute.localRouteName || '—'}</span>
//                                 </div>
//                                 <div className="detail-row">
//                                     <label>Route Type:</label>
//                                     <span className={`route-type-badge ${viewingRoute.isRoundTrip ? 'roundtrip' : 'oneway'}`}>
//                                         {viewingRoute.isRoundTrip ? 'Round Trip' : 'One Way'}
//                                     </span>
//                                 </div>
//                                 <div className="detail-row">
//                                     <label>Multi-Trip:</label>
//                                     <span>{viewingRoute.isMultiTrip ? `Yes (${viewingRoute.numberOfTrips || viewingRoute.origin?.timings?.length || 1} trips per day)` : 'No'}</span>
//                                 </div>

//                                 {/* Origin Section */}
//                                 <div className="detail-section">
//                                     <h4>Origin</h4>
//                                     <div className="detail-row"><label>City:</label><span>{viewingRoute.origin?.city}</span></div>
//                                     <div className="detail-row"><label>State:</label><span>{viewingRoute.origin?.state}</span></div>
//                                     <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.origin?.terminal}</span></div>

//                                     {/* Display timings array for multi-trip */}
//                                     {viewingRoute.origin?.timings && viewingRoute.origin.timings.length > 0 ? (
//                                         <div className="detail-row">
//                                             <label>Departure Times:</label>
//                                             <div className="multi-trip-times">
//                                                 {viewingRoute.origin.timings.map((timing, idx) => (
//                                                     <span key={idx} className="time-badge">
//                                                         Trip {timing.timeSlotSequence}: {formatTime(timing.departureTime)}
//                                                     </span>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <div className="detail-row"><label>Departure Time:</label><span>{formatTime(viewingRoute.origin?.departureTime)}</span></div>
//                                     )}

//                                     {viewingRoute.origin?.address && (
//                                         <div className="detail-row"><label>Address:</label><span className="address-text">{viewingRoute.origin.address}</span></div>
//                                     )}
//                                 </div>

//                                 {/* Destination Section */}
//                                 <div className="detail-section">
//                                     <h4>Destination</h4>
//                                     <div className="detail-row"><label>City:</label><span>{viewingRoute.destination?.city}</span></div>
//                                     <div className="detail-row"><label>State:</label><span>{viewingRoute.destination?.state}</span></div>
//                                     <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.destination?.terminal}</span></div>

//                                     {/* Display timings array for multi-trip */}
//                                     {viewingRoute.destination?.timings && viewingRoute.destination.timings.length > 0 ? (
//                                         <div className="detail-row">
//                                             <label>Arrival Times:</label>
//                                             <div className="multi-trip-times">
//                                                 {viewingRoute.destination.timings.map((timing, idx) => (
//                                                     <span key={idx} className="time-badge">
//                                                         Trip {timing.timeSlotSequence}: {formatTime(timing.arrivalTime)}
//                                                     </span>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <div className="detail-row"><label>Arrival Time:</label><span>{formatTime(viewingRoute.destination?.arrivalTime)}</span></div>
//                                     )}

//                                     {viewingRoute.destination?.address && (
//                                         <div className="detail-row"><label>Address:</label><span className="address-text">{viewingRoute.destination.address}</span></div>
//                                     )}
//                                 </div>

//                                 {/* Intermediate Stops Section */}
//                                 {viewingRoute.intermediateStops && viewingRoute.intermediateStops.length > 0 && (
//                                     <div className="detail-section">
//                                         <h4>Intermediate Stops ({viewingRoute.intermediateStops.length})</h4>
//                                         <div className="stops-list-container">
//                                             {viewingRoute.intermediateStops.map((stop, index) => (
//                                                 <div key={index} className="stop-card">
//                                                     <div className="stop-header">
//                                                         <span className="stop-sequence">#{stop.sequence}</span>
//                                                         <span className="stop-city">{stop.city}</span>
//                                                         <span className={`stop-type-badge ${stop.stopType}`}>
//                                                             {stop.stopType === 'both' ? 'Boarding & Dropping' :
//                                                                 stop.stopType === 'boarding' ? 'Boarding' :
//                                                                     stop.stopType === 'dropping' ? 'Dropping' : 'Stop'}
//                                                         </span>
//                                                     </div>
//                                                     <div className="stop-details">
//                                                         <div className="stop-info"><span className="info-label">Distance:</span><span className="stop-distance">
//                                                             ({typeof stop.distanceFromOrigin === 'number'
//                                                                 ? stop.distanceFromOrigin.toFixed(2)
//                                                                 : parseFloat(stop.distanceFromOrigin || 0).toFixed(2)} km)
//                                                         </span></div>
//                                                         <div className="stop-info"><span className="info-label">Terminal:</span><span>{stop.terminal}</span></div>

//                                                         {/* Display timings array for multi-trip */}
//                                                         {stop.timings && stop.timings.length > 0 ? (
//                                                             <div className="stop-info full-width">
//                                                                 <span className="info-label">Timings:</span>
//                                                                 <div className="multi-trip-times">
//                                                                     {stop.timings.map((timing, idx) => (
//                                                                         <div key={idx} className="timing-entry">
//                                                                             <span className="time-badge">Trip {timing.timeSlotSequence}:</span>
//                                                                             <span className="time-badge">Arr {formatTime(timing.arrivalTime)}</span>
//                                                                             <span className="time-badge">Dep {formatTime(timing.departureTime)}</span>
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>
//                                                             </div>
//                                                         ) : (
//                                                             <>
//                                                                 <div className="stop-info"><span className="info-label">Arrival:</span><span className="time-badge">{formatTime(stop.arrivalTime)}</span></div>
//                                                                 <div className="stop-info"><span className="info-label">Departure:</span><span className="time-badge">{formatTime(stop.departureTime)}</span></div>
//                                                             </>
//                                                         )}

//                                                         <div className="stop-info"><span className="info-label">State:</span><span>{stop.state}</span></div>
//                                                         {stop.manualDistToNext && (
//                                                             <div className="stop-info"><span className="info-label">To Next:</span><span>{stop.manualDistToNext} km</span></div>
//                                                         )}
//                                                         {stop.address && (
//                                                             <div className="stop-info full-width"><span className="info-label">Address:</span><span className="address-text">{stop.address}</span></div>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Return Journey Section */}
//                                 {viewingRoute.isRoundTrip && viewingRoute.returnJourney && (
//                                     <div className="detail-section return-journey">
//                                         <h4>Return Journey</h4>

//                                         {/* Return Origin */}
//                                         <div className="return-subsection">
//                                             <h5>Return Origin</h5>
//                                             <div className="detail-row"><label>City:</label><span>{viewingRoute.returnJourney.origin?.city}</span></div>
//                                             <div className="detail-row"><label>State:</label><span>{viewingRoute.returnJourney.origin?.state}</span></div>
//                                             <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.returnJourney.origin?.terminal}</span></div>

//                                             {viewingRoute.returnJourney.origin?.timings && viewingRoute.returnJourney.origin.timings.length > 0 ? (
//                                                 <div className="detail-row">
//                                                     <label>Departure Times:</label>
//                                                     <div className="multi-trip-times">
//                                                         {viewingRoute.returnJourney.origin.timings.map((timing, idx) => (
//                                                             <span key={idx} className="time-badge">
//                                                                 Trip {timing.timeSlotSequence}: {formatTime(timing.departureTime)}
//                                                             </span>
//                                                         ))}
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 <div className="detail-row"><label>Departure Time:</label><span>{formatTime(viewingRoute.returnJourney.origin?.departureTime)}</span></div>
//                                             )}
//                                         </div>

//                                         {/* Return Destination */}
//                                         <div className="return-subsection">
//                                             <h5>Return Destination</h5>
//                                             <div className="detail-row"><label>City:</label><span>{viewingRoute.returnJourney.destination?.city}</span></div>
//                                             <div className="detail-row"><label>State:</label><span>{viewingRoute.returnJourney.destination?.state}</span></div>
//                                             <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.returnJourney.destination?.terminal}</span></div>

//                                             {viewingRoute.returnJourney.destination?.timings && viewingRoute.returnJourney.destination.timings.length > 0 ? (
//                                                 <div className="detail-row">
//                                                     <label>Arrival Times:</label>
//                                                     <div className="multi-trip-times">
//                                                         {viewingRoute.returnJourney.destination.timings.map((timing, idx) => (
//                                                             <span key={idx} className="time-badge">
//                                                                 Trip {timing.timeSlotSequence}: {formatTime(timing.arrivalTime)}
//                                                             </span>
//                                                         ))}
//                                                     </div>
//                                                 </div>
//                                             ) : (
//                                                 <div className="detail-row"><label>Arrival Time:</label><span>{formatTime(viewingRoute.returnJourney.destination?.arrivalTime)}</span></div>
//                                             )}

//                                             <div className="detail-row"><label>Distance:</label><span>{viewingRoute.returnJourney.routeDetails?.totalDistance} km</span></div>
//                                         </div>

//                                         {/* Return Intermediate Stops */}
//                                         {viewingRoute.returnJourney.intermediateStops?.length > 0 && (
//                                             <div className="return-subsection">
//                                                 <h5>Return Stops ({viewingRoute.returnJourney.intermediateStops.length})</h5>
//                                                 <div className="stops-list-container">
//                                                     {viewingRoute.returnJourney.intermediateStops.map((stop, index) => (
//                                                         <div key={index} className="stop-card">
//                                                             <div className="stop-header">
//                                                                 <span className="stop-sequence">#{stop.sequence}</span>
//                                                                 <span className="stop-city">{stop.city}</span>
//                                                                 <span className={`stop-type-badge ${stop.stopType}`}>
//                                                                     {stop.stopType === 'both' ? 'Boarding & Dropping' :
//                                                                         stop.stopType === 'boarding' ? 'Boarding' :
//                                                                             stop.stopType === 'dropping' ? 'Dropping' : 'Stop'}
//                                                                 </span>
//                                                             </div>
//                                                             <div className="stop-details">
//                                                                 <div className="stop-info"><span className="info-label">Distance:</span><span className="stop-distance">
//                                                                     ({typeof stop.distanceFromOrigin === 'number'
//                                                                         ? stop.distanceFromOrigin.toFixed(2)
//                                                                         : parseFloat(stop.distanceFromOrigin || 0).toFixed(2)} km)
//                                                                 </span></div>

//                                                                 {/* Display timings array for return stops */}
//                                                                 {stop.timings && stop.timings.length > 0 ? (
//                                                                     <div className="stop-info full-width">
//                                                                         <span className="info-label">Timings:</span>
//                                                                         <div className="multi-trip-times">
//                                                                             {stop.timings.map((timing, idx) => (
//                                                                                 <div key={idx} className="timing-entry">
//                                                                                     <span className="time-badge">Trip {timing.timeSlotSequence}:</span>
//                                                                                     <span className="time-badge">Arr {formatTime(timing.arrivalTime)}</span>
//                                                                                     <span className="time-badge">Dep {formatTime(timing.departureTime)}</span>
//                                                                                 </div>
//                                                                             ))}
//                                                                         </div>
//                                                                     </div>
//                                                                 ) : (
//                                                                     <>
//                                                                         <div className="stop-info"><span className="info-label">Arrival:</span><span className="time-badge">{formatTime(stop.arrivalTime)}</span></div>
//                                                                         <div className="stop-info"><span className="info-label">Departure:</span><span className="time-badge">{formatTime(stop.departureTime)}</span></div>
//                                                                     </>
//                                                                 )}

//                                                                 <div className="stop-info"><span className="info-label">State:</span><span>{stop.state}</span></div>
//                                                                 {stop.address && (
//                                                                     <div className="stop-info full-width"><span className="info-label">Address:</span><span className="address-text">{stop.address}</span></div>
//                                                                 )}
//                                                             </div>
//                                                         </div>
//                                                     ))}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 )}

//                                 {/* Route Details */}
//                                 <div className="detail-section">
//                                     <h4>Route Details</h4>
//                                     <div className="detail-row"><label>Total Distance:</label><span>{viewingRoute.routeDetails?.totalDistance} km</span></div>
//                                     <div className="detail-row">
//                                         <label>Estimated Duration:</label>
//                                         <span>{viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m</span>
//                                     </div>
//                                 </div>

//                                 {/* Status Information */}
//                                 <div className="detail-section">
//                                     <h4>Status Information</h4>
//                                     <div className="detail-row">
//                                         <label>Status:</label>
//                                         <span className={`status-badge ${viewingRoute.isActive ? 'active' : 'inactive'}`}>
//                                             {viewingRoute.isActive ? 'Active' : 'Inactive'}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row"><label>Created By:</label><span>{viewingRoute.creatorName} ({viewingRoute.creatorType})</span></div>
//                                     <div className="detail-row"><label>Created At:</label><span>{new Date(viewingRoute.createdAt).toLocaleString()}</span></div>
//                                     <div className="detail-row"><label>Updated At:</label><span>{new Date(viewingRoute.updatedAt).toLocaleString()}</span></div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="modal-footer">
//                             <button className="modal-close-btn secondary" onClick={() => setViewingRoute(null)}>Close</button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showEditModal && editingRoute && (
//                 <div className="modal-overlay edit-route-modal" onClick={() => setShowEditModal(false)}>
//                     <div className="modal-content edit-route-content" onClick={(e) => e.stopPropagation()}>
//                         <div className="modal-header">
//                             <h3>Edit Route: {editingRoute.routeName}</h3>
//                             <button className="modal-close-btn" onClick={() => setShowEditModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             {/* Round Trip Toggle */}
//                             <div className="round-trip-toggle">
//                                 <label className="checkbox-container">
//                                     <input
//                                         type="checkbox"
//                                         checked={editForm.isRoundTrip}
//                                         onChange={(e) => {
//                                             setEditForm(prev => ({ ...prev, isRoundTrip: e.target.checked }));
//                                             if (e.target.checked && downStops.length === 0 && upStops.length > 0) {
//                                                 const reversed = [...upStops].reverse().map((s, idx) => ({
//                                                     ...s,
//                                                     sequence: idx + 1,
//                                                     stopType: s.stopType === 'boarding' ? 'dropping' :
//                                                         (s.stopType === 'dropping' ? 'boarding' :
//                                                             (s.stopType === 'both' ? 'both' : 'none')),
//                                                     arrivalTime: '',
//                                                     departureTime: '',
//                                                     manualDistFromPrev: s.manualDistToNext || null,
//                                                     manualDistToNext: s.manualDistFromPrev || null,
//                                                     distanceFromOrigin: 0
//                                                 }));
//                                                 setDownStops(reversed);
//                                             }
//                                         }}
//                                         className="checkbox-input"
//                                     />
//                                     <span className="checkbox-label">Round Trip (Main + Return Routes)</span>
//                                 </label>
//                             </div>

//                             {/* Route Tabs */}
//                             {editForm.isRoundTrip && (
//                                 <div className="route-tabs">
//                                     <button
//                                         className={`route-tab ${activeRouteTab === 'UP' ? 'active' : ''}`}
//                                         onClick={() => setActiveRouteTab('UP')}
//                                     >
//                                         UP (Main) Route
//                                     </button>
//                                     <button
//                                         className={`route-tab ${activeRouteTab === 'DOWN' ? 'active' : ''}`}
//                                         onClick={() => setActiveRouteTab('DOWN')}
//                                     >
//                                         DOWN (Return) Route
//                                     </button>
//                                 </div>
//                             )}

//                             {/* Number of Trips Info */}
//                             {(editForm.isMultiTrip || isMultiTrip) && (
//                                 <div style={{
//                                     marginBottom: '16px',
//                                     padding: '12px 16px',
//                                     backgroundColor: '#e3f2fd',
//                                     borderRadius: '8px',
//                                     border: '1px solid #90caf9',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'space-between',
//                                     flexWrap: 'wrap',
//                                     gap: '10px'
//                                 }}>
//                                     <div>
//                                         <span style={{ fontSize: '13px', fontWeight: '500', color: '#0d47a1' }}>
//                                             🚍 Number of Trips per Day ({activeRouteTab} Route):
//                                         </span>
//                                         <span style={{
//                                             marginLeft: '8px',
//                                             fontSize: '16px',
//                                             fontWeight: 'bold',
//                                             color: '#1565c0',
//                                             backgroundColor: '#bbdefb',
//                                             padding: '4px 12px',
//                                             borderRadius: '20px',
//                                             display: 'inline-block'
//                                         }}>
//                                             {editForm.numberOfTrips || 1} trip{editForm.numberOfTrips !== 1 ? 's' : ''}
//                                         </span>
//                                     </div>
//                                     <button
//                                         type="button"
//                                         onClick={() => {
//                                             if (window.confirm(`This will set default timings for all stops. Continue?`)) {
//                                                 const currentStops = getActiveStops();
//                                                 const updatedStops = currentStops.map(stop => ({
//                                                     ...stop,
//                                                     timings: Array.from({ length: editForm.numberOfTrips || 1 }, (_, i) => ({
//                                                         timeSlotSequence: i + 1,
//                                                         arrivalTime: '',
//                                                         departureTime: ''
//                                                     }))
//                                                 }));
//                                                 setActiveStops(updatedStops);
//                                                 toast.info(`Timings initialized for all ${currentStops.length} stops`);
//                                             }
//                                         }}
//                                         style={{
//                                             padding: '4px 12px',
//                                             fontSize: '11px',
//                                             backgroundColor: '#1565c0',
//                                             color: 'white',
//                                             border: 'none',
//                                             borderRadius: '4px',
//                                             cursor: 'pointer'
//                                         }}
//                                     >
//                                         Initialize All Stops
//                                     </button>
//                                 </div>
//                             )}

//                             <div className="form-sections">
//                                 {/* Route Identity Section */}
//                                 <div className="form-section">
//                                     <h4>Route Identity</h4>
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label>Route Name *</label>
//                                             <input
//                                                 type="text"
//                                                 value={editForm.routeName}
//                                                 onChange={(e) => setEditForm(prev => ({ ...prev, routeName: e.target.value }))}
//                                                 placeholder="Route name"
//                                                 className="form-input"
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Local Route Name (Optional)</label>
//                                             <input
//                                                 type="text"
//                                                 value={editForm.localRouteName || ''}
//                                                 onChange={(e) => setEditForm(prev => ({ ...prev, localRouteName: e.target.value }))}
//                                                 placeholder="Enter local/regional name for this route"
//                                                 className="form-input"
//                                             />
//                                             <small className="helper-text">This name will be displayed to passengers as the local route identifier</small>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Origin Section */}
//                                 <div className="form-section">
//                                     <h4>{activeRouteTab === 'UP' ? 'Origin' : 'Return Origin'}</h4>
//                                     {activeRouteTab === 'UP' ? (
//                                         <React.Fragment>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Search Location</label>
//                                                     <LocationInput
//                                                         value={editForm.originCity}
//                                                         onChange={(value) => setEditForm(prev => ({ ...prev, originCity: value }))}
//                                                         onLocationSelect={handleEditOriginSelect}
//                                                         placeholder="Search origin city or address..."
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Address</label>
//                                                     <input type="text" value={editForm.originAddress} onChange={(e) => setEditForm(prev => ({ ...prev, originAddress: e.target.value }))} placeholder="Full address" className="form-input" />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>State</label>
//                                                     <input type="text" value={editForm.originState} onChange={(e) => setEditForm(prev => ({ ...prev, originState: e.target.value }))} placeholder="State" className="form-input" />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Terminal</label>
//                                                     <input type="text" value={editForm.originTerminal} onChange={(e) => setEditForm(prev => ({ ...prev, originTerminal: e.target.value }))} placeholder="Terminal name" className="form-input" />
//                                                 </div>
//                                             </div>
//                                             {editForm.isMultiTrip && editForm.originTimings && editForm.originTimings.length > 0 && (
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Departure Times (Multi-Trip)</label>
//                                                         <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
//                                                             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                                 <thead>
//                                                                     <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {editForm.originTimings.map((timing, idx) => (
//                                                                         <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.originTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                             <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>Trip #{timing.timeSlotSequence || idx + 1}</td>
//                                                                             <td style={{ padding: '10px' }}>
//                                                                                 <TimePicker
//                                                                                     value={timing.departureTime}
//                                                                                     onChange={(value) => {
//                                                                                         const updatedTimings = [...(editForm.originTimings || [])];
//                                                                                         updatedTimings[idx] = { ...timing, departureTime: value };
//                                                                                         setEditForm(prev => ({ ...prev, originTimings: updatedTimings }));
//                                                                                     }}
//                                                                                     placeholder="--:--"
//                                                                                 />
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             {!editForm.isMultiTrip && (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Departure Time *</label>
//                                                         <TimePicker
//                                                             value={editForm.originDepTime}
//                                                             onChange={(value) => {
//                                                                 setEditForm(prev => ({ ...prev, originDepTime: value }));
//                                                                 const dur = getDuration(value, editForm.destArrTime);
//                                                                 setEditForm(prev => ({ ...prev, durationHours: dur.hours, durationMinutes: dur.minutes }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </React.Fragment>
//                                     ) : (
//                                         <React.Fragment>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <input type="text" value={editForm.returnOriginCity || ''} onChange={(e) => setEditForm(prev => ({ ...prev, returnOriginCity: e.target.value }))} placeholder="Return Origin City" className="form-input" />
//                                                 </div>
//                                             </div>
//                                             {editForm.isMultiTrip && editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0 && (
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Return Departure Times (Multi-Trip)</label>
//                                                         <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
//                                                             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                                 <thead>
//                                                                     <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {editForm.returnOriginTimings.map((timing, idx) => (
//                                                                         <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.returnOriginTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                             <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>Trip #{timing.timeSlotSequence || idx + 1}</td>
//                                                                             <td style={{ padding: '10px' }}>
//                                                                                 <TimePicker
//                                                                                     value={timing.departureTime}
//                                                                                     onChange={(value) => {
//                                                                                         const updatedTimings = [...(editForm.returnOriginTimings || [])];
//                                                                                         updatedTimings[idx] = { ...timing, departureTime: value };
//                                                                                         setEditForm(prev => ({ ...prev, returnOriginTimings: updatedTimings }));
//                                                                                     }}
//                                                                                     placeholder="--:--"
//                                                                                 />
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             {!editForm.isMultiTrip && (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Return Departure Time *</label>
//                                                         <TimePicker
//                                                             value={editForm.returnOriginDepTime}
//                                                             onChange={(value) => {
//                                                                 setEditForm(prev => ({ ...prev, returnOriginDepTime: value }));
//                                                                 const dur = getDuration(value, editForm.returnDestArrTime);
//                                                                 setEditForm(prev => ({ ...prev, returnDurationHours: dur.hours, returnDurationMinutes: dur.minutes }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </React.Fragment>
//                                     )}
//                                 </div>

//                                 {/* Destination Section */}
//                                 <div className="form-section">
//                                     <h4>{activeRouteTab === 'UP' ? 'Destination' : 'Return Destination'}</h4>
//                                     {activeRouteTab === 'UP' ? (
//                                         <React.Fragment>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <label>Search Location</label>
//                                                     <LocationInput
//                                                         value={editForm.destCity}
//                                                         onChange={(value) => setEditForm(prev => ({ ...prev, destCity: value }))}
//                                                         onLocationSelect={handleEditDestSelect}
//                                                         placeholder="Search destination city or address..."
//                                                     />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>Address</label>
//                                                     <input type="text" value={editForm.destAddress} onChange={(e) => setEditForm(prev => ({ ...prev, destAddress: e.target.value }))} placeholder="Full address" className="form-input" />
//                                                 </div>
//                                             </div>
//                                             <div className="form-row">
//                                                 <div className="form-group">
//                                                     <label>State</label>
//                                                     <input type="text" value={editForm.destState} onChange={(e) => setEditForm(prev => ({ ...prev, destState: e.target.value }))} placeholder="State" className="form-input" />
//                                                 </div>
//                                                 <div className="form-group">
//                                                     <label>Terminal</label>
//                                                     <input type="text" value={editForm.destTerminal} onChange={(e) => setEditForm(prev => ({ ...prev, destTerminal: e.target.value }))} placeholder="Terminal name" className="form-input" />
//                                                 </div>
//                                             </div>
//                                             {editForm.isMultiTrip && editForm.destTimings && editForm.destTimings.length > 0 && (
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Arrival Times (Multi-Trip)</label>
//                                                         <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
//                                                             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                                 <thead>
//                                                                     <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {editForm.destTimings.map((timing, idx) => (
//                                                                         <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.destTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                             <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>Trip #{timing.timeSlotSequence || idx + 1}</td>
//                                                                             <td style={{ padding: '10px' }}>
//                                                                                 <TimePicker
//                                                                                     value={timing.arrivalTime}
//                                                                                     onChange={(value) => {
//                                                                                         const updatedTimings = [...(editForm.destTimings || [])];
//                                                                                         updatedTimings[idx] = { ...timing, arrivalTime: value };
//                                                                                         setEditForm(prev => ({ ...prev, destTimings: updatedTimings }));
//                                                                                     }}
//                                                                                     placeholder="--:--"
//                                                                                 />
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             {!editForm.isMultiTrip && (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Arrival Time *</label>
//                                                         <TimePicker
//                                                             value={editForm.destArrTime}
//                                                             onChange={(value) => {
//                                                                 setEditForm(prev => ({ ...prev, destArrTime: value }));
//                                                                 const dur = getDuration(editForm.originDepTime, value);
//                                                                 setEditForm(prev => ({ ...prev, durationHours: dur.hours, durationMinutes: dur.minutes }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </React.Fragment>
//                                     ) : (
//                                         <React.Fragment>
//                                             <div className="form-row">
//                                                 <div className="form-group full-width">
//                                                     <input type="text" value={editForm.returnDestCity || ''} onChange={(e) => setEditForm(prev => ({ ...prev, returnDestCity: e.target.value }))} placeholder="Return Destination City" className="form-input" />
//                                                 </div>
//                                             </div>
//                                             {editForm.isMultiTrip && editForm.returnDestTimings && editForm.returnDestTimings.length > 0 && (
//                                                 <div className="form-row">
//                                                     <div className="form-group full-width">
//                                                         <label>Return Arrival Times (Multi-Trip)</label>
//                                                         <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
//                                                             <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                                 <thead>
//                                                                     <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                                         <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {editForm.returnDestTimings.map((timing, idx) => (
//                                                                         <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.returnDestTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                             <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>Trip #{timing.timeSlotSequence || idx + 1}</td>
//                                                                             <td style={{ padding: '10px' }}>
//                                                                                 <TimePicker
//                                                                                     value={timing.arrivalTime}
//                                                                                     onChange={(value) => {
//                                                                                         const updatedTimings = [...(editForm.returnDestTimings || [])];
//                                                                                         updatedTimings[idx] = { ...timing, arrivalTime: value };
//                                                                                         setEditForm(prev => ({ ...prev, returnDestTimings: updatedTimings }));
//                                                                                     }}
//                                                                                     placeholder="--:--"
//                                                                                 />
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             )}
//                                             {!editForm.isMultiTrip && (
//                                                 <div className="form-row">
//                                                     <div className="form-group">
//                                                         <label>Return Arrival Time *</label>
//                                                         <TimePicker
//                                                             value={editForm.returnDestArrTime}
//                                                             onChange={(value) => {
//                                                                 setEditForm(prev => ({ ...prev, returnDestArrTime: value }));
//                                                                 const dur = getDuration(editForm.returnOriginDepTime, value);
//                                                                 setEditForm(prev => ({ ...prev, returnDurationHours: dur.hours, returnDurationMinutes: dur.minutes }));
//                                                             }}
//                                                             placeholder="Select time"
//                                                         />
//                                                     </div>
//                                                 </div>
//                                             )}
//                                         </React.Fragment>
//                                     )}
//                                 </div>

//                                 {/* Intermediate Stops Section */}
//                                 <div className="form-section stops-section">
//                                     <h4>Intermediate Stops ({activeRouteTab})</h4>

//                                     {activeRouteTab === 'DOWN' && editForm.isRoundTrip && (
//                                         <button className="sync-btn" onClick={() => {
//                                             if (window.confirm("This will update your Return Route stops based on your Main Route. Proceed?")) {
//                                                 // Get UP total distance
//                                                 const upTotalDist = parseFloat(editForm.totalDistance || 0);

//                                                 // Get UP stops and reverse them
//                                                 const reversedStops = [...upStops].reverse();

//                                                 // Calculate DOWN total distance (should match UP total distance)
//                                                 let downTotalDistance = upTotalDist;

//                                                 // Check if we have return total distance from editForm
//                                                 if (editForm.returnTotalDistance && parseFloat(editForm.returnTotalDistance) > 0) {
//                                                     downTotalDistance = parseFloat(editForm.returnTotalDistance);
//                                                 }

//                                                 // Calculate segment distances for DOWN route
//                                                 const segmentDistances = [];
//                                                 let prevDist = 0;

//                                                 // Calculate distances between consecutive UP stops (in original order)
//                                                 const upSegmentDistances = [];
//                                                 for (let i = 0; i < upStops.length; i++) {
//                                                     const currentDist = upStops[i].distanceFromOrigin || 0;
//                                                     let segment = currentDist - prevDist;
//                                                     if (segment <= 0 && upStops[i].manualDistFromPrev) {
//                                                         segment = parseFloat(upStops[i].manualDistFromPrev);
//                                                     }
//                                                     if (segment <= 0 && i === 0 && upTotalDist > 0) {
//                                                         // First segment approximation
//                                                         segment = upTotalDist / (upStops.length + 1);
//                                                     }
//                                                     if (segment <= 0) segment = 5; // Default fallback

//                                                     upSegmentDistances.push(segment);
//                                                     prevDist = currentDist;
//                                                 }

//                                                 // Last segment from last UP stop to destination
//                                                 const lastUpStopDist = upStops.length > 0 ? (upStops[upStops.length - 1].distanceFromOrigin || 0) : 0;
//                                                 let finalUpSegment = upTotalDist - lastUpStopDist;
//                                                 if (finalUpSegment <= 0 && editForm.upManualFinalLeg) {
//                                                     finalUpSegment = parseFloat(editForm.upManualFinalLeg);
//                                                 }
//                                                 if (finalUpSegment <= 0) finalUpSegment = upTotalDist / (upStops.length + 1);

//                                                 // Build DOWN segment distances (reversed order with preserved manual values)
//                                                 const downSegmentDistances = [finalUpSegment, ...upSegmentDistances.reverse()];

//                                                 // Calculate DOWN stops with cumulative distances
//                                                 let cumulativeDist = 0;
//                                                 const newDownStops = [];

//                                                 for (let i = 0; i < reversedStops.length; i++) {
//                                                     const originalStop = reversedStops[i];

//                                                     // Get segment distance for this DOWN stop
//                                                     let segmentDist = downSegmentDistances[i] || 5;

//                                                     // If original stop had manualDistFromPrev, use that value instead
//                                                     if (originalStop.manualDistFromPrev && originalStop.manualDistFromPrev > 0) {
//                                                         segmentDist = parseFloat(originalStop.manualDistFromPrev);
//                                                     }
//                                                     // If original stop had manualDistToNext, that becomes manualDistFromPrev in DOWN
//                                                     else if (originalStop.manualDistToNext && originalStop.manualDistToNext > 0) {
//                                                         segmentDist = parseFloat(originalStop.manualDistToNext);
//                                                     }

//                                                     cumulativeDist += segmentDist;

//                                                     // Determine stop type for return journey
//                                                     let newStopType = originalStop.stopType;
//                                                     if (originalStop.stopType === 'boarding') {
//                                                         newStopType = 'dropping';
//                                                     } else if (originalStop.stopType === 'dropping') {
//                                                         newStopType = 'boarding';
//                                                     }

//                                                     newDownStops.push({
//                                                         ...originalStop,
//                                                         sequence: i + 1,
//                                                         stopType: newStopType,
//                                                         distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
//                                                         manualDistFromPrev: parseFloat(segmentDist.toFixed(1)),
//                                                         manualDistToNext: originalStop.manualDistFromPrev || null,
//                                                         arrivalTime: originalStop.arrivalTime || '',
//                                                         departureTime: originalStop.departureTime || '',
//                                                         timings: originalStop.timings ? [...originalStop.timings] : []
//                                                     });
//                                                 }

//                                                 // Calculate final segment to destination
//                                                 let finalSegment = downTotalDistance - cumulativeDist;
//                                                 if (finalSegment <= 0) {
//                                                     // If can't calculate from total, use the last segment from UP or default
//                                                     const lastUpFirstSegment = upSegmentDistances[0] || 5;
//                                                     finalSegment = lastUpFirstSegment;
//                                                 }

//                                                 // Update the last stop's manualDistToNext
//                                                 if (newDownStops.length > 0 && finalSegment > 0) {
//                                                     newDownStops[newDownStops.length - 1] = {
//                                                         ...newDownStops[newDownStops.length - 1],
//                                                         manualDistToNext: parseFloat(finalSegment.toFixed(1))
//                                                     };
//                                                 }

//                                                 // Update total distance if needed
//                                                 const calculatedTotal = cumulativeDist + finalSegment;
//                                                 if (Math.abs(calculatedTotal - downTotalDistance) > 0.1) {
//                                                     downTotalDistance = calculatedTotal;
//                                                 }

//                                                 // Update state
//                                                 setDownStops(newDownStops);
//                                                 setEditForm(prev => ({
//                                                     ...prev,
//                                                     returnTotalDistance: downTotalDistance.toFixed(1),
//                                                     returnManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.returnManualFinalLeg,
//                                                     returnDurationHours: prev.durationHours,
//                                                     returnDurationMinutes: prev.durationMinutes
//                                                 }));

//                                                 setIsDistanceCalculated(prev => ({ ...prev, down: false }));
//                                                 toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${downTotalDistance.toFixed(1)} km`);
//                                             }
//                                         }}>
//                                             🔄 Auto-Fill / Sync Reversed Stops from UP Route
//                                         </button>
//                                     )}

//                                     <div className="stops-list">
//                                         {getActiveStops().length > 0 && renderInsertButton(0, activeRouteTab === 'UP' ? 'up' : 'down')}
//                                         {getActiveStops().map((stop, index) => (
//                                             <React.Fragment key={index}>
//                                                 <div className={`stop-list-item ${(activeRouteTab === 'UP' ? editUpIndex : editDownIndex) === index ? 'editing-highlight' : ''}`}>
//                                                     <div className="stop-info">
//                                                         <div className="stop-name">
//                                                             {index + 1}. {stop.city}
//                                                             <span className="stop-distance">
//                                                                 ({typeof stop.distanceFromOrigin === 'number'
//                                                                     ? stop.distanceFromOrigin.toFixed(2)
//                                                                     : parseFloat(stop.distanceFromOrigin || 0).toFixed(2)} km)
//                                                             </span>
//                                                         </div>
//                                                         {(editForm.isMultiTrip || isMultiTrip) && stop.timings && stop.timings.length > 0 ? (
//                                                             <div className="stop-multi-times" style={{ marginTop: '8px', marginBottom: '8px' }}>
//                                                                 {stop.timings.map(timing => (
//                                                                     <div key={timing.timeSlotSequence} style={{
//                                                                         display: 'inline-flex', alignItems: 'center', gap: '8px',
//                                                                         backgroundColor: '#e9ecef', padding: '4px 10px', borderRadius: '16px',
//                                                                         margin: '2px 4px', fontSize: '11px'
//                                                                     }}>
//                                                                         <span style={{ fontWeight: '500' }}>Trip {timing.timeSlotSequence}:</span>
//                                                                         <span>Arr {timing.arrivalTime || '--:--'}</span>
//                                                                         <span>→</span>
//                                                                         <span>Dep {timing.departureTime || '--:--'}</span>
//                                                                     </div>
//                                                                 ))}
//                                                             </div>
//                                                         ) : (
//                                                             <div className="stop-times">
//                                                                 Arr: {stop.arrivalTime || 'TBD'} • Dep: {stop.departureTime || 'N/A'}
//                                                             </div>
//                                                         )}
//                                                         {stop.stopType && stop.stopType !== 'none' && (
//                                                             <span style={{
//                                                                 marginLeft: '8px',
//                                                                 marginRight: '19px',
//                                                                 fontSize: '11px',
//                                                                 fontWeight: '500',
//                                                                 padding: '2px 8px',
//                                                                 borderRadius: '12px',
//                                                                 backgroundColor: stop.stopType === 'boarding'
//                                                                     ? '#e3f2fd'
//                                                                     : stop.stopType === 'dropping'
//                                                                         ? '#fce4ec'
//                                                                         : '#e8f5e9',
//                                                                 color: stop.stopType === 'boarding'
//                                                                     ? '#1565c0'
//                                                                     : stop.stopType === 'dropping'
//                                                                         ? '#c62828'
//                                                                         : '#2e7d32',
//                                                                 border: `1px solid ${stop.stopType === 'boarding'
//                                                                     ? '#90caf9'
//                                                                     : stop.stopType === 'dropping'
//                                                                         ? '#f48fb1'
//                                                                         : '#a5d6a7'}`
//                                                             }}>
//                                                                 {stop.stopType === 'boarding' ? '🟢 Boarding'
//                                                                     : stop.stopType === 'dropping' ? '🔴 Dropping'
//                                                                         : '🟡 Both'}
//                                                             </span>
//                                                         )}
//                                                     </div>
//                                                     <div className="stop-actions">
//                                                         <button className="stop-action-btn edit" onClick={() => handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down')}>Edit</button>
//                                                         <button className="stop-action-btn delete" onClick={() => handleDeleteStop(index)}>Delete</button>
//                                                     </div>
//                                                 </div>
//                                                 {renderInsertButton(index + 1, activeRouteTab === 'UP' ? 'up' : 'down')}
//                                             </React.Fragment>
//                                         ))}
//                                     </div>
//                                 </div>

//                                 <div className="form-section">
//                                     <h4>{activeRouteTab} Summary</h4>

//                                     <button
//                                         className="btn btn-success calculate-btn"
//                                         onClick={() => handleEditCalculateDistances(activeRouteTab === 'UP' ? 'up' : 'down')}
//                                         disabled={isCalculatingDistances}
//                                     >
//                                         {isCalculatingDistances ? 'Calculating...' : `Auto-Calculate Distances (${activeRouteTab})`}
//                                     </button>

//                                     {/* Show Distance from Last Stop to Destination field */}
//                                     {(() => {
//                                         const stops = activeRouteTab === 'UP' ? upStops : downStops;
//                                         const lastStop = stops.length > 0 ? stops[stops.length - 1] : null;

//                                         const isLastManual = lastStop?.isManualStop === true ||
//                                             (lastStop && (!lastStop.coordinates || (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0)));

//                                         const shouldShow = (activeRouteTab === 'DOWN' && stops.length > 0) ||
//                                             (activeRouteTab === 'UP' && isLastManual);

//                                         if (!shouldShow) return null;

//                                         const fieldValue = activeRouteTab === 'UP'
//                                             ? (editForm.upManualFinalLeg || '')
//                                             : (editForm.returnManualFinalLeg || '');

//                                         return (
//                                             <div className="form-row" style={{ marginTop: '10px' }}>
//                                                 <div className="form-group full-width">
//                                                     <label>Distance from Last Stop to Destination (KM) *</label>
//                                                     <input
//                                                         type="number"
//                                                         value={fieldValue}
//                                                         onChange={(e) => {
//                                                             const value = e.target.value;
//                                                             if (activeRouteTab === 'UP') {
//                                                                 setEditForm(prev => ({ ...prev, upManualFinalLeg: value }));
//                                                                 const lastStopDist = stops.length > 0 ? (stops[stops.length - 1].distanceFromOrigin || 0) : 0;
//                                                                 const newTotal = lastStopDist + (parseFloat(value) || 0);
//                                                                 if (newTotal > 0) {
//                                                                     setEditForm(prev => ({ ...prev, totalDistance: newTotal.toFixed(1) }));
//                                                                 }
//                                                             } else {
//                                                                 setEditForm(prev => ({ ...prev, returnManualFinalLeg: value }));
//                                                                 const lastStopDist = stops.length > 0 ? (stops[stops.length - 1].distanceFromOrigin || 0) : 0;
//                                                                 const newTotal = lastStopDist + (parseFloat(value) || 0);
//                                                                 if (newTotal > 0) {
//                                                                     setEditForm(prev => ({ ...prev, returnTotalDistance: newTotal.toFixed(1) }));
//                                                                 }
//                                                             }
//                                                         }}
//                                                         placeholder="Distance from last stop to destination"
//                                                         className="form-input"
//                                                         min="0"
//                                                         step="0.1"
//                                                         style={{ borderColor: '#dc3545', backgroundColor: '#fff5f5' }}
//                                                     />
//                                                     <small className="helper-text" style={{ color: '#dc3545' }}>
//                                                         ⚠️ Required because the last stop is manual. This distance will be added to the total.
//                                                     </small>
//                                                 </div>
//                                             </div>
//                                         );
//                                     })()}

//                                     <div className="form-row summary-fields">
//                                         <div className="form-group">
//                                             <label>Total Distance (KM)</label>
//                                             <input
//                                                 type="number"
//                                                 value={activeRouteTab === 'UP' ? (editForm.totalDistance || '') : (editForm.returnTotalDistance || '')}
//                                                 onChange={(e) => {
//                                                     const value = e.target.value;
//                                                     if (activeRouteTab === 'UP') {
//                                                         setEditForm(prev => ({ ...prev, totalDistance: value }));
//                                                     } else {
//                                                         setEditForm(prev => ({ ...prev, returnTotalDistance: value }));
//                                                     }
//                                                 }}
//                                                 className="form-input"
//                                                 min="0"
//                                                 step="0.1"
//                                             />
//                                         </div>
//                                         <div className="form-group">
//                                             <label>Est. Duration</label>
//                                             <div className="duration-inputs">
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? (editForm.durationHours || '') : (editForm.returnDurationHours || '')}
//                                                     onChange={(e) => {
//                                                         const value = e.target.value;
//                                                         if (activeRouteTab === 'UP') {
//                                                             setEditForm(prev => ({ ...prev, durationHours: value }));
//                                                         } else {
//                                                             setEditForm(prev => ({ ...prev, returnDurationHours: value }));
//                                                         }
//                                                     }}
//                                                     className="form-input"
//                                                     placeholder="Hours"
//                                                     min="0"
//                                                 />
//                                                 <span>h</span>
//                                                 <input
//                                                     type="number"
//                                                     value={activeRouteTab === 'UP' ? (editForm.durationMinutes || '') : (editForm.returnDurationMinutes || '')}
//                                                     onChange={(e) => {
//                                                         let value = e.target.value;
//                                                         // Validate minutes between 0-59
//                                                         let minutes = Math.min(59, Math.max(0, parseInt(value) || 0));
//                                                         if (activeRouteTab === 'UP') {
//                                                             setEditForm(prev => ({ ...prev, durationMinutes: minutes.toString() }));
//                                                         } else {
//                                                             setEditForm(prev => ({ ...prev, returnDurationMinutes: minutes.toString() }));
//                                                         }
//                                                     }}
//                                                     className="form-input"
//                                                     placeholder="Minutes"
//                                                     min="0"
//                                                     max="59"
//                                                 />
//                                                 <span>m</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Status Section */}
//                                 <div className="form-section">
//                                     <h4>Status</h4>
//                                     <div className="form-row">
//                                         <div className="form-group">
//                                             <label className="checkbox-container">
//                                                 <input type="checkbox" checked={editForm.isActive} onChange={(e) => setEditForm(prev => ({ ...prev, isActive: e.target.checked }))} />
//                                                 <span>Route is Active</span>
//                                             </label>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Form Actions */}
//                             <div className="form-actions">
//                                 <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
//                                 <button className="btn btn-primary save-route-btn" onClick={handleUpdateRoute} disabled={isUpdatingRoute}>
//                                     {isUpdatingRoute ? 'Updating...' : 'Update Route'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showStopEditModal && stopBeingEdited && (
//                 <div className="modal-overlay" onClick={() => setShowStopEditModal(false)}>
//                     <div className="modal-content edit-stop-modal" onClick={(e) => e.stopPropagation()}
//                         style={{ maxWidth: '1200px', width: '90%' }}>

//                         <div className="modal-header">
//                             <h3>
//                                 Edit Stop #{stopBeingEdited.index + 1}
//                                 <span style={{ fontWeight: 'normal', color: '#666', fontSize: '14px' }}>
//                                     {' '}— {stopBeingEdited.originalStop.city}
//                                 </span>
//                             </h3>
//                             <button className="modal-close-btn" onClick={() => setShowStopEditModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             {/* Manual toggle */}
//                             <div className="form-row" style={{ marginBottom: '12px' }}>
//                                 <Checkbox
//                                     label="Manually Typed Stop (No Map Suggestions)"
//                                     checked={stopEditForm.isManualStop}
//                                     onChange={() => setStopEditForm(prev => ({
//                                         ...prev,
//                                         isManualStop: !prev.isManualStop,
//                                         manualDistFromPrev: !prev.isManualStop ? prev.manualDistFromPrev : ''
//                                     }))}
//                                 />
//                             </div>

//                             {/* Location */}
//                             {/* {!stopEditForm.isManualStop ? (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search Location *</label>
//                                             <LocationInput
//                                                 value={stopEditForm.city}
//                                                 onChange={(value) => setStopEditForm(prev => ({ ...prev, city: value }))}
//                                                 onLocationSelect={(location) => setStopEditForm(prev => ({
//                                                     ...prev,
//                                                     city: location.city || location.name || '',
//                                                     state: location.state || prev.state,
//                                                     address: location.address || '',
//                                                 }))}
//                                                 placeholder="Search city or address..."
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={stopEditForm.address}
//                                                 onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address" className="form-input" />
//                                         </div>
//                                     </div>
//                                 </>
//                            ) : (
//     <>
//         <div className="form-row">
//             <div className="form-group full-width">
//                 <label>City Name *</label>
//                 <input type="text" value={stopEditForm.city}
//                     onChange={(e) => setStopEditForm(prev => ({ ...prev, city: e.target.value }))}
//                     placeholder="Enter city name manually" className="form-input" />
//             </div>
//         </div>
//         <div className="form-row">
//             <div className="form-group full-width">
//                 <label>Address</label>
//                 <input type="text" value={stopEditForm.address}
//                     onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
//                     placeholder="Full address (e.g., NH-19, Near Bus Stand)" className="form-input" />
//                 <small className="helper-text">Complete address of the stop location</small>
//             </div>
//         </div>
//     </>
// )} */}

//                             {!stopEditForm.isManualStop ? (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search Location *</label>
//                                             <LocationInput
//                                                 value={stopEditForm.city}
//                                                 onChange={(value) => setStopEditForm(prev => ({ ...prev, city: value }))}
//                                                 onLocationSelect={(location) => setStopEditForm(prev => ({
//                                                     ...prev,
//                                                     city: location.city || location.name || '',
//                                                     state: location.state || prev.state,
//                                                     address: location.address || '',
//                                                 }))}
//                                                 placeholder="Search city or address..."
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={stopEditForm.address}
//                                                 onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address" className="form-input" />
//                                         </div>
//                                     </div>
//                                 </>
//                             ) : (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search City *</label>
//                                             <div className="city-search-container" style={{ position: 'relative' }}>
//                                                 <input
//                                                     type="text"
//                                                     value={stopEditForm.city}
//                                                     onChange={async (e) => {
//                                                         const value = toTitleCase(e.target.value);        // ← ADD toTitleCase
//                                                         setNewRoute(prev => ({ ...prev, stopCity: value }));

//                                                         if (value !== stopEditForm.city) {
//                                                             setStopEditForm(prev => ({
//                                                                 ...prev,
//                                                                 address: '',
//                                                                 state: '',
//                                                                 terminal: ''
//                                                             }));
//                                                         }

//                                                         if (value.length >= 2) {
//                                                             try {
//                                                                 const response = await searchRouteIntermediateStops(token, value);
//                                                                 if (response.success && response.cities && response.cities.length > 0) {
//                                                                     setEditCitySuggestions(response.cities);
//                                                                     setShowEditCityDropdown(true);
//                                                                 } else {
//                                                                     setEditCitySuggestions([]);
//                                                                     setShowEditCityDropdown(false);
//                                                                 }
//                                                             } catch (error) {
//                                                                 console.error('Error searching cities:', error);
//                                                                 setEditCitySuggestions([]);
//                                                                 setShowEditCityDropdown(false);
//                                                             }
//                                                         } else {
//                                                             setEditCitySuggestions([]);
//                                                             setShowEditCityDropdown(false);
//                                                         }
//                                                     }}
//                                                     onFocus={() => {
//                                                         if (editCitySuggestions.length > 0) {
//                                                             setShowEditCityDropdown(true);
//                                                         }
//                                                     }}
//                                                     onBlur={() => {
//                                                         setTimeout(() => setShowEditCityDropdown(false), 200);
//                                                     }}
//                                                     placeholder="Type city name (min 2 characters)..."
//                                                     className="form-input"
//                                                 />
//                                                 {showEditCityDropdown && editCitySuggestions.length > 0 && (
//                                                     <div className="city-suggestions-dropdown" style={{
//                                                         position: 'absolute',
//                                                         top: '100%',
//                                                         left: 0,
//                                                         right: 0,
//                                                         backgroundColor: 'white',
//                                                         border: '1px solid #ddd',
//                                                         borderRadius: '4px',
//                                                         maxHeight: '200px',
//                                                         overflowY: 'auto',
//                                                         zIndex: 10000,
//                                                         boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                                                     }}>
//                                                         {editCitySuggestions.map((city, idx) => (
//                                                             <div
//                                                                 key={city.id || idx}
//                                                                 onClick={() => {
//                                                                     setStopEditForm(prev => ({
//                                                                         ...prev,
//                                                                         city: city.name,
//                                                                         address: city.address || city.name,
//                                                                         state: city.state || '',
//                                                                         terminal: city.terminal || `${city.name} Bus Stand`
//                                                                     }));
//                                                                     setShowEditCityDropdown(false);
//                                                                     toast.success(`Auto-filled details for ${city.name}`);
//                                                                 }}
//                                                                 style={{
//                                                                     padding: '10px 12px',
//                                                                     cursor: 'pointer',
//                                                                     borderBottom: '1px solid #f0f0f0'
//                                                                 }}
//                                                                 onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                                                 onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
//                                                             >
//                                                                 <div style={{ fontWeight: '500' }}>{city.name}</div>
//                                                                 <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                                     {city.state}
//                                                                     {city.terminal && ` • ${city.terminal}`}
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                             <small className="helper-text">Type at least 2 characters to search for cities from existing routes</small>
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={stopEditForm.address}
//                                                 onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address (e.g., NH-19, Near Bus Stand)" className="form-input" />
//                                             <small className="helper-text">Complete address of the stop location</small>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}

//                             {/* State & Terminal */}
//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label>State</label>
//                                     <input type="text" value={stopEditForm.state}
//                                         onChange={(e) => setStopEditForm(prev => ({ ...prev, state: e.target.value }))}
//                                         placeholder="State" className="form-input" />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Terminal</label>
//                                     <input type="text" value={stopEditForm.terminal}
//                                         onChange={(e) => setStopEditForm(prev => ({ ...prev, terminal: e.target.value }))}
//                                         placeholder="Terminal name" className="form-input" />
//                                 </div>
//                             </div>

//                             {/* Times section - Multi-trip aware */}
//                             {isMultiTrip ? (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label style={{ marginBottom: '12px', display: 'block' }}>
//                                                 Timings for each trip: {numberOfTrips} {numberOfTrips === 1 ? 'trip' : 'trips'} per day
//                                             </label>
//                                             <div style={{
//                                                 border: '1px solid #e0e0e0',
//                                                 borderRadius: '8px',
//                                                 overflow: 'hidden',
//                                                 marginTop: '8px'
//                                             }}>
//                                                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                                     <thead>
//                                                         <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
//                                                             <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
//                                                             <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
//                                                             <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
//                                                         </tr>
//                                                     </thead>
//                                                     <tbody>
//                                                         {Array.from({ length: numberOfTrips }, (_, i) => {
//                                                             const tripNumber = i + 1;
//                                                             const timing = stopEditForm.timings?.find(t => t.timeSlotSequence === tripNumber) ||
//                                                                 { timeSlotSequence: tripNumber, arrivalTime: '', departureTime: '' };

//                                                             return (
//                                                                 <tr key={tripNumber} style={{ borderBottom: i < numberOfTrips - 1 ? '1px solid #f0f0f0' : 'none' }}>
//                                                                     <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
//                                                                         Trip #{tripNumber}
//                                                                     </td>
//                                                                     <td style={{ padding: '10px' }}>
//                                                                         <TimePicker
//                                                                             value={timing.arrivalTime}
//                                                                             onChange={(value) => {
//                                                                                 const updatedTimings = [...(stopEditForm.timings || [])];
//                                                                                 const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === tripNumber);
//                                                                                 const timingData = {
//                                                                                     timeSlotSequence: tripNumber,
//                                                                                     arrivalTime: value,
//                                                                                     departureTime: timing.departureTime || ''
//                                                                                 };
//                                                                                 if (existingIndex >= 0) {
//                                                                                     updatedTimings[existingIndex] = timingData;
//                                                                                 } else {
//                                                                                     updatedTimings.push(timingData);
//                                                                                 }
//                                                                                 setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
//                                                                             }}
//                                                                             placeholder="--:--"
//                                                                         />
//                                                                     </td>
//                                                                     <td style={{ padding: '10px' }}>
//                                                                         <TimePicker
//                                                                             value={timing.departureTime}
//                                                                             onChange={(value) => {
//                                                                                 const updatedTimings = [...(stopEditForm.timings || [])];
//                                                                                 const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === tripNumber);
//                                                                                 const timingData = {
//                                                                                     timeSlotSequence: tripNumber,
//                                                                                     arrivalTime: timing.arrivalTime || '',
//                                                                                     departureTime: value
//                                                                                 };
//                                                                                 if (existingIndex >= 0) {
//                                                                                     updatedTimings[existingIndex] = timingData;
//                                                                                 } else {
//                                                                                     updatedTimings.push(timingData);
//                                                                                 }
//                                                                                 setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
//                                                                             }}
//                                                                             placeholder="--:--"
//                                                                         />
//                                                                     </td>
//                                                                 </tr>
//                                                             );
//                                                         })}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                             <small className="helper-text" style={{ display: 'block', marginTop: '8px', color: '#666' }}>
//                                                 Tip: Set arrival and departure times for each trip separately
//                                             </small>
//                                         </div>
//                                     </div>
//                                 </>
//                             ) : (
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Arrival Time *</label>
//                                         <TimePicker
//                                             value={stopEditForm.arrivalTime}
//                                             onChange={(value) => setStopEditForm(prev => ({ ...prev, arrivalTime: value }))}
//                                             placeholder="Select time"
//                                         />
//                                     </div>
//                                     <div className="form-group">
//                                         <label>Departure Time (Opt)</label>
//                                         <TimePicker
//                                             value={stopEditForm.departureTime}
//                                             onChange={(value) => setStopEditForm(prev => ({ ...prev, departureTime: value }))}
//                                             placeholder="Select time"
//                                         />
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Manual distance */}
//                             {stopEditForm.isManualStop && (
//                                 <div className="form-row">
//                                     <div className="form-group full-width">
//                                         <label>Distance from Previous Stop (km) *</label>
//                                         <input type="number" value={stopEditForm.manualDistFromPrev}
//                                             onChange={(e) => setStopEditForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
//                                             placeholder="e.g., 50" className="form-input" min="0" step="0.1" />
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Distance to next if next stop has GPS */}
//                             {stopEditForm.isManualStop && (() => {
//                                 const stops = stopBeingEdited.type === 'up' ? upStops : downStops;
//                                 const nextStop = stops[stopBeingEdited.index + 1];
//                                 const isNextAuto = nextStop?.coordinates &&
//                                     (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
//                                 if (isNextAuto) return (
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Distance to Next Stop ({nextStop.city}) (km) *</label>
//                                             <input type="number" value={stopEditForm.manualDistToNext}
//                                                 onChange={(e) => setStopEditForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
//                                                 placeholder={`Distance to ${nextStop.city}`}
//                                                 className="form-input" min="0" step="0.1" />
//                                             <small style={{ color: '#dc3545' }}>
//                                                 ⚠️ Required because next stop has GPS coordinates
//                                             </small>
//                                         </div>
//                                     </div>
//                                 );
//                                 return null;
//                             })()}

//                             {/* Stop type */}
//                             <div className="form-row checkbox-row">
//                                 <Checkbox label="Boarding Point" checked={stopEditForm.isBoarding}
//                                     onChange={() => setStopEditForm(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
//                                 <Checkbox label="Dropping Point" checked={stopEditForm.isDropping}
//                                     onChange={() => setStopEditForm(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
//                             </div>
//                         </div>

//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', padding: '16px' }}>
//                             <button className="btn btn-secondary" onClick={() => setShowStopEditModal(false)}>
//                                 Cancel
//                             </button>
//                             <button className="btn btn-primary" onClick={saveEditedStop}
//                             // disabled={!stopEditForm.city || !stopEditForm.arrivalTime}
//                             >
//                                 Save Changes
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {showStopInsertModal && (
//                 <div className="modal-overlay" onClick={() => setShowStopInsertModal(false)}>
//                     <div className="modal-content edit-stop-modal" onClick={(e) => e.stopPropagation()}
//                         style={{ width: '90%' }}>

//                         <div className="modal-header">
//                             <h3>Insert Stop at Position #{pendingInsertIndex + 1}</h3>
//                             <button className="modal-close-btn" onClick={() => setShowStopInsertModal(false)}>×</button>
//                         </div>

//                         <div className="modal-body">
//                             <div className="form-row" style={{ marginBottom: '12px' }}>
//                                 <Checkbox
//                                     label="Manually Typed Stop (No Map Suggestions)"
//                                     checked={insertStopForm.isManualStop}
//                                     onChange={() => setInsertStopForm(prev => ({
//                                         ...prev,
//                                         isManualStop: !prev.isManualStop,
//                                         city: '', address: '', state: '', terminal: '',
//                                         manualDistFromPrev: ''
//                                     }))}
//                                 />
//                             </div>

//                             {!insertStopForm.isManualStop ? (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search Location *</label>
//                                             <LocationInput
//                                                 value={insertStopForm.city}
//                                                 onChange={(value) => setInsertStopForm(prev => ({ ...prev, city: value }))}
//                                                 onLocationSelect={(location) => setInsertStopForm(prev => ({
//                                                     ...prev,
//                                                     city: location.city || location.name || '',
//                                                     state: location.state || prev.state,
//                                                     address: location.address || '',
//                                                 }))}
//                                                 placeholder="Search city or address..."
//                                             />
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={insertStopForm.address}
//                                                 onChange={(e) => setInsertStopForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address" className="form-input" />
//                                         </div>
//                                     </div>
//                                 </>
//                             ) : (
//                                 <>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Search City *</label>
//                                             <div style={{ position: 'relative' }}>
//                                                 <input
//                                                     type="text"
//                                                     value={insertStopForm.city}
//                                                     onChange={async (e) => {
//                                                         const value = e.target.value;
//                                                         setInsertStopForm(prev => ({ ...prev, city: value, address: '', state: '', terminal: '' }));
//                                                         if (value.length >= 2) {
//                                                             try {
//                                                                 const response = await searchRouteIntermediateStops(token, value);
//                                                                 if (response.success && response.cities?.length > 0) {
//                                                                     // setInsertCitySuggestions(response.cities);
//                                                                     normalizeAndDeduplicateSuggestions(response.cities);
//                                                                     setShowInsertCityDropdown(true);
//                                                                 } else {
//                                                                     setInsertCitySuggestions([]);
//                                                                     setShowInsertCityDropdown(false);
//                                                                 }
//                                                             } catch { setInsertCitySuggestions([]); setShowInsertCityDropdown(false); }
//                                                         } else {
//                                                             setInsertCitySuggestions([]);
//                                                             setShowInsertCityDropdown(false);
//                                                         }
//                                                     }}
//                                                     onFocus={() => insertCitySuggestions.length > 0 && setShowInsertCityDropdown(true)}
//                                                     onBlur={() => setTimeout(() => setShowInsertCityDropdown(false), 200)}
//                                                     placeholder="Type city name (min 2 characters)..."
//                                                     className="form-input"
//                                                 />
//                                                 {showInsertCityDropdown && insertCitySuggestions.length > 0 && (
//                                                     <div style={{
//                                                         position: 'absolute', top: '100%', left: 0, right: 0,
//                                                         backgroundColor: 'white', border: '1px solid #ddd',
//                                                         borderRadius: '4px', maxHeight: '200px', overflowY: 'auto',
//                                                         zIndex: 10000, boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
//                                                     }}>
//                                                         {insertCitySuggestions.map((city, idx) => (
//                                                             <div key={city.id || idx}
//                                                                 onMouseDown={() => {
//                                                                     setInsertStopForm(prev => ({
//                                                                         ...prev,
//                                                                         city: city.name,
//                                                                         address: city.address || city.name,
//                                                                         state: city.state || '',
//                                                                         terminal: city.terminal || `${city.name} Bus Stand`,
//                                                                     }));
//                                                                     setShowInsertCityDropdown(false);
//                                                                     setInsertCitySuggestions([]);
//                                                                     toast.success(`Auto-filled details for ${city.name}`);
//                                                                 }}
//                                                                 style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
//                                                                 onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f7ff'}
//                                                                 onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
//                                                             >
//                                                                 <div style={{ fontWeight: '500' }}>{city.name}</div>
//                                                                 <div style={{ fontSize: '12px', color: '#6c757d' }}>
//                                                                     {city.state}{city.terminal ? ` • ${city.terminal}` : ''}
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                             <small className="helper-text">Type at least 2 characters to search cities</small>
//                                         </div>
//                                     </div>
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Address</label>
//                                             <input type="text" value={insertStopForm.address}
//                                                 onChange={(e) => setInsertStopForm(prev => ({ ...prev, address: e.target.value }))}
//                                                 placeholder="Full address" className="form-input" />
//                                         </div>
//                                     </div>
//                                 </>
//                             )}

//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label>State</label>
//                                     <input type="text" value={insertStopForm.state}
//                                         onChange={(e) => setInsertStopForm(prev => ({ ...prev, state: e.target.value }))}
//                                         placeholder="State" className="form-input" />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Terminal</label>
//                                     <input type="text" value={insertStopForm.terminal}
//                                         onChange={(e) => setInsertStopForm(prev => ({ ...prev, terminal: e.target.value }))}
//                                         placeholder="Terminal name" className="form-input" />
//                                 </div>
//                             </div>

//                             <div className="form-row">
//                                 <div className="form-group">
//                                     <label>Arrival Time *</label>
//                                     <TimePicker value={insertStopForm.arrivalTime}
//                                         onChange={(value) => setInsertStopForm(prev => ({ ...prev, arrivalTime: value }))}
//                                         placeholder="Select time" />
//                                 </div>
//                                 <div className="form-group">
//                                     <label>Departure Time (Opt)</label>
//                                     <TimePicker value={insertStopForm.departureTime}
//                                         onChange={(value) => setInsertStopForm(prev => ({ ...prev, departureTime: value }))}
//                                         placeholder="Select time" />
//                                 </div>
//                             </div>

//                             {insertStopForm.isManualStop && (
//                                 <div className="form-row">
//                                     <div className="form-group full-width">
//                                         <label>Distance from Previous Stop (km) *</label>
//                                         <input type="number" value={insertStopForm.manualDistFromPrev}
//                                             onChange={(e) => setInsertStopForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
//                                             placeholder="e.g., 50" className="form-input" min="0" step="0.1" />
//                                         <small className="helper-text">Required for manual stops</small>
//                                     </div>
//                                 </div>
//                             )}

//                             {insertStopForm.isManualStop && (() => {
//                                 const stops = activeRouteTab === 'UP' ? upStops : downStops;
//                                 const nextStop = stops[pendingInsertIndex];
//                                 const isNextAuto = nextStop?.coordinates &&
//                                     (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
//                                 if (isNextAuto) return (
//                                     <div className="form-row">
//                                         <div className="form-group full-width">
//                                             <label>Distance to Next Stop ({nextStop.city}) (km)</label>
//                                             <input type="number" value={insertStopForm.manualDistToNext}
//                                                 onChange={(e) => setInsertStopForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
//                                                 placeholder={`Distance to ${nextStop.city}`}
//                                                 className="form-input" min="0" step="0.1" />
//                                             <small style={{ color: '#dc3545' }}>⚠️ Next stop has GPS coordinates</small>
//                                         </div>
//                                     </div>
//                                 );
//                                 return null;
//                             })()}

//                             <div className="form-row checkbox-row">
//                                 <Checkbox label="Boarding Point" checked={insertStopForm.isBoarding}
//                                     onChange={() => setInsertStopForm(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
//                                 <Checkbox label="Dropping Point" checked={insertStopForm.isDropping}
//                                     onChange={() => setInsertStopForm(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
//                             </div>
//                         </div>

//                         <div className="modal-footer" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', padding: '16px' }}>
//                             <button className="btn btn-secondary" onClick={() => setShowStopInsertModal(false)}>Cancel</button>
//                             <button className="btn btn-primary" onClick={saveInsertedStop}
//                                 disabled={!insertStopForm.city || !insertStopForm.arrivalTime}>
//                                 Insert Stop
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//             {/* Platform Fee Modal */}
//             {showPlatformFeeModal && selectedBusForActivation && (
//                 <PlatformFeeModal
//                     bus={selectedBusForActivation}
//                     onClose={() => {
//                         console.log("Closing platform fee modal");
//                         setShowPlatformFeeModal(false);
//                         setSelectedBusForActivation(null);
//                     }}
//                     onActivated={() => {
//                         console.log("Bus activated, refreshing routes...");
//                         fetchRoutes();
//                         toast.success('Bus activated successfully!');
//                     }}
//                 />
//             )}
//         </div>
//     );
// };

// export default RouteManage;

// RouteManage.jsx - Complete with trip management and proper display in intermediate stops

import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import '../../Styles/ManagementPages.css';
import {
    getAllRoutes,
    getRouteById,
    createRoute,
    updateRoute,
    deleteRoute,
    toggleRouteStatus,
    getAllMasterRoutes,
    getMasterRouteByName,
    searchRouteIntermediateStops,
    getMasterRouteById,
    searchMasterRoutesByCities,
    getBusById,
    activateBusWithPlatformFee
} from '../../Services/Operations/ProductAPI';
import { toast } from 'react-toastify';
import '../../Styles/RouteManage.css';
import { useNavigate } from 'react-router-dom';
import { getPlacePredictions, getPlaceDetails, getDistanceMatrix } from '../../utilis/mapUtils';
import PlatformFeeModal from './PlatformFeeModal';
import TimeSlotManager from './TimeSlotManager';
import StopTimingManager from './StopTimingManager';
import {
    toTitleCase,
    toTitleCaseLive,
    normalizeAndDeduplicateSuggestions,
} from '../../utilis/normalizeUtils';

// Helper function to format time for display
const TimeDisplay = ({ time }) => {
    if (!time) return '--:--';
    if (time.includes(':')) {
        const [hours, minutes] = time.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour % 12 || 12;
        return `${displayHour}:${minutes} ${ampm}`;
    }
    return time;
};

// Helper function to calculate manualDistFromPrev from distanceFromOrigin
const calculateManualDistFromPrev = (stops, index) => {
    if (!stops || stops.length === 0 || index < 0 || index >= stops.length) return '';

    const stop = stops[index];
    if (!stop) return '';

    if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
        return String(stop.manualDistFromPrev);
    }

    if (stop.distanceFromOrigin && parseFloat(stop.distanceFromOrigin) > 0) {
        if (index === 0) {
            return String(stop.distanceFromOrigin);
        } else {
            const prevStop = stops[index - 1];
            if (prevStop && prevStop.distanceFromOrigin !== undefined) {
                const segmentDist = parseFloat((stop.distanceFromOrigin - prevStop.distanceFromOrigin).toFixed(1));
                if (segmentDist > 0) {
                    return String(segmentDist);
                }
            }
        }
    }

    return '';
};

// Skeleton Components
const SkeletonStatsCard = () => (
    <div className="stat-card skeleton">
        <div className="skeleton-title"></div>
        <div className="skeleton-value"></div>
        <div className="skeleton-subtitle"></div>
    </div>
);

const SkeletonTableRow = () => (
    <tr className="skeleton-row">
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-cell"></div></td>
        <td><div className="skeleton-badge"></div></td>
        <td><div className="skeleton-badge"></div></td>
        <td><div className="skeleton-actions"></div></td>
    </tr>
);

const SkeletonTable = () => (
    <div className="table-container skeleton">
        <table className="data-table">
            <thead>
                <tr>
                    <th>No.</th>
                    <th>Route Name</th>
                    <th>Route No.</th>
                    <th>Origin</th>
                    <th>Destination</th>
                    <th>Distance</th>
                    <th>Stops</th>
                    <th>Type</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                    <SkeletonTableRow key={i} />
                ))}
            </tbody>
        </table>
    </div>
);

const SkeletonModal = () => (
    <div className="modal-overlay">
        <div className="modal-content add-route-content skeleton">
            <div className="modal-header">
                <div className="skeleton-title"></div>
                <div className="skeleton-close"></div>
            </div>
            <div className="modal-body">
                <div className="skeleton-toggle"></div>
                <div className="skeleton-tabs"></div>
                <div className="form-sections">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="form-section">
                            <div className="skeleton-section-title"></div>
                            <div className="form-row">
                                <div className="form-group"><div className="skeleton-input"></div></div>
                                <div className="form-group"><div className="skeleton-input"></div></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="modal-footer">
                <div className="skeleton-button"></div>
                <div className="skeleton-button"></div>
            </div>
        </div>
    </div>
);

const LocationInput = ({ value, onChange, placeholder, onLocationSelect, type = 'origin' }) => {
    const [searchQuery, setSearchQuery] = useState(value || '');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        setSearchQuery(value || '');
    }, [value]);

    const searchLocations = async (query) => {
        if (!query || query.trim().length < 2) {
            setSuggestions([]);
            return;
        }

        setIsLoading(true);
        try {
            const predictions = await getPlacePredictions(query);
            setSuggestions(predictions);
            setShowSuggestions(predictions.length > 0);
        } catch (error) {
            console.error('Search error:', error);
            setSuggestions([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelect = async (prediction) => {
        setIsLoading(true);
        try {
            const placeDetails = await getPlaceDetails(prediction.place_id);

            if (placeDetails) {
                setSearchQuery(placeDetails.name || placeDetails.address);
                setShowSuggestions(false);

                if (onLocationSelect) {
                    onLocationSelect({
                        name: placeDetails.name,
                        address: placeDetails.address,
                        city: placeDetails.city || prediction.structured_formatting?.secondary_text?.split(',')[0] || '',
                        state: placeDetails.state || prediction.structured_formatting?.secondary_text?.split(',')[1]?.trim() || '',
                        coordinates: placeDetails.coordinates || { lat: 0, lng: 0 },
                        placeId: prediction.place_id
                    });
                }
            }
        } catch (error) {
            console.error('Error getting place details:', error);
            toast.error('Failed to get location details');
        } finally {
            setIsLoading(false);
        }
    };

    const handleTextChange = (e) => {
        const newValue = e.target.value;
        setSearchQuery(newValue);
        onChange(newValue);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            searchLocations(newValue);
        }, 500);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <div className="location-input-container">
            <div className="location-input-wrapper">
                <input
                    type="text"
                    value={searchQuery}
                    onChange={handleTextChange}
                    onFocus={() => {
                        if (suggestions.length > 0) {
                            setShowSuggestions(true);
                        }
                    }}
                    onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                    className="edit-input"
                    placeholder={placeholder}
                />
                {isLoading && (
                    <div className="location-loading">
                        <div className="spinner"></div>
                    </div>
                )}
            </div>
            {showSuggestions && suggestions.length > 0 && (
                <div className="location-suggestions">
                    <div className="suggestions-header">
                        <span>Search Results</span>
                    </div>
                    {suggestions.map((prediction, index) => (
                        <div
                            key={prediction.place_id || index}
                            className="suggestion-item"
                            onClick={() => handleSelect(prediction)}
                        >
                            <div className="suggestion-main">
                                {prediction.structured_formatting?.main_text || prediction.description}
                            </div>
                            <div className="suggestion-secondary">
                                {prediction.structured_formatting?.secondary_text}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const TimePicker = ({ value, onChange, placeholder }) => {
    return (
        <div className="time-picker">
            <input
                type="time"
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                className="edit-input"
                placeholder={placeholder}
            />
        </div>
    );
};

const Checkbox = ({ label, checked, onChange }) => (
    <label className="checkbox-container">
        <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="checkbox-input"
        />
        <span className="checkbox-label">{label}</span>
    </label>
);

const StopTypeBadge = ({ type }) => {
    const types = {
        boarding: { label: '🟢 Boarding', className: 'boarding' },
        dropping: { label: '🔴 Dropping', className: 'dropping' },
        both: { label: '🟡 Both', className: 'both' },
        none: { label: 'Pass-through', className: 'none' }
    };
    const info = types[type] || types.none;
    return <span className={`stop-type-badge ${info.className}`}>{info.label}</span>;
};

const StatusBadge = ({ isActive }) => (
    <span className={`status-badge ${isActive ? 'active' : 'inactive'}`}>
        {isActive ? 'Active' : 'Inactive'}
    </span>
);

const MasterRouteSelector = ({ value, onChange, onRouteNameChange, token, disabled }) => {
    const [masterRoutes, setMasterRoutes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [source, setSource] = useState('');
    const [destination, setDestination] = useState('');
    const [isManualEntry, setIsManualEntry] = useState(false);
    const [routeNameValue, setRouteNameValue] = useState('');
    const [selectedRouteValue, setSelectedRouteValue] = useState(null);
    const [selectedRouteDetails, setSelectedRouteDetails] = useState(null);

    const [sourceSuggestions, setSourceSuggestions] = useState([]);
    const [destSuggestions, setDestSuggestions] = useState([]);
    const [showSourceSuggestions, setShowSourceSuggestions] = useState(false);
    const [showDestSuggestions, setShowDestSuggestions] = useState(false);
    const [isLoadingSource, setIsLoadingSource] = useState(false);
    const [isLoadingDest, setIsLoadingDest] = useState(false);

    const sourceTimeoutRef = useRef(null);
    const destTimeoutRef = useRef(null);
    const searchTimeoutRef = useRef(null);

    useEffect(() => {
        if (value && value.masterRouteName) {
            setRouteNameValue(value.masterRouteName);
            setSelectedRouteValue(value);
            if (value.origin?.city) setSource(value.origin.city);
            if (value.destination?.city) setDestination(value.destination.city);
        } else {
            setRouteNameValue('');
            setSelectedRouteValue(null);
            setSource('');
            setDestination('');
            setMasterRoutes([]);
            setShowDropdown(false);
            setIsManualEntry(false);
        }
    }, [value]);

    const toTitleCase = (str) =>
        str
            ? str.trim().replace(/\s+/g, ' ').replace(/[^\s-]+/g, (w) =>
                w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
            )
            : str;

    const searchCities = async (query, type) => {
        if (!query || query.length < 2) {
            if (type === 'source') {
                setSourceSuggestions([]);
                setShowSourceSuggestions(false);
            } else {
                setDestSuggestions([]);
                setShowDestSuggestions(false);
            }
            return;
        }

        try {
            if (type === 'source') {
                setIsLoadingSource(true);
            } else {
                setIsLoadingDest(true);
            }

            const response = await searchRouteIntermediateStops(token, query);

            if (response.success && response.cities) {
                const deduped = normalizeAndDeduplicateSuggestions(response.cities);
                if (type === 'source') {
                    setSourceSuggestions(deduped);
                    setShowSourceSuggestions(deduped.length > 0);
                } else {
                    setDestSuggestions(deduped);
                    setShowDestSuggestions(deduped.length > 0);
                }
            }
        } catch (error) {
            console.error('Error fetching city suggestions:', error);
        } finally {
            if (type === 'source') {
                setIsLoadingSource(false);
            } else {
                setIsLoadingDest(false);
            }
        }
    };

    const searchMasterRoutes = async (sourceCity, destCity) => {
        if (!sourceCity && !destCity) {
            setMasterRoutes([]);
            setShowDropdown(false);
            return;
        }

        setIsLoading(true);
        try {
            const response = await searchMasterRoutesByCities(token, sourceCity, destCity);

            if (response.success && response.data) {
                const routesData = response.data.routes || (Array.isArray(response.data) ? response.data : []);
                const mappedRoutes = routesData.map(route => ({
                    _id: route._id,
                    originCity: toTitleCase(route.origin?.city || ''),
                    destinationCity: toTitleCase(route.destination?.city || ''),
                    masterRouteName: toTitleCase(route.masterRouteName || ''),
                    description: route.description || '',
                    originState: route.origin?.state || '',
                    originAddress: route.origin?.address || '',
                    originTerminal: route.origin?.terminal || '',
                    originCoords: route.origin?.coordinates || null,
                    destinationState: route.destination?.state || '',
                    destinationAddress: route.destination?.address || '',
                    destinationTerminal: route.destination?.terminal || '',
                    destinationCoords: route.destination?.coordinates || null,
                    totalDistance: route.routeDetails?.totalDistance || 0,
                    durationHours: route.routeDetails?.estimatedDuration?.hours || 0,
                    durationMinutes: route.routeDetails?.estimatedDuration?.minutes || 0,
                    intermediateStops: route.intermediateStops || [],
                    isRoundTrip: route.isRoundTrip || false,
                    returnJourney: route.returnJourney || null
                }));

                setMasterRoutes(mappedRoutes);
                setShowDropdown(mappedRoutes.length > 0);

                if (response.data.sourceSuggestions) {
                    setSourceSuggestions(
                        normalizeAndDeduplicateSuggestions(response.data.sourceSuggestions)
                    );
                }
                if (response.data.destinationSuggestions) {
                    setDestSuggestions(
                        normalizeAndDeduplicateSuggestions(response.data.destinationSuggestions)
                    );
                }
            } else {
                setMasterRoutes([]);
                setShowDropdown(true);
            }
        } catch (error) {
            console.error('Error fetching routes:', error);
            setMasterRoutes([]);
            setShowDropdown(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSourceInputChange = (e) => {
        const value = toTitleCaseLive(e.target.value);
        setSource(value);
        setShowDropdown(false);
        setShowSourceSuggestions(false);

        if (selectedRouteValue) {
            setSelectedRouteValue(null);
            onChange(null);
        }

        if (sourceTimeoutRef.current) {
            clearTimeout(sourceTimeoutRef.current);
        }

        sourceTimeoutRef.current = setTimeout(() => {
            searchCities(value, 'source');
        }, 300);

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            if (value.length >= 2 || destination.length >= 2) {
                searchMasterRoutes(value, destination);
            } else {
                setMasterRoutes([]);
            }
        }, 500);
    };

    const handleDestinationInputChange = (e) => {
        const value = toTitleCaseLive(e.target.value);
        setDestination(value);
        setShowDropdown(false);
        setShowDestSuggestions(false);

        if (selectedRouteValue) {
            setSelectedRouteValue(null);
            onChange(null);
        }

        if (destTimeoutRef.current) {
            clearTimeout(destTimeoutRef.current);
        }

        destTimeoutRef.current = setTimeout(() => {
            searchCities(value, 'destination');
        }, 300);

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        searchTimeoutRef.current = setTimeout(() => {
            if (source.length >= 2 || value.length >= 2) {
                searchMasterRoutes(source, value);
            } else {
                setMasterRoutes([]);
            }
        }, 500);
    };

    const handleSourceSelect = (selectedCity) => {
        if (!selectedCity) return;
        const cityName = toTitleCase(
            typeof selectedCity === 'object'
                ? (selectedCity.city || selectedCity.name || '')
                : selectedCity
        );
        setSource(cityName);
        setShowSourceSuggestions(false);
        setSourceSuggestions([]);

        if (selectedRouteValue) {
            setSelectedRouteValue(null);
            onChange(null);
        }

        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
            searchMasterRoutes(cityName, destination);
        }, 100);
    };

    const handleDestinationSelect = (selectedCity) => {
        if (!selectedCity) return;
        const cityName = toTitleCase(
            typeof selectedCity === 'object'
                ? (selectedCity.city || selectedCity.name || '')
                : selectedCity
        );
        setDestination(cityName);
        setShowDestSuggestions(false);
        setDestSuggestions([]);

        if (selectedRouteValue) {
            setSelectedRouteValue(null);
            onChange(null);
        }

        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
            searchMasterRoutes(source, cityName);
        }, 100);
    };

    const handleRouteSelect = async (route) => {
        setSelectedRouteDetails(route);
        setShowDropdown(false);

        try {
            setIsLoading(true);
            const response = await getMasterRouteById(route._id, token);

            if (response.success && response.data) {
                const fullRoute = response.data;
                setSource(fullRoute.origin?.city || '');
                setDestination(fullRoute.destination?.city || '');
                setRouteNameValue(fullRoute.masterRouteName);

                const selectedRouteObj = {
                    _id: fullRoute._id,
                    masterRouteName: fullRoute.masterRouteName,
                    description: fullRoute.description || '',
                    isManual: false,
                    via: fullRoute.via || [],
                    origin: {
                        city: fullRoute.origin?.city || '',
                        state: fullRoute.origin?.state || '',
                        address: fullRoute.origin?.address || '',
                        terminal: fullRoute.origin?.terminal || '',
                        coordinates: fullRoute.origin?.coordinates || null
                    },
                    destination: {
                        city: fullRoute.destination?.city || '',
                        state: fullRoute.destination?.state || '',
                        address: fullRoute.destination?.address || '',
                        terminal: fullRoute.destination?.terminal || '',
                        coordinates: fullRoute.destination?.coordinates || null
                    },
                    intermediateStops: fullRoute.intermediateStops || [],
                    routeDetails: {
                        totalDistance: fullRoute.routeDetails?.totalDistance || 0,
                        estimatedDuration: {
                            hours: fullRoute.routeDetails?.estimatedDuration?.hours || 0,
                            minutes: fullRoute.routeDetails?.estimatedDuration?.minutes || 0
                        }
                    },
                    isRoundTrip: fullRoute.isRoundTrip || false,
                    returnJourney: fullRoute.returnJourney || null
                };

                onChange(selectedRouteObj);
                if (onRouteNameChange) onRouteNameChange(fullRoute.masterRouteName);
            } else {
                toast.error('Failed to load complete route details');
            }
        } catch (error) {
            console.error('Error fetching full route details:', error);
            toast.error('Failed to load route details. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleRouteNameChange = (e) => {
        const newName = e.target.value;
        setRouteNameValue(newName);
        if (onRouteNameChange) onRouteNameChange(newName);
        if (selectedRouteValue) onChange({ ...selectedRouteValue, masterRouteName: newName });
    };

    const handleClearSelection = () => {
        setSelectedRouteValue(null);
        setSelectedRouteDetails(null);
        setRouteNameValue('');
        setSource('');
        setDestination('');
        setMasterRoutes([]);
        setShowDropdown(false);
        setIsManualEntry(false);
        onChange(null);
        if (onRouteNameChange) onRouteNameChange('');
    };

    const handleOpenManualEntry = () => {
        setIsManualEntry(true);
        setShowDropdown(false);
    };

    const handleManualEntrySubmit = () => {
        if (!routeNameValue.trim()) {
            toast.error('Please enter a route name');
            return;
        }

        const emptyRoute = {
            _id: null,
            masterRouteName: routeNameValue.trim(),
            isManual: true,
            origin: { city: source || '', state: '' },
            destination: { city: destination || '', state: '' },
            routeDetails: { totalDistance: 0 },
            isRoundTrip: false
        };

        setIsManualEntry(false);
        setSelectedRouteValue(emptyRoute);
        onChange(emptyRoute);
    };

    const handleCancelManualEntry = () => {
        setIsManualEntry(false);
        setRouteNameValue('');
    };

    const showSearchFields = !selectedRouteValue && !isManualEntry;

    useEffect(() => {
        return () => {
            if (sourceTimeoutRef.current) clearTimeout(sourceTimeoutRef.current);
            if (destTimeoutRef.current) clearTimeout(destTimeoutRef.current);
            if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        };
    }, []);

    const suggestionsDropdownStyle = {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: 'white',
        border: '1px solid #ddd',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 10000,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        marginTop: '2px'
    };

    const suggestionItemStyle = {
        padding: '10px 12px',
        cursor: 'pointer',
        borderBottom: '1px solid #f0f0f0',
        transition: 'background-color 0.2s'
    };

    return (
        <div className="master-route-selector" style={{ position: 'relative', width: '100%' }}>
            {showSearchFields && (
                <>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                        <div className="form-group" style={{ flex: 1, position: 'relative' }}>
                            <label>Source City</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    value={source}
                                    onChange={handleSourceInputChange}
                                    onFocus={() => {
                                        if (sourceSuggestions.length > 0) {
                                            setShowSourceSuggestions(true);
                                        }
                                    }}
                                    onBlur={() => setTimeout(() => setShowSourceSuggestions(false), 200)}
                                    placeholder="Enter source city (min 2 chars)..."
                                    className="form-input"
                                    disabled={disabled}
                                />
                                {isLoadingSource && (
                                    <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                        <div className="spinner-small"></div>
                                    </div>
                                )}
                            </div>

                            {showSourceSuggestions && sourceSuggestions.length > 0 && (
                                <div style={suggestionsDropdownStyle}>
                                    {sourceSuggestions.map((city, idx) => (
                                        <div
                                            key={city.id || idx}
                                            style={suggestionItemStyle}
                                            onMouseDown={() => handleSourceSelect(city)}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                        >
                                            <div style={{ fontWeight: '500' }}>
                                                {city.city || city.name || city}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                                {city.state}
                                                {city.terminal && ` • ${city.terminal}`}
                                            </div>
                                            {city.address && city.address !== (city.city || city.name) && (
                                                <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{city.address}</div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="form-group" style={{ flex: 1, position: 'relative' }}>
                            <label>Destination City</label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    value={destination}
                                    onChange={handleDestinationInputChange}
                                    onFocus={() => {
                                        if (destSuggestions.length > 0) {
                                            setShowDestSuggestions(true);
                                        }
                                    }}
                                    onBlur={() => setTimeout(() => setShowDestSuggestions(false), 200)}
                                    placeholder="Enter destination city (min 2 chars)..."
                                    className="form-input"
                                    disabled={disabled}
                                />
                                {isLoadingDest && (
                                    <div className="loading-indicator" style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                        <div className="spinner-small"></div>
                                    </div>
                                )}
                            </div>

                            {showDestSuggestions && destSuggestions.length > 0 && (
                                <div style={suggestionsDropdownStyle}>
                                    {destSuggestions.map((city, idx) => (
                                        <div
                                            key={city.id || idx}
                                            style={suggestionItemStyle}
                                            onMouseDown={() => handleDestinationSelect(city)}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                        >
                                            <div style={{ fontWeight: '500' }}>
                                                {city.city || city.name || city}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                                {city.state}
                                                {city.terminal && ` • ${city.terminal}`}
                                            </div>
                                            {city.address && city.address !== (city.city || city.name) && (
                                                <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{city.address}</div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {(showDropdown || isLoading) && (source || destination) && (
                        <div style={{
                            border: '1px solid #ddd',
                            borderRadius: '4px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            backgroundColor: 'white',
                            maxHeight: '300px',
                            overflowY: 'auto',
                            marginBottom: '10px',
                            zIndex: 1000,
                            position: 'relative'
                        }}>
                            {isLoading ? (
                                <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
                                    <div className="spinner-small"></div> Searching routes...
                                </div>
                            ) : masterRoutes.length > 0 ? (
                                <>
                                    <div style={{ padding: '8px 12px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee', fontSize: '12px', color: '#666' }}>
                                        Found {masterRoutes.length} matching route(s)
                                    </div>
                                    {masterRoutes.map((route) => (
                                        <div
                                            key={route._id}
                                            onClick={() => handleRouteSelect(route)}
                                            style={{
                                                padding: '10px 12px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #f0f0f0',
                                                transition: 'background-color 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                        >
                                            <div style={{ fontWeight: '500', marginBottom: '3px' }}>{route.masterRouteName}</div>
                                            <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                                {route.originCity || route.origin?.city || 'N/A'} → {route.destinationCity || route.destination?.city || 'N/A'} &nbsp;•&nbsp;
                                                {route.isRoundTrip ? 'Round Trip' : 'One Way'} &nbsp;•&nbsp;
                                                {route.totalDistance || route.routeDetails?.totalDistance || 0} km
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
                                    No routes found for this route.
                                    <button
                                        type="button"
                                        onClick={handleOpenManualEntry}
                                        style={{ color: '#007bff', background: 'none', border: 'none', cursor: 'pointer', padding: '0 0 0 5px' }}
                                    >
                                        Create new route instead
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    <div style={{ textAlign: 'right' }}>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={handleOpenManualEntry}
                            style={{ padding: '5px 12px', fontSize: '12px' }}
                        >
                            + Create New Route (skip search)
                        </button>
                    </div>
                </>
            )}

            {isManualEntry && (
                <div className="selector-input-group" style={{ display: 'flex', gap: '10px', alignItems: 'center', flexDirection: 'column' }}>
                    <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <input
                                type="text"
                                value={routeNameValue}
                                onChange={handleRouteNameChange}
                                placeholder="Enter new master route name..."
                                className="form-input"
                                style={{ flex: 1 }}
                                disabled={disabled}
                            />
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleManualEntrySubmit}
                                style={{ padding: '8px 16px', whiteSpace: 'nowrap' }}
                            >
                                Save Manual
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleCancelManualEntry}
                                style={{ padding: '8px 16px' }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                    <small className="helper-text" style={{ color: '#666' }}>
                        You're creating a new master route. Fill in the details below.
                    </small>
                </div>
            )}

            {selectedRouteValue && selectedRouteValue.masterRouteName && !isManualEntry && (
                <div style={{ marginBottom: '5px' }}>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <input
                            type="text"
                            value={routeNameValue}
                            onChange={handleRouteNameChange}
                            placeholder="Enter master route name..."
                            className="form-input"
                            style={{ flex: 1 }}
                            disabled={disabled}
                        />
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            onClick={handleClearSelection}
                            style={{ padding: '8px 14px', whiteSpace: 'nowrap' }}
                            title="Clear and search again"
                        >
                            ✕ Change
                        </button>
                    </div>
                    <small style={{ color: selectedRouteValue.isManual ? '#007bff' : '#28a745', display: 'block', marginTop: '4px' }}>
                        {selectedRouteValue.isManual
                            ? 'ℹ️ New route — fill in details below'
                            : `✓ Auto-filled from "${selectedRouteValue.masterRouteName}" — edit name above if needed`}
                    </small>
                </div>
            )}
        </div>
    );
};

const RouteManage = () => {
    const { token } = useSelector(state => state.user);
    const [routes, setRoutes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [editingRoute, setEditingRoute] = useState(null);
    const [editForm, setEditForm] = useState({});
    const [viewingRoute, setViewingRoute] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [isRoundTrip, setIsRoundTrip] = useState(false);
    const [activeRouteTab, setActiveRouteTab] = useState('UP');
    const [showEditModal, setShowEditModal] = useState(false);
    const [isUpdatingRoute, setIsUpdatingRoute] = useState(false);
    const [editUpIndex, setEditUpIndex] = useState(null);
    const [editDownIndex, setEditDownIndex] = useState(null);
    const [isManualStop, setIsManualStop] = useState(true);
    const [isManualDistance, setIsManualDistance] = useState(false);
    const [isOriginManual, setIsOriginManual] = useState(false);
    const [isDestinationManual, setIsDestinationManual] = useState(false);

    const [destinationTimeSlots, setDestinationTimeSlots] = useState([]);
    const [destinationNumberOfTrips, setDestinationNumberOfTrips] = useState(1);

    const [returnOriginTimeSlots, setReturnOriginTimeSlots] = useState([]);
    const [returnDestTimeSlots, setReturnDestTimeSlots] = useState([]);

    const [masterRouteSuggestions, setMasterRouteSuggestions] = useState([]);
    const [showMasterRouteSuggestions, setShowMasterRouteSuggestions] = useState(false);
    const [isLoadingMasterRoutes, setIsLoadingMasterRoutes] = useState(false);
    const [masterRouteSearchTimeout, setMasterRouteSearchTimeout] = useState(null);
    const [selectedMasterRoute, setSelectedMasterRoute] = useState(null);

    const [filterOrigin, setFilterOrigin] = useState('');
    const [filterDestination, setFilterDestination] = useState('');
    const [originSuggestions, setOriginSuggestions] = useState([]);
    const [destSuggestions, setDestSuggestions] = useState([]);
    const [showOriginSuggestions, setShowOriginSuggestions] = useState(false);
    const [showDestSuggestions, setShowDestSuggestions] = useState(false);

    const [citySuggestions, setCitySuggestions] = useState([]);
    const [showCityDropdown, setShowCityDropdown] = useState(false);
    const [editCitySuggestions, setEditCitySuggestions] = useState([]);
    const [showEditCityDropdown, setShowEditCityDropdown] = useState(false);

    const [showStopInsertModal, setShowStopInsertModal] = useState(false);
    const [insertStopForm, setInsertStopForm] = useState({
        city: '', state: '', address: '', terminal: '',
        arrivalTime: '', departureTime: '',
        isBoarding: false, isDropping: false,
        manualDistFromPrev: '', manualDistToNext: '',
        isManualStop: true
    });
    const [insertCitySuggestions, setInsertCitySuggestions] = useState([]);
    const [showInsertCityDropdown, setShowInsertCityDropdown] = useState(false);
    const [pendingInsertIndex, setPendingInsertIndex] = useState(null);

    const [timeSlots, setTimeSlots] = useState([]);
    const [numberOfTrips, setNumberOfTrips] = useState(1);
    const [isMultiTrip, setIsMultiTrip] = useState(false);

    const [newRoute, setNewRoute] = useState({
        routeName: '',
        localRouteName: '',
        upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
        upOriginCoords: null, upOriginDepTime: '',
        upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
        upDestCoords: null, upDestArrTime: '',
        upTotalDistance: '', upDurationHours: '', upDurationMinutes: '',
        downOriginDepTime: '',
        downDestArrTime: '',
        downTotalDistance: '', downDurationHours: '', downDurationMinutes: '',
        upManualFinalLeg: '',
        downManualFinalLeg: '',
        stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
        stopCoords: null, stopArrivalTime: '', stopDepartureTime: '',
        stopDistFromPrev: '', stopDistToNext: '',
        isBoarding: false, isDropping: false
    });

    const [upStops, setUpStops] = useState([]);
    const [downStops, setDownStops] = useState([]);
    const [editingStopIndex, setEditingStopIndex] = useState(null);
    const [insertIndex, setInsertIndex] = useState(null);
    const [isCreatingRoute, setIsCreatingRoute] = useState(false);
    const [isCalculatingDistances, setIsCalculatingDistances] = useState(false);
    const [isDistanceCalculated, setIsDistanceCalculated] = useState({ up: false, down: false });
    const [activeTab, setActiveTab] = useState('basic');

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRoutes, setTotalRoutes] = useState(0);
    const [pageSize] = useState(10);

    const [showStopEditModal, setShowStopEditModal] = useState(false);
    const [stopBeingEdited, setStopBeingEdited] = useState(null);

    // ========== TRIP MANAGEMENT STATE FOR EDIT MODE ==========
    const [editTimeSlots, setEditTimeSlots] = useState([]);
    const [editDestinationTimeSlots, setEditDestinationTimeSlots] = useState([]);
    const [editNumberOfTrips, setEditNumberOfTrips] = useState(1);
    const [editIsMultiTrip, setEditIsMultiTrip] = useState(false);

    // const [stopEditForm, setStopEditForm] = useState({
    //     city: '',
    //     state: '',
    //     address: '',
    //     terminal: '',
    //     arrivalTime: '',
    //     departureTime: '',
    //     timings: [],
    //     stopType: 'none',
    //     isBoarding: false,
    //     isDropping: false,
    //     manualDistFromPrev: '',
    //     manualDistToNext: '',
    //     isManualStop: true
    // });

    const [stopEditForm, setStopEditForm] = useState({
    city: '',
    state: '',
    address: '',
    terminal: '',
    arrivalTime: '',
    departureTime: '',
    isBoarding: false,
    isDropping: false,
    isManualStop: false,
    manualDistFromPrev: '',
    manualDistToNext: '',
    timings: [], // Array of { timeSlotSequence, arrivalTime, departureTime }
    coordinates: null,
    isMultiTrip: false,
    tripCount: 1
});

    const [inlineInsertIndex, setInlineInsertIndex] = useState(null);
    const [inlineInsertForm, setInlineInsertForm] = useState({
        city: '', state: '', address: '', terminal: '',
        arrivalTime: '', departureTime: '',
        isBoarding: false, isDropping: false,
        manualDistFromPrev: '', manualDistToNext: '',
        isManual: true
    });
    const [inlineInsertCitySuggestions, setInlineInsertCitySuggestions] = useState([]);
    const [showInlineInsertDropdown, setShowInlineInsertDropdown] = useState(false);

    const navigate = useNavigate();
    const [selectedMasterRouteFromDropdown, setSelectedMasterRouteFromDropdown] = useState(null);
    const [showPlatformFeeModal, setShowPlatformFeeModal] = useState(false);
    const [selectedBusForActivation, setSelectedBusForActivation] = useState(null);

    // ========== SORT TIMINGS HELPER ==========
    const sortTimings = (timings) => {
        if (!timings || !Array.isArray(timings)) return [];
        return [...timings].sort((a, b) =>
            (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0)
        );
    };

    // ========== AUTO-CALCULATE DURATION FOR MULTI-TRIP IN EDIT MODAL ==========
    useEffect(() => {
        // Check if we're in multi-trip mode
        const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip;

        if (!isMultiTripMode) return;

        // Get first trip's departure time from originTimings
        const originTimings = editForm.originTimings || [];
        const destTimings = editForm.destTimings || [];

        if (originTimings.length === 0 || destTimings.length === 0) return;

        // Get the first trip's times
        const firstOrigin = originTimings[0];
        const firstDest = destTimings[0];

        const depTime = firstOrigin?.departureTime || editForm.originDepTime || '';
        const arrTime = firstDest?.arrivalTime || editForm.destArrTime || '';

        if (depTime && arrTime) {
            const [depHour, depMin] = depTime.split(':').map(Number);
            const [arrHour, arrMin] = arrTime.split(':').map(Number);

            if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                // If arrival is before departure, add 24 hours (next day)
                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                const hours = Math.floor(durationMins / 60);
                const minutes = durationMins % 60;

                setEditForm(prev => ({
                    ...prev,
                    durationHours: hours.toString(),
                    durationMinutes: minutes.toString()
                }));
            }
        }
    }, [editForm.originTimings, editForm.destTimings, editForm.isMultiTrip, editIsMultiTrip, isMultiTrip, editForm.originDepTime, editForm.destArrTime]);

    // ========== AUTO-CALCULATE DURATION FOR RETURN MULTI-TRIP IN EDIT MODAL ==========
    useEffect(() => {
        // Check if we're in multi-trip mode
        const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip;

        if (!isMultiTripMode) return;
        if (!editForm.isRoundTrip) return;

        // Get first trip's departure time from returnOriginTimings
        const returnOriginTimings = editForm.returnOriginTimings || [];
        const returnDestTimings = editForm.returnDestTimings || [];

        if (returnOriginTimings.length === 0 || returnDestTimings.length === 0) return;

        // Get the first trip's times
        const firstReturnOrigin = returnOriginTimings[0];
        const firstReturnDest = returnDestTimings[0];

        const depTime = firstReturnOrigin?.departureTime || editForm.returnOriginDepTime || '';
        const arrTime = firstReturnDest?.arrivalTime || editForm.returnDestArrTime || '';

        if (depTime && arrTime) {
            const [depHour, depMin] = depTime.split(':').map(Number);
            const [arrHour, arrMin] = arrTime.split(':').map(Number);

            if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                // If arrival is before departure, add 24 hours (next day)
                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                const hours = Math.floor(durationMins / 60);
                const minutes = durationMins % 60;

                setEditForm(prev => ({
                    ...prev,
                    returnDurationHours: hours.toString(),
                    returnDurationMinutes: minutes.toString()
                }));
            }
        }
    }, [editForm.returnOriginTimings, editForm.returnDestTimings, editForm.isRoundTrip, editForm.isMultiTrip, editIsMultiTrip, isMultiTrip, editForm.returnOriginDepTime, editForm.returnDestArrTime]);

    // ========== AUTO-CALCULATE DURATION FOR MULTI-TRIP IN ADD ROUTE MODAL ==========
    useEffect(() => {
        if (!isMultiTrip) return;

        // Get first trip's departure time from timeSlots
        if (timeSlots.length === 0 || destinationTimeSlots.length === 0) return;

        const firstOrigin = timeSlots[0];
        const firstDest = destinationTimeSlots[0];

        const depTime = firstOrigin?.departureTime || newRoute.upOriginDepTime || '';
        const arrTime = firstDest?.arrivalTime || newRoute.upDestArrTime || '';

        if (depTime && arrTime) {
            const [depHour, depMin] = depTime.split(':').map(Number);
            const [arrHour, arrMin] = arrTime.split(':').map(Number);

            if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                const hours = Math.floor(durationMins / 60);
                const minutes = durationMins % 60;

                setNewRoute(prev => ({
                    ...prev,
                    upDurationHours: hours.toString(),
                    upDurationMinutes: minutes.toString()
                }));
            }
        }
    }, [timeSlots, destinationTimeSlots, isMultiTrip, newRoute.upOriginDepTime, newRoute.upDestArrTime]);

    // ========== AUTO-CALCULATE DURATION FOR RETURN MULTI-TRIP IN ADD ROUTE MODAL ==========
    useEffect(() => {
        if (!isMultiTrip) return;
        if (!isRoundTrip) return;

        // Get first trip's departure time from returnOriginTimeSlots
        if (returnOriginTimeSlots.length === 0 || returnDestTimeSlots.length === 0) return;

        const firstReturnOrigin = returnOriginTimeSlots[0];
        const firstReturnDest = returnDestTimeSlots[0];

        const depTime = firstReturnOrigin?.departureTime || newRoute.downOriginDepTime || '';
        const arrTime = firstReturnDest?.arrivalTime || newRoute.downDestArrTime || '';

        if (depTime && arrTime) {
            const [depHour, depMin] = depTime.split(':').map(Number);
            const [arrHour, arrMin] = arrTime.split(':').map(Number);

            if (!isNaN(depHour) && !isNaN(depMin) && !isNaN(arrHour) && !isNaN(arrMin)) {
                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                const hours = Math.floor(durationMins / 60);
                const minutes = durationMins % 60;

                setNewRoute(prev => ({
                    ...prev,
                    downDurationHours: hours.toString(),
                    downDurationMinutes: minutes.toString()
                }));
            }
        }
    }, [returnOriginTimeSlots, returnDestTimeSlots, isMultiTrip, isRoundTrip, newRoute.downOriginDepTime, newRoute.downDestArrTime]);
    // ========== TRIP MANAGEMENT FUNCTIONS FOR RETURN ROUTE ==========
    const addEditReturnOriginTrip = () => {
        const currentTimings = editForm.returnOriginTimings || [];
        const newSequence = currentTimings.length + 1;
        const newTiming = {
            timeSlotSequence: newSequence,
            departureTime: '',
            arrivalTime: ''
        };
        setEditForm(prev => ({
            ...prev,
            returnOriginTimings: [...currentTimings, newTiming]
        }));
        setEditNumberOfTrips(newSequence);

        // Update all return stops with new trip
        const updatedStops = downStops.map(stop => {
            const existingTimings = stop.timings || [];
            const existing = existingTimings.find(t => t.timeSlotSequence === newSequence);
            if (existing) {
                return stop;
            }
            const newTimings = [...existingTimings];
            newTimings.push({
                timeSlotSequence: newSequence,
                arrivalTime: '',
                departureTime: ''
            });
            newTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
            return { ...stop, timings: newTimings };
        });
        setDownStops(updatedStops);

        toast.info(`Added Return Trip #${newSequence}. Please set timings for this trip in each return stop.`);
    };

    const addEditReturnDestinationTrip = () => {
        const currentTimings = editForm.returnDestTimings || [];
        const newSequence = currentTimings.length + 1;
        const newTiming = {
            timeSlotSequence: newSequence,
            arrivalTime: '',
            departureTime: ''
        };
        setEditForm(prev => ({
            ...prev,
            returnDestTimings: [...currentTimings, newTiming]
        }));
        setEditNumberOfTrips(newSequence);
    };

    const removeEditReturnOriginTrip = (index) => {
        const currentTimings = editForm.returnOriginTimings || [];
        if (currentTimings.length <= 1) {
            toast.warning('At least one trip is required');
            return;
        }
        const updatedTimings = currentTimings.filter((_, i) => i !== index);
        updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
        setEditForm(prev => ({
            ...prev,
            returnOriginTimings: updatedTimings
        }));
        setEditNumberOfTrips(updatedTimings.length);

        // Remove trip from all return stops and re-sequence
        const tripToRemove = index + 1;
        const updatedStops = downStops.map(stop => {
            const existingTimings = stop.timings || [];
            const filteredTimings = existingTimings
                .filter(t => t.timeSlotSequence !== tripToRemove)
                .map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
            filteredTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
            return { ...stop, timings: filteredTimings };
        });
        setDownStops(updatedStops);

        toast.info(`Removed Return Trip #${tripToRemove}.`);
    };


    const removeEditReturnDestinationTrip = (index) => {
        const currentTimings = editForm.returnDestTimings || [];
        if (currentTimings.length <= 1) {
            toast.warning('At least one trip is required');
            return;
        }
        const updatedTimings = currentTimings.filter((_, i) => i !== index);
        updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
        setEditForm(prev => ({
            ...prev,
            returnDestTimings: updatedTimings
        }));
        setEditNumberOfTrips(updatedTimings.length);
    };

    // ========== TRIP MANAGEMENT FUNCTIONS FOR EDIT MODE ==========
    const addEditOriginTrip = () => {
        const currentTimings = editForm.originTimings || [];
        const newSequence = currentTimings.length + 1;
        const newTiming = {
            timeSlotSequence: newSequence,
            departureTime: '',
            arrivalTime: ''
        };
        setEditForm(prev => ({
            ...prev,
            originTimings: [...currentTimings, newTiming],
            numberOfTrips: newSequence
        }));
        setEditNumberOfTrips(newSequence);

        // Update all stops with new trip
        const updatedStops = upStops.map(stop => {
            const existingTimings = stop.timings || [];
            const existing = existingTimings.find(t => t.timeSlotSequence === newSequence);
            if (existing) {
                return stop;
            }
            const newTimings = [...existingTimings];
            newTimings.push({
                timeSlotSequence: newSequence,
                arrivalTime: '',
                departureTime: ''
            });
            newTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
            return { ...stop, timings: newTimings };
        });
        setUpStops(updatedStops);

        toast.info(`Added Trip #${newSequence}. Please set timings for this trip in each stop.`);
    };

    const removeEditOriginTrip = (index) => {
        const currentTimings = editForm.originTimings || [];
        if (currentTimings.length <= 1) {
            toast.warning('At least one trip is required');
            return;
        }
        const updatedTimings = currentTimings.filter((_, i) => i !== index);
        updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
        setEditForm(prev => ({
            ...prev,
            originTimings: updatedTimings,
            numberOfTrips: updatedTimings.length
        }));
        setEditNumberOfTrips(updatedTimings.length);

        // Remove trip from all stops and re-sequence
        const tripToRemove = index + 1;
        const updatedStops = upStops.map(stop => {
            const existingTimings = stop.timings || [];
            const filteredTimings = existingTimings
                .filter(t => t.timeSlotSequence !== tripToRemove)
                .map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
            filteredTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
            return { ...stop, timings: filteredTimings };
        });
        setUpStops(updatedStops);

        toast.info(`Removed Trip #${tripToRemove}.`);
    };

    const addEditDestinationTrip = () => {
        const currentTimings = editForm.destTimings || [];
        const newSequence = currentTimings.length + 1;
        const newTiming = {
            timeSlotSequence: newSequence,
            arrivalTime: '',
            departureTime: ''
        };
        setEditForm(prev => ({
            ...prev,
            destTimings: [...currentTimings, newTiming],
            numberOfTrips: newSequence
        }));
        setEditNumberOfTrips(newSequence);
    };

    const removeEditDestinationTrip = (index) => {
        const currentTimings = editForm.destTimings || [];
        if (currentTimings.length <= 1) {
            toast.warning('At least one trip is required');
            return;
        }
        const updatedTimings = currentTimings.filter((_, i) => i !== index);
        updatedTimings.forEach((t, i) => t.timeSlotSequence = i + 1);
        setEditForm(prev => ({
            ...prev,
            destTimings: updatedTimings,
            numberOfTrips: updatedTimings.length
        }));
        setEditNumberOfTrips(updatedTimings.length);
    };

    // ========== RENDER STOPS WITH INLINE INSERT (FIXED FOR MULTI-TRIP) ==========
    const renderStopsWithInlineInsert = (stops) => {
        if (!stops || stops.length === 0) {
            return (
                <div className="stops-empty-state">
                    <p>No intermediate stops added yet.</p>
                    <button
                        className="btn btn-sm btn-add-stop"
                        onClick={() => {
                            // Open add stop modal
                            setEditingStopIndex(null);
                            setInsertIndex(null);
                            setIsManualStop(true);
                            clearStopForm();
                        }}
                    >
                        + Add First Stop
                    </button>
                </div>
            );
        }

        const renderInsertButton = (index) => (
            <div className="insert-stop-wrapper">
                <div className="insert-line"></div>
                <button
                    className="insert-stop-btn"
                    onClick={() => {
                        setInsertIndex(index);
                        setIsManualStop(true);
                        clearStopForm();
                    }}
                >
                    <span className="insert-icon">+</span> Insert stop here
                </button>
                <div className="insert-line"></div>
            </div>
        );

        return (
            <div className="stops-list-container">
                {renderInsertButton(0)}

                {stops.map((stop, index) => {
                    const displayManualDist = calculateManualDistFromPrev(stops, index);
                    const distanceDisplay = displayManualDist ||
                        (typeof stop.distanceFromOrigin === 'number'
                            ? stop.distanceFromOrigin.toFixed(2)
                            : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));

                    // Check if we have multi-trip timings
                    const hasMultiTimings = stop.timings && stop.timings.length > 0;
                    const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];

                    return (
                        <React.Fragment key={stop._id || index}>
                            <div className="stop-item-card">
                                <div className="stop-item-header">
                                    <div className="stop-item-left">
                                        <span className="stop-item-number">{index + 1}.</span>
                                        <span className="stop-item-name">{stop.city}</span>
                                        <span className="stop-item-distance">
                                            ({distanceDisplay} km)
                                        </span>
                                        <StopTypeBadge type={stop.stopType} />
                                        <StatusBadge isActive={stop.isEnabled !== false} />
                                    </div>
                                    <div className="stop-item-actions">
                                        <button
                                            className="stop-action-btn edit"
                                            onClick={() => {
                                                setEditingStopIndex(index);
                                                handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down');
                                            }}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className="stop-action-btn delete"
                                            onClick={() => handleDeleteStop(index)}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </div>

                                {/* ========== DISPLAY MULTI-TRIP TIMINGS ========== */}
                                {hasMultiTimings && sortedTimings.length > 0 ? (
                                    <div className="stop-timings-grid">
                                        {sortedTimings.map((timing, idx) => (
                                            <div key={timing.timeSlotSequence || idx} className="stop-timing-row">
                                                <span className="trip-badge">Trip {timing.timeSlotSequence || idx + 1}:</span>
                                                <span className="timing-arrival">Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
                                                <span className="timing-arrow">→</span>
                                                <span className="timing-departure">Dep {TimeDisplay({ time: timing.departureTime })}</span>
                                            </div>
                                        ))}
                                    </div>
                                ) : (stop.arrivalTime || stop.departureTime) ? (
                                    <div className="stop-timing-row">
                                        <span className="timing-arrival">Arr {TimeDisplay({ time: stop.arrivalTime })}</span>
                                        <span className="timing-arrow">→</span>
                                        <span className="timing-departure">Dep {TimeDisplay({ time: stop.departureTime })}</span>
                                    </div>
                                ) : (
                                    <div className="stop-timing-row" style={{ color: '#999', fontStyle: 'italic' }}>
                                        No timings set
                                    </div>
                                )}
                            </div>

                            {renderInsertButton(index + 1)}
                        </React.Fragment>
                    );
                })}
            </div>
        );
    };

    // ========== EXISTING FUNCTIONS ==========
    const clearCurrentRoute = () => {
        if (!window.confirm(`Are you sure you want to clear all data for the ${activeRouteTab} route? This will remove origin, destination, and all intermediate stops.`)) {
            return;
        }

        if (activeRouteTab === 'UP') {
            setNewRoute(prev => ({
                ...prev,
                upOriginCity: '',
                upOriginState: '',
                upOriginAddress: '',
                upOriginTerminal: '',
                upOriginCoords: null,
                upOriginDepTime: '',
                upDestCity: '',
                upDestState: '',
                upDestAddress: '',
                upDestTerminal: '',
                upDestCoords: null,
                upDestArrTime: '',
                upTotalDistance: '',
                upDurationHours: '',
                upDurationMinutes: '',
                upManualFinalLeg: '',
                upManualFirstLeg: ''
            }));
            setUpStops([]);
            setIsDistanceCalculated(prev => ({ ...prev, up: false }));

            if (isMultiTrip) {
                setTimeSlots([]);
                setDestinationTimeSlots([]);
                setNumberOfTrips(1);
            }

            toast.info('UP route cleared successfully');
        } else {
            setNewRoute(prev => ({
                ...prev,
                downOriginDepTime: '',
                downDestArrTime: '',
                downTotalDistance: '',
                downDurationHours: '',
                downDurationMinutes: '',
                downManualFinalLeg: '',
                downManualFirstLeg: ''
            }));
            setDownStops([]);
            setIsDistanceCalculated(prev => ({ ...prev, down: false }));

            if (isMultiTrip) {
                setReturnOriginTimeSlots([]);
                setReturnDestTimeSlots([]);
            }

            toast.info('DOWN route cleared successfully');
        }
    };

    const copyScheduleToDestination = (slots) => {
        setDestinationTimeSlots(slots.map(slot => ({
            ...slot,
            arrivalTime: slot.arrivalTime || '',
            departureTime: ''
        })));
        setDestinationNumberOfTrips(slots.length);
    };

    useEffect(() => {
        setCurrentPage(1);
        const timer = setTimeout(() => {
            fetchRoutes();
        }, 500);
        return () => clearTimeout(timer);
    }, [searchTerm, filterOrigin, filterDestination]);

    useEffect(() => {
        fetchRoutes();
    }, [currentPage]);

    useEffect(() => {
        const savedData = localStorage.getItem('pendingRouteFormData');
        if (savedData) {
            const formData = JSON.parse(savedData);
            if (window.confirm('You have unsaved route data. Would you like to restore it?')) {
                setNewRoute(prev => ({
                    ...prev,
                    routeName: formData.routeName || '',
                    upOriginCity: formData.upOriginCity || '',
                    upOriginState: formData.upOriginState || '',
                    upOriginAddress: formData.upOriginAddress || '',
                    upOriginTerminal: formData.upOriginTerminal || '',
                    upOriginCoords: formData.upOriginCoords || null,
                    upOriginDepTime: formData.upOriginDepTime || '',
                    upDestCity: formData.upDestCity || '',
                    upDestState: formData.upDestState || '',
                    upDestAddress: formData.upDestAddress || '',
                    upDestTerminal: formData.upDestTerminal || '',
                    upDestCoords: formData.upDestCoords || null,
                    upDestArrTime: formData.upDestArrTime || '',
                }));
                setIsRoundTrip(formData.isRoundTrip || false);
                if (formData.upStops) setUpStops(formData.upStops);
                if (formData.downStops) setDownStops(formData.downStops);
                localStorage.removeItem('pendingRouteFormData');
            } else {
                localStorage.removeItem('pendingRouteFormData');
            }
        }
    }, []);

    useEffect(() => {
        if (isRoundTrip && activeRouteTab === 'DOWN' && downStops.length > 0) {
            const missingDistances = downStops.some(stop =>
                stop.distanceFromOrigin === undefined || stop.distanceFromOrigin === 0
            );

            if (missingDistances && upStops.length > 0 && isDistanceCalculated.up) {
                const upTotalDist = parseFloat(newRoute.upTotalDistance) || 0;
                const downTotalDist = parseFloat(newRoute.downTotalDistance) || 0;

                if (downTotalDist === 0 && upTotalDist > 0) {
                    syncDownStopsWithUpStops(false);
                }
            }
        }
    }, [downStops, upStops, isRoundTrip, activeRouteTab, isDistanceCalculated.up]);

    const handleActivateBusFromRoute = (route) => {
        const pendingBuses = route.associatedBuses?.filter(bus => !bus.isActive && (bus.approvalStatus === 'pending' || !bus.approvalStatus));

        if (pendingBuses && pendingBuses.length > 0) {
            if (pendingBuses.length === 1) {
                handleActivateSingleBus(pendingBuses[0]);
            } else {
                const busList = pendingBuses.map((bus, idx) =>
                    `${idx + 1}. ${bus.busName} (${bus.busNumber})`
                ).join('\n');

                const selectedIndex = window.prompt(
                    `Multiple pending buses found on this route:\n${busList}\n\nEnter the number of the bus to activate (1-${pendingBuses.length}):`
                );

                const index = parseInt(selectedIndex) - 1;
                if (index >= 0 && index < pendingBuses.length) {
                    handleActivateSingleBus(pendingBuses[index]);
                } else {
                    toast.error('Invalid selection');
                }
            }
        } else {
            toast.info('No pending buses found on this route');
        }
    };

    const fetchBusDetails = async (busId) => {
        try {
            const response = await getBusById(busId, token);
            if (response.success) {
                setSelectedBusForActivation(response.data);
                setShowPlatformFeeModal(true);
            } else {
                toast.error('Failed to fetch bus details');
            }
        } catch (error) {
            console.error('Error fetching bus details:', error);
            toast.error(error.response?.data?.message || 'Failed to fetch bus details');
        }
    };

    const handleActivateSingleBus = async (bus) => {
        const busId = bus._id || bus.busId;

        if (!busId) {
            toast.error('Invalid bus ID');
            return;
        }

        try {
            const response = await getBusById(busId, token);

            if (response && response.success) {
                const busData = response.data || response.bus;
                if (busData) {
                    setSelectedBusForActivation(busData);
                    setShowPlatformFeeModal(true);
                    return;
                }
            }

            const busWithId = {
                ...bus,
                _id: busId
            };
            setSelectedBusForActivation(busWithId);
            setShowPlatformFeeModal(true);
            toast.info('Using existing bus data for activation');

        } catch (error) {
            console.error('Error fetching bus details:', error);

            const busWithId = {
                ...bus,
                _id: busId
            };
            setSelectedBusForActivation(busWithId);
            setShowPlatformFeeModal(true);
            toast.info('Using existing bus data for activation');
        }
    };

    const getDefaultStateForStop = (activeRouteTab, upStops, downStops, newRoute) => {
        if (activeRouteTab === 'UP') {
            if (upStops.length > 0) {
                const lastStop = upStops[upStops.length - 1];
                if (lastStop.state && lastStop.state.trim()) {
                    return lastStop.state;
                }
            }
            if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
                return newRoute.upOriginState;
            }
            if (newRoute.upDestState && newRoute.upDestState.trim()) {
                return newRoute.upDestState;
            }
        } else if (activeRouteTab === 'DOWN') {
            if (downStops.length > 0) {
                const lastStop = downStops[downStops.length - 1];
                if (lastStop.state && lastStop.state.trim()) {
                    return lastStop.state;
                }
            }
            if (newRoute.upOriginState && newRoute.upOriginState.trim()) {
                return newRoute.upOriginState;
            }
            if (newRoute.upDestState && newRoute.upDestState.trim()) {
                return newRoute.upDestState;
            }
        }
        return '';
    };

const renderInlineInsertPanel = (idx) => {
    const stops = getActiveStops();
    const prevStop = idx > 0 ? stops[idx - 1] : null;
    const nextStop = stops[idx] || null;
    const nextHasGPS = nextStop?.coordinates?.lat && nextStop.coordinates.lat !== 0;
    const cityOk = inlineInsertForm.city.trim().length > 0;
    const timeOk = inlineInsertForm.arrivalTime.trim().length > 0;
    const distOk = parseFloat(inlineInsertForm.manualDistFromPrev) > 0;
    const canInsert = cityOk && timeOk && (!inlineInsertForm.isManual || distOk);

    // ========== FIX: Search cities function ==========
    const searchCitiesForInsert = async (query) => {
        if (!query || query.trim().length < 2) {
            setInlineInsertCitySuggestions([]);
            setShowInlineInsertDropdown(false);
            return;
        }

        try {
            const response = await searchRouteIntermediateStops(token, query);
            if (response.success && response.cities && response.cities.length > 0) {
                const deduped = normalizeAndDeduplicateSuggestions(response.cities);
                setInlineInsertCitySuggestions(deduped);
                setShowInlineInsertDropdown(deduped.length > 0);
            } else {
                setInlineInsertCitySuggestions([]);
                setShowInlineInsertDropdown(false);
            }
        } catch (error) {
            console.error('Error searching cities:', error);
            setInlineInsertCitySuggestions([]);
            setShowInlineInsertDropdown(false);
        }
    };

    const fieldStyle = {
        display: 'flex', flexDirection: 'column', gap: 5
    };
    const labelStyle = {
        fontSize: 11, fontWeight: 500,
        color: 'var(--color-text-secondary, #777)', letterSpacing: '.2px'
    };
    const inputStyle = (hasErr = false) => ({
        width: '100%', height: 38, padding: '0 12px',
        border: `1px solid ${hasErr ? '#e24b4a' : 'var(--color-border-secondary, rgba(0,0,0,.2))'}`,
        borderRadius: 8, fontSize: 13,
        background: hasErr ? 'rgba(252,235,235,.05)' : 'var(--color-background-primary, #fff)',
        color: 'var(--color-text-primary, #333)', outline: 'none',
        boxSizing: 'border-box'
    });
    const sectionHead = (label) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '18px 0 12px' }}>
            <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--color-text-secondary, #888)', letterSpacing: '.4px', whiteSpace: 'nowrap' }}>{label}</span>
            <div style={{ flex: 1, height: 1, background: 'var(--color-border-tertiary, rgba(0,0,0,.1))' }} />
        </div>
    );

    return (
        <div style={{
            width: '100%', background: 'var(--color-background-primary, #fff)',
            border: '1.5px solid #378add', borderRadius: 14,
            overflow: 'hidden', margin: '6px 0', alignSelf: 'stretch'
        }}>
            <div style={{
                background: 'linear-gradient(135deg, #185fa5 0%, #378add 100%)',
                padding: '14px 18px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{
                        width: 34, height: 34, borderRadius: 8,
                        background: 'rgba(255,255,255,.18)', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0
                    }}>📍</div>
                    <div>
                        <div style={{ fontSize: 14, fontWeight: 500, color: '#fff' }}>
                            Insert stop at position {idx + 1}
                        </div>
                    </div>
                </div>
                <button onClick={() => { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }}
                    style={{ width: 26, height: 26, borderRadius: 6, border: '1px solid rgba(255,255,255,.3)', background: 'transparent', color: '#fff', cursor: 'pointer', fontSize: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    ×
                </button>
            </div>

            <div style={{ padding: 18 }}>
                <label style={{
                    display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px',
                    background: 'var(--color-background-secondary, #f7f7f5)',
                    border: '0.5px solid var(--color-border-tertiary, rgba(0,0,0,.1))',
                    borderRadius: 8, cursor: 'pointer', userSelect: 'none'
                }}>
                    <input type="checkbox" checked={inlineInsertForm.isManual}
                        onChange={() => setInlineInsertForm(prev => ({
                            ...prev, isManual: !prev.isManual,
                            city: '', address: '', state: '', terminal: '', manualDistFromPrev: '', manualDistToNext: ''
                        }))}
                        style={{ width: 16, height: 16, accentColor: '#378add', cursor: 'pointer' }} />
                    <span style={{ fontSize: 13, color: 'var(--color-text-primary, #333)' }}>
                        Manually typed stop (no map suggestions)
                    </span>
                </label>

                {sectionHead('Stop details')}

                <div style={{ marginBottom: 12 }}>
                    <div style={fieldStyle}>
                        <label style={labelStyle}>City / stop name <span style={{ color: '#e24b4a' }}>*</span></label>
                        {!inlineInsertForm.isManual ? (
                            <LocationInput
                                value={inlineInsertForm.city}
                                onChange={(v) => setInlineInsertForm(prev => ({ ...prev, city: v }))}
                                onLocationSelect={(loc) => setInlineInsertForm(prev => ({
                                    ...prev,
                                    city: loc.city || loc.name || '',
                                    state: loc.state || prev.state,
                                    address: loc.address || ''
                                }))}
                                placeholder="Search stop city or address…"
                            />
                        ) : (
                            // ========== FIX: Manual city input with dropdown ==========
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="text"
                                    value={inlineInsertForm.city}
                                    onChange={async (e) => {
                                        const value = toTitleCase(e.target.value);
                                        setInlineInsertForm(prev => ({ 
                                            ...prev, 
                                            city: value, 
                                            address: '', 
                                            state: '', 
                                            terminal: '' 
                                        }));
                                        // Call the search function
                                        await searchCitiesForInsert(value);
                                    }}
                                    onFocus={() => {
                                        if (inlineInsertCitySuggestions.length > 0) {
                                            setShowInlineInsertDropdown(true);
                                        }
                                    }}
                                    onBlur={() => setTimeout(() => setShowInlineInsertDropdown(false), 200)}
                                    placeholder="Type city name (min 2 chars)…"
                                    style={inputStyle()}
                                />
                                {showInlineInsertDropdown && inlineInsertCitySuggestions.length > 0 && (
                                    <div style={{ 
                                        position: 'absolute', 
                                        top: '100%', 
                                        left: 0, 
                                        right: 0, 
                                        background: 'white', 
                                        border: '1px solid #ddd', 
                                        borderRadius: 8, 
                                        maxHeight: 200, 
                                        overflowY: 'auto', 
                                        zIndex: 10000, 
                                        boxShadow: '0 4px 12px rgba(0,0,0,.12)' 
                                    }}>
                                        {inlineInsertCitySuggestions.map((city, i) => (
                                            <div key={city.id || i}
                                                onMouseDown={() => {
                                                    setInlineInsertForm(prev => ({
                                                        ...prev,
                                                        city: city.name,
                                                        address: city.address || city.name,
                                                        state: city.state || '',
                                                        terminal: city.terminal || `${city.name} Bus Stand`
                                                    }));
                                                    setShowInlineInsertDropdown(false);
                                                    setInlineInsertCitySuggestions([]);
                                                }}
                                                style={{ 
                                                    padding: '9px 12px', 
                                                    cursor: 'pointer', 
                                                    borderBottom: '0.5px solid #f0f0f0' 
                                                }}
                                                onMouseEnter={e => e.currentTarget.style.background = '#f0f7ff'}
                                                onMouseLeave={e => e.currentTarget.style.background = 'white'}>
                                                <div style={{ fontWeight: 500, fontSize: 13 }}>{city.name}</div>
                                                <div style={{ fontSize: 11, color: '#888' }}>{city.state}{city.terminal ? ` · ${city.terminal}` : ''}</div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                {/* Rest of the form... */}
                <div style={{ marginBottom: 12 }}>
                    <div style={fieldStyle}>
                        <label style={labelStyle}>Address</label>
                        <input type="text" value={inlineInsertForm.address}
                            onChange={e => setInlineInsertForm(prev => ({ ...prev, address: e.target.value }))}
                            placeholder="e.g. NH-19, Near Bus Stand" style={inputStyle()} />
                    </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 4 }}>
                    <div style={fieldStyle}>
                        <label style={labelStyle}>State</label>
                        <input type="text" value={inlineInsertForm.state}
                            onChange={e => setInlineInsertForm(prev => ({ ...prev, state: e.target.value }))}
                            placeholder="State" style={inputStyle()} />
                    </div>
                    <div style={fieldStyle}>
                        <label style={labelStyle}>Terminal</label>
                        <input type="text" value={inlineInsertForm.terminal}
                            onChange={e => setInlineInsertForm(prev => ({ ...prev, terminal: e.target.value }))}
                            placeholder="Terminal name" style={inputStyle()} />
                    </div>
                </div>

                {sectionHead('Schedule')}

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 4 }}>
                    <div style={fieldStyle}>
                        <label style={labelStyle}>Arrival Time <span style={{ color: '#e24b4a' }}>*</span></label>
                        <TimePicker
                            value={inlineInsertForm.arrivalTime}
                            onChange={(value) => setInlineInsertForm(prev => ({ ...prev, arrivalTime: value }))}
                            placeholder="Select time"
                        />
                    </div>
                    <div style={fieldStyle}>
                        <label style={labelStyle}>Departure Time (Opt)</label>
                        <TimePicker
                            value={inlineInsertForm.departureTime}
                            onChange={(value) => setInlineInsertForm(prev => ({ ...prev, departureTime: value }))}
                            placeholder="Select time"
                        />
                    </div>
                </div>

                {sectionHead('Distance')}

                <div style={{ display: 'grid', gridTemplateColumns: nextHasGPS ? '1fr 1fr' : '1fr', gap: 12, marginBottom: 4 }}>
                    <div style={{ border: '1px solid rgba(226,75,74,.4)', borderRadius: 10, padding: 14, background: 'rgba(252,235,235,.04)' }}>
                        <div style={{ fontSize: 11, fontWeight: 500, color: '#a32d2d', marginBottom: 6 }}>
                            From previous stop <span style={{ color: '#e24b4a' }}>*</span>
                        </div>
                        <input type="number" value={inlineInsertForm.manualDistFromPrev}
                            onChange={e => setInlineInsertForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
                            placeholder="0" min="0" step="0.1"
                            style={{ ...inputStyle(true), border: '1px solid #e24b4a' }} />
                        <div style={{ fontSize: 11, color: '#a32d2d', marginTop: 5, display: 'flex', alignItems: 'center', gap: 4 }}>
                            ⚠ Required for manual stops
                        </div>
                        <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #888)', marginTop: 2 }}>km</div>
                    </div>

                    {nextHasGPS && (
                        <div style={{ border: '1px solid rgba(55,138,221,.3)', borderRadius: 10, padding: 14, background: 'rgba(230,241,251,.04)' }}>
                            <div style={{ fontSize: 11, fontWeight: 500, color: '#185fa5', marginBottom: 6 }}>
                                To next stop — {nextStop.city}
                            </div>
                            <input type="number" value={inlineInsertForm.manualDistToNext}
                                onChange={e => setInlineInsertForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
                                placeholder="0" min="0" step="0.1"
                                style={{ ...inputStyle(), border: '1px solid rgba(55,138,221,.5)' }} />
                            <div style={{ fontSize: 11, color: '#185fa5', marginTop: 5, display: 'flex', alignItems: 'center', gap: 4 }}>
                                ℹ Next stop has GPS — helps accuracy
                            </div>
                            <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #888)', marginTop: 2 }}>km</div>
                        </div>
                    )}
                </div>

                {sectionHead('Stop type')}

                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {[
                        { val: 'none', label: 'Pass-through', bg: '#f1efe8', color: '#5f5e5a', border: '#888' },
                        { val: 'boarding', label: 'Boarding only', bg: '#eaf3de', color: '#3b6d11', border: '#3b6d11' },
                        { val: 'dropping', label: 'Dropping only', bg: '#fcebeb', color: '#a32d2d', border: '#a32d2d' },
                        { val: 'both', label: 'Both boarding & dropping', bg: '#e6f1fb', color: '#185fa5', border: '#378add' },
                    ].map(opt => {
                        const sel = inlineInsertForm.stopType === opt.val;
                        return (
                            <button key={opt.val}
                                type="button"
                                onClick={() => setInlineInsertForm(prev => ({ ...prev, stopType: opt.val }))}
                                style={{
                                    padding: '6px 14px', borderRadius: 999, fontSize: 12, cursor: 'pointer',
                                    border: `1px solid ${sel ? opt.border : 'rgba(0,0,0,.2)'}`,
                                    background: sel ? opt.bg : 'transparent',
                                    color: sel ? opt.color : 'var(--color-text-secondary, #666)',
                                    fontWeight: sel ? 500 : 400, transition: 'all .12s'
                                }}>
                                {opt.label}
                            </button>
                        );
                    })}
                </div>

                <div style={{ display: 'flex', gap: 16, marginTop: 16 }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
                        <input type="checkbox" checked={inlineInsertForm.isBoarding}
                            onChange={e => setInlineInsertForm(prev => ({ ...prev, isBoarding: e.target.checked }))} />
                        Boarding Point
                    </label>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
                        <input type="checkbox" checked={inlineInsertForm.isDropping}
                            onChange={e => setInlineInsertForm(prev => ({ ...prev, isDropping: e.target.checked }))} />
                        Dropping Point
                    </label>
                </div>
            </div>

            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8,
                padding: '12px 18px',
                borderTop: '1px solid var(--color-border-tertiary, rgba(0,0,0,.08))',
                background: 'var(--color-background-secondary, #fafafa)'
            }}>
                <button type="button"
                    onClick={() => { setInlineInsertIndex(null); setInlineInsertCitySuggestions([]); setShowInlineInsertDropdown(false); }}
                    style={{ padding: '8px 18px', fontSize: 13, borderRadius: 8, border: '1px solid var(--color-border-secondary, rgba(0,0,0,.2))', background: 'transparent', cursor: 'pointer', color: 'var(--color-text-secondary, #666)' }}>
                    Cancel
                </button>
                <button type="button"
                    onClick={saveInlineInsert}
                    disabled={!canInsert}
                    style={{ padding: '8px 22px', fontSize: 13, borderRadius: 8, border: 'none', background: '#378add', color: '#fff', fontWeight: 500, cursor: canInsert ? 'pointer' : 'not-allowed', opacity: canInsert ? 1 : 0.45, display: 'flex', alignItems: 'center', gap: 6 }}>
                    ✓ Insert stop
                </button>
            </div>
        </div>
    );
};

    const saveInlineInsert = () => {
        if (!inlineInsertForm.city) {
            toast.error('City is required');
            return;
        }
        if (!inlineInsertForm.arrivalTime) {
            toast.error('Arrival time is required');
            return;
        }
        // State is required
    if (!inlineInsertForm.state || inlineInsertForm.state.trim() === '') {
        toast.error('State is required');
        return;
    }

    // Address is required
    if (!inlineInsertForm.address || inlineInsertForm.address.trim() === '') {
        toast.error('Address is required');
        return;
    }

    // Terminal is required
    if (!inlineInsertForm.terminal || inlineInsertForm.terminal.trim() === '') {
        toast.error('Terminal is required');
        return;
    }

        if (inlineInsertForm.isManual && (!inlineInsertForm.manualDistFromPrev || parseFloat(inlineInsertForm.manualDistFromPrev) <= 0)) {
            toast.error('For manual stops, please provide distance from previous stop');
            return;
        }

        const type = activeRouteTab === 'UP' ? 'up' : 'down';
        let currentStops = type === 'up' ? [...upStops] : [...downStops];

        let coordinates = null;
        let manualDistFromPrev = null;
        let manualDistToNext = null;
        let distanceFromOrigin = 0;

        if (inlineInsertForm.isManual) {
            coordinates = { lat: 0, lng: 0 };
            manualDistFromPrev = parseFloat(inlineInsertForm.manualDistFromPrev);
            manualDistToNext = inlineInsertForm.manualDistToNext ? parseFloat(inlineInsertForm.manualDistToNext) : null;

            if (inlineInsertIndex > 0 && currentStops[inlineInsertIndex - 1]) {
                distanceFromOrigin = parseFloat(((currentStops[inlineInsertIndex - 1].distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
            } else {
                distanceFromOrigin = manualDistFromPrev || 0;
            }
        }

        let stopType = inlineInsertForm.stopType || 'none';
        if (stopType === 'none') {
            if (inlineInsertForm.isBoarding && inlineInsertForm.isDropping) stopType = 'both';
            else if (inlineInsertForm.isBoarding) stopType = 'boarding';
            else if (inlineInsertForm.isDropping) stopType = 'dropping';
        }

        const newStop = {
            city: inlineInsertForm.city,
            state: inlineInsertForm.state || '',
            address: inlineInsertForm.address || `${inlineInsertForm.city}, ${inlineInsertForm.state || 'India'}`,
            terminal: inlineInsertForm.terminal || `${inlineInsertForm.city} Bus Stand`,
            arrivalTime: inlineInsertForm.arrivalTime,
            departureTime: inlineInsertForm.departureTime || inlineInsertForm.arrivalTime,
            stopType: stopType,
            coordinates: coordinates,
            manualDistFromPrev: manualDistFromPrev,
            manualDistToNext: manualDistToNext,
            distanceFromOrigin: distanceFromOrigin,
            isManualStop: inlineInsertForm.isManual
        };

        currentStops.splice(inlineInsertIndex, 0, newStop);
        setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

        if (type === 'up') {
            setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
        } else {
            setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
        }

        toast.success(`Stop "${inlineInsertForm.city}" inserted at position ${inlineInsertIndex + 1}`);

        setInlineInsertIndex(null);
        setInlineInsertCitySuggestions([]);
        setShowInlineInsertDropdown(false);
    };

    const searchCitySuggestions = async (query, type) => {
        if (!query || query.trim().length < 2) {
            if (type === 'origin') {
                setOriginSuggestions([]);
            } else {
                setDestSuggestions([]);
            }
            return;
        }

        try {
            const allRoutes = await getAllRoutes(token, 1, 100, '');
            if (allRoutes.success && allRoutes.data?.routes) {
                const cities = new Set();
                allRoutes.data.routes.forEach(route => {
                    if (type === 'origin' && route.origin?.city) {
                        if (route.origin.city.toLowerCase().includes(query.toLowerCase())) {
                            cities.add(route.origin.city);
                        }
                    } else if (type === 'destination' && route.destination?.city) {
                        if (route.destination.city.toLowerCase().includes(query.toLowerCase())) {
                            cities.add(route.destination.city);
                        }
                    }
                });

                const suggestions = Array.from(cities).map(city => ({ city }));
                if (type === 'origin') {
                    setOriginSuggestions(suggestions);
                    setShowOriginSuggestions(true);
                } else {
                    setDestSuggestions(suggestions);
                    setShowDestSuggestions(true);
                }
            }
        } catch (error) {
            console.error('Error fetching city suggestions:', error);
        }
    };

    const formatTime = (time) => {
        if (!time) return 'N/A';
        if (time.includes(':')) {
            const [hours, minutes] = time.split(':');
            const hour = parseInt(hours);
            const ampm = hour >= 12 ? 'pm' : 'am';
            const displayHour = hour % 12 || 12;
            return `${displayHour}:${minutes} ${ampm}`;
        }
        return time;
    };

    const formatDuration = (hours, minutes) => {
        if (!hours && !minutes) return 'N/A';
        const parts = [];
        if (hours) parts.push(`${hours}h`);
        if (minutes) parts.push(`${minutes}m`);
        return parts.join(' ');
    };

    const getDuration = (start, end) => {
        if (!start || !end) return { hours: '0', minutes: '0' };
        const [sh, sm] = start.split(':').map(Number);
        const [eh, em] = end.split(':').map(Number);
        let sMins = sh * 60 + sm;
        let eMins = eh * 60 + em;
        if (eMins < sMins) eMins += 24 * 60;
        const diff = eMins - sMins;
        return { hours: String(Math.floor(diff / 60)), minutes: String(diff % 60) };
    };

    const isLastStopManual = () => {
        const stops = activeRouteTab === 'UP' ? upStops : downStops;

        if (stops.length === 0) return false;

        const lastStop = stops[stops.length - 1];

        const isManual =
            lastStop.isManualStop === true ||
            (lastStop.manualDistFromPrev !== null && lastStop.manualDistFromPrev !== undefined && lastStop.manualDistFromPrev > 0) ||
            (lastStop.manualDistToNext !== null && lastStop.manualDistToNext !== undefined && lastStop.manualDistToNext > 0) ||
            !lastStop.coordinates ||
            (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0);

        return isManual;
    };

    const isNextStopAuto = (currentIndex) => {
        const stops = getActiveStops();
        const nextStop = stops[currentIndex + 1];
        return nextStop && nextStop.coordinates &&
            (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
    };

    const handleSelectOrigin = (location) => {
        setNewRoute(prev => ({
            ...prev,
            upOriginCity: location.city || location.name || '',
            upOriginState: location.state || '',
            upOriginAddress: location.address || '',
            upOriginCoords: location.coordinates || { lat: 0, lng: 0 }
        }));
        setIsDistanceCalculated(prev => ({ ...prev, up: false }));
    };

    const handleSelectDest = (location) => {
        setNewRoute(prev => ({
            ...prev,
            upDestCity: location.city || location.name || '',
            upDestState: location.state || '',
            upDestAddress: location.address || '',
            upDestCoords: location.coordinates || { lat: 0, lng: 0 }
        }));
        setIsDistanceCalculated(prev => ({ ...prev, up: false }));
    };

    const handleSelectStop = (location) => {
        let autoState = location.state || '';

        if (!autoState && activeRouteTab === 'UP') {
            if (upStops.length > 0) {
                const lastStop = upStops[upStops.length - 1];
                if (lastStop.state && lastStop.state.trim()) {
                    autoState = lastStop.state;
                }
            }
            if (!autoState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
                autoState = newRoute.upOriginState;
            }
        } else if (!autoState && activeRouteTab === 'DOWN') {
            if (downStops.length > 0) {
                const lastStop = downStops[downStops.length - 1];
                if (lastStop.state && lastStop.state.trim()) {
                    autoState = lastStop.state;
                }
            }
            if (!autoState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
                autoState = newRoute.upOriginState;
            }
        }

        setNewRoute(prev => ({
            ...prev,
            stopCity: location.city || location.name || '',
            stopState: autoState,
            stopAddress: location.address || '',
            stopCoords: location.coordinates || { lat: 0, lng: 0 }
        }));
        setIsManualStop(false);
        setIsManualDistance(false);
    };

    const syncDownStopsWithUpStops = (forcePrompt = false) => {
        if (upStops.length === 0) {
            toast.warning("No UP route stops to sync from.");
            return;
        }

        const upTotalDist = parseFloat(editForm.totalDistance || newRoute.upTotalDistance || 0);
        let downTotalDist = parseFloat(editForm.returnTotalDistance || newRoute.downTotalDistance || 0);

        if (downTotalDist === 0 && upTotalDist > 0) {
            downTotalDist = upTotalDist;
        }

        // Get the number of trips from UP route
        const numTrips = editForm.numberOfTrips || editNumberOfTrips || numberOfTrips || 1;
        const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip || false;

        const doSync = () => {
            const newDownStops = [];
            const upDistances = upStops.map(stop => stop.distanceFromOrigin || 0);
            const maxUpDistance = upDistances[upDistances.length - 1] || 0;

            for (let i = 0; i < upStops.length; i++) {
                const originalIndex = upStops.length - 1 - i;
                const originalStop = upStops[originalIndex];

                const upDistance = originalStop.distanceFromOrigin || 0;
                let downDistance = downTotalDist - upDistance;

                if (downDistance <= 0 && i === 0) {
                    downDistance = downTotalDist - maxUpDistance;
                }
                if (downDistance <= 0) downDistance = (downTotalDist / (upStops.length + 1)) * (i + 1);

                let manualDistFromPrev = null;
                if (i === 0) {
                    manualDistFromPrev = downDistance;
                } else {
                    const prevDownDist = newDownStops[i - 1]?.distanceFromOrigin || 0;
                    manualDistFromPrev = downDistance - prevDownDist;
                }
                if (manualDistFromPrev <= 0) manualDistFromPrev = originalStop.manualDistFromPrev || downDistance / (i + 1);

                let newStopType = originalStop.stopType;
                if (originalStop.stopType === 'boarding') newStopType = 'dropping';
                else if (originalStop.stopType === 'dropping') newStopType = 'boarding';

                // ========== CREATE TIMINGS FOR RETURN STOP ==========
                let stopTimings = [];
                if (isMultiTripMode) {
                    // Check if we have timings from editForm originTimings
                    if (editForm.originTimings && editForm.originTimings.length > 0) {
                        // Create timings based on the number of trips from UP route
                        stopTimings = editForm.originTimings.map(t => ({
                            timeSlotSequence: t.timeSlotSequence || t.sequence || 1,
                            arrivalTime: '', // User will set these
                            departureTime: '' // User will set these
                        }));
                    } else if (editForm.destTimings && editForm.destTimings.length > 0) {
                        stopTimings = editForm.destTimings.map(t => ({
                            timeSlotSequence: t.timeSlotSequence || t.sequence || 1,
                            arrivalTime: '',
                            departureTime: ''
                        }));
                    } else if (originalStop.timings && originalStop.timings.length > 0) {
                        // Copy timings from original stop but clear times
                        stopTimings = originalStop.timings.map(t => ({
                            timeSlotSequence: t.timeSlotSequence || 1,
                            arrivalTime: '',
                            departureTime: ''
                        }));
                    } else {
                        // Create default timings for each trip
                        stopTimings = Array.from({ length: numTrips }, (_, idx) => ({
                            timeSlotSequence: idx + 1,
                            arrivalTime: '',
                            departureTime: ''
                        }));
                    }

                    // Ensure we have the correct number of timings
                    while (stopTimings.length < numTrips) {
                        stopTimings.push({
                            timeSlotSequence: stopTimings.length + 1,
                            arrivalTime: '',
                            departureTime: ''
                        });
                    }
                    // Sort by sequence
                    stopTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                }

                newDownStops.push({
                    ...originalStop,
                    sequence: i + 1,
                    stopType: newStopType,
                    distanceFromOrigin: parseFloat(downDistance.toFixed(1)),
                    manualDistFromPrev: parseFloat(manualDistFromPrev.toFixed(1)),
                    manualDistToNext: originalStop.manualDistFromPrev || null,
                    arrivalTime: isMultiTripMode ? '' : '',
                    departureTime: isMultiTripMode ? '' : '',
                    timings: stopTimings
                });
            }

            if (newDownStops.length > 0) {
                const lastDownDist = newDownStops[newDownStops.length - 1].distanceFromOrigin || 0;
                const finalSegment = downTotalDist - lastDownDist;
                if (finalSegment > 0) {
                    newDownStops[newDownStops.length - 1] = {
                        ...newDownStops[newDownStops.length - 1],
                        manualDistToNext: parseFloat(finalSegment.toFixed(1))
                    };
                }
            }

            setDownStops(newDownStops);

            // ========== ALSO SYNC THE RETURN TIMINGS ==========
            if (isMultiTripMode) {
                // Create return origin timings from UP route origin timings
                if (editForm.originTimings && editForm.originTimings.length > 0) {
                    const returnOriginTimings = editForm.originTimings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence || 1,
                        departureTime: '', // User will set these
                        arrivalTime: ''
                    }));
                    setEditForm(prev => ({
                        ...prev,
                        returnOriginTimings: returnOriginTimings
                    }));
                } else {
                    // Create default return origin timings
                    const returnOriginTimings = Array.from({ length: numTrips }, (_, idx) => ({
                        timeSlotSequence: idx + 1,
                        departureTime: '',
                        arrivalTime: ''
                    }));
                    setEditForm(prev => ({
                        ...prev,
                        returnOriginTimings: returnOriginTimings
                    }));
                }

                // Create return destination timings from UP route destination timings
                if (editForm.destTimings && editForm.destTimings.length > 0) {
                    const returnDestTimings = editForm.destTimings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence || 1,
                        arrivalTime: '', // User will set these
                        departureTime: ''
                    }));
                    setEditForm(prev => ({
                        ...prev,
                        returnDestTimings: returnDestTimings
                    }));
                } else {
                    // Create default return destination timings
                    const returnDestTimings = Array.from({ length: numTrips }, (_, idx) => ({
                        timeSlotSequence: idx + 1,
                        arrivalTime: '',
                        departureTime: ''
                    }));
                    setEditForm(prev => ({
                        ...prev,
                        returnDestTimings: returnDestTimings
                    }));
                }

                setEditNumberOfTrips(numTrips);
            }

            setEditForm(prev => ({
                ...prev,
                returnTotalDistance: downTotalDist.toFixed(1),
                returnDurationHours: prev.durationHours,
                returnDurationMinutes: prev.durationMinutes,
                isMultiTrip: isMultiTripMode,
                numberOfTrips: numTrips
            }));
            setNewRoute(prev => ({
                ...prev,
                downTotalDistance: downTotalDist.toFixed(1)
            }));

            setIsDistanceCalculated(prev => ({ ...prev, down: false }));

            if (isMultiTripMode) {
                toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${downTotalDist.toFixed(1)} km with ${numTrips} trip(s). Each stop has timings for ${numTrips} trip(s).`);
            } else {
                toast.success(`DOWN route populated with ${newDownStops.length} stops. Total distance: ${downTotalDist.toFixed(1)} km`);
            }
        };

        if (forcePrompt && downStops.length > 0) {
            if (window.confirm("This will update your Return Route stops based on your Main Route. Any existing DOWN route data will be replaced. Proceed?")) {
                doSync();
            }
        } else {
            doSync();
        }
    };

    const toggleRoundTrip = (newVal) => {
        setIsRoundTrip(newVal);

        if (newVal) {
            // When enabling round trip for ADD route
            if (isMultiTrip) {
                if (destinationTimeSlots && destinationTimeSlots.length > 0) {
                    setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
                        sequence: slot.sequence,
                        departureTime: slot.arrivalTime || '',
                        arrivalTime: '',
                        fareMultiplier: slot.fareMultiplier || 1.0,
                        isActive: true
                    })));
                } else if (timeSlots && timeSlots.length > 0) {
                    setReturnOriginTimeSlots(timeSlots.map(slot => ({
                        sequence: slot.sequence,
                        departureTime: slot.departureTime || '',
                        arrivalTime: '',
                        fareMultiplier: slot.fareMultiplier || 1.0,
                        isActive: true
                    })));
                }

                if (timeSlots && timeSlots.length > 0) {
                    setReturnDestTimeSlots(timeSlots.map(slot => ({
                        sequence: slot.sequence,
                        arrivalTime: slot.departureTime || '',
                        departureTime: '',
                        fareMultiplier: slot.fareMultiplier || 1.0,
                        isActive: true
                    })));
                }
            }

            // Auto-populate return destination with origin data
            if (newRoute.upOriginCity) {
                setNewRoute(prev => ({
                    ...prev,
                    downDestCity: prev.upOriginCity,
                    downDestState: prev.upOriginState,
                    downDestAddress: prev.upOriginAddress,
                    downDestTerminal: prev.upOriginTerminal,
                    downTotalDistance: prev.upTotalDistance || '',
                    downDurationHours: prev.upDurationHours || '',
                    downDurationMinutes: prev.upDurationMinutes || '',
                    // Auto-fill return times based on forward times
                    downOriginDepTime: prev.upDestArrTime || '',
                    downDestArrTime: prev.upOriginDepTime || '',
                }));
            }

            // If there are UP stops, sync them to DOWN
            if (upStops.length > 0 && downStops.length === 0) {
                const upTotalDist = parseFloat(newRoute.upTotalDistance || 0);
                const reversedStops = [...upStops].reverse();
                let downTotalDistance = upTotalDist || 0;

                // Calculate segment distances
                const upSegmentDistances = [];
                let prevDist = 0;
                for (let i = 0; i < upStops.length; i++) {
                    const currentDist = upStops[i].distanceFromOrigin || 0;
                    let segment = currentDist - prevDist;
                    if (segment <= 0 && upStops[i].manualDistFromPrev) {
                        segment = parseFloat(upStops[i].manualDistFromPrev);
                    }
                    if (segment <= 0 && i === 0 && upTotalDist > 0) {
                        segment = upTotalDist / (upStops.length + 1);
                    }
                    if (segment <= 0) segment = 5;
                    upSegmentDistances.push(segment);
                    prevDist = currentDist;
                }

                // Final segment from last stop to destination
                const lastUpStopDist = upStops.length > 0 ? (upStops[upStops.length - 1].distanceFromOrigin || 0) : 0;
                let finalUpSegment = upTotalDist - lastUpStopDist;
                if (finalUpSegment <= 0 && newRoute.upManualFinalLeg) {
                    finalUpSegment = parseFloat(newRoute.upManualFinalLeg);
                }
                if (finalUpSegment <= 0) finalUpSegment = upTotalDist / (upStops.length + 1);

                // For DOWN route, reverse the segments: final segment becomes first, then reverse the rest
                const downSegmentDistances = [finalUpSegment, ...upSegmentDistances.reverse()];
                let cumulativeDist = 0;
                const newDownStops = [];

                for (let i = 0; i < reversedStops.length; i++) {
                    const originalStop = reversedStops[i];
                    let segmentDist = downSegmentDistances[i] || 5;

                    if (originalStop.manualDistFromPrev && originalStop.manualDistFromPrev > 0) {
                        segmentDist = parseFloat(originalStop.manualDistFromPrev);
                    } else if (originalStop.manualDistToNext && originalStop.manualDistToNext > 0) {
                        segmentDist = parseFloat(originalStop.manualDistToNext);
                    }

                    cumulativeDist += segmentDist;

                    let newStopType = originalStop.stopType;
                    if (originalStop.stopType === 'boarding') {
                        newStopType = 'dropping';
                    } else if (originalStop.stopType === 'dropping') {
                        newStopType = 'boarding';
                    }

                    // Copy timings for multi-trip
                    let stopTimings = [];
                    if (isMultiTrip && originalStop.timings && originalStop.timings.length > 0) {
                        stopTimings = originalStop.timings.map(t => ({
                            timeSlotSequence: t.timeSlotSequence,
                            arrivalTime: '',
                            departureTime: ''
                        }));
                    } else if (isMultiTrip && timeSlots && timeSlots.length > 0) {
                        stopTimings = timeSlots.map(slot => ({
                            timeSlotSequence: slot.sequence,
                            arrivalTime: '',
                            departureTime: ''
                        }));
                    }

                    newDownStops.push({
                        ...originalStop,
                        sequence: i + 1,
                        stopType: newStopType,
                        distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
                        manualDistFromPrev: parseFloat(segmentDist.toFixed(1)),
                        manualDistToNext: originalStop.manualDistFromPrev || null,
                        arrivalTime: isMultiTrip ? '' : originalStop.arrivalTime || '',
                        departureTime: isMultiTrip ? '' : originalStop.departureTime || '',
                        timings: stopTimings
                    });
                }

                // Calculate final segment
                let finalSegment = downTotalDistance - cumulativeDist;
                if (finalSegment <= 0) {
                    const lastUpFirstSegment = upSegmentDistances[0] || 5;
                    finalSegment = lastUpFirstSegment;
                }

                if (newDownStops.length > 0 && finalSegment > 0) {
                    newDownStops[newDownStops.length - 1] = {
                        ...newDownStops[newDownStops.length - 1],
                        manualDistToNext: parseFloat(finalSegment.toFixed(1))
                    };
                }

                const calculatedTotal = cumulativeDist + finalSegment;
                if (Math.abs(calculatedTotal - downTotalDistance) > 0.1) {
                    downTotalDistance = calculatedTotal;
                }

                setDownStops(newDownStops);
                setNewRoute(prev => ({
                    ...prev,
                    downTotalDistance: downTotalDistance.toFixed(1),
                    downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.downManualFinalLeg,
                    downDurationHours: prev.upDurationHours || '',
                    downDurationMinutes: prev.upDurationMinutes || ''
                }));

                setIsDistanceCalculated(prev => ({ ...prev, down: false }));
                toast.success(`Return route populated with ${newDownStops.length} stops. Total distance: ${downTotalDistance.toFixed(1)} km`);
            } else if (upStops.length === 0) {
                toast.info('Add stops to the UP route first, then enable round trip to auto-populate the return route.');
            }

            // Switch to DOWN tab
            setActiveRouteTab('DOWN');
        } else {
            // When disabling round trip
            setDownStops([]);
            setReturnOriginTimeSlots([]);
            setReturnDestTimeSlots([]);
            setIsDistanceCalculated(prev => ({ ...prev, down: false }));
            setNewRoute(prev => ({
                ...prev,
                downTotalDistance: '',
                downDurationHours: '',
                downDurationMinutes: '',
                downOriginDepTime: '',
                downDestArrTime: '',
                downManualFinalLeg: '',
                downManualFirstLeg: ''
            }));
            setActiveRouteTab('UP');
            toast.info('Return route disabled');
        }
    };

    const handleTabSwitch = (tab) => {
        if (tab === 'DOWN' && upStops.length > 0 && isRoundTrip) {
            if (isMultiTrip) {
                if (returnOriginTimeSlots.length === 0 && destinationTimeSlots.length > 0) {
                    setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
                        sequence: slot.sequence,
                        departureTime: slot.arrivalTime || '',
                        arrivalTime: '',
                        fareMultiplier: slot.fareMultiplier || 1.0,
                        isActive: true
                    })));
                }
                if (returnDestTimeSlots.length === 0 && timeSlots.length > 0) {
                    setReturnDestTimeSlots(timeSlots.map(slot => ({
                        sequence: slot.sequence,
                        arrivalTime: slot.departureTime || '',
                        departureTime: '',
                        fareMultiplier: slot.fareMultiplier || 1.0,
                        isActive: true
                    })));
                }
            }

            if (downStops.length === 0) {
                syncDownStopsWithUpStops(false);
            } else if (downStops.length > 0) {
                const hasStaleData = downStops.some(stop => {
                    if (isMultiTrip) {
                        return !stop.timings || stop.timings.length === 0;
                    }
                    return !stop.arrivalTime;
                });

                if (hasStaleData && window.confirm("Return route stops are missing timing information. Would you like to sync with UP route?")) {
                    syncDownStopsWithUpStops(false);
                }
            }
        }
        setActiveRouteTab(tab);
        clearStopForm();
    };

    const getActiveStops = () => activeRouteTab === 'UP' ? upStops : downStops;
    const setActiveStops = (stops) => {
        if (activeRouteTab === 'UP') {
            setUpStops(stops);
        } else {
            setDownStops(stops);
        }
    };

    const clearStopForm = () => {
        let defaultState = '';

        if (activeRouteTab === 'UP') {
            if (upStops.length > 0) {
                const lastStop = upStops[upStops.length - 1];
                if (lastStop.state && lastStop.state.trim()) {
                    defaultState = lastStop.state;
                }
            }
            if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
                defaultState = newRoute.upOriginState;
            }
            if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) {
                defaultState = newRoute.upDestState;
            }
        } else if (activeRouteTab === 'DOWN') {
            if (downStops.length > 0) {
                const lastStop = downStops[downStops.length - 1];
                if (lastStop.state && lastStop.state.trim()) {
                    defaultState = lastStop.state;
                }
            }
            if (!defaultState && newRoute.upOriginState && newRoute.upOriginState.trim()) {
                defaultState = newRoute.upOriginState;
            }
            if (!defaultState && newRoute.upDestState && newRoute.upDestState.trim()) {
                defaultState = newRoute.upDestState;
            }
        }

        setNewRoute(prev => ({
            ...prev,
            stopCity: '',
            stopState: defaultState,
            stopAddress: '',
            stopTerminal: '',
            stopArrivalTime: '',
            stopDepartureTime: '',
            stopCoords: null,
            stopDistFromPrev: '',
            stopDistToNext: '',
            isBoarding: false,
            isDropping: false,
            stopTimings: []
        }));
        setIsManualDistance(false);
        setEditingStopIndex(null);
        setInsertIndex(null);
        setIsManualStop(true);
    };

    const addIntermediateStop = (type = 'up') => {
        if (!newRoute.stopCity) {
            toast.error('City is required.');
            return;
        }

        if (isMultiTrip && (!newRoute.stopTimings || newRoute.stopTimings.length === 0)) {
            toast.warning('Please add at least one trip timing for this stop');
            return;
        }

        if (!isMultiTrip && !newRoute.stopArrivalTime) {
            toast.error('Arrival Time is required.');
            return;
        }

        let coordinates = newRoute.stopCoords;
        let manualDistFromPrev = null;
        let manualDistToNext = null;
        let distanceFromOrigin = 0;

        const stops = getActiveStops();
        const isManualLocation = isManualStop || !newRoute.stopCoords || (newRoute.stopCoords.lat === 0 && newRoute.stopCoords.lng === 0);

        if (isManualLocation) {
            if (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0) {
                toast.error('For manual stops, please provide distance from previous stop');
                return;
            }
            coordinates = { lat: 0, lng: 0 };
            manualDistFromPrev = parseFloat(newRoute.stopDistFromPrev);

            if (stops.length > 0) {
                const lastStop = stops[stops.length - 1];
                distanceFromOrigin = parseFloat(((lastStop.distanceFromOrigin || 0) + manualDistFromPrev).toFixed(2));
            } else {
                distanceFromOrigin = manualDistFromPrev;
            }

            const currentIndex = editingStopIndex !== null ? editingStopIndex :
                (insertIndex !== null ? insertIndex : stops.length);
            const nextStop = stops[currentIndex];
            const isNextAuto = nextStop && nextStop.coordinates &&
                (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);

            if (isNextAuto && newRoute.stopDistToNext && parseFloat(newRoute.stopDistToNext) > 0) {
                manualDistToNext = parseFloat(newRoute.stopDistToNext);
            }
        } else if (newRoute.stopCoords && (newRoute.stopCoords.lat !== 0 || newRoute.stopCoords.lng !== 0)) {
            distanceFromOrigin = 0;
        }

        let stopType = 'none';
        if (newRoute.isBoarding && newRoute.isDropping) stopType = 'both';
        else if (newRoute.isBoarding) stopType = 'boarding';
        else if (newRoute.isDropping) stopType = 'dropping';

        let autoState = newRoute.stopState;
        if (!autoState || !autoState.trim()) {
            if (type === 'up' && upStops.length > 0) {
                const lastStop = upStops[upStops.length - 1];
                if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state;
            } else if (type === 'down' && downStops.length > 0) {
                const lastStop = downStops[downStops.length - 1];
                if (lastStop.state && lastStop.state.trim()) autoState = lastStop.state;
            }
            if (!autoState && newRoute.upOriginState) autoState = newRoute.upOriginState;
            if (!autoState && newRoute.upDestState) autoState = newRoute.upDestState;
        }

        const newStop = {
            city: newRoute.stopCity,
            state: autoState || newRoute.stopState || '',
            address: newRoute.stopAddress || `${newRoute.stopCity}, ${autoState || 'India'}`,
            terminal: newRoute.stopTerminal || `${newRoute.stopCity} Bus Stand`,
            arrivalTime: isMultiTrip ? '' : newRoute.stopArrivalTime,
            departureTime: isMultiTrip ? '' : (newRoute.stopDepartureTime || newRoute.stopArrivalTime),
            timings: isMultiTrip ? (newRoute.stopTimings || []).map(t => ({
                timeSlotSequence: t.timeSlotSequence,
                arrivalTime: t.arrivalTime,
                departureTime: t.departureTime || t.arrivalTime
            })) : [],
            stopType: stopType,
            coordinates: coordinates,
            manualDistFromPrev: manualDistFromPrev,
            manualDistToNext: manualDistToNext,
            distanceFromOrigin: distanceFromOrigin,
            isManualStop: isManualLocation
        };

        setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

        let currentStops = type === 'up' ? [...upStops] : [...downStops];
        let editingIndex = null;

        if (type === 'up' && editUpIndex !== null) {
            editingIndex = editUpIndex;
        } else if (type === 'down' && editDownIndex !== null) {
            editingIndex = editDownIndex;
        }

        if (editingIndex !== null) {
            currentStops[editingIndex] = { ...currentStops[editingIndex], ...newStop, sequence: editingIndex + 1 };
            if (type === 'up') setEditUpIndex(null);
            else setEditDownIndex(null);
            setEditingStopIndex(null);
            toast.success(`Stop "${newRoute.stopCity}" updated successfully`);
        } else if (insertIndex !== null) {
            currentStops.splice(insertIndex, 0, newStop);
            setInsertIndex(null);
            toast.success(`Stop inserted at position ${insertIndex + 1}`);
        } else {
            currentStops.push(newStop);
            toast.success(`Stop "${newRoute.stopCity}" added successfully`);
        }

        if (type === 'up') {
            setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
        } else {
            setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
        }

        clearStopForm();
    };

    // ========== HANDLE EDIT STOP (FIXED FOR MULTI-TRIP) ==========
    // const handleEditStop = (index, type = 'up') => {
    //     const stop = type === 'up' ? upStops[index] : downStops[index];
    //     const stops = type === 'up' ? upStops : downStops;

    //     const isManual = !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);

    //     let manualDistValue = stop.manualDistFromPrev ? String(stop.manualDistFromPrev) : '';

    //     if (!manualDistValue && stop.distanceFromOrigin > 0) {
    //         let calculatedDist = stop.distanceFromOrigin;
    //         if (index > 0) {
    //             const prevStop = stops[index - 1];
    //             if (prevStop && prevStop.distanceFromOrigin > 0) {
    //                 calculatedDist = stop.distanceFromOrigin - prevStop.distanceFromOrigin;
    //             }
    //         }
    //         if (calculatedDist > 0) {
    //             manualDistValue = calculatedDist.toFixed(1);
    //         }
    //     }

    //     let manualDistToNextValue = stop.manualDistToNext ? String(stop.manualDistToNext) : '';
    //     if (!manualDistToNextValue && stop.distanceFromOrigin > 0 && index < stops.length - 1) {
    //         const nextStop = stops[index + 1];
    //         if (nextStop && nextStop.distanceFromOrigin > 0) {
    //             const calculatedNextDist = nextStop.distanceFromOrigin - stop.distanceFromOrigin;
    //             if (calculatedNextDist > 0) {
    //                 manualDistToNextValue = calculatedNextDist.toFixed(1);
    //             }
    //         }
    //     }

    //     // ========== DETERMINE IF THIS IS A MULTI-TRIP STOP ==========
    //     const isMultiTripRoute = editForm.isMultiTrip || editIsMultiTrip || isMultiTrip;
    //     const hasMultiTimings = stop.timings && stop.timings.length > 0;
    //     const hasMultipleTrips = (editForm.numberOfTrips || editNumberOfTrips || numberOfTrips || 1) > 1;
    //     const isMultiTripStop = isMultiTripRoute || hasMultiTimings || hasMultipleTrips;

    //     // ========== SYNC TIMINGS WITH TOTAL NUMBER OF TRIPS ==========
    //     const totalTrips = editForm.numberOfTrips || editNumberOfTrips || numberOfTrips || 1;

    //     // Get existing timings from the stop
    //     let existingTimings = stop.timings ? [...stop.timings] : [];

    //     // If there are no timings but the stop has arrivalTime/departureTime (legacy format)
    //     if (existingTimings.length === 0 && (stop.arrivalTime || stop.departureTime)) {
    //         existingTimings = [{
    //             timeSlotSequence: 1,
    //             arrivalTime: stop.arrivalTime || '',
    //             departureTime: stop.departureTime || stop.arrivalTime || ''
    //         }];
    //     }

    //     // Ensure we have timings for ALL trips
    //     let updatedTimings = [];
    //     for (let i = 1; i <= totalTrips; i++) {
    //         const existing = existingTimings.find(t => t.timeSlotSequence === i);
    //         if (existing) {
    //             updatedTimings.push({
    //                 timeSlotSequence: i,
    //                 arrivalTime: existing.arrivalTime || '',
    //                 departureTime: existing.departureTime || existing.arrivalTime || ''
    //             });
    //         } else {
    //             // Create a new timing entry for this trip
    //             updatedTimings.push({
    //                 timeSlotSequence: i,
    //                 arrivalTime: '',
    //                 departureTime: ''
    //             });
    //         }
    //     }

    //     // Sort by sequence
    //     updatedTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));

    //     setStopBeingEdited({ index, type, originalStop: stop });

    //     // ========== DETERMINE THE CORRECT ARRIVAL TIME FOR DISPLAY ==========
    //     // For multi-trip stops, use the first timing's arrival time for the top-level display
    //     let displayArrivalTime = '';
    //     let displayDepartureTime = '';

    //     if (isMultiTripStop && updatedTimings.length > 0) {
    //         // Use the first timing's values for display
    //         displayArrivalTime = updatedTimings[0].arrivalTime || '';
    //         displayDepartureTime = updatedTimings[0].departureTime || '';
    //     } else {
    //         // Single trip mode - use stop's arrival/departure
    //         displayArrivalTime = stop.arrivalTime || '';
    //         displayDepartureTime = stop.departureTime || '';
    //     }

    //     // ========== SET STOP EDIT FORM ==========
    //     setStopEditForm({
    //         city: stop.city || '',
    //         state: stop.state || '',
    //         address: stop.address || '',
    //         terminal: stop.terminal || '',
    //         // Use the determined display values
    //         arrivalTime: displayArrivalTime,
    //         departureTime: displayDepartureTime,
    //         timings: updatedTimings,  // This now has ALL trips with their actual values
    //         isBoarding: stop.stopType === 'boarding' || stop.stopType === 'both',
    //         isDropping: stop.stopType === 'dropping' || stop.stopType === 'both',
    //         manualDistFromPrev: manualDistValue,
    //         manualDistToNext: manualDistToNextValue,
    //         isManualStop: isManual || stop.manualDistFromPrev !== null || manualDistValue !== '',
    //         // Add flags for multi-trip handling
    //         isMultiTrip: isMultiTripStop,
    //         tripCount: totalTrips
    //     });

    //     setShowStopEditModal(true);
    // };

    // Add this useEffect near your other useEffects
useEffect(() => {
    // When stopEditForm.timings changes, update the tripCount
    if (stopEditForm.timings && stopEditForm.timings.length > 0) {
        setStopEditForm(prev => ({
            ...prev,
            tripCount: stopEditForm.timings.length
        }));
    }
}, [stopEditForm.timings]);

const handleEditStop = (index, type) => {
    const stops = type === 'up' ? upStops : downStops;
    const stop = stops[index];
    
    if (!stop) {
        console.error('Stop not found at index:', index);
        return;
    }
    
    console.log('🛑 Editing stop:', stop);
    console.log('📋 Original stop timings:', stop.timings);
    
    // ========== FIX: Get number of trips from stop.timings FIRST ==========
    let numTrips = 1;
    
    // Priority 1: Use the stop's timings length
    if (stop.timings && stop.timings.length > 0) {
        numTrips = stop.timings.length;
        console.log('📊 Number of trips from stop.timings:', numTrips);
    } 
    // Priority 2: Use editForm.numberOfTrips
    else if (editForm.numberOfTrips && editForm.numberOfTrips > 1) {
        numTrips = editForm.numberOfTrips;
        console.log('📊 Number of trips from editForm.numberOfTrips:', numTrips);
    } 
    // Priority 3: Use editNumberOfTrips
    else if (editNumberOfTrips && editNumberOfTrips > 1) {
        numTrips = editNumberOfTrips;
        console.log('📊 Number of trips from editNumberOfTrips:', numTrips);
    } 
    // Priority 4: Use timeSlots.length
    else if (timeSlots && timeSlots.length > 0) {
        numTrips = timeSlots.length;
        console.log('📊 Number of trips from timeSlots:', numTrips);
    } 
    // Priority 5: Use numberOfTrips
    else if (numberOfTrips && numberOfTrips > 1) {
        numTrips = numberOfTrips;
        console.log('📊 Number of trips from numberOfTrips:', numTrips);
    }
    
    console.log('📊 Final number of trips:', numTrips);
    
    // Get timings from the stop
    let stopTimings = stop.timings || [];
    
    // CRITICAL FIX: If stop has timings but they don't match numTrips, use stop.timings length
    if (stopTimings.length > 0) {
        // Use the actual timings from the stop
        numTrips = stopTimings.length;
        console.log('📊 Using stop.timings length as numTrips:', numTrips);
    }
    
    // Create a map of existing timings by timeSlotSequence
    const existingTimingsMap = new Map();
    stopTimings.forEach(t => {
        const seq = t.timeSlotSequence || 1;
        existingTimingsMap.set(seq, t);
    });
    
    // Create timings for ALL trips (including empty ones)
    const allTimings = [];
    for (let i = 1; i <= numTrips; i++) {
        if (existingTimingsMap.has(i)) {
            // Use existing timing
            allTimings.push({
                timeSlotSequence: i,
                arrivalTime: existingTimingsMap.get(i).arrivalTime || '',
                departureTime: existingTimingsMap.get(i).departureTime || ''
            });
        } else {
            // Create empty timing for this trip
            allTimings.push({
                timeSlotSequence: i,
                arrivalTime: '',
                departureTime: ''
            });
        }
    }
    
    // Sort by timeSlotSequence to maintain order
    allTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
    
    console.log('✅ Final timings for edit form (ALL TRIPS):', allTimings);
    console.log('✅ Number of trips in edit form:', allTimings.length);
    
    // ========== FIX: Determine boarding/dropping from stopType ==========
    let isBoarding = false;
    let isDropping = false;
    
    if (stop.stopType === 'boarding' || stop.stopType === 'both') {
        isBoarding = true;
    }
    if (stop.stopType === 'dropping' || stop.stopType === 'both') {
        isDropping = true;
    }
    
    // Also check if the stop has isBoarding/isDropping flags directly
    if (stop.isBoarding !== undefined) {
        isBoarding = stop.isBoarding || isBoarding;
    }
    if (stop.isDropping !== undefined) {
        isDropping = stop.isDropping || isDropping;
    }
    
    console.log('📋 Boarding:', isBoarding, 'Dropping:', isDropping);
    
    setStopBeingEdited({
        index,
        originalStop: stop,
        type
    });
    
    setStopEditForm({
        city: stop.city || '',
        state: stop.state || '',
        address: stop.address || '',
        terminal: stop.terminal || '',
        arrivalTime: stop.arrivalTime || '',
        departureTime: stop.departureTime || '',
        isBoarding: isBoarding, // FIXED: Properly set from stopType
        isDropping: isDropping, // FIXED: Properly set from stopType
        isManualStop: stop.isManualStop || false,
        manualDistFromPrev: stop.manualDistFromPrev || '',
        manualDistToNext: stop.manualDistToNext || '',
        timings: allTimings, // ALL timings preserved
        coordinates: stop.coordinates || null,
        isMultiTrip: editForm.isMultiTrip || editIsMultiTrip || true,
        tripCount: allTimings.length || numTrips
    });
    
    setShowStopEditModal(true);
};

const saveEditedStop = () => {
    console.log("stopEditForm ::::::::::: s ", stopEditForm);
    
    // ========== VALIDATE REQUIRED FIELDS ==========
    // City is required
    if (!stopEditForm.city || stopEditForm.city.trim() === '') {
        toast.error('City is required');
        return;
    }

    // State is required
    if (!stopEditForm.state || stopEditForm.state.trim() === '') {
        toast.error('State is required');
        return;
    }

    // Address is required
    if (!stopEditForm.address || stopEditForm.address.trim() === '') {
        toast.error('Address is required');
        return;
    }

    // Terminal is required
    if (!stopEditForm.terminal || stopEditForm.terminal.trim() === '') {
        toast.error('Terminal is required');
        return;
    }

        const totalTrips = editForm.numberOfTrips || editNumberOfTrips || numberOfTrips || 1;

        // Check if there are timings with arrival times
        const hasTimings = stopEditForm.timings && stopEditForm.timings.length > 0;
        const hasArrivalInTimings = hasTimings && stopEditForm.timings.some(t => t.arrivalTime && t.arrivalTime.trim() !== '');
        const hasTopLevelArrival = stopEditForm.arrivalTime && stopEditForm.arrivalTime.trim() !== '';

        // Determine if multi-trip mode
        const isMultiTripStop = stopEditForm.isMultiTrip ||
            (stopEditForm.timings && stopEditForm.timings.length > 0) ||
            (editForm.isMultiTrip || editIsMultiTrip || isMultiTrip) ||
            totalTrips > 1 ||
            hasArrivalInTimings ||
            hasTopLevelArrival;

        // ========== PREPARE TIMINGS ==========
        let finalTimings = [];

        // Check if we're in multi-trip mode (more than 1 trip or explicit multi-trip flag)
        const isActuallyMultiTrip = (editForm.isMultiTrip || editIsMultiTrip || isMultiTrip) || totalTrips > 1;

        if (isActuallyMultiTrip) {
            // MULTI-TRIP MODE - use timings array
            if (hasTimings) {
                // Check if any timing has arrival time
                const hasAnyArrivalInTimings = stopEditForm.timings.some(t => t.arrivalTime && t.arrivalTime.trim() !== '');

                if (hasAnyArrivalInTimings) {
                    // Use existing timings from the form
                    finalTimings = stopEditForm.timings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence || 1,
                        arrivalTime: t.arrivalTime || '',
                        departureTime: t.departureTime || t.arrivalTime || ''
                    }));
                } else if (hasTopLevelArrival) {
                    // If timings exist but are empty, but top level has arrival, use top level value for all trips
                    finalTimings = stopEditForm.timings.map((t, index) => ({
                        timeSlotSequence: t.timeSlotSequence || (index + 1),
                        arrivalTime: stopEditForm.arrivalTime || '',
                        departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || ''
                    }));
                } else {
                    // Create timings for all trips
                    for (let i = 1; i <= totalTrips; i++) {
                        finalTimings.push({
                            timeSlotSequence: i,
                            arrivalTime: stopEditForm.arrivalTime || '',
                            departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || ''
                        });
                    }
                }
            } else {
                // Create timings for all trips from top-level values
                for (let i = 1; i <= totalTrips; i++) {
                    finalTimings.push({
                        timeSlotSequence: i,
                        arrivalTime: stopEditForm.arrivalTime || '',
                        departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime || ''
                    });
                }
            }

            // Check if all trips have arrival times
            const missingArrival = finalTimings.some(t => !t.arrivalTime || t.arrivalTime.trim() === '');
            if (missingArrival) {
                toast.error('Please provide arrival time for all trips');
                return;
            }
        } else {
            // SINGLE TRIP MODE - validate arrival time
            if (!stopEditForm.arrivalTime || stopEditForm.arrivalTime.trim() === '') {
                toast.error('Arrival time is required');
                return;
            }

            // Create a single timing entry with the updated time
            finalTimings = [{
                timeSlotSequence: 1,
                arrivalTime: stopEditForm.arrivalTime,
                departureTime: stopEditForm.departureTime || stopEditForm.arrivalTime
            }];
        }

        // Sort timings by sequence
        finalTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));

        // ========== PREPARE DISTANCE VALUES ==========
        const isManualLocation = stopEditForm.isManualStop;

        let manualDistFromPrev = null;
        let manualDistToNext = null;

        if (stopEditForm.manualDistFromPrev && parseFloat(stopEditForm.manualDistFromPrev) > 0) {
            manualDistFromPrev = parseFloat(stopEditForm.manualDistFromPrev);
        }

        if (stopEditForm.manualDistToNext && parseFloat(stopEditForm.manualDistToNext) > 0) {
            manualDistToNext = parseFloat(stopEditForm.manualDistToNext);
        }

        let distanceFromOrigin = stopBeingEdited.originalStop.distanceFromOrigin || 0;

        if (manualDistFromPrev && manualDistFromPrev > 0) {
            const stops = stopBeingEdited.type === 'up' ? upStops : downStops;
            if (stopBeingEdited.index === 0) {
                distanceFromOrigin = manualDistFromPrev;
            } else {
                const prevStop = stops[stopBeingEdited.index - 1];
                const prevDistance = prevStop?.distanceFromOrigin || 0;
                distanceFromOrigin = parseFloat((prevDistance + manualDistFromPrev).toFixed(2));
            }
        }

        // ========== DETERMINE STOP TYPE ==========
        let stopType = 'none';
        if (stopEditForm.isBoarding && stopEditForm.isDropping) stopType = 'both';
        else if (stopEditForm.isBoarding) stopType = 'boarding';
        else if (stopEditForm.isDropping) stopType = 'dropping';

        // ========== BUILD UPDATED STOP OBJECT ==========
        const updatedStop = {
            ...stopBeingEdited.originalStop,
            city: stopEditForm.city,
            state: stopEditForm.state || '',
            address: stopEditForm.address || `${stopEditForm.city}, ${stopEditForm.state || 'India'}`,
            terminal: stopEditForm.terminal || `${stopEditForm.city} Bus Stand`,
            stopType,
            coordinates: isManualLocation ? { lat: 0, lng: 0 } : stopBeingEdited.originalStop.coordinates,
            manualDistFromPrev: manualDistFromPrev,
            manualDistToNext: manualDistToNext,
            distanceFromOrigin: distanceFromOrigin,
            isManualStop: isManualLocation,
            // ALWAYS set timings array - even for single trip mode
            timings: finalTimings,
            // For display purposes, set arrival/departure from the first timing
            arrivalTime: finalTimings.length > 0 ? finalTimings[0].arrivalTime || '' : '',
            departureTime: finalTimings.length > 0 ? finalTimings[0].departureTime || finalTimings[0].arrivalTime || '' : ''
        };

        // ========== APPLY UPDATE ==========
        const { index, type } = stopBeingEdited;
        setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

        if (type === 'up') {
            const updated = [...upStops];
            updated[index] = { ...updatedStop, sequence: index + 1 };
            setUpStops(updated);
            if (isRoundTrip) {
                toast.info('UP route updated. Use "Auto-Fill / Sync Reversed Stops" to update DOWN route if needed.');
            }
        } else {
            const updated = [...downStops];
            updated[index] = { ...updatedStop, sequence: index + 1 };
            setDownStops(updated);
        }

        setShowStopEditModal(false);
        setStopBeingEdited(null);
        toast.success('Stop updated successfully');
    };

    const handleDeleteStop = (index) => {
        const isUp = activeRouteTab === 'UP';
        setIsDistanceCalculated(prev => ({ ...prev, [isUp ? 'up' : 'down']: false }));

        if (isUp) {
            const updated = upStops.filter((_, i) => i !== index);
            setUpStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
            if (editingStopIndex === index && editUpIndex === index) clearStopForm();
        } else {
            const updated = downStops.filter((_, i) => i !== index);
            setDownStops(updated.map((s, i) => ({ ...s, sequence: i + 1 })));
            if (editingStopIndex === index && editDownIndex === index) clearStopForm();
        }
    };

    const checkOriginManual = () => {
        return isOriginManual || !newRoute.upOriginCoords || (newRoute.upOriginCoords.lat === 0 && newRoute.upOriginCoords.lng === 0);
    };

    const checkDestinationManual = () => {
        return isDestinationManual || !newRoute.upDestCoords || (newRoute.upDestCoords.lat === 0 && newRoute.upDestCoords.lng === 0);
    };

    const handleCalculateDistances = async () => {
        const isUp = activeRouteTab === 'UP';
        const stops = isUp ? upStops : downStops;

        if (!newRoute.upOriginCity || !newRoute.upDestCity) {
            toast.error("Main Route Origin and Destination required.");
            return;
        }

        if (!newRoute.upOriginCoords) {
            toast.error('Please select Origin from suggestions to get coordinates');
            return;
        }

        if (!newRoute.upDestCoords) {
            toast.error('Please select Destination from suggestions to get coordinates');
            return;
        }

        let originNode, destNode;
        if (isUp) {
            originNode = {
                id: 'origin',
                name: newRoute.upOriginCity,
                lat: newRoute.upOriginCoords?.lat || 0,
                lng: newRoute.upOriginCoords?.lng || 0
            };
            destNode = {
                id: 'destination',
                name: newRoute.upDestCity,
                lat: newRoute.upDestCoords?.lat || 0,
                lng: newRoute.upDestCoords?.lng || 0
            };
        } else {
            originNode = {
                id: 'origin',
                name: newRoute.upDestCity,
                lat: newRoute.upDestCoords?.lat || 0,
                lng: newRoute.upDestCoords?.lng || 0
            };
            destNode = {
                id: 'destination',
                name: newRoute.upOriginCity,
                lat: newRoute.upOriginCoords?.lat || 0,
                lng: newRoute.upOriginCoords?.lng || 0
            };
        }

        setIsCalculatingDistances(true);
        toast.info(`Calculating ${activeRouteTab} route distances...`);

        let departureTimeForDuration = '';
        let arrivalTimeForDuration = '';

        if (isUp) {
            if (isMultiTrip) {
                if (timeSlots && timeSlots.length > 0) {
                    departureTimeForDuration = timeSlots[0]?.departureTime || '';
                }
                if (destinationTimeSlots && destinationTimeSlots.length > 0) {
                    arrivalTimeForDuration = destinationTimeSlots[0]?.arrivalTime || '';
                }
            } else {
                departureTimeForDuration = newRoute.upOriginDepTime;
                arrivalTimeForDuration = newRoute.upDestArrTime;
            }
        } else {
            if (isMultiTrip) {
                if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) {
                    departureTimeForDuration = returnOriginTimeSlots[0]?.departureTime || '';
                }
                if (returnDestTimeSlots && returnDestTimeSlots.length > 0) {
                    arrivalTimeForDuration = returnDestTimeSlots[0]?.arrivalTime || '';
                }
            } else {
                departureTimeForDuration = newRoute.downOriginDepTime;
                arrivalTimeForDuration = newRoute.downDestArrTime;
            }
        }

        try {
            const stopNodes = stops.map((s, i) => ({
                id: `stop_${i}`,
                name: s.city,
                lat: s.coordinates?.lat,
                lng: s.coordinates?.lng,
                manualFromPrev: s.manualDistFromPrev,
                manualToNext: s.manualDistToNext,
                isManual: s.isManualStop === true || !s.coordinates || (s.coordinates.lat === 0 && s.coordinates.lng === 0),
                originalStop: s
            }));

            const fullPath = [originNode, ...stopNodes, destNode];
            const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);

            let matrixResponse = null;
            if (validNodes.length >= 2) {
                matrixResponse = await getDistanceMatrix(validNodes, validNodes);
            }

            let cumulativeDist = 0;
            let lastAutoNodeIndex = -1;
            let sumManualSinceLastAuto = 0;
            const updatedStops = [];
            let validNodeCounter = -1;
            let prevCumulativeDist = 0;
            let firstStopAlreadyCounted = false;

            if (stops.length > 0 && stops[0]) {
                const isFirstStopManual = stopNodes[0].isManual;

                if (isFirstStopManual && stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
                    const firstLeg = parseFloat(stopNodes[0].manualFromPrev);
                    cumulativeDist = firstLeg;
                    sumManualSinceLastAuto = firstLeg;
                    prevCumulativeDist = cumulativeDist;
                    firstStopAlreadyCounted = true;
                } else if ((checkOriginManual() && !isFirstStopManual) || (!checkOriginManual() && isFirstStopManual)) {
                    const firstLeg = parseFloat(isUp ? newRoute.upManualFirstLeg : newRoute.downManualFirstLeg);
                    if (!firstLeg || parseFloat(firstLeg) <= 0) {
                        toast.error('Please provide distance from origin to first stop.');
                        setIsCalculatingDistances(false);
                        return;
                    }
                    cumulativeDist = parseFloat(firstLeg);
                    sumManualSinceLastAuto = cumulativeDist;
                    prevCumulativeDist = cumulativeDist;
                    firstStopAlreadyCounted = true;
                } else if (!checkOriginManual() && !isFirstStopManual) {
                    lastAutoNodeIndex = 0;
                    validNodeCounter = 0;
                } else if (checkOriginManual() && isFirstStopManual) {
                    if (stopNodes[0].manualFromPrev && parseFloat(stopNodes[0].manualFromPrev) > 0) {
                        cumulativeDist = parseFloat(stopNodes[0].manualFromPrev);
                        prevCumulativeDist = cumulativeDist;
                        firstStopAlreadyCounted = true;
                    } else {
                        cumulativeDist = 0;
                        prevCumulativeDist = 0;
                    }
                }
            }

            for (let i = 0; i < stopNodes.length; i++) {
                const currNode = stopNodes[i];
                const isManual = currNode.isManual;
                let segment = 0;

                if (isManual) {
                    if (currNode.manualFromPrev === null || currNode.manualFromPrev === undefined || currNode.manualFromPrev === '') {
                        toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
                        setIsCalculatingDistances(false);
                        return;
                    }

                    segment = parseFloat(currNode.manualFromPrev) || 0;

                    if (i === 0 && firstStopAlreadyCounted) {
                        // Already counted
                    } else {
                        if (segment <= 0 && i > 0) {
                            toast.warning(`Manual stop '${currNode.name}' has distance 0 from previous stop.`);
                        }
                        cumulativeDist += segment;
                        sumManualSinceLastAuto += segment;
                    }

                    prevCumulativeDist = i === 0 && firstStopAlreadyCounted ? segment : cumulativeDist;

                    updatedStops.push({
                        ...stops[i],
                        distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
                        manualDistFromPrev: parseFloat(segment.toFixed(1)),
                        manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
                    });

                    if (currNode.manualToNext && parseFloat(currNode.manualToNext) > 0) {
                        sumManualSinceLastAuto = parseFloat(currNode.manualToNext);
                    }

                } else {
                    validNodeCounter++;
                    let apiDistance = 0;

                    let matrixOriginIndex = lastAutoNodeIndex;
                    let matrixDestIndex = validNodeCounter;

                    if (checkOriginManual() && lastAutoNodeIndex === -1 && i === 0) {
                        matrixOriginIndex = 0;
                        matrixDestIndex = validNodeCounter;
                    } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
                        matrixOriginIndex = lastAutoNodeIndex;
                        matrixDestIndex = validNodeCounter;
                    } else if (!checkOriginManual() && lastAutoNodeIndex === -1) {
                        matrixOriginIndex = 0;
                        matrixDestIndex = validNodeCounter;
                    }

                    if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
                        const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
                        if (element?.status === 'OK') {
                            apiDistance = element.distance.value / 1000;
                        }
                    }

                    if (i > 0 && stopNodes[i - 1]?.manualToNext && parseFloat(stopNodes[i - 1].manualToNext) > 0) {
                        segment = parseFloat(stopNodes[i - 1].manualToNext);
                        sumManualSinceLastAuto = 0;
                    } else {
                        segment = apiDistance - sumManualSinceLastAuto;
                        if (segment < 0) segment = 0;
                        sumManualSinceLastAuto = 0;
                    }

                    cumulativeDist += segment;

                    if (lastAutoNodeIndex === -1) {
                        lastAutoNodeIndex = validNodeCounter;
                    }
                    if (matrixOriginIndex >= 0) {
                        lastAutoNodeIndex = validNodeCounter;
                    }

                    const distanceFromPrev = cumulativeDist - prevCumulativeDist;
                    prevCumulativeDist = cumulativeDist;

                    updatedStops.push({
                        ...stops[i],
                        distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
                        manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)),
                        manualDistToNext: currNode.manualToNext ? parseFloat(currNode.manualToNext) : null
                    });
                }
            }

            validNodeCounter++;
            let finalSegment = 0;
            const lastStop = stopNodes[stopNodes.length - 1];
            const isLastStopManualFlag = lastStop && lastStop.isManual;
            const isDestManual = checkDestinationManual();

            if (isDestManual) {
                const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
                if (isNaN(finalLeg) || finalLeg <= 0) {
                    toast.error(`Destination is manual. Please provide distance from last stop to destination in the Summary section.`);
                    setIsCalculatingDistances(false);
                    return;
                }
                finalSegment = finalLeg;
            } else if (!isDestManual && isLastStopManualFlag) {
                if (lastStop.manualToNext && parseFloat(lastStop.manualToNext) > 0) {
                    finalSegment = parseFloat(lastStop.manualToNext);
                } else {
                    const finalLeg = parseFloat(isUp ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg);
                    if (!isNaN(finalLeg) && finalLeg > 0) {
                        finalSegment = finalLeg;
                    } else {
                        const totalDist = parseFloat(isUp ? newRoute.upTotalDistance : newRoute.downTotalDistance) || 0;
                        const lastStopDist = updatedStops.length > 0
                            ? (updatedStops[updatedStops.length - 1].distanceFromOrigin || 0)
                            : 0;
                        const derived = parseFloat((totalDist - lastStopDist).toFixed(1));
                        if (derived > 0) {
                            finalSegment = derived;
                        } else {
                            toast.error(`Last stop is manual and destination has GPS. Please enter the distance to destination in the Summary section, or set "Distance to Next Stop" on the last stop.`);
                            setIsCalculatingDistances(false);
                            return;
                        }
                    }
                }
            } else if (!isDestManual && !isLastStopManualFlag && stopNodes.length > 0) {
                let apiDistance = 0;
                let matrixOriginIndex = lastAutoNodeIndex;
                let matrixDestIndex = validNodeCounter;

                if (checkOriginManual() && lastAutoNodeIndex === -1) {
                    matrixOriginIndex = 0;
                    matrixDestIndex = validNodeCounter;
                } else if (checkOriginManual() && lastAutoNodeIndex !== -1) {
                    matrixOriginIndex = lastAutoNodeIndex;
                    matrixDestIndex = validNodeCounter;
                }

                if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
                    const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
                    if (element?.status === 'OK') {
                        apiDistance = element.distance.value / 1000;
                    }
                }
                finalSegment = apiDistance - sumManualSinceLastAuto;
                if (finalSegment < 0) finalSegment = 0;
            } else if (stopNodes.length === 0) {
                if (checkOriginManual() && isDestManual) {
                    const totalDistance = parseFloat(newRoute.upTotalDistance);
                    if (isNaN(totalDistance) || totalDistance <= 0) {
                        toast.error('Both origin and destination are manual. Please provide total distance.');
                        setIsCalculatingDistances(false);
                        return;
                    }
                    finalSegment = totalDistance;
                } else if (!checkOriginManual() && !isDestManual && matrixResponse) {
                    const element = matrixResponse.rows[0]?.elements[1];
                    if (element?.status === 'OK') {
                        finalSegment = element.distance.value / 1000;
                    } else {
                        toast.error('Could not calculate distance. Please check addresses or enter manually.');
                        setIsCalculatingDistances(false);
                        return;
                    }
                } else {
                    toast.error('Cannot calculate distance. Please ensure both origin and destination have coordinates or provide manual total distance.');
                    setIsCalculatingDistances(false);
                    return;
                }
            }

            cumulativeDist += finalSegment;

            if (updatedStops.length > 0 && finalSegment > 0) {
                const lastIndex = updatedStops.length - 1;
                updatedStops[lastIndex] = {
                    ...updatedStops[lastIndex],
                    manualDistToNext: parseFloat(finalSegment.toFixed(1))
                };
            }

            setActiveStops(updatedStops);

            let calculatedHours = 0;
            let calculatedMinutes = 0;

            if (departureTimeForDuration && departureTimeForDuration.trim() !== '' &&
                arrivalTimeForDuration && arrivalTimeForDuration.trim() !== '') {

                const [depHour, depMin] = departureTimeForDuration.split(':').map(Number);
                const [arrHour, arrMin] = arrivalTimeForDuration.split(':').map(Number);

                let depTotalMins = depHour * 60 + depMin;
                let arrTotalMins = arrHour * 60 + arrMin;

                if (arrTotalMins < depTotalMins) {
                    arrTotalMins += 24 * 60;
                }

                const durationMins = arrTotalMins - depTotalMins;
                calculatedHours = Math.floor(durationMins / 60);
                calculatedMinutes = durationMins % 60;
            } else {
                const avgSpeed = 40;
                const durationMins = Math.round((cumulativeDist / avgSpeed) * 60);
                calculatedHours = Math.floor(durationMins / 60);
                calculatedMinutes = durationMins % 60;
            }

            if (isUp) {
                setNewRoute(prev => ({
                    ...prev,
                    upTotalDistance: cumulativeDist.toFixed(1),
                    upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.upManualFinalLeg,
                    upDurationHours: calculatedHours.toString(),
                    upDurationMinutes: calculatedMinutes.toString()
                }));

                if (editingRoute) {
                    setEditForm(prev => ({
                        ...prev,
                        totalDistance: cumulativeDist.toFixed(1),
                        durationHours: calculatedHours.toString(),
                        durationMinutes: calculatedMinutes.toString()
                    }));
                }
            } else {
                setNewRoute(prev => ({
                    ...prev,
                    downTotalDistance: cumulativeDist.toFixed(1),
                    downManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.downManualFinalLeg,
                    downDurationHours: calculatedHours.toString(),
                    downDurationMinutes: calculatedMinutes.toString()
                }));

                if (editingRoute) {
                    setEditForm(prev => ({
                        ...prev,
                        returnTotalDistance: cumulativeDist.toFixed(1),
                        returnDurationHours: calculatedHours.toString(),
                        returnDurationMinutes: calculatedMinutes.toString()
                    }));
                }
            }

            setIsDistanceCalculated(prev => ({ ...prev, [activeRouteTab.toLowerCase()]: true }));

            toast.success(`${activeRouteTab} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km, Duration: ${calculatedHours}h ${calculatedMinutes}m`);

        } catch (error) {
            console.error('Distance calculation error:', error);
            toast.error("Calculation failed. Please enter distances manually.");
        } finally {
            setIsCalculatingDistances(false);
        }
    };

    const handleEditCalculateDistances = async (type = 'up') => {
        const isUp = type === 'up';
        const stops = isUp ? upStops : downStops;

        if (isUp) {
            if (!editForm.originCity || !editForm.destCity) {
                toast.error("Origin and Destination required for UP route.");
                return;
            }
            if (!editForm.originCoords) {
                toast.error('Please select Origin from suggestions');
                return;
            }
            if (!editForm.destCoords) {
                toast.error('Please select Destination from suggestions');
                return;
            }
        } else {
            if (!editForm.returnOriginCity || !editForm.returnDestCity) {
                toast.error("Return Origin and Destination required for DOWN route.");
                return;
            }
            if (!editForm.returnOriginCoords) {
                toast.error('Please select Return Origin from suggestions');
                return;
            }
            if (!editForm.returnDestCoords) {
                toast.error('Please select Return Destination from suggestions');
                return;
            }
        }

        let originNode, destNode;
        if (isUp) {
            originNode = {
                id: 'origin',
                name: editForm.originCity,
                lat: editForm.originCoords?.lat || 0,
                lng: editForm.originCoords?.lng || 0,
                isManual: !editForm.originCoords?.lat || editForm.originCoords.lat === 0
            };
            destNode = {
                id: 'destination',
                name: editForm.destCity,
                lat: editForm.destCoords?.lat || 0,
                lng: editForm.destCoords?.lng || 0,
                isManual: !editForm.destCoords?.lat || editForm.destCoords.lat === 0
            };
        } else {
            originNode = {
                id: 'origin',
                name: editForm.returnOriginCity,
                lat: editForm.returnOriginCoords?.lat || 0,
                lng: editForm.returnOriginCoords?.lng || 0,
                isManual: !editForm.returnOriginCoords?.lat || editForm.returnOriginCoords.lat === 0
            };
            destNode = {
                id: 'destination',
                name: editForm.returnDestCity,
                lat: editForm.returnDestCoords?.lat || 0,
                lng: editForm.returnDestCoords?.lng || 0,
                isManual: !editForm.returnDestCoords?.lat || editForm.returnDestCoords.lat === 0
            };
        }

        setIsCalculatingDistances(true);
        toast.info(`Calculating ${type === 'up' ? 'UP' : 'DOWN'} route distances...`);

        try {
            const enrichedStops = [...stops];

            for (let i = 0; i < enrichedStops.length; i++) {
                const stop = enrichedStops[i];
                const isManual = stop.isManualStop === true || !stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0);

                if (isManual && (!stop.manualDistFromPrev || stop.manualDistFromPrev === 0) && stop.distanceFromOrigin > 0) {
                    const prevStop = i > 0 ? enrichedStops[i - 1] : null;
                    const prevDistance = prevStop?.distanceFromOrigin || 0;
                    const calculatedDist = stop.distanceFromOrigin - prevDistance;

                    if (calculatedDist > 0) {
                        enrichedStops[i] = {
                            ...stop,
                            manualDistFromPrev: parseFloat(calculatedDist.toFixed(1))
                        };
                    }
                }
            }

            const stopNodes = enrichedStops.map((s, i) => {
                const hasValidCoords = s.coordinates?.lat && s.coordinates.lat !== 0;
                const hasManualDist = s.manualDistFromPrev && s.manualDistFromPrev > 0;
                const hasDistanceFromOrigin = s.distanceFromOrigin && s.distanceFromOrigin > 0;

                const isManual = s.isManualStop === true || !hasValidCoords || hasManualDist;

                return {
                    id: `stop_${i}`,
                    name: s.city,
                    lat: s.coordinates?.lat,
                    lng: s.coordinates?.lng,
                    manualFromPrev: s.manualDistFromPrev ? parseFloat(s.manualDistFromPrev) : null,
                    manualToNext: s.manualDistToNext ? parseFloat(s.manualDistToNext) : null,
                    existingDistance: s.distanceFromOrigin || 0,
                    isManual: isManual,
                    originalStop: s
                };
            });

            const fullPath = [originNode, ...stopNodes, destNode];
            const validNodes = fullPath.filter(s => s.lat && s.lng && s.lat !== 0 && s.lng !== 0 && !s.isManual);

            let matrixResponse = null;
            if (validNodes.length >= 2) {
                matrixResponse = await getDistanceMatrix(fullPath, fullPath);
            }

            let cumulativeDist = 0;
            let prevCumulativeDist = 0;
            const updatedStops = [];
            let lastAutoNodeIndex = 0;
            let sumManualSinceLastAuto = 0;
            let validNodeCounter = -1;

            if (stops.length > 0) {
                const firstStop = stopNodes[0];
                const hasFirstStopDistance = firstStop && (firstStop.existingDistance > 0 || (firstStop.manualFromPrev && firstStop.manualFromPrev > 0));

                if (hasFirstStopDistance) {
                    cumulativeDist = firstStop.existingDistance > 0 ? firstStop.existingDistance : firstStop.manualFromPrev;
                    sumManualSinceLastAuto = cumulativeDist;
                    prevCumulativeDist = cumulativeDist;
                } else if (originNode.isManual) {
                    const firstLeg = isUp ? editForm.upManualFirstLeg : editForm.returnManualFirstLeg;
                    if (!firstLeg || parseFloat(firstLeg) <= 0) {
                        toast.error('Please provide distance from origin to first stop in the Summary section.');
                        setIsCalculatingDistances(false);
                        return;
                    }
                    cumulativeDist = parseFloat(firstLeg);
                    sumManualSinceLastAuto = cumulativeDist;
                    prevCumulativeDist = cumulativeDist;
                } else {
                    lastAutoNodeIndex = 0;
                    validNodeCounter = 0;
                }
            }

            for (let i = 0; i < stopNodes.length; i++) {
                const currNode = stopNodes[i];
                const isManual = currNode.isManual;
                let segment = 0;

                if (i === 0 && cumulativeDist > 0 && (currNode.existingDistance > 0 || currNode.manualFromPrev > 0)) {
                    updatedStops.push({
                        ...enrichedStops[i],
                        distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
                        manualDistFromPrev: currNode.manualFromPrev || cumulativeDist,
                        manualDistToNext: currNode.manualToNext || null
                    });
                    continue;
                }

                if (isManual) {
                    let manualDist = currNode.manualFromPrev;

                    if ((!manualDist || manualDist === 0) && currNode.existingDistance > 0) {
                        const prevDistance = i > 0 ? updatedStops[i - 1]?.distanceFromOrigin || 0 : cumulativeDist;
                        manualDist = currNode.existingDistance - prevDistance;
                        if (manualDist > 0) {
                            // use calculated value
                        }
                    }

                    if (!manualDist || manualDist === 0) {
                        toast.error(`Manual stop '${currNode.name}' is missing distance from previous stop. Please edit and provide the distance.`);
                        setIsCalculatingDistances(false);
                        return;
                    }

                    segment = manualDist;
                    cumulativeDist += segment;
                    sumManualSinceLastAuto += segment;

                    const distanceFromPrev = cumulativeDist - prevCumulativeDist;
                    prevCumulativeDist = cumulativeDist;

                    updatedStops.push({
                        ...enrichedStops[i],
                        distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
                        manualDistFromPrev: segment,
                        manualDistToNext: currNode.manualToNext || null
                    });
                } else {
                    validNodeCounter++;
                    let apiDistance = 0;

                    let matrixOriginIndex = lastAutoNodeIndex;
                    let matrixDestIndex = validNodeCounter;

                    if (matrixResponse && matrixOriginIndex >= 0 && matrixDestIndex >= 0) {
                        const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
                        if (element?.status === 'OK') {
                            apiDistance = element.distance.value / 1000;
                        }
                    }

                    if (i > 0 && stopNodes[i - 1].manualToNext && stopNodes[i - 1].manualToNext > 0) {
                        segment = stopNodes[i - 1].manualToNext;
                        sumManualSinceLastAuto = 0;
                    } else {
                        segment = apiDistance - sumManualSinceLastAuto;
                        if (segment < 0) segment = 0;
                        sumManualSinceLastAuto = 0;
                    }

                    cumulativeDist += segment;

                    if (lastAutoNodeIndex === -1 || matrixOriginIndex >= 0) {
                        lastAutoNodeIndex = validNodeCounter;
                    }

                    const distanceFromPrev = cumulativeDist - prevCumulativeDist;
                    prevCumulativeDist = cumulativeDist;

                    updatedStops.push({
                        ...enrichedStops[i],
                        distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
                        manualDistFromPrev: parseFloat(distanceFromPrev.toFixed(1)),
                        manualDistToNext: currNode.manualToNext || null
                    });
                }
            }

            let finalSegment = 0;
            const lastStop = stopNodes[stopNodes.length - 1];
            const isLastStopManual = lastStop && lastStop.isManual;
            const hasLastStopDistanceToDest = lastStop && lastStop.manualToNext && lastStop.manualToNext > 0;

            const totalDistance = isUp ? parseFloat(editForm.totalDistance) : parseFloat(editForm.returnTotalDistance);
            const lastStopDistance = updatedStops.length > 0 ? updatedStops[updatedStops.length - 1].distanceFromOrigin : 0;

            if (totalDistance > 0 && lastStopDistance > 0 && !hasLastStopDistanceToDest) {
                const calculatedFinalSegment = totalDistance - lastStopDistance;
                if (calculatedFinalSegment > 0) {
                    finalSegment = parseFloat(calculatedFinalSegment.toFixed(1));
                    if (isUp) {
                        setEditForm(prev => ({ ...prev, upManualFinalLeg: finalSegment.toString() }));
                    } else {
                        setEditForm(prev => ({ ...prev, returnManualFinalLeg: finalSegment.toString() }));
                    }
                }
            }

            if (finalSegment === 0) {
                if (hasLastStopDistanceToDest) {
                    finalSegment = lastStop.manualToNext;
                } else if (destNode.isManual) {
                    const finalLeg = isUp ? editForm.upManualFinalLeg : editForm.returnManualFinalLeg;
                    if (!finalLeg || parseFloat(finalLeg) <= 0) {
                        if (totalDistance > 0 && lastStopDistance > 0) {
                            finalSegment = totalDistance - lastStopDistance;
                            if (finalSegment > 0) {
                                if (isUp) {
                                    setEditForm(prev => ({ ...prev, upManualFinalLeg: finalSegment.toString() }));
                                } else {
                                    setEditForm(prev => ({ ...prev, returnManualFinalLeg: finalSegment.toString() }));
                                }
                            } else {
                                toast.error('Destination is manual. Please provide distance from last stop to destination in Summary section.');
                                setIsCalculatingDistances(false);
                                return;
                            }
                        } else {
                            toast.error('Destination is manual. Please provide distance from last stop to destination in Summary section.');
                            setIsCalculatingDistances(false);
                            return;
                        }
                    } else {
                        finalSegment = parseFloat(finalLeg);
                    }
                } else if (!destNode.isManual && isLastStopManual) {
                    const finalLeg = isUp ? editForm.destManualDistFromLastStop : editForm.returnDestManualDistFromLastStop;
                    if (!finalLeg || parseFloat(finalLeg) <= 0) {
                        if (totalDistance > 0 && lastStopDistance > 0) {
                            finalSegment = totalDistance - lastStopDistance;
                            if (finalSegment > 0) {
                                // use calculated value
                            } else {
                                toast.error('Last stop is manual. Please provide distance to destination in Summary section.');
                                setIsCalculatingDistances(false);
                                return;
                            }
                        } else {
                            toast.error('Last stop is manual. Please provide distance to destination in Summary section.');
                            setIsCalculatingDistances(false);
                            return;
                        }
                    } else {
                        finalSegment = parseFloat(finalLeg);
                    }
                } else if (!destNode.isManual && !isLastStopManual && matrixResponse) {
                    validNodeCounter++;
                    let matrixOriginIndex = lastAutoNodeIndex;
                    let matrixDestIndex = validNodeCounter;

                    const element = matrixResponse.rows[matrixOriginIndex]?.elements[matrixDestIndex];
                    if (element?.status === 'OK') {
                        finalSegment = element.distance.value / 1000 - sumManualSinceLastAuto;
                        if (finalSegment < 0) finalSegment = 0;
                    }
                } else if (stopNodes.length === 0) {
                    if (originNode.isManual && destNode.isManual) {
                        const totalDist = isUp ? editForm.totalDistance : editForm.returnTotalDistance;
                        if (!totalDist || parseFloat(totalDist) <= 0) {
                            toast.error('Both origin and destination are manual. Please provide total distance.');
                            setIsCalculatingDistances(false);
                            return;
                        }
                        finalSegment = parseFloat(totalDist);
                    } else if (matrixResponse) {
                        const element = matrixResponse.rows[0]?.elements[1];
                        if (element?.status === 'OK') {
                            finalSegment = element.distance.value / 1000;
                        }
                    }
                }
            }

            cumulativeDist += finalSegment;

            if (updatedStops.length > 0 && finalSegment > 0) {
                const lastIndex = updatedStops.length - 1;
                updatedStops[lastIndex] = {
                    ...updatedStops[lastIndex],
                    manualDistToNext: parseFloat(finalSegment.toFixed(1))
                };
            }

            if (type === 'up') {
                setUpStops(updatedStops);
                setEditForm(prev => ({
                    ...prev,
                    totalDistance: cumulativeDist.toFixed(1),
                    upManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.upManualFinalLeg
                }));
            } else {
                setDownStops(updatedStops);
                setEditForm(prev => ({
                    ...prev,
                    returnTotalDistance: cumulativeDist.toFixed(1),
                    returnManualFinalLeg: finalSegment > 0 ? finalSegment.toFixed(1) : prev.returnManualFinalLeg
                }));
            }

            setIsDistanceCalculated(prev => ({ ...prev, [type]: true }));
            toast.success(`${type === 'up' ? 'UP' : 'DOWN'} route distances calculated! Total: ${cumulativeDist.toFixed(1)} km`);

        } catch (error) {
            console.error('Distance calculation error:', error);
            toast.error("Calculation failed. Please enter distances manually.");
        } finally {
            setIsCalculatingDistances(false);
        }
    };

    const fetchRoutes = async () => {
        try {
            setLoading(true);
            const response = await getAllRoutes(
                token,
                currentPage,
                pageSize,
                searchTerm,
                filterOrigin,
                filterDestination
            );

            if (response && response.success) {
                const routesData = response.data?.routes || [];

                const transformedRoutes = routesData.map((route, index) => {
                    const getDepartureTime = (origin) => {
                        if (origin?.departureTime) return origin.departureTime;
                        if (origin?.timings && origin.timings.length > 0) {
                            const firstTiming = origin.timings[0];
                            if (firstTiming?.departureTime) return firstTiming.departureTime;
                        }
                        return 'N/A';
                    };

                    const getArrivalTime = (destination) => {
                        if (destination?.arrivalTime) return destination.arrivalTime;
                        if (destination?.timings && destination.timings.length > 0) {
                            const firstTiming = destination.timings[0];
                            if (firstTiming?.arrivalTime) return firstTiming.arrivalTime;
                        }
                        return 'N/A';
                    };

                    let departureTime = getDepartureTime(route.origin);
                    let arrivalTime = getArrivalTime(route.destination);

                    if (route.routeNumber?.includes('REV') && route.returnJourney) {
                        departureTime = getDepartureTime(route.returnJourney.origin);
                        arrivalTime = getArrivalTime(route.returnJourney.destination);
                    }

                    const formatDisplayTime = (timeStr) => {
                        if (!timeStr || timeStr === 'N/A') return 'N/A';
                        if (timeStr.includes(':')) {
                            const [hours, minutes] = timeStr.split(':');
                            const hour = parseInt(hours);
                            const ampm = hour >= 12 ? 'pm' : 'am';
                            const displayHour = hour % 12 || 12;
                            return `${displayHour}:${minutes} ${ampm}`;
                        }
                        return timeStr;
                    };

                    return {
                        id: route._id || route.id,
                        serialNo: (currentPage - 1) * pageSize + index + 1,
                        routeNumber: route.routeNumber || 'N/A',
                        routeName: route.routeName || 'N/A',
                        localRouteName: route.localRouteName || null,
                        originCity: route.origin?.city || 'N/A',
                        destinationCity: route.destination?.city || 'N/A',
                        distance: route.routeDetails?.totalDistance || 0,
                        duration: formatDuration(
                            route.routeDetails?.estimatedDuration?.hours,
                            route.routeDetails?.estimatedDuration?.minutes
                        ),
                        stops: route.intermediateStops?.length || 0,
                        status: route.isActive ? 'Active' : 'Inactive',
                        departureTime: formatDisplayTime(departureTime),
                        arrivalTime: formatDisplayTime(arrivalTime),
                        isActive: route.isActive,
                        createdAt: route.createdAt,
                        updatedAt: route.updatedAt,
                        creatorType: route.creatorType || 'Admin',
                        creatorName: route.creatorName || 'Admin',
                        isRoundTrip: route.isRoundTrip || false,
                        associatedBuses: (route.associatedBuses || []).map(bus => ({
                            ...bus,
                            _id: bus.busId || bus._id,
                            busId: bus.busId || bus._id,
                            approvalStatus: bus.approvalStatus || (bus.isActive ? 'approved' : 'pending')
                        })),
                        busCount: route.busCount || 0,
                        activeBusCount: route.activeBusCount || 0,
                        hasActiveBuses: route.hasActiveBuses || false,
                        hasPendingBuses: (route.associatedBuses || []).some(bus => !bus.isActive && bus.approvalStatus === 'pending'),
                        fullData: route
                    };
                });

                setRoutes(transformedRoutes);

                if (response.data?.pagination) {
                    setTotalPages(response.data.pagination.totalPages || 1);
                    setTotalRoutes(response.data.pagination.total || 0);
                }
            }
        } catch (err) {
            console.error('Error fetching routes:', err);
            toast.error('Failed to fetch routes');
        } finally {
            setLoading(false);
        }
    };

    const handleSaveRoute = async () => {
        if (!selectedMasterRouteFromDropdown) {
            toast.error('Please select a Master Route first');
            return;
        }

        if (!newRoute.routeName) {
            toast.error('Route Name is required. Please select a Master Route.');
            return;
        }

        if (!newRoute.upOriginCoords) {
            toast.error('Please select Origin from suggestions to get coordinates');
            return;
        }

        if (!newRoute.upDestCoords) {
            toast.error('Please select Destination from suggestions to get coordinates');
            return;
        }

        const invalidStops = upStops.filter(stop => {
            const missingFields = [];
            if (!stop.city?.trim()) missingFields.push('city');
            if (!stop.coordinates) missingFields.push('coordinates');

            if (isMultiTrip) {
                if (!stop.timings || stop.timings.length === 0) {
                    missingFields.push('timings');
                } else {
                    const missingTimings = stop.timings.filter(t => !t.arrivalTime);
                    if (missingTimings.length > 0) {
                        missingFields.push(`timings for ${missingTimings.length} trip(s)`);
                    }
                }
            } else if (!stop.arrivalTime) {
                missingFields.push('arrivalTime');
            }

            if (missingFields.length > 0) {
                return true;
            }
            return false;
        });

        if (invalidStops.length > 0) {
            toast.error(`Stop(s) missing required fields: ${invalidStops.map(s => s.city || 'Unknown').join(', ')}`);
            return;
        }

        if (!isDistanceCalculated.up) {
            toast.error('Please calculate UP route distances first');
            return;
        }

        if (isRoundTrip && !isDistanceCalculated.down) {
            toast.error('Please calculate DOWN route distances first');
            return;
        }

        if (isRoundTrip && !isMultiTrip && (!newRoute.downOriginDepTime || !newRoute.downDestArrTime)) {
            toast.error("Please provide Departure and Arrival times for the Return Route");
            return;
        }

        setIsCreatingRoute(true);

        try {
            const originData = {
                city: newRoute.upOriginCity,
                state: newRoute.upOriginState || '',
                address: newRoute.upOriginAddress || '',
                terminal: newRoute.upOriginTerminal || newRoute.upOriginCity + ' Terminal',
                coordinates: newRoute.upOriginCoords || { lat: 0, lng: 0 }
            };

            if (isMultiTrip) {
                originData.timings = timeSlots.map(slot => ({
                    timeSlotSequence: slot.sequence,
                    departureTime: slot.departureTime,
                    arrivalTime: ''
                }));
            } else {
                originData.departureTime = newRoute.upOriginDepTime;
            }

            const destData = {
                city: newRoute.upDestCity,
                state: newRoute.upDestState || '',
                address: newRoute.upDestAddress || '',
                terminal: newRoute.upDestTerminal || newRoute.upDestCity + ' Terminal',
                coordinates: newRoute.upDestCoords || { lat: 0, lng: 0 },
                distanceFromOrigin: parseFloat(newRoute.upTotalDistance || 0)
            };

            if (isMultiTrip) {
                destData.timings = destinationTimeSlots.map(slot => ({
                    timeSlotSequence: slot.sequence,
                    arrivalTime: slot.arrivalTime,
                    departureTime: ''
                }));
            } else {
                destData.arrivalTime = newRoute.upDestArrTime;
            }

            const cleanStops = (list) => list.map((s, index) => {
                const stopCoords = s.coordinates || { lat: 0, lng: 0 };
                const city = s.city?.trim();
                if (!city) {
                    throw new Error(`Stop ${index + 1} is missing city name`);
                }

                const state = s.state?.trim() || 'West Bengal';
                const address = s.address?.trim() || `${city}, ${state}, India`;
                const terminal = s.terminal?.trim() || `${city} Terminal`;

                const stopPayload = {
                    sequence: index + 1,
                    city: city,
                    state: state,
                    address: address,
                    terminal: terminal,
                    stopType: s.stopType || 'none',
                    coordinates: stopCoords,
                    distanceFromOrigin: s.distanceFromOrigin || 0
                };

                if (isMultiTrip) {
                    if (s.timings && s.timings.length > 0) {
                        stopPayload.timings = s.timings.map(timing => ({
                            timeSlotSequence: timing.timeSlotSequence,
                            arrivalTime: timing.arrivalTime,
                            departureTime: timing.departureTime || timing.arrivalTime
                        }));
                    } else {
                        stopPayload.timings = timeSlots.map(slot => ({
                            timeSlotSequence: slot.sequence,
                            arrivalTime: '',
                            departureTime: ''
                        }));
                    }
                } else {
                    if (!s.arrivalTime) {
                        throw new Error(`Stop ${index + 1} (${city}) is missing arrival time`);
                    }
                    stopPayload.arrivalTime = s.arrivalTime;
                    stopPayload.departureTime = s.departureTime?.trim() || s.arrivalTime;
                }

                if (s.manualDistFromPrev) stopPayload.manualDistFromPrev = s.manualDistFromPrev;
                if (s.manualDistToNext) stopPayload.manualDistToNext = s.manualDistToNext;
                if (s.isManualStop) stopPayload.isManualStop = s.isManualStop;

                return stopPayload;
            });

            const generateNullPoints = (stops, origin, destination) => {
                const nullPoints = [];
                nullPoints.push({
                    name: origin.terminal,
                    address: origin.address,
                    city: origin.city,
                    state: origin.state,
                    landmark: origin.terminal,
                    referenceTime: origin.departureTime
                });
                nullPoints.push({
                    name: destination.terminal,
                    address: destination.address,
                    city: destination.city,
                    state: destination.state,
                    landmark: destination.terminal,
                    referenceTime: destination.arrivalTime
                });
                stops.forEach(stop => {
                    if (stop.stopType === 'none') {
                        nullPoints.push({
                            name: stop.terminal,
                            address: stop.address,
                            city: stop.city,
                            state: stop.state,
                            landmark: stop.terminal,
                            referenceTime: stop.arrivalTime
                        });
                    }
                });
                return nullPoints;
            };

            const generateBoardingPoints = (stops, origin) => {
                const boardingPoints = [];
                boardingPoints.push({
                    name: origin.terminal,
                    address: origin.address,
                    city: origin.city,
                    state: origin.state,
                    landmark: origin.terminal,
                    pickupTime: origin.departureTime
                });
                stops.forEach(stop => {
                    if (stop.stopType === 'boarding' || stop.stopType === 'both') {
                        boardingPoints.push({
                            name: stop.terminal,
                            address: stop.address,
                            city: stop.city,
                            state: stop.state,
                            landmark: stop.terminal,
                            pickupTime: stop.departureTime || stop.arrivalTime
                        });
                    }
                });
                return boardingPoints;
            };

            const generateDroppingPoints = (stops, destination) => {
                const droppingPoints = [];
                droppingPoints.push({
                    name: destination.terminal,
                    address: destination.address,
                    city: destination.city,
                    state: destination.state,
                    landmark: destination.terminal,
                    dropTime: destination.arrivalTime
                });
                stops.forEach(stop => {
                    if (stop.stopType === 'dropping' || stop.stopType === 'both') {
                        droppingPoints.push({
                            name: stop.terminal,
                            address: stop.address,
                            city: stop.city,
                            state: stop.state,
                            landmark: stop.terminal,
                            dropTime: stop.arrivalTime
                        });
                    }
                });
                return droppingPoints;
            };

            const boardingPoints = generateBoardingPoints(upStops, originData);
            const droppingPoints = generateDroppingPoints(upStops, destData);
            const nullPoints = generateNullPoints(upStops, originData, destData);

            const finalPayload = {
                routeName: newRoute.routeName.trim(),
                via: selectedMasterRouteFromDropdown?.via || [],
                localRouteName: newRoute.localRouteName?.trim() || null,
                isMultiTrip: isMultiTrip,
                numberOfTrips: isMultiTrip ? numberOfTrips : 1,
                timeSlots: isMultiTrip ? timeSlots : [],
                origin: originData,
                destination: destData,
                intermediateStops: cleanStops(upStops),
                additionalBoardingPoints: boardingPoints,
                additionalDroppingPoints: droppingPoints,
                additionalNullPoints: nullPoints,
                routeDetails: {
                    totalDistance: parseFloat(newRoute.upTotalDistance || 0),
                    estimatedDuration: {
                        hours: parseInt(newRoute.upDurationHours || 0, 10),
                        minutes: parseInt(newRoute.upDurationMinutes || 0, 10)
                    }
                },
                isRoundTrip: isRoundTrip
            };

            if (isRoundTrip) {
                const invalidReturnStops = downStops.filter(stop => !stop.coordinates);

                if (invalidReturnStops.length > 0) {
                    toast.error('All return stops must have coordinates. Please select from suggestions or add manually with distances.');
                    setIsCreatingRoute(false);
                    return;
                }

                const returnOriginData = {
                    city: destData.city,
                    state: destData.state,
                    address: destData.address,
                    terminal: destData.terminal,
                    coordinates: destData.coordinates
                };

                if (isMultiTrip) {
                    if (returnOriginTimeSlots && returnOriginTimeSlots.length > 0) {
                        returnOriginData.timings = returnOriginTimeSlots.map(slot => ({
                            timeSlotSequence: slot.sequence,
                            departureTime: slot.departureTime || slot.arrivalTime || '',
                            arrivalTime: ''
                        }));
                    } else if (destinationTimeSlots && destinationTimeSlots.length > 0) {
                        returnOriginData.timings = destinationTimeSlots.map(slot => ({
                            timeSlotSequence: slot.sequence,
                            departureTime: slot.arrivalTime || '',
                            arrivalTime: ''
                        }));
                    } else {
                        returnOriginData.timings = timeSlots.map(slot => ({
                            timeSlotSequence: slot.sequence,
                            departureTime: slot.departureTime || '',
                            arrivalTime: ''
                        }));
                    }
                } else {
                    returnOriginData.departureTime = newRoute.downOriginDepTime;
                }

                const returnDestData = {
                    city: originData.city,
                    state: originData.state,
                    address: originData.address,
                    terminal: originData.terminal,
                    coordinates: originData.coordinates,
                    distanceFromOrigin: parseFloat(newRoute.downTotalDistance || 0)
                };

                if (isMultiTrip) {
                    if (returnDestTimeSlots && returnDestTimeSlots.length > 0) {
                        returnDestData.timings = returnDestTimeSlots.map(slot => ({
                            timeSlotSequence: slot.sequence,
                            arrivalTime: slot.arrivalTime || slot.departureTime || '',
                            departureTime: ''
                        }));
                    } else if (timeSlots && timeSlots.length > 0) {
                        returnDestData.timings = timeSlots.map(slot => ({
                            timeSlotSequence: slot.sequence,
                            arrivalTime: slot.departureTime || '',
                            departureTime: ''
                        }));
                    } else {
                        returnDestData.timings = Array.from({ length: numberOfTrips || 1 }, (_, i) => ({
                            timeSlotSequence: i + 1,
                            arrivalTime: '',
                            departureTime: ''
                        }));
                    }
                } else {
                    returnDestData.arrivalTime = newRoute.downDestArrTime;
                }

                if (isMultiTrip && returnOriginData.timings) {
                    const missingDepartures = returnOriginData.timings.filter(t => !t.departureTime);
                    if (missingDepartures.length > 0) {
                        toast.error(`Return origin is missing departure times for ${missingDepartures.length} trip(s). Please set them in the DOWN route section.`);
                        setIsCreatingRoute(false);
                        return;
                    }
                }

                if (isMultiTrip && returnDestData.timings) {
                    const missingArrivals = returnDestData.timings.filter(t => !t.arrivalTime);
                    if (missingArrivals.length > 0) {
                        toast.error(`Return destination is missing arrival times for ${missingArrivals.length} trip(s). Please set them in the DOWN route section.`);
                        setIsCreatingRoute(false);
                        return;
                    }
                }

                const cleanedReturnStops = downStops.map((stop, index) => {
                    const stopCoords = stop.coordinates || { lat: 0, lng: 0 };
                    const city = stop.city?.trim();
                    if (!city) {
                        throw new Error(`Return stop ${index + 1} is missing city name`);
                    }

                    const state = stop.state?.trim() || 'West Bengal';
                    const address = stop.address?.trim() || `${city}, ${state}, India`;
                    const terminal = stop.terminal?.trim() || `${city} Terminal`;

                    const stopPayload = {
                        sequence: index + 1,
                        city: city,
                        state: state,
                        address: address,
                        terminal: terminal,
                        stopType: stop.stopType || 'none',
                        coordinates: stopCoords,
                        distanceFromOrigin: stop.distanceFromOrigin || 0
                    };

                    if (isMultiTrip) {
                        if (stop.timings && stop.timings.length > 0) {
                            stopPayload.timings = stop.timings.map(timing => ({
                                timeSlotSequence: timing.timeSlotSequence,
                                arrivalTime: timing.arrivalTime || '',
                                departureTime: timing.departureTime || timing.arrivalTime || ''
                            }));
                        } else {
                            const numTrips = returnOriginTimeSlots.length || numberOfTrips || 1;
                            stopPayload.timings = Array.from({ length: numTrips }, (_, i) => ({
                                timeSlotSequence: i + 1,
                                arrivalTime: '',
                                departureTime: ''
                            }));
                        }
                    } else {
                        if (!stop.arrivalTime) {
                            throw new Error(`Return stop ${index + 1} (${city}) is missing arrival time`);
                        }
                        stopPayload.arrivalTime = stop.arrivalTime;
                        stopPayload.departureTime = stop.departureTime?.trim() || stop.arrivalTime;
                    }

                    if (stop.manualDistFromPrev) stopPayload.manualDistFromPrev = stop.manualDistFromPrev;
                    if (stop.manualDistToNext) stopPayload.manualDistToNext = stop.manualDistToNext;
                    if (stop.isManualStop) stopPayload.isManualStop = stop.isManualStop;

                    return stopPayload;
                });

                const returnBoardingPoints = generateBoardingPoints(downStops, returnOriginData);
                const returnDroppingPoints = generateDroppingPoints(downStops, returnDestData);
                const returnNullPoints = generateNullPoints(downStops, returnOriginData, returnDestData);

                finalPayload.returnOrigin = returnOriginData;
                finalPayload.returnDestination = returnDestData;
                finalPayload.returnIntermediateStops = cleanedReturnStops;
                finalPayload.returnAdditionalBoardingPoints = returnBoardingPoints;
                finalPayload.returnAdditionalDroppingPoints = returnDroppingPoints;
                finalPayload.returnAdditionalNullPoints = returnNullPoints;
                finalPayload.returnRouteDetails = {
                    totalDistance: parseFloat(newRoute.downTotalDistance || 0),
                    estimatedDuration: {
                        hours: parseInt(newRoute.downDurationHours || 0, 10),
                        minutes: parseInt(newRoute.downDurationMinutes || 0, 10)
                    }
                };
            }

            const response = await createRoute(finalPayload, token);
            if (response.success) {
                toast.success(isRoundTrip ? 'Round trip route created successfully!' : 'Route created successfully!');
                setShowAddModal(false);
                resetNewRouteForm();
                fetchRoutes();
            } else {
                toast.error(response.message || 'Failed to create route');
            }
        } catch (err) {
            console.error('Error creating route:', err);
            if (err.response) {
                const serverError = err.response.data?.message || err.response.data || err.message;
                toast.error(serverError);
            } else if (err.request) {
                toast.error('No response from server. Please check your connection.');
            } else {
                toast.error(err.message || 'Failed to create route');
            }
        } finally {
            setIsCreatingRoute(false);
        }
    };

    const resetNewRouteForm = () => {
        setNewRoute({
            routeName: '',
            localRouteName: '',
            upOriginCity: '', upOriginState: '', upOriginAddress: '', upOriginTerminal: '',
            upOriginCoords: null, upOriginDepTime: '',
            upDestCity: '', upDestState: '', upDestAddress: '', upDestTerminal: '',
            upDestCoords: null, upDestArrTime: '',
            upTotalDistance: '', upDurationHours: '', upDurationMinutes: '',
            downOriginDepTime: '', downDestArrTime: '',
            downTotalDistance: '', downDurationHours: '', downDurationMinutes: '',
            upManualFinalLeg: '',
            downManualFinalLeg: '',
            stopCity: '', stopState: '', stopAddress: '', stopTerminal: '',
            stopCoords: null, stopArrivalTime: '', stopDepartureTime: '',
            stopDistFromPrev: '', stopDistToNext: '',
            isBoarding: false, isDropping: false
        });
        setUpStops([]);
        setDownStops([]);
        setIsRoundTrip(false);
        setActiveRouteTab('UP');
        setIsDistanceCalculated({ up: false, down: false });
        setActiveTab('basic');
        setSelectedMasterRoute(null);
        setSelectedMasterRouteFromDropdown(null);
        setMasterRouteSuggestions([]);
    };

    const handleViewRoute = async (route) => {
        try {
            const routeData = await getRouteById(route.id, token);
            setViewingRoute(routeData.data || routeData);
        } catch (err) {
            setViewingRoute(route.fullData);
            toast.warning('Could not fetch latest route details. Showing cached data.');
        }
    };

    const handleAddNewMasterRoute = () => {
        const currentFormData = {
            routeName: newRoute.routeName,
            upOriginCity: newRoute.upOriginCity,
            upOriginState: newRoute.upOriginState,
            upOriginAddress: newRoute.upOriginAddress,
            upOriginTerminal: newRoute.upOriginTerminal,
            upOriginCoords: newRoute.upOriginCoords,
            upOriginDepTime: newRoute.upOriginDepTime,
            upDestCity: newRoute.upDestCity,
            upDestState: newRoute.upDestState,
            upDestAddress: newRoute.upDestAddress,
            upDestTerminal: newRoute.upDestTerminal,
            upDestCoords: newRoute.upDestCoords,
            upDestArrTime: newRoute.upDestArrTime,
            isRoundTrip: isRoundTrip,
            upStops: upStops,
            downStops: downStops,
            via: upStops.map(stop => ({
                city: stop.city,
                state: stop.state,
                sequence: stop.sequence
            }))
        };
        localStorage.setItem('pendingRouteFormData', JSON.stringify(currentFormData));

        toast.info('Redirecting to create master route. Your current form data has been saved.');

        navigate('/masterroutes', {
            state: {
                returnTo: 'routes',
                formData: currentFormData
            }
        });
    };

    const autoFillFromMasterRoute = (masterRoute) => {
        if (!masterRoute) return;

        setSelectedMasterRouteFromDropdown(masterRoute);

        const isMultiTripRoute = masterRoute.isMultiTrip ||
            (masterRoute.origin?.timings && masterRoute.origin.timings.length > 0) ||
            (masterRoute.intermediateStops && masterRoute.intermediateStops.some(stop => stop.timings && stop.timings.length > 0));

        setIsMultiTrip(isMultiTripRoute);

        setNewRoute(prev => ({
            ...prev,
            routeName: masterRoute.masterRouteName,
            localRouteName: masterRoute.localRouteName || prev.localRouteName
        }));

        if (masterRoute.origin) {
            setNewRoute(prev => ({
                ...prev,
                upOriginCity: masterRoute.origin.city || '',
                upOriginState: masterRoute.origin.state || '',
                upOriginAddress: masterRoute.origin.address || `${masterRoute.origin.city || ''}, ${masterRoute.origin.state || 'India'}`,
                upOriginTerminal: masterRoute.origin.terminal || `${masterRoute.origin.city || ''} Terminal`,
                upOriginCoords: masterRoute.origin.coordinates || null,
                upOriginDepTime: masterRoute.origin.departureTime || ''
            }));

            if (isMultiTripRoute && masterRoute.origin.timings && masterRoute.origin.timings.length > 0) {
                const numTrips = masterRoute.numberOfTrips || masterRoute.origin.timings.length;
                setNumberOfTrips(numTrips);
                setTimeSlots(masterRoute.origin.timings.map(timing => ({
                    sequence: timing.timeSlotSequence,
                    departureTime: timing.departureTime,
                    arrivalTime: '',
                    fareMultiplier: timing.fareMultiplier || 1.0,
                    isActive: timing.isActive !== undefined ? timing.isActive : true
                })));
            }
        }

        if (masterRoute.destination) {
            setNewRoute(prev => ({
                ...prev,
                upDestCity: masterRoute.destination.city || '',
                upDestState: masterRoute.destination.state || '',
                upDestAddress: masterRoute.destination.address || `${masterRoute.destination.city || ''}, ${masterRoute.destination.state || 'India'}`,
                upDestTerminal: masterRoute.destination.terminal || `${masterRoute.destination.city || ''} Terminal`,
                upDestCoords: masterRoute.destination.coordinates || null,
                upDestArrTime: masterRoute.destination.arrivalTime || '',
                upTotalDistance: masterRoute.routeDetails?.totalDistance || '',
                upDurationHours: masterRoute.routeDetails?.estimatedDuration?.hours || '',
                upDurationMinutes: masterRoute.routeDetails?.estimatedDuration?.minutes || ''
            }));

            if (isMultiTripRoute && masterRoute.destination.timings && masterRoute.destination.timings.length > 0) {
                setDestinationTimeSlots(masterRoute.destination.timings.map(timing => ({
                    sequence: timing.timeSlotSequence,
                    arrivalTime: timing.arrivalTime,
                    departureTime: '',
                    fareMultiplier: timing.fareMultiplier || 1.0
                })));
                setDestinationNumberOfTrips(masterRoute.destination.timings.length);
            }
        }

        const existingIntermediateStops = masterRoute.intermediateStops || [];
        const sortedStops = [...existingIntermediateStops].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

        if (sortedStops.length > 0) {
            const upTotalDist = parseFloat(masterRoute.routeDetails?.totalDistance) || 0;

            const transformedUpStops = sortedStops.map((stop, index) => {
                const actualDist = stop.distanceFromOrigin || 0;
                const prevStop = index > 0 ? sortedStops[index - 1] : null;
                const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

                let segmentDist = 0;
                if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
                    segmentDist = parseFloat(stop.manualDistFromPrev);
                } else if (actualDist > 0) {
                    segmentDist = parseFloat((actualDist - prevDist).toFixed(1));
                }

                if (segmentDist <= 0 && upTotalDist > 0 && sortedStops.length > 0) {
                    segmentDist = parseFloat((upTotalDist / (sortedStops.length + 1)).toFixed(1));
                }
                if (segmentDist <= 0) segmentDist = 5;

                const existingTimings = stop.timings || [];
                let stopTimings = existingTimings;
                if (isMultiTripRoute && existingTimings.length === 0) {
                    const numTrips = masterRoute.numberOfTrips || 1;
                    stopTimings = Array.from({ length: numTrips }, (_, i) => ({
                        timeSlotSequence: i + 1,
                        arrivalTime: '',
                        departureTime: ''
                    }));
                }

                return {
                    sequence: index + 1,
                    city: stop.city || '',
                    state: stop.state || masterRoute.origin?.state || '',
                    address: stop.address || `${stop.city || ''}, ${stop.state || masterRoute.origin?.state || 'India'}`,
                    terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
                    stopType: stop.stopType || 'none',
                    coordinates: stop.coordinates || { lat: 0, lng: 0 },
                    distanceFromOrigin: actualDist,
                    manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
                    manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
                    isManualStop: stop.isManualStop !== undefined
                        ? stop.isManualStop
                        : (!stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)),
                    arrivalTime: stop.arrivalTime || '',
                    departureTime: stop.departureTime || '',
                    timings: stopTimings
                };
            });

            setUpStops(transformedUpStops);
            setIsDistanceCalculated(prev => ({ ...prev, up: true }));

            const firstStopDist = transformedUpStops[0].distanceFromOrigin || 0;
            const firstSegment = transformedUpStops[0].manualDistFromPrev || firstStopDist;
            if (firstSegment > 0) {
                setNewRoute(prev => ({ ...prev, upManualFirstLeg: String(firstSegment) }));
            }

            const lastStopDist = transformedUpStops[transformedUpStops.length - 1].distanceFromOrigin || 0;
            const finalLeg = parseFloat((upTotalDist - lastStopDist).toFixed(1));
            if (finalLeg > 0) {
                setNewRoute(prev => ({ ...prev, upManualFinalLeg: String(finalLeg) }));
            }
        } else {
            setUpStops([]);
        }

        if (masterRoute.isRoundTrip && masterRoute.returnJourney) {
            setIsRoundTrip(true);

            const returnJourney = masterRoute.returnJourney;
            const returnTotalDist = parseFloat(returnJourney.routeDetails?.totalDistance) || 0;

            if (returnJourney.origin) {
                setNewRoute(prev => ({
                    ...prev,
                    downOriginCity: returnJourney.origin.city || masterRoute.destination?.city || '',
                    downOriginState: returnJourney.origin.state || masterRoute.destination?.state || '',
                    downOriginAddress: returnJourney.origin.address || `${masterRoute.destination?.city || ''}, ${masterRoute.destination?.state || 'India'}`,
                    downOriginTerminal: returnJourney.origin.terminal || `${masterRoute.destination?.city || ''} Terminal`,
                    downOriginCoords: returnJourney.origin.coordinates || masterRoute.destination?.coordinates || null,
                    downOriginDepTime: returnJourney.origin.departureTime || ''
                }));

                if (isMultiTripRoute && returnJourney.origin.timings && returnJourney.origin.timings.length > 0) {
                    setReturnOriginTimeSlots(returnJourney.origin.timings.map(timing => ({
                        sequence: timing.timeSlotSequence,
                        departureTime: timing.departureTime,
                        arrivalTime: '',
                        fareMultiplier: timing.fareMultiplier || 1.0
                    })));
                } else if (isMultiTripRoute && destinationTimeSlots.length > 0) {
                    setReturnOriginTimeSlots(destinationTimeSlots.map(slot => ({
                        sequence: slot.sequence,
                        departureTime: slot.arrivalTime,
                        arrivalTime: ''
                    })));
                }
            }

            if (returnJourney.destination) {
                setNewRoute(prev => ({
                    ...prev,
                    downDestCity: returnJourney.destination.city || masterRoute.origin?.city || '',
                    downDestState: returnJourney.destination.state || masterRoute.origin?.state || '',
                    downDestAddress: returnJourney.destination.address || `${masterRoute.origin?.city || ''}, ${masterRoute.origin?.state || 'India'}`,
                    downDestTerminal: returnJourney.destination.terminal || `${masterRoute.origin?.city || ''} Terminal`,
                    downDestCoords: returnJourney.destination.coordinates || masterRoute.origin?.coordinates || null,
                    downDestArrTime: returnJourney.destination.arrivalTime || '',
                    downTotalDistance: returnTotalDist,
                    downDurationHours: returnJourney.routeDetails?.estimatedDuration?.hours || '',
                    downDurationMinutes: returnJourney.routeDetails?.estimatedDuration?.minutes || ''
                }));

                if (isMultiTripRoute && returnJourney.destination.timings && returnJourney.destination.timings.length > 0) {
                    setReturnDestTimeSlots(returnJourney.destination.timings.map(timing => ({
                        sequence: timing.timeSlotSequence,
                        arrivalTime: timing.arrivalTime,
                        departureTime: '',
                        fareMultiplier: timing.fareMultiplier || 1.0
                    })));
                } else if (isMultiTripRoute && timeSlots.length > 0) {
                    setReturnDestTimeSlots(timeSlots.map(slot => ({
                        sequence: slot.sequence,
                        arrivalTime: slot.departureTime,
                        departureTime: ''
                    })));
                }
            }

            const returnExistingStops = returnJourney.intermediateStops || [];
            const sortedReturnStops = [...returnExistingStops].sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

            if (sortedReturnStops.length > 0) {
                const transformedDownStops = sortedReturnStops.map((stop, index) => {
                    const actualDist = stop.distanceFromOrigin || 0;
                    const prevStop = index > 0 ? sortedReturnStops[index - 1] : null;
                    const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

                    let segmentDist = 0;
                    if (stop.manualDistFromPrev && parseFloat(stop.manualDistFromPrev) > 0) {
                        segmentDist = parseFloat(stop.manualDistFromPrev);
                    } else if (actualDist > 0) {
                        segmentDist = parseFloat((actualDist - prevDist).toFixed(1));
                    }

                    if (segmentDist <= 0 && returnTotalDist > 0 && sortedReturnStops.length > 0) {
                        segmentDist = parseFloat((returnTotalDist / (sortedReturnStops.length + 1)).toFixed(1));
                    }
                    if (segmentDist <= 0) segmentDist = 5;

                    const existingTimings = stop.timings || [];
                    let stopTimings = existingTimings;
                    if (isMultiTripRoute && existingTimings.length === 0) {
                        const numTrips = masterRoute.numberOfTrips || 1;
                        stopTimings = Array.from({ length: numTrips }, (_, i) => ({
                            timeSlotSequence: i + 1,
                            arrivalTime: '',
                            departureTime: ''
                        }));
                    }

                    let newStopType = stop.stopType || 'none';
                    if (newStopType === 'boarding') newStopType = 'dropping';
                    else if (newStopType === 'dropping') newStopType = 'boarding';

                    return {
                        sequence: index + 1,
                        city: stop.city || '',
                        state: stop.state || masterRoute.destination?.state || '',
                        address: stop.address || `${stop.city || ''}, ${stop.state || masterRoute.destination?.state || 'India'}`,
                        terminal: stop.terminal || `${stop.city || ''} Bus Stand`,
                        arrivalTime: stop.arrivalTime || '',
                        departureTime: stop.departureTime || '',
                        stopType: newStopType,
                        coordinates: stop.coordinates || { lat: 0, lng: 0 },
                        distanceFromOrigin: actualDist,
                        manualDistFromPrev: segmentDist > 0 ? segmentDist : null,
                        manualDistToNext: stop.manualDistToNext ? parseFloat(stop.manualDistToNext) : null,
                        isManualStop: stop.isManualStop !== undefined
                            ? stop.isManualStop
                            : (!stop.coordinates || (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)),
                        timings: stopTimings
                    };
                });

                setDownStops(transformedDownStops);
                setIsDistanceCalculated(prev => ({ ...prev, down: true }));

                const returnFirstSegment = transformedDownStops[0].manualDistFromPrev ||
                    transformedDownStops[0].distanceFromOrigin || 0;
                if (returnFirstSegment > 0) {
                    setNewRoute(prev => ({ ...prev, downManualFirstLeg: String(returnFirstSegment) }));
                }

                const returnLastStopDist = transformedDownStops[transformedDownStops.length - 1].distanceFromOrigin || 0;
                const returnFinalLeg = parseFloat((returnTotalDist - returnLastStopDist).toFixed(1));
                if (returnFinalLeg > 0) {
                    setNewRoute(prev => ({ ...prev, downManualFinalLeg: String(returnFinalLeg) }));
                }
            } else {
                setDownStops([]);
            }
        } else {
            setIsRoundTrip(false);
            setDownStops([]);
            setReturnOriginTimeSlots([]);
            setReturnDestTimeSlots([]);
        }

        toast.success(`Master route "${masterRoute.masterRouteName}" loaded successfully! Please verify and fill in the timings.`);
    };

    const handleEditRoute = async (route) => {
        try {
            const response = await getRouteById(route.id, token);
            const routeData = response.data || route.fullData;

            setEditingRoute(routeData);

            // In handleEditRoute function, update this section:
            const resolvedIsMultiTrip = routeData.isMultiTrip ||
                (routeData.origin?.timings && routeData.origin.timings.length > 0) ||
                (routeData.intermediateStops && routeData.intermediateStops.some(
                    stop => stop.timings && stop.timings.length > 0
                )) ||
                (routeData.numberOfTrips && routeData.numberOfTrips > 1);

            setEditIsMultiTrip(resolvedIsMultiTrip);

            let resolvedNumberOfTrips = 1;
            if (resolvedIsMultiTrip) {
                resolvedNumberOfTrips = routeData.numberOfTrips ||
                    routeData.origin?.timings?.length ||
                    (routeData.intermediateStops && routeData.intermediateStops.length > 0 ?
                        routeData.intermediateStops[0]?.timings?.length || 1 : 1);
                setEditNumberOfTrips(resolvedNumberOfTrips);
            } else {
                setEditNumberOfTrips(1);
            }

            const origin = routeData.origin || {};
            const destination = routeData.destination || {};
            const routeDetails = routeData.routeDetails || {};
            const estimatedDuration = routeDetails.estimatedDuration || {};

            const transformStops = (stops) => {
                return (stops || []).map((stop, index, array) => {
                    const actualDist = stop.distanceFromOrigin || 0;
                    const prevStop = index > 0 ? array[index - 1] : null;
                    const prevDist = prevStop ? (prevStop.distanceFromOrigin || 0) : 0;

                    let manualDistFromPrev = stop.manualDistFromPrev
                        ? parseFloat(stop.manualDistFromPrev)
                        : null;

                    if (!manualDistFromPrev && actualDist > 0) {
                        const calculated = parseFloat((actualDist - prevDist).toFixed(1));
                        if (calculated > 0) manualDistFromPrev = calculated;
                    }

                    const sortedTimings = sortTimings(stop.timings || []);
                    const hasMultiTimings = sortedTimings.length > 0;

                    let finalTimings = sortedTimings;
                    if (resolvedIsMultiTrip && sortedTimings.length < resolvedNumberOfTrips) {
                        const existingSequences = sortedTimings.map(t => t.timeSlotSequence);
                        finalTimings = [...sortedTimings];
                        for (let i = 1; i <= resolvedNumberOfTrips; i++) {
                            if (!existingSequences.includes(i)) {
                                finalTimings.push({
                                    timeSlotSequence: i,
                                    arrivalTime: '',
                                    departureTime: ''
                                });
                            }
                        }
                        finalTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                    } else if (resolvedIsMultiTrip && sortedTimings.length > resolvedNumberOfTrips) {
                        finalTimings = sortedTimings
                            .filter(t => t.timeSlotSequence <= resolvedNumberOfTrips)
                            .map((t, i) => ({ ...t, timeSlotSequence: i + 1 }));
                    }

                    return {
                        city: stop.city,
                        state: stop.state || '',
                        address: stop.address || '',
                        terminal: stop.terminal || '',
                        arrivalTime: hasMultiTimings ? '' : (stop.arrivalTime || ''),
                        departureTime: hasMultiTimings ? '' : (stop.departureTime || ''),
                        timings: finalTimings,
                        stopType: stop.stopType || 'none',
                        coordinates: stop.coordinates || { lat: 0, lng: 0 },
                        distanceFromOrigin: actualDist,
                        manualDistFromPrev: manualDistFromPrev,
                        manualDistToNext: stop.manualDistToNext
                            ? parseFloat(stop.manualDistToNext)
                            : null,
                        isManualStop: stop.isManualStop === true ||
                            !stop.coordinates ||
                            (stop.coordinates.lat === 0 && stop.coordinates.lng === 0)
                    };
                });
            };

            const transformedStops = transformStops(routeData.intermediateStops);

            let forwardManualFinalLeg = '';
            if (routeDetails.totalDistance && transformedStops.length > 0) {
                const lastStopDist = transformedStops[transformedStops.length - 1].distanceFromOrigin || 0;
                const calculated = routeDetails.totalDistance - lastStopDist;
                if (calculated > 0) {
                    forwardManualFinalLeg = calculated.toFixed(1);
                }
            }

            const originTimings = sortTimings(origin.timings || []);
            const destTimings = sortTimings(destination.timings || []);

            let finalOriginTimings = [...originTimings];
            if (resolvedIsMultiTrip && originTimings.length < resolvedNumberOfTrips) {
                const existingSequences = originTimings.map(t => t.timeSlotSequence);
                for (let i = 1; i <= resolvedNumberOfTrips; i++) {
                    if (!existingSequences.includes(i)) {
                        finalOriginTimings.push({
                            timeSlotSequence: i,
                            departureTime: '',
                            arrivalTime: ''
                        });
                    }
                }
                finalOriginTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
            }

            let finalDestTimings = [...destTimings];
            if (resolvedIsMultiTrip && destTimings.length < resolvedNumberOfTrips) {
                const existingSequences = destTimings.map(t => t.timeSlotSequence);
                for (let i = 1; i <= resolvedNumberOfTrips; i++) {
                    if (!existingSequences.includes(i)) {
                        finalDestTimings.push({
                            timeSlotSequence: i,
                            arrivalTime: '',
                            departureTime: ''
                        });
                    }
                }
                finalDestTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
            }

            setEditForm({
                routeNumber: routeData.routeNumber || '',
                routeName: routeData.routeName || '',
                localRouteName: routeData.localRouteName || '',
                isMultiTrip: resolvedIsMultiTrip,
                numberOfTrips: resolvedNumberOfTrips,
                timeSlots: routeData.timeSlots || [],
                originCity: origin.city || '',
                originState: origin.state || '',
                originAddress: origin.address || '',
                originTerminal: origin.terminal || '',
                originDepTime: origin.departureTime || '',
                originCoords: origin.coordinates || { lat: 0, lng: 0 },
                originTimings: finalOriginTimings,
                destCity: destination.city || '',
                destState: destination.state || '',
                destAddress: destination.address || '',
                destTerminal: destination.terminal || '',
                destArrTime: destination.arrivalTime || '',
                destCoords: destination.coordinates || { lat: 0, lng: 0 },
                destTimings: finalDestTimings,
                totalDistance: routeDetails.totalDistance || '',
                durationHours: estimatedDuration.hours || '',
                durationMinutes: estimatedDuration.minutes || '',
                intermediateStops: transformedStops,
                isActive: routeData.isActive !== undefined ? routeData.isActive : true,
                isRoundTrip: routeData.isRoundTrip || false,
                returnJourney: routeData.returnJourney || null,
                upManualFinalLeg: forwardManualFinalLeg,
                upManualFirstLeg: transformedStops.length > 0 && transformedStops[0].manualDistFromPrev
                    ? String(transformedStops[0].manualDistFromPrev)
                    : ''
            });

            if (transformedStops.length > 0) {
                setUpStops(transformedStops);
                if (transformedStops.every(stop => stop.distanceFromOrigin > 0)) {
                    setIsDistanceCalculated(prev => ({ ...prev, up: true }));
                }
            } else {
                setUpStops([]);
            }

            // ========== HANDLE RETURN JOURNEY ==========
            if (routeData.isRoundTrip && routeData.returnJourney) {
                const returnJourney = routeData.returnJourney;
                const returnOrigin = returnJourney.origin || {};
                const returnDestination = returnJourney.destination || {};
                const returnRouteDetails = returnJourney.routeDetails || {};
                const returnEstimatedDuration = returnRouteDetails.estimatedDuration || {};

                const transformedReturnStops = transformStops(returnJourney.intermediateStops);

                let returnManualFinalLeg = '';
                if (returnRouteDetails.totalDistance && transformedReturnStops.length > 0) {
                    const lastStopDist = transformedReturnStops[transformedReturnStops.length - 1].distanceFromOrigin || 0;
                    const calculated = returnRouteDetails.totalDistance - lastStopDist;
                    if (calculated > 0) {
                        returnManualFinalLeg = calculated.toFixed(1);
                    }
                }

                let returnOriginTimings = sortTimings(returnOrigin.timings || []);
                let returnDestTimings = sortTimings(returnDestination.timings || []);

                if (resolvedIsMultiTrip && returnOriginTimings.length < resolvedNumberOfTrips) {
                    const existingSequences = returnOriginTimings.map(t => t.timeSlotSequence);
                    for (let i = 1; i <= resolvedNumberOfTrips; i++) {
                        if (!existingSequences.includes(i)) {
                            returnOriginTimings.push({
                                timeSlotSequence: i,
                                departureTime: '',
                                arrivalTime: ''
                            });
                        }
                    }
                    returnOriginTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                } else if (resolvedIsMultiTrip && returnOriginTimings.length === 0) {
                    returnOriginTimings = finalOriginTimings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence,
                        departureTime: '',
                        arrivalTime: ''
                    }));
                }

                if (resolvedIsMultiTrip && returnDestTimings.length < resolvedNumberOfTrips) {
                    const existingSequences = returnDestTimings.map(t => t.timeSlotSequence);
                    for (let i = 1; i <= resolvedNumberOfTrips; i++) {
                        if (!existingSequences.includes(i)) {
                            returnDestTimings.push({
                                timeSlotSequence: i,
                                arrivalTime: '',
                                departureTime: ''
                            });
                        }
                    }
                    returnDestTimings.sort((a, b) => (a.timeSlotSequence || 0) - (b.timeSlotSequence || 0));
                } else if (resolvedIsMultiTrip && returnDestTimings.length === 0) {
                    returnDestTimings = finalDestTimings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence,
                        arrivalTime: '',
                        departureTime: ''
                    }));
                }

                setEditForm(prev => ({
                    ...prev,
                    returnOriginCity: returnOrigin.city || destination.city || '',
                    returnOriginState: returnOrigin.state || destination.state || '',
                    returnOriginAddress: returnOrigin.address || destination.address || '',
                    returnOriginTerminal: returnOrigin.terminal || destination.terminal || '',
                    returnOriginDepTime: returnOrigin.departureTime || '',
                    returnOriginCoords: returnOrigin.coordinates || destination.coordinates || { lat: 0, lng: 0 },
                    returnOriginTimings: returnOriginTimings,
                    returnDestCity: returnDestination.city || origin.city || '',
                    returnDestState: returnDestination.state || origin.state || '',
                    returnDestAddress: returnDestination.address || origin.address || '',
                    returnDestTerminal: returnDestination.terminal || origin.terminal || '',
                    returnDestArrTime: returnDestination.arrivalTime || '',
                    returnDestCoords: returnDestination.coordinates || origin.coordinates || { lat: 0, lng: 0 },
                    returnDestTimings: returnDestTimings,
                    returnTotalDistance: returnRouteDetails.totalDistance || routeDetails.totalDistance || '',
                    returnDurationHours: returnEstimatedDuration.hours || estimatedDuration.hours || '',
                    returnDurationMinutes: returnEstimatedDuration.minutes || estimatedDuration.minutes || '',
                    returnIntermediateStops: transformedReturnStops,
                    returnManualFinalLeg: returnManualFinalLeg,
                    returnManualFirstLeg: transformedReturnStops.length > 0 && transformedReturnStops[0].manualDistFromPrev
                        ? String(transformedReturnStops[0].manualDistFromPrev)
                        : ''
                }));

                if (transformedReturnStops.length > 0) {
                    setDownStops(transformedReturnStops);
                    if (transformedReturnStops.every(stop => stop.distanceFromOrigin > 0)) {
                        setIsDistanceCalculated(prev => ({ ...prev, down: true }));
                    }
                } else {
                    setDownStops([]);
                }
            } else {
                // ========== IF NO RETURN JOURNEY EXISTS, PREPARE DEFAULT RETURN DATA ==========
                // This handles the case where we're editing a one-way route and will convert to round trip
                setDownStops([]);
                setEditForm(prev => ({
                    ...prev,
                    // Auto-populate return origin from destination
                    returnOriginCity: destination.city || '',
                    returnOriginState: destination.state || '',
                    returnOriginAddress: destination.address || '',
                    returnOriginTerminal: destination.terminal || '',
                    returnOriginDepTime: '', // User will set this
                    returnOriginCoords: destination.coordinates || { lat: 0, lng: 0 },
                    // Auto-populate return destination from origin
                    returnDestCity: origin.city || '',
                    returnDestState: origin.state || '',
                    returnDestAddress: origin.address || '',
                    returnDestTerminal: origin.terminal || '',
                    returnDestArrTime: '', // User will set this
                    returnDestCoords: origin.coordinates || { lat: 0, lng: 0 },
                    returnTotalDistance: routeDetails.totalDistance || '',
                    returnDurationHours: estimatedDuration.hours || '',
                    returnDurationMinutes: estimatedDuration.minutes || '',
                    returnIntermediateStops: [],
                    returnManualFinalLeg: '',
                    returnManualFirstLeg: ''
                }));
            }

            if (routeData.isRoundTrip) {
                setIsRoundTrip(true);
                setActiveRouteTab('UP');
            } else {
                setIsRoundTrip(false);
                setActiveRouteTab('UP');
            }

            setShowEditModal(true);

        } catch (err) {
            console.error('Error fetching route for edit:', err);
            toast.error('Failed to load route for editing');
        }
    };

    // ========== HANDLE ROUND TRIP TOGGLE IN EDIT MODE ==========
    const handleEditRoundTripToggle = (checked) => {
        if (checked) {
            // Converting to round trip - auto-populate return fields
            // Get values from editForm or fallback to newRoute
            const originCity = editForm.originCity || newRoute.upOriginCity || '';
            const originState = editForm.originState || newRoute.upOriginState || '';
            const originAddress = editForm.originAddress || newRoute.upOriginAddress || '';
            const originTerminal = editForm.originTerminal || newRoute.upOriginTerminal || '';
            const originCoords = editForm.originCoords || newRoute.upOriginCoords || { lat: 0, lng: 0 };
            const originDepTime = editForm.originDepTime || newRoute.upOriginDepTime || '';

            const destCity = editForm.destCity || newRoute.upDestCity || '';
            const destState = editForm.destState || newRoute.upDestState || '';
            const destAddress = editForm.destAddress || newRoute.upDestAddress || '';
            const destTerminal = editForm.destTerminal || newRoute.upDestTerminal || '';
            const destCoords = editForm.destCoords || newRoute.upDestCoords || { lat: 0, lng: 0 };
            const destArrTime = editForm.destArrTime || newRoute.upDestArrTime || '';

            const totalDist = editForm.totalDistance || newRoute.upTotalDistance || '';
            const durationH = editForm.durationHours || newRoute.upDurationHours || '';
            const durationM = editForm.durationMinutes || newRoute.upDurationMinutes || '';

            // Get the number of trips
            const numTrips = editForm.numberOfTrips || editNumberOfTrips || 1;
            const isMultiTripMode = editForm.isMultiTrip || editIsMultiTrip || false;

            // ========== CREATE RETURN TIMINGS FOR MULTI-TRIP ==========
            let returnOriginTimings = [];
            let returnDestTimings = [];

            if (isMultiTripMode) {
                // Copy timings from origin for return origin (departure times)
                if (editForm.originTimings && editForm.originTimings.length > 0) {
                    returnOriginTimings = editForm.originTimings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence,
                        departureTime: '', // User will set these
                        arrivalTime: ''
                    }));
                } else {
                    // Create default timings if none exist
                    returnOriginTimings = Array.from({ length: numTrips }, (_, i) => ({
                        timeSlotSequence: i + 1,
                        departureTime: '',
                        arrivalTime: ''
                    }));
                }

                // Copy timings from destination for return destination (arrival times)
                if (editForm.destTimings && editForm.destTimings.length > 0) {
                    returnDestTimings = editForm.destTimings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence,
                        arrivalTime: '', // User will set these
                        departureTime: ''
                    }));
                } else {
                    // Create default timings if none exist
                    returnDestTimings = Array.from({ length: numTrips }, (_, i) => ({
                        timeSlotSequence: i + 1,
                        arrivalTime: '',
                        departureTime: ''
                    }));
                }
            }

            // ========== SET RETURN ORIGIN AND DESTINATION ==========
            // Return Origin = Forward Destination (Digha)
            // Return Destination = Forward Origin (Arambagh)
            setEditForm(prev => ({
                ...prev,
                // Return Origin (starts from destination of forward route)
                returnOriginCity: destCity,
                returnOriginState: destState,
                returnOriginAddress: destAddress,
                returnOriginTerminal: destTerminal,
                returnOriginCoords: destCoords,
                returnOriginDepTime: isMultiTripMode ? '' : destArrTime,
                returnOriginTimings: returnOriginTimings,

                // Return Destination (ends at origin of forward route)
                returnDestCity: originCity,
                returnDestState: originState,
                returnDestAddress: originAddress,
                returnDestTerminal: originTerminal,
                returnDestCoords: originCoords,
                returnDestArrTime: isMultiTripMode ? '' : originDepTime,
                returnDestTimings: returnDestTimings,

                // Route details
                returnTotalDistance: totalDist,
                returnDurationHours: durationH,
                returnDurationMinutes: durationM,

                // Multi-trip flag
                isMultiTrip: isMultiTripMode,
                numberOfTrips: numTrips,
                isRoundTrip: true
            }));

            // ========== AUTO-POPULATE RETURN STOPS ==========
            if (upStops.length > 0) {
                const upTotalDist = parseFloat(editForm.totalDistance || newRoute.upTotalDistance || 0);
                const reversedStops = [...upStops].reverse();

                // Calculate segment distances for reverse
                const upDistances = upStops.map(stop => stop.distanceFromOrigin || 0);
                const upSegments = [];
                let prevDist = 0;
                for (let i = 0; i < upDistances.length; i++) {
                    const segment = upDistances[i] - prevDist;
                    upSegments.push(segment > 0 ? segment : 5);
                    prevDist = upDistances[i];
                }
                // Last segment to destination
                const lastSegment = upTotalDist - (upDistances[upDistances.length - 1] || 0);
                upSegments.push(lastSegment > 0 ? lastSegment : 5);

                // Reverse the segments for down direction
                const downSegments = [...upSegments].reverse();

                const newDownStops = [];
                let cumulativeDist = 0;

                for (let i = 0; i < reversedStops.length; i++) {
                    const stop = reversedStops[i];
                    let newStopType = stop.stopType;
                    if (stop.stopType === 'boarding') newStopType = 'dropping';
                    else if (stop.stopType === 'dropping') newStopType = 'boarding';

                    const segmentDist = downSegments[i] || 5;
                    cumulativeDist += segmentDist;

                    // ========== CREATE TIMINGS FOR RETURN STOP ==========
                    let stopTimings = [];
                    if (isMultiTripMode) {
                        if (stop.timings && stop.timings.length > 0) {
                            stopTimings = stop.timings.map(t => ({
                                timeSlotSequence: t.timeSlotSequence,
                                arrivalTime: '',
                                departureTime: ''
                            }));
                        } else {
                            stopTimings = Array.from({ length: numTrips }, (_, idx) => ({
                                timeSlotSequence: idx + 1,
                                arrivalTime: '',
                                departureTime: ''
                            }));
                        }
                    }

                    // For single trip mode, preserve the time but reverse the logic
                    let arrivalTime = '';
                    let departureTime = '';
                    if (!isMultiTripMode) {
                        if (stop.departureTime) {
                            departureTime = stop.departureTime;
                        }
                        if (stop.arrivalTime) {
                            arrivalTime = stop.arrivalTime;
                        }
                    }

                    newDownStops.push({
                        ...stop,
                        sequence: i + 1,
                        stopType: newStopType,
                        distanceFromOrigin: parseFloat(cumulativeDist.toFixed(1)),
                        manualDistFromPrev: parseFloat(segmentDist.toFixed(1)),
                        manualDistToNext: i < reversedStops.length - 1 ? parseFloat(downSegments[i + 1]?.toFixed(1) || 0) : null,
                        arrivalTime: isMultiTripMode ? '' : arrivalTime,
                        departureTime: isMultiTripMode ? '' : departureTime,
                        timings: stopTimings
                    });
                }

                // Add final segment to destination
                const finalSegment = downSegments[downSegments.length - 1] || 5;
                if (newDownStops.length > 0 && finalSegment > 0) {
                    const lastIndex = newDownStops.length - 1;
                    newDownStops[lastIndex] = {
                        ...newDownStops[lastIndex],
                        manualDistToNext: parseFloat(finalSegment.toFixed(1))
                    };
                }

                setDownStops(newDownStops);
                setIsDistanceCalculated(prev => ({ ...prev, down: false }));

                if (isMultiTripMode) {
                    toast.info(`Return route populated with ${newDownStops.length} reversed stops. Each stop has ${numTrips} trip timings to set.`);
                } else {
                    toast.info(`Return route populated with ${newDownStops.length} reversed stops.`);
                }
            } else {
                toast.info('Return route enabled. Add stops for the return journey or use the "Auto-Fill" button.');
            }

            setActiveRouteTab('DOWN');
        } else {
            // Converting back to one-way - clear return data
            setDownStops([]);
            setIsDistanceCalculated(prev => ({ ...prev, down: false }));
            setEditForm(prev => ({
                ...prev,
                returnOriginCity: '',
                returnOriginState: '',
                returnOriginAddress: '',
                returnOriginTerminal: '',
                returnOriginDepTime: '',
                returnOriginCoords: null,
                returnOriginTimings: [],
                returnDestCity: '',
                returnDestState: '',
                returnDestAddress: '',
                returnDestTerminal: '',
                returnDestArrTime: '',
                returnDestCoords: null,
                returnDestTimings: [],
                returnTotalDistance: '',
                returnDurationHours: '',
                returnDurationMinutes: '',
                returnIntermediateStops: [],
                returnManualFinalLeg: '',
                returnManualFirstLeg: '',
                isRoundTrip: false
            }));
            setActiveRouteTab('UP');
            toast.info('Return route disabled');
        }
    };

    // Update the handleUpdateRoute function - find the section where return stops are processed
    // and make sure timings are properly set

    const handleUpdateRoute = async () => {
        if (!editForm.routeName) {
            toast.error('Route Name is required');
            return;
        }

        setIsUpdatingRoute(true);

        try {
            const isMultiTripMode = editForm.isMultiTrip || isMultiTrip;

            const cleanStops = (list, stopType = 'forward') => {
                if (!list || !Array.isArray(list)) return [];

                return list.map((s, index) => {
                    if (!s.city) {
                        throw new Error(`Stop ${index + 1} is missing city name`);
                    }

                    const stopObj = {
                        sequence: index + 1,
                        city: s.city,
                        state: s.state || '',
                        address: s.address || `${s.city}, ${s.state || 'India'}`,
                        terminal: s.terminal || `${s.city} Bus Stand`,
                        stopType: s.stopType || 'none',
                        coordinates: s.coordinates || { lat: 0, lng: 0 },
                        distanceFromOrigin: s.distanceFromOrigin || 0,
                    };

                    if (s.manualDistFromPrev) stopObj.manualDistFromPrev = s.manualDistFromPrev;
                    if (s.manualDistToNext) stopObj.manualDistToNext = s.manualDistToNext;
                    if (s.isManualStop) stopObj.isManualStop = s.isManualStop;

                    if (isMultiTripMode) {
                        if (s.timings && s.timings.length > 0) {
                            stopObj.timings = sortTimings(s.timings).map(timing => ({
                                timeSlotSequence: timing.timeSlotSequence,
                                arrivalTime: timing.arrivalTime || '',
                                departureTime: timing.departureTime || timing.arrivalTime || ''
                            }));
                        } else {
                            const numTrips = editForm.numberOfTrips || 1;
                            stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({
                                timeSlotSequence: i + 1,
                                arrivalTime: s.arrivalTime || '',
                                departureTime: s.departureTime || s.arrivalTime || ''
                            }));
                        }
                        stopObj.arrivalTime = s.arrivalTime || (stopObj.timings[0]?.arrivalTime) || '';
                        stopObj.departureTime = s.departureTime || (stopObj.timings[0]?.departureTime) || stopObj.arrivalTime;
                    } else {
                        // Single trip mode - require arrival time
                        if (!s.arrivalTime) {
                            throw new Error(`Stop ${index + 1} (${s.city}) is missing arrival time`);
                        }
                        stopObj.arrivalTime = s.arrivalTime;
                        stopObj.departureTime = s.departureTime || s.arrivalTime;
                        stopObj.timings = [];
                    }

                    return stopObj;
                });
            };

            const originData = {
                city: editForm.originCity,
                state: editForm.originState || '',
                address: editForm.originAddress || '',
                terminal: editForm.originTerminal || editForm.originCity + ' Terminal',
                coordinates: editForm.originCoords || { lat: 0, lng: 0 }
            };

            if (isMultiTripMode && editForm.originTimings && editForm.originTimings.length > 0) {
                originData.timings = sortTimings(editForm.originTimings).map(t => ({
                    timeSlotSequence: t.timeSlotSequence,
                    departureTime: t.departureTime,
                    arrivalTime: t.arrivalTime || ''
                }));
            } else {
                originData.departureTime = editForm.originDepTime;
                originData.timings = [];
            }

            const destData = {
                city: editForm.destCity,
                state: editForm.destState || '',
                address: editForm.destAddress || '',
                terminal: editForm.destTerminal || editForm.destCity + ' Terminal',
                coordinates: editForm.destCoords || { lat: 0, lng: 0 },
                distanceFromOrigin: parseFloat(editForm.totalDistance || 0)
            };

            if (isMultiTripMode && editForm.destTimings && editForm.destTimings.length > 0) {
                destData.timings = sortTimings(editForm.destTimings).map(t => ({
                    timeSlotSequence: t.timeSlotSequence,
                    arrivalTime: t.arrivalTime,
                    departureTime: t.departureTime || ''
                }));
            } else {
                destData.arrivalTime = editForm.destArrTime;
                destData.timings = [];
            }

            const updatePayload = {
                routeName: editForm.routeName.trim(),
                localRouteName: editForm.localRouteName?.trim() || null,
                isMultiTrip: isMultiTripMode,
                numberOfTrips: editForm.numberOfTrips || 1,
                timeSlots: editForm.timeSlots || [],
                origin: originData,
                destination: destData,
                intermediateStops: cleanStops(upStops, 'forward'),
                routeDetails: {
                    totalDistance: parseFloat(editForm.totalDistance || 0),
                    estimatedDuration: {
                        hours: parseInt(editForm.durationHours || 0, 10),
                        minutes: parseInt(editForm.durationMinutes || 0, 10)
                    }
                },
                isActive: editForm.isActive,
                isRoundTrip: editForm.isRoundTrip
            };

            if (editForm.isRoundTrip) {
                // Build return origin data
                const returnOriginData = {
                    city: editForm.returnOriginCity || editForm.destCity,
                    state: editForm.returnOriginState || editForm.destState,
                    address: editForm.returnOriginAddress || editForm.destAddress,
                    terminal: editForm.returnOriginTerminal || editForm.destTerminal,
                    coordinates: editForm.returnOriginCoords || editForm.destCoords || { lat: 0, lng: 0 }
                };

                if (isMultiTripMode && editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0) {
                    returnOriginData.timings = sortTimings(editForm.returnOriginTimings).map(t => ({
                        timeSlotSequence: t.timeSlotSequence,
                        departureTime: t.departureTime || '',
                        arrivalTime: t.arrivalTime || ''
                    }));
                } else if (isMultiTripMode && originData.timings && originData.timings.length > 0) {
                    returnOriginData.timings = originData.timings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence,
                        departureTime: '',
                        arrivalTime: ''
                    }));
                } else {
                    returnOriginData.departureTime = editForm.returnOriginDepTime;
                    returnOriginData.timings = [];
                }

                // Build return destination data
                const returnDestData = {
                    city: editForm.returnDestCity || editForm.originCity,
                    state: editForm.returnDestState || editForm.originState,
                    address: editForm.returnDestAddress || editForm.originAddress,
                    terminal: editForm.returnDestTerminal || editForm.originTerminal,
                    coordinates: editForm.returnDestCoords || editForm.originCoords || { lat: 0, lng: 0 },
                    distanceFromOrigin: parseFloat(editForm.returnTotalDistance || 0)
                };

                if (isMultiTripMode && editForm.returnDestTimings && editForm.returnDestTimings.length > 0) {
                    returnDestData.timings = sortTimings(editForm.returnDestTimings).map(t => ({
                        timeSlotSequence: t.timeSlotSequence,
                        arrivalTime: t.arrivalTime || '',
                        departureTime: t.departureTime || ''
                    }));
                } else if (isMultiTripMode && destData.timings && destData.timings.length > 0) {
                    returnDestData.timings = destData.timings.map(t => ({
                        timeSlotSequence: t.timeSlotSequence,
                        arrivalTime: '',
                        departureTime: ''
                    }));
                } else {
                    returnDestData.arrivalTime = editForm.returnDestArrTime;
                    returnDestData.timings = [];
                }

                // Clean return stops - IMPORTANT: Make sure timings are preserved
                const cleanedReturnStops = downStops.map((stop, index) => {
                    const stopObj = {
                        sequence: index + 1,
                        city: stop.city,
                        state: stop.state || '',
                        address: stop.address || `${stop.city}, ${stop.state || 'India'}`,
                        terminal: stop.terminal || `${stop.city} Bus Stand`,
                        stopType: stop.stopType || 'none',
                        coordinates: stop.coordinates || { lat: 0, lng: 0 },
                        distanceFromOrigin: stop.distanceFromOrigin || 0,
                    };

                    if (stop.manualDistFromPrev) stopObj.manualDistFromPrev = stop.manualDistFromPrev;
                    if (stop.manualDistToNext) stopObj.manualDistToNext = stop.manualDistToNext;
                    if (stop.isManualStop) stopObj.isManualStop = stop.isManualStop;

                    if (isMultiTripMode) {
                        // Preserve timings if they exist
                        if (stop.timings && stop.timings.length > 0) {
                            stopObj.timings = sortTimings(stop.timings).map(timing => ({
                                timeSlotSequence: timing.timeSlotSequence,
                                arrivalTime: timing.arrivalTime || '',
                                departureTime: timing.departureTime || timing.arrivalTime || ''
                            }));
                        } else {
                            // Create timings from the stop's arrival/departure times
                            const numTrips = editForm.numberOfTrips || 1;
                            stopObj.timings = Array.from({ length: numTrips }, (_, i) => ({
                                timeSlotSequence: i + 1,
                                arrivalTime: stop.arrivalTime || '',
                                departureTime: stop.departureTime || stop.arrivalTime || ''
                            }));
                        }
                        // Keep single time fields for backward compatibility
                        stopObj.arrivalTime = stop.arrivalTime || (stopObj.timings[0]?.arrivalTime) || '';
                        stopObj.departureTime = stop.departureTime || (stopObj.timings[0]?.departureTime) || stopObj.arrivalTime;
                    } else {
                        // Single trip mode - require arrival time
                        if (!stop.arrivalTime) {
                            throw new Error(`Return stop ${index + 1} (${stop.city}) is missing arrival time`);
                        }
                        stopObj.arrivalTime = stop.arrivalTime;
                        stopObj.departureTime = stop.departureTime || stop.arrivalTime;
                        stopObj.timings = [];
                    }

                    return stopObj;
                });

                updatePayload.returnOrigin = returnOriginData;
                updatePayload.returnDestination = returnDestData;
                updatePayload.returnIntermediateStops = cleanedReturnStops;
                updatePayload.returnRouteDetails = {
                    totalDistance: parseFloat(editForm.returnTotalDistance || 0),
                    estimatedDuration: {
                        hours: parseInt(editForm.returnDurationHours || 0, 10),
                        minutes: parseInt(editForm.returnDurationMinutes || 0, 10)
                    }
                };
            }

            const response = await updateRoute(editingRoute._id, updatePayload, token);

            if (response.success) {
                toast.success('Route updated successfully!');
                setShowEditModal(false);
                setEditingRoute(null);
                setEditForm({});
                fetchRoutes();
            } else {
                throw new Error(response.message || 'Failed to update route');
            }
        } catch (err) {
            console.error('Error updating route:', err);
            toast.error(err.message || 'Failed to update route');
        } finally {
            setIsUpdatingRoute(false);
        }
    };

    const handleEditOriginSelect = (location) => {
        setEditForm(prev => ({
            ...prev,
            originCity: location.city || location.name || '',
            originState: location.state || '',
            originAddress: location.address || '',
            originCoords: location.coordinates || { lat: 0, lng: 0 }
        }));
    };

    const handleEditDestSelect = (location) => {
        setEditForm(prev => ({
            ...prev,
            destCity: location.city || location.name || '',
            destState: location.state || '',
            destAddress: location.address || '',
            destCoords: location.coordinates || { lat: 0, lng: 0 }
        }));
    };

    const handleToggleStatus = async (routeId, currentStatus) => {
        const newStatus = !currentStatus;
        const action = newStatus ? 'activate' : 'deactivate';

        if (window.confirm(`Are you sure you want to ${action} this route?`)) {
            try {
                const response = await toggleRouteStatus(routeId, newStatus, token);

                if (response.success) {
                    setRoutes(prevRoutes =>
                        prevRoutes.map(route =>
                            route.id === routeId ? {
                                ...route,
                                isActive: newStatus,
                                status: newStatus ? 'Active' : 'Inactive'
                            } : route
                        )
                    );
                    toast.success(`Route ${action}d successfully!`);
                } else {
                    throw new Error(response.message || `Failed to ${action} route`);
                }
            } catch (err) {
                console.error(`Error ${action}ing route:`, err);
                toast.error(`Failed to ${action} route`);
            }
        }
    };

    const saveInsertedStop = () => {
        if (!insertStopForm.city) {
            toast.error('City is required');
            return;
        }
            // State is required
    if (!insertStopForm.state || insertStopForm.state.trim() === '') {
        toast.error('State is required');
        return;
    }

    // Address is required
    if (!insertStopForm.address || insertStopForm.address.trim() === '') {
        toast.error('Address is required');
        return;
    }

    // Terminal is required
    if (!insertStopForm.terminal || insertStopForm.terminal.trim() === '') {
        toast.error('Terminal is required');
        return;
    }
        if (!insertStopForm.arrivalTime) {
            toast.error('Arrival time is required');
            return;
        }
        const isManualLocation = insertStopForm.isManualStop;
        if (isManualLocation && (!insertStopForm.manualDistFromPrev || parseFloat(insertStopForm.manualDistFromPrev) <= 0)) {
            toast.error('For manual stops, please provide distance from previous stop');
            return;
        }

        let stopType = 'none';
        if (insertStopForm.isBoarding && insertStopForm.isDropping) stopType = 'both';
        else if (insertStopForm.isBoarding) stopType = 'boarding';
        else if (insertStopForm.isDropping) stopType = 'dropping';

        const type = activeRouteTab === 'UP' ? 'up' : 'down';
        const currentStops = type === 'up' ? [...upStops] : [...downStops];

        let manualDistFromPrev = isManualLocation ? parseFloat(insertStopForm.manualDistFromPrev) : null;
        let manualDistToNext = insertStopForm.manualDistToNext ? parseFloat(insertStopForm.manualDistToNext) : null;

        let distanceFromOrigin = 0;
        if (pendingInsertIndex > 0 && currentStops[pendingInsertIndex - 1]) {
            distanceFromOrigin = (currentStops[pendingInsertIndex - 1].distanceFromOrigin || 0) + (manualDistFromPrev || 0);
        } else {
            distanceFromOrigin = manualDistFromPrev || 0;
        }

        const newStop = {
            city: insertStopForm.city,
            state: insertStopForm.state || '',
            address: insertStopForm.address || `${insertStopForm.city}, ${insertStopForm.state || 'India'}`,
            terminal: insertStopForm.terminal || `${insertStopForm.city} Bus Stand`,
            arrivalTime: insertStopForm.arrivalTime,
            departureTime: insertStopForm.departureTime || insertStopForm.arrivalTime,
            stopType,
            coordinates: isManualLocation ? { lat: 0, lng: 0 } : null,
            manualDistFromPrev,
            manualDistToNext,
            distanceFromOrigin,
            isManualStop: isManualLocation
        };

        currentStops.splice(pendingInsertIndex, 0, newStop);
        setIsDistanceCalculated(prev => ({ ...prev, [type]: false }));

        if (type === 'up') {
            setUpStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
        } else {
            setDownStops(currentStops.map((s, i) => ({ ...s, sequence: i + 1 })));
        }

        toast.success(`Stop "${insertStopForm.city}" inserted at position ${pendingInsertIndex + 1}`);
        setShowStopInsertModal(false);
        setPendingInsertIndex(null);
        setInsertCitySuggestions([]);
        setShowInsertCityDropdown(false);
    };

    const handleDeleteRoute = async (routeId) => {
        if (window.confirm('Are you sure you want to delete this route?')) {
            try {
                const response = await deleteRoute(routeId, token);

                if (response.success) {
                    setRoutes(prevRoutes => prevRoutes.filter(route => route.id !== routeId));
                    setTotalRoutes(prev => prev - 1);
                    toast.success('Route deleted successfully!');
                } else {
                    throw new Error(response.message || 'Failed to delete route');
                }
            } catch (err) {
                console.error('Error deleting route:', err);
                toast.error('Failed to delete route');
            }
        }
    };

    const renderInsertButton = (idx, type = 'up') => {
        const isOpen = inlineInsertIndex === idx;
        const stops = getActiveStops();

        return (
            <div key={`insert-wrap-${idx}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '8px 0' }}>
                <div style={{ width: 2, height: 16, background: 'rgba(0,0,0,.12)', flexShrink: 0 }} />

                <button
                    onClick={() => {
                        if (isOpen) {
                            setInlineInsertIndex(null);
                            setInlineInsertCitySuggestions([]);
                            setShowInlineInsertDropdown(false);
                        } else {
                            let defaultState = '';
                            const currentStops = type === 'up' ? upStops : downStops;
                            if (idx > 0 && currentStops[idx - 1]?.state) {
                                defaultState = currentStops[idx - 1].state;
                            } else if (newRoute.upOriginState) {
                                defaultState = newRoute.upOriginState;
                            }

                            setInlineInsertForm({
                                city: '', state: defaultState, address: '', terminal: '',
                                arrivalTime: '', departureTime: '',
                                isBoarding: false, isDropping: false,
                                manualDistFromPrev: '', manualDistToNext: '',
                                isManual: true,
                                stopType: 'none'
                            });
                            setInlineInsertCitySuggestions([]);
                            setShowInlineInsertDropdown(false);
                            setInlineInsertIndex(idx);
                        }
                    }}
                    style={{
                        display: 'flex', alignItems: 'center', gap: 6,
                        padding: '5px 14px', borderRadius: 999,
                        border: `1.5px ${isOpen ? 'solid' : 'dashed'} ${isOpen ? '#378add' : 'rgba(0,0,0,.25)'}`,
                        background: isOpen ? '#e6f1fb' : 'var(--color-background-primary, #fff)',
                        fontSize: 12, fontWeight: 500,
                        color: isOpen ? '#185fa5' : 'var(--color-text-secondary, #666)',
                        cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all .15s'
                    }}
                >
                    <span style={{ fontSize: 15 }}>{isOpen ? '✕' : '+'}</span>
                    {isOpen ? 'Cancel insert' : 'Insert stop here'}
                </button>

                <div style={{ width: 2, height: isOpen ? 0 : 16, background: 'rgba(0,0,0,.12)', flexShrink: 0 }} />

                {isOpen && renderInlineInsertPanel(idx)}
            </div>
        );
    };

    // Stats
    const activeRoutes = routes.filter(r => r.isActive).length;
    const totalDistance = routes.reduce((sum, route) => sum + (parseInt(route.distance) || 0), 0);
    const totalStops = routes.reduce((sum, route) => sum + (parseInt(route.stops) || 0), 0);

    if (loading && routes.length === 0) {
        return (
            <div className="management-page">
                <div className="page-header">
                    <div className="skeleton-header-title"></div>
                    <div className="header-actions">
                        <div className="skeleton-search"></div>
                        <div className="skeleton-button"></div>
                        <div className="skeleton-button"></div>
                    </div>
                </div>

                <div className="stats-cards">
                    {[1, 2, 3, 4].map((i) => (
                        <SkeletonStatsCard key={i} />
                    ))}
                </div>

                <SkeletonTable />

                <div className="pagination-container">
                    <div className="skeleton-pagination-info"></div>
                    <div className="skeleton-pagination-controls"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="management-page">
            <div className="page-header">
                <h1>Route Management</h1>
                <div className="header-actions">
                    <div className="filter-group">
                        <input
                            type="text"
                            placeholder="Search routes by name..."
                            className="search-input"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="filter-group">
                        <div className="location-input-container" style={{ minWidth: '200px' }}>
                            <input
                                type="text"
                                placeholder="Filter by Origin City"
                                className="search-input"
                                value={filterOrigin}
                                onChange={(e) => {
                                    setFilterOrigin(e.target.value);
                                    searchCitySuggestions(e.target.value, 'origin');
                                }}
                                onFocus={() => filterOrigin && setShowOriginSuggestions(true)}
                                onBlur={() => setTimeout(() => setShowOriginSuggestions(false), 200)}
                            />
                            {showOriginSuggestions && originSuggestions.length > 0 && (
                                <div className="location-suggestions" style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000 }}>
                                    {originSuggestions.map((suggestion, idx) => (
                                        <div
                                            key={idx}
                                            className="suggestion-item"
                                            onClick={() => {
                                                setFilterOrigin(suggestion.city);
                                                setShowOriginSuggestions(false);
                                                setCurrentPage(1);
                                            }}
                                        >
                                            {suggestion.city}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="filter-group">
                        <div className="location-input-container" style={{ minWidth: '200px' }}>
                            <input
                                type="text"
                                placeholder="Filter by Destination City"
                                className="search-input"
                                value={filterDestination}
                                onChange={(e) => {
                                    setFilterDestination(e.target.value);
                                    searchCitySuggestions(e.target.value, 'destination');
                                }}
                                onFocus={() => filterDestination && setShowDestSuggestions(true)}
                                onBlur={() => setTimeout(() => setShowDestSuggestions(false), 200)}
                            />
                            {showDestSuggestions && destSuggestions.length > 0 && (
                                <div className="location-suggestions" style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000 }}>
                                    {destSuggestions.map((suggestion, idx) => (
                                        <div
                                            key={idx}
                                            className="suggestion-item"
                                            onClick={() => {
                                                setFilterDestination(suggestion.city);
                                                setShowDestSuggestions(false);
                                                setCurrentPage(1);
                                            }}
                                        >
                                            {suggestion.city}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                    <button className="refresh-btn" onClick={fetchRoutes}>
                        Refresh
                    </button>
                    <button className="add-btn" onClick={() => setShowAddModal(true)}>
                        + Add Route
                    </button>
                </div>
            </div>

            <div className="stats-cards">
                <div className="stat-card">
                    <h3>Total Routes</h3>
                    <p>{totalRoutes}</p>
                    <span>All registered routes</span>
                </div>
                <div className="stat-card">
                    <h3>Active Routes</h3>
                    <p>{activeRoutes}</p>
                    <span>Currently active</span>
                </div>
                <div className="stat-card">
                    <h3>Total Stops</h3>
                    <p>{totalStops}</p>
                    <span>Across all routes</span>
                </div>
                <div className="stat-card">
                    <h3>Total Distance</h3>
                    <p>{totalDistance} km</p>
                    <span>Covered by all routes</span>
                </div>
            </div>

            <div className="table-container">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th>Route Name</th>
                            <th>Local Route Name</th>
                            <th>Origin</th>
                            <th>Destination</th>
                            <th>Distance</th>
                            <th>Stops</th>
                            <th>Assigned Buses</th>
                            <th>Type</th>
                            <th>Status</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {routes.map(route => (
                            <tr key={route.id}>
                                <td>{route.serialNo}</td>
                                <td>{route.routeName}</td>
                                <td>{route.localRouteName || '—'}</td>
                                <td>
                                    <div>
                                        <div>{route.originCity}</div>
                                        <div style={{ fontSize: '12px', color: '#666' }}>
                                            {route.departureTime}
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div>
                                        <div>{route.destinationCity}</div>
                                        <div style={{ fontSize: '12px', color: '#666' }}>
                                            {route.arrivalTime}
                                        </div>
                                    </div>
                                </td>
                                <td>{route.distance} km</td>
                                <td>{route.stops}</td>
                                <td>
                                    {route.associatedBuses && route.associatedBuses.length > 0 ? (
                                        <div className="buses-container">
                                            {route.associatedBuses.map((bus, idx) => {
                                                const isPending = !bus.isActive && (bus.approvalStatus === 'pending' || !bus.approvalStatus);

                                                return (
                                                    <div key={bus.busId || idx} className="bus-item">
                                                        <div className="bus-info-wrapper">
                                                            <span className="bus-name">{bus.busName}</span>
                                                            <span className="bus-number">({bus.busNumber})</span>
                                                            {bus.localRouteName && (
                                                                <span className="bus-local-name"> - {bus.localRouteName}</span>
                                                            )}
                                                            <span className={`bus-status-badge ${bus.isActive ? 'active' : (bus.approvalStatus === 'pending' ? 'pending' : 'inactive')}`}>
                                                                {bus.isActive ? 'Active' : (bus.approvalStatus === 'pending' ? 'Pending Approval' : 'Inactive')}
                                                            </span>
                                                        </div>
                                                        {isPending && (
                                                            <button
                                                                className="activate-bus-inline"
                                                                onClick={() => handleActivateSingleBus(bus)}
                                                                style={{
                                                                    marginLeft: '10px',
                                                                    padding: '4px 12px',
                                                                    fontSize: '11px',
                                                                    backgroundColor: '#20c997',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                Activate
                                                            </button>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <span className="no-buses">No buses assigned</span>
                                    )}
                                </td>
                                <td>
                                    <span className={`route-type-badge ${route.isRoundTrip ? 'roundtrip' : 'oneway'}`}>
                                        {route.isRoundTrip ? 'Round Trip' : 'One Way'}
                                    </span>
                                </td>
                                <td>
                                    <span className={`status-badge ${route.status.toLowerCase()}`}>
                                        {route.status}
                                    </span>
                                </td>
                                <td>
                                    <div className="action-buttons">
                                        <button
                                            className="action-btn view"
                                            onClick={() => handleViewRoute(route)}
                                        >
                                            View
                                        </button>
                                        <button
                                            className="action-btn edit"
                                            onClick={() => handleEditRoute(route)}
                                            style={{ backgroundColor: '#17a2b8', color: 'white' }}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className={`action-btn ${route.isActive ? 'deactivate' : 'activate'}`}
                                            onClick={() => handleToggleStatus(route.id, route.isActive)}
                                            style={{
                                                backgroundColor: route.isActive ? '#ffc107' : '#28a745',
                                                color: route.isActive ? '#000' : 'white'
                                            }}
                                        >
                                            {route.isActive ? 'Deactivate' : 'Activate'}
                                        </button>

                                        {route.associatedBuses && route.associatedBuses.some(bus => !bus.isActive && (bus.approvalStatus === 'pending' || !bus.approvalStatus)) && (
                                            <button
                                                className="action-btn activate-bus"
                                                onClick={() => handleActivateBusFromRoute(route)}
                                                style={{ backgroundColor: '#20c997', color: 'white' }}
                                                title="Activate pending buses on this route"
                                            >
                                                Activate Bus
                                            </button>
                                        )}

                                        <button
                                            className="action-btn delete"
                                            onClick={() => handleDeleteRoute(route.id)}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination-container">
                <div className="pagination-info">
                    Showing {Math.min(pageSize, routes.length)} of {totalRoutes} routes
                    (Page {currentPage} of {totalPages})
                </div>
                <div className="pagination-controls">
                    <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>

                    <div className="page-numbers">
                        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                            let pageNumber;
                            if (totalPages <= 5) {
                                pageNumber = i + 1;
                            } else if (currentPage <= 3) {
                                pageNumber = i + 1;
                            } else if (currentPage >= totalPages - 2) {
                                pageNumber = totalPages - 4 + i;
                            } else {
                                pageNumber = currentPage - 2 + i;
                            }

                            return (
                                <button
                                    key={pageNumber}
                                    className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
                                    onClick={() => setCurrentPage(pageNumber)}
                                >
                                    {pageNumber}
                                </button>
                            );
                        })}
                    </div>

                    <button
                        className="pagination-btn"
                        onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                        disabled={currentPage === totalPages || totalPages === 0}
                    >
                        Next
                    </button>
                </div>
            </div>

            {/* Add Route Modal */}
            {showAddModal && (
                <div className="modal-overlay add-route-modal" onClick={() => setShowAddModal(false)}>
                    <div className="modal-content add-route-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Create New Route</h3>
                            <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>×</button>
                        </div>

                        <div className="modal-body">
                            {/* Round Trip Toggle */}
                            {/* Round Trip Toggle */}
                            <div className="round-trip-toggle">
                                <label className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        checked={isRoundTrip}
                                        onChange={(e) => toggleRoundTrip(e.target.checked)}
                                        className="checkbox-input"
                                    />
                                    <span className="checkbox-label">Round Trip (Main + Return Routes)</span>
                                </label>
                            </div>

                            {/* Tabs for Round Trip */}
                            {isRoundTrip && (
                                <div className="route-tabs">
                                    <button
                                        className={`route-tab ${activeRouteTab === 'UP' ? 'active' : ''}`}
                                        onClick={() => handleTabSwitch('UP')}
                                    >
                                        UP (Main) Route
                                    </button>
                                    <button
                                        className={`route-tab ${activeRouteTab === 'DOWN' ? 'active' : ''}`}
                                        onClick={() => handleTabSwitch('DOWN')}
                                    >
                                        DOWN (Return) Route
                                    </button>
                                    <button
                                        className="route-tab clear-tab"
                                        onClick={clearCurrentRoute}
                                        style={{
                                            marginLeft: 'auto',
                                            backgroundColor: '#dc3545',
                                            color: 'white',
                                            border: 'none',
                                            padding: '6px 16px',
                                            borderRadius: '4px',
                                            fontSize: '13px',
                                            fontWeight: '500',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.2s'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#c82333'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#dc3545'}
                                        title={`Clear all data for ${activeRouteTab} route`}
                                    >
                                        ✕ Clear {activeRouteTab} Route
                                    </button>
                                </div>
                            )}

                            <div className="form-sections">
                                <div className="form-section">
                                    <h4>Route Identity</h4>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Select Master Route *</label>
                                            <MasterRouteSelector
                                                token={token}
                                                value={selectedMasterRouteFromDropdown}
                                                onChange={(masterRoute) => {
                                                    setSelectedMasterRouteFromDropdown(masterRoute);
                                                    if (masterRoute) {
                                                        autoFillFromMasterRoute(masterRoute);
                                                    } else {
                                                        setNewRoute(prev => ({ ...prev, routeName: '' }));
                                                    }
                                                }}
                                                onAddNew={handleAddNewMasterRoute}
                                            />
                                            <small className="helper-text">
                                                {selectedMasterRouteFromDropdown
                                                    ? `✓ Route name set to: "${selectedMasterRouteFromDropdown.masterRouteName}"`
                                                    : 'Select a master route to auto-fill all route details, or click + New Master Route to create one first'}
                                            </small>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Local Route Name</label>
                                            <input
                                                type="text"
                                                value={newRoute.localRouteName}
                                                onChange={(e) => setNewRoute(prev => ({ ...prev, localRouteName: e.target.value }))}
                                                placeholder="Enter local/regional name for this route (e.g., 'City Express', 'Night Special')"
                                                className="form-input"
                                            />
                                            <small className="helper-text">This name will be displayed to passengers as the local route identifier</small>
                                        </div>
                                    </div>
                                </div>

                                {/* Origin Section */}
                                <div className="form-section">
                                    <h4>{activeRouteTab === 'UP' ? 'Origin *' : 'Return Origin (Locked to Main Dest)'}</h4>

                                    {activeRouteTab === 'UP' ? (
                                        <>
                                            <div className="form-row">
                                                <div className="form-group full-width">
                                                    <label>Search Location</label>
                                                    <LocationInput
                                                        value={newRoute.upOriginCity}
                                                        onChange={(value) => setNewRoute(prev => ({ ...prev, upOriginCity: value }))}
                                                        onLocationSelect={handleSelectOrigin}
                                                        placeholder="Search origin city or address..."
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>Address</label>
                                                    <input
                                                        type="text"
                                                        value={newRoute.upOriginAddress}
                                                        onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginAddress: e.target.value }))}
                                                        placeholder="Full address"
                                                        className="form-input"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>State</label>
                                                    <input
                                                        type="text"
                                                        value={newRoute.upOriginState}
                                                        onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginState: e.target.value }))}
                                                        placeholder="State"
                                                        className="form-input"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Terminal</label>
                                                    <input
                                                        type="text"
                                                        value={newRoute.upOriginTerminal}
                                                        onChange={(e) => setNewRoute(prev => ({ ...prev, upOriginTerminal: e.target.value }))}
                                                        placeholder="Terminal name"
                                                        className="form-input"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <Checkbox
                                                    label="Multi-Trip Route (Multiple departures per day)"
                                                    checked={isMultiTrip}
                                                    onChange={() => {
                                                        setIsMultiTrip(!isMultiTrip);
                                                        if (!isMultiTrip && timeSlots.length === 0) {
                                                            setTimeSlots([{
                                                                sequence: 1,
                                                                departureTime: newRoute.upOriginDepTime || '',
                                                                arrivalTime: '',
                                                                fareMultiplier: 1.0,
                                                                isActive: true
                                                            }]);
                                                            setNumberOfTrips(1);
                                                        }
                                                    }}
                                                />
                                            </div>

                                            {isMultiTrip ? (
                                                <TimeSlotManager
                                                    timeSlots={timeSlots}
                                                    onTimeSlotsChange={setTimeSlots}
                                                    numberOfTrips={numberOfTrips}
                                                    onNumberOfTripsChange={setNumberOfTrips}
                                                    disabled={false}
                                                    showDeparture={true}
                                                    showArrival={false}
                                                    labelPrefix="Trip"
                                                />
                                            ) : (
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Departure Time *</label>
                                                        <TimePicker
                                                            value={newRoute.upOriginDepTime}
                                                            onChange={(value) => {
                                                                setNewRoute(prev => ({ ...prev, upOriginDepTime: value }));
                                                            }}
                                                            placeholder="Select time"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className="locked-fields">
                                            <div className="form-row">
                                                <div className="form-group full-width">
                                                    <input
                                                        type="text"
                                                        value={newRoute.upDestCity || 'Auto-filled from Main Destination'}
                                                        className="form-input locked"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            {isMultiTrip ? (
                                                <TimeSlotManager
                                                    timeSlots={returnOriginTimeSlots}
                                                    onTimeSlotsChange={(slots) => {
                                                        setReturnOriginTimeSlots(slots);
                                                    }}
                                                    numberOfTrips={returnOriginTimeSlots.length || numberOfTrips}
                                                    onNumberOfTripsChange={(count) => {
                                                        const newSlots = Array.from({ length: count }, (_, i) => ({
                                                            sequence: i + 1,
                                                            departureTime: returnOriginTimeSlots[i]?.departureTime || '',
                                                            arrivalTime: '',
                                                            fareMultiplier: 1.0,
                                                            isActive: true
                                                        }));
                                                        setReturnOriginTimeSlots(newSlots);
                                                    }}
                                                    disabled={false}
                                                    showDeparture={true}
                                                    showArrival={false}
                                                    labelPrefix="Return Trip"
                                                />
                                            ) : null}
                                        </div>
                                    )}
                                </div>

                                {/* Destination Section */}
                                <div className="form-section">
                                    <h4>{activeRouteTab === 'UP' ? 'Destination *' : 'Return Destination (Locked to Main Origin)'}</h4>

                                    {activeRouteTab === 'UP' ? (
                                        <>
                                            <div className="form-row">
                                                <div className="form-group full-width">
                                                    <label>Search Location</label>
                                                    <LocationInput
                                                        value={newRoute.upDestCity}
                                                        onChange={(value) => setNewRoute(prev => ({ ...prev, upDestCity: value }))}
                                                        onLocationSelect={handleSelectDest}
                                                        placeholder="Search destination city or address..."
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>Address</label>
                                                    <input
                                                        type="text"
                                                        value={newRoute.upDestAddress}
                                                        onChange={(e) => setNewRoute(prev => ({ ...prev, upDestAddress: e.target.value }))}
                                                        placeholder="Full address"
                                                        className="form-input"
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>State</label>
                                                    <input
                                                        type="text"
                                                        value={newRoute.upDestState}
                                                        onChange={(e) => setNewRoute(prev => ({ ...prev, upDestState: e.target.value }))}
                                                        placeholder="State"
                                                        className="form-input"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Terminal</label>
                                                    <input
                                                        type="text"
                                                        value={newRoute.upDestTerminal}
                                                        onChange={(e) => setNewRoute(prev => ({ ...prev, upDestTerminal: e.target.value }))}
                                                        placeholder="Terminal name"
                                                        className="form-input"
                                                    />
                                                </div>
                                            </div>
                                            {isMultiTrip ? (
                                                <TimeSlotManager
                                                    timeSlots={destinationTimeSlots}
                                                    onTimeSlotsChange={setDestinationTimeSlots}
                                                    numberOfTrips={destinationNumberOfTrips}
                                                    onNumberOfTripsChange={setDestinationNumberOfTrips}
                                                    disabled={false}
                                                    showDeparture={false}
                                                    showArrival={true}
                                                    labelPrefix="Trip"
                                                />
                                            ) : (
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Arrival Time *</label>
                                                        <TimePicker
                                                            value={newRoute.upDestArrTime}
                                                            onChange={(value) => {
                                                                setNewRoute(prev => ({ ...prev, upDestArrTime: value }));
                                                            }}
                                                            placeholder="Select time"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className="locked-fields">
                                            <div className="form-row">
                                                <div className="form-group full-width">
                                                    <input
                                                        type="text"
                                                        value={newRoute.upOriginCity || 'Auto-filled from Main Origin'}
                                                        className="form-input locked"
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                            {isMultiTrip ? (
                                                <TimeSlotManager
                                                    timeSlots={returnDestTimeSlots}
                                                    onTimeSlotsChange={(slots) => {
                                                        setReturnDestTimeSlots(slots);
                                                    }}
                                                    numberOfTrips={returnDestTimeSlots.length || numberOfTrips}
                                                    onNumberOfTripsChange={(count) => {
                                                        const newSlots = Array.from({ length: count }, (_, i) => ({
                                                            sequence: i + 1,
                                                            arrivalTime: returnDestTimeSlots[i]?.arrivalTime || '',
                                                            departureTime: '',
                                                            fareMultiplier: 1.0,
                                                            isActive: true
                                                        }));
                                                        setReturnDestTimeSlots(newSlots);
                                                    }}
                                                    disabled={false}
                                                    showDeparture={false}
                                                    showArrival={true}
                                                    labelPrefix="Return Trip"
                                                />
                                            ) : null}
                                        </div>
                                    )}
                                </div>

                                {/* Intermediate Stops Section */}
                                <div className="form-section stops-section">
                                    <h4>Intermediate Stops ({activeRouteTab})</h4>

                                    {isMultiTrip && (
                                        <div style={{
                                            marginBottom: '16px',
                                            padding: '12px 16px',
                                            backgroundColor: '#e3f2fd',
                                            borderRadius: '8px',
                                            border: '1px solid #90caf9',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            flexWrap: 'wrap',
                                            gap: '10px'
                                        }}>
                                            <div>
                                                <span style={{ fontSize: '13px', fontWeight: '500', color: '#0d47a1' }}>
                                                    🚍 Number of Trips per Day:
                                                </span>
                                                <span style={{
                                                    marginLeft: '8px',
                                                    fontSize: '16px',
                                                    fontWeight: 'bold',
                                                    color: '#1565c0',
                                                    backgroundColor: '#bbdefb',
                                                    padding: '4px 12px',
                                                    borderRadius: '20px',
                                                    display: 'inline-block'
                                                }}>
                                                    {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}
                                                </span>
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#1565c0' }}>
                                                ⏰ Each stop needs timings for all {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (window.confirm(`This will set default timings (00:00) for all ${numberOfTrips} trips at all stops. Continue?`)) {
                                                        const currentStops = getActiveStops();
                                                        const updatedStops = currentStops.map(stop => ({
                                                            ...stop,
                                                            timings: timeSlots.map(slot => ({
                                                                timeSlotSequence: slot.sequence,
                                                                sequence: stop.sequence,
                                                                arrivalTime: '',
                                                                departureTime: ''
                                                            }))
                                                        }));
                                                        setActiveStops(updatedStops);
                                                        toast.info(`Timings initialized for all ${currentStops.length} stops`);
                                                    }
                                                }}
                                                style={{
                                                    padding: '4px 12px',
                                                    fontSize: '11px',
                                                    backgroundColor: '#1565c0',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Initialize All Stops
                                            </button>
                                        </div>
                                    )}

                                    {activeRouteTab === 'DOWN' && (
                                        <button
                                            className="sync-btn"
                                            onClick={() => syncDownStopsWithUpStops(true)}
                                        >
                                            🔄 Auto-Fill / Sync Reversed Stops from UP Route
                                        </button>
                                    )}

                                    <div className="stops-list">
                                        {getActiveStops().length > 0 && renderInsertButton(0, activeRouteTab === 'UP' ? 'up' : 'down')}

                                        {getActiveStops().map((stop, index) => {
                                            // Calculate distance display
                                            const displayManualDist = calculateManualDistFromPrev(getActiveStops(), index);
                                            const distanceDisplay = displayManualDist ||
                                                (typeof stop.distanceFromOrigin === 'number'
                                                    ? stop.distanceFromOrigin.toFixed(2)
                                                    : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));

                                            const hasMultiTimings = stop.timings && stop.timings.length > 0;
                                            const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];

                                            return (
                                                <React.Fragment key={index}>
                                                    <div className={`stop-list-item ${(activeRouteTab === 'UP' ? editUpIndex : editDownIndex) === index ? 'editing-highlight' : ''}`}>
                                                        <div className="stop-info">
                                                            <div className="stop-name">
                                                                {index + 1}. {stop.city}
                                                                <span className="stop-distance">
                                                                    ({distanceDisplay} km)
                                                                </span>
                                                            </div>

                                                            {/* ========== DISPLAY MULTI-TRIP TIMINGS ========== */}
                                                            {hasMultiTimings && sortedTimings.length > 0 ? (
                                                                <div className="stop-multi-times" style={{ marginTop: '8px', marginBottom: '8px' }}>
                                                                    {sortedTimings.map((timing, idx) => (
                                                                        <div key={timing.timeSlotSequence || idx} style={{
                                                                            display: 'inline-flex', alignItems: 'center', gap: '8px',
                                                                            backgroundColor: '#e9ecef', padding: '4px 10px',
                                                                            borderRadius: '16px', margin: '2px 4px', fontSize: '11px'
                                                                        }}>
                                                                            <span style={{ fontWeight: '500' }}>Trip {timing.timeSlotSequence || idx + 1}:</span>
                                                                            <span>Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
                                                                            <span>→</span>
                                                                            <span>Dep {TimeDisplay({ time: timing.departureTime })}</span>
                                                                        </div>
                                                                    ))}
                                                                    {stop.stopType && stop.stopType !== 'none' && (
                                                                        <span style={{
                                                                            display: 'inline-flex', alignItems: 'center',
                                                                            marginLeft: '8px', fontSize: '11px', fontWeight: '500',
                                                                            padding: '2px 8px', borderRadius: '12px',
                                                                            backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
                                                                                : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
                                                                            color: stop.stopType === 'boarding' ? '#1565c0'
                                                                                : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
                                                                            border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
                                                                                : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
                                                                        }}>
                                                                            {stop.stopType === 'boarding' ? '🟢 Boarding'
                                                                                : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="stop-times" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                                    <span>Arr: {stop.arrivalTime || 'TBD'} • Dep: {stop.departureTime || 'N/A'}</span>
                                                                    {stop.stopType && stop.stopType !== 'none' && (
                                                                        <span style={{
                                                                            fontSize: '11px', fontWeight: '500',
                                                                            padding: '2px 8px', borderRadius: '12px',
                                                                            backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
                                                                                : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
                                                                            color: stop.stopType === 'boarding' ? '#1565c0'
                                                                                : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
                                                                            border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
                                                                                : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
                                                                        }}>
                                                                            {stop.stopType === 'boarding' ? '🟢 Boarding'
                                                                                : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="stop-actions">
                                                            <button
                                                                className="stop-action-btn edit"
                                                                onClick={() => {
                                                                    setEditingStopIndex(index);
                                                                    handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down');
                                                                }}
                                                            >
                                                                Edit
                                                            </button>
                                                            <button
                                                                className="stop-action-btn delete"
                                                                onClick={() => handleDeleteStop(index)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {renderInsertButton(index + 1, activeRouteTab === 'UP' ? 'up' : 'down')}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>

                                    {/* Stop Form */}
                                    <div className="stop-form">
                                        <h5>
                                            {editingStopIndex !== null ? `Edit Stop #${editingStopIndex + 1}` :
                                                insertIndex !== null ? `Insert Stop at #${insertIndex + 1}` :
                                                    'Add Stop at End'}
                                        </h5>

                                        {insertIndex !== null && (
                                            <button className="cancel-insert-btn" onClick={() => setInsertIndex(null)}>
                                                Cancel Insert
                                            </button>
                                        )}

                                        {isMultiTrip && editingStopIndex !== null && (
                                            <div style={{
                                                marginBottom: '16px',
                                                padding: '8px 12px',
                                                backgroundColor: '#fff3cd',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                color: '#856404'
                                            }}>
                                                💡 This stop has {numberOfTrips} trip{numberOfTrips !== 1 ? 's' : ''}. Set timings for each trip below.
                                            </div>
                                        )}

                                        <div className="form-row">
                                            <Checkbox
                                                label="Manually Typed Stop (No Map Suggestions)"
                                                checked={!isManualStop}
                                                onChange={() => {
                                                    setIsManualStop(!isManualStop);
                                                    if (!isManualStop) {
                                                        setNewRoute(prev => ({
                                                            ...prev,
                                                            stopCity: '',
                                                            stopCoords: null,
                                                            stopDistFromPrev: '',
                                                            stopDistToNext: '',
                                                            stopAddress: '',
                                                            stopState: '',
                                                            stopTerminal: ''
                                                        }));
                                                        setCitySuggestions([]);
                                                        setShowCityDropdown(false);
                                                    }
                                                }}
                                            />
                                        </div>

                                        {isManualStop ? (
                                            <>
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <label>Search Location</label>
                                                        <LocationInput
                                                            value={newRoute.stopCity}
                                                            onChange={(value) => setNewRoute(prev => ({ ...prev, stopCity: value }))}
                                                            onLocationSelect={handleSelectStop}
                                                            placeholder="Search stop city or address..."
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <label>Address</label>
                                                        <input
                                                            type="text"
                                                            value={newRoute.stopAddress}
                                                            onChange={(e) => setNewRoute(prev => ({ ...prev, stopAddress: e.target.value }))}
                                                            placeholder="Full address (e.g., NH-19, Near Bus Stand)"
                                                            className="form-input"
                                                        />
                                                        <small className="helper-text">Complete address of the stop location</small>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <label>Search City *</label>
                                                        <div className="city-search-container" style={{ position: 'relative' }}>
                                                            <input
                                                                type="text"
                                                                value={newRoute.stopCity}
                                                                onChange={async (e) => {
                                                                    const value = toTitleCase(e.target.value);
                                                                    setNewRoute(prev => ({ ...prev, stopCity: value }));

                                                                    if (value !== newRoute.stopCity) {
                                                                        setNewRoute(prev => ({
                                                                            ...prev,
                                                                            stopAddress: '',
                                                                            stopState: '',
                                                                            stopTerminal: ''
                                                                        }));
                                                                    }

                                                                    if (value.length >= 2) {
                                                                        try {
                                                                            const response = await searchRouteIntermediateStops(token, value);
                                                                            if (response.success && response.cities && response.cities.length > 0) {
                                                                                setCitySuggestions(response.cities);
                                                                                setShowCityDropdown(true);
                                                                            } else {
                                                                                setCitySuggestions([]);
                                                                                setShowCityDropdown(false);
                                                                            }
                                                                        } catch (error) {
                                                                            console.error('Error searching cities:', error);
                                                                            setCitySuggestions([]);
                                                                            setShowCityDropdown(false);
                                                                        }
                                                                    } else {
                                                                        setCitySuggestions([]);
                                                                        setShowCityDropdown(false);
                                                                    }
                                                                }}
                                                                onFocus={() => {
                                                                    if (citySuggestions.length > 0) {
                                                                        setShowCityDropdown(true);
                                                                    }
                                                                }}
                                                                onBlur={() => {
                                                                    setTimeout(() => setShowCityDropdown(false), 200);
                                                                }}
                                                                placeholder="Type city name (min 2 characters)..."
                                                                className="form-input"
                                                            />
                                                            {showCityDropdown && citySuggestions.length > 0 && (
                                                                <div className="city-suggestions-dropdown" style={{
                                                                    position: 'absolute',
                                                                    top: '100%',
                                                                    left: 0,
                                                                    right: 0,
                                                                    backgroundColor: 'white',
                                                                    border: '1px solid #ddd',
                                                                    borderRadius: '4px',
                                                                    maxHeight: '200px',
                                                                    overflowY: 'auto',
                                                                    zIndex: 10000,
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                                                }}>
                                                                    {citySuggestions.map((city, idx) => (
                                                                        <div
                                                                            key={city.id || idx}
                                                                            onClick={() => {
                                                                                setNewRoute(prev => ({
                                                                                    ...prev,
                                                                                    stopCity: toTitleCase(city.name),
                                                                                    stopAddress: toTitleCase(city.address || city.name),
                                                                                    stopState: toTitleCase(city.state || ''),
                                                                                    stopTerminal: toTitleCase(city.terminal || `${city.name} Bus Stand`),
                                                                                    stopCoords: city.coordinates || null
                                                                                }));
                                                                                setShowCityDropdown(false);
                                                                                toast.success(`Auto-filled details for ${city.name}`);
                                                                            }}
                                                                            style={{
                                                                                padding: '10px 12px',
                                                                                cursor: 'pointer',
                                                                                borderBottom: '1px solid #f0f0f0',
                                                                                transition: 'background-color 0.2s'
                                                                            }}
                                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                                                        >
                                                                            <div style={{ fontWeight: '500' }}>{city.name}</div>
                                                                            <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                                                                {city.state}
                                                                                {city.terminal && ` • ${city.terminal}`}
                                                                            </div>
                                                                            <div style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>
                                                                                {city.address !== city.name ? city.address : ''}
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <small className="helper-text">Type at least 2 characters to search for cities from existing routes</small>
                                                    </div>
                                                </div>
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <label>Address *</label>
                                                        <input
                                                            type="text"
                                                            value={newRoute.stopAddress}
                                                            onChange={(e) => setNewRoute(prev => ({ ...prev, stopAddress: e.target.value }))}
                                                            placeholder="Complete address of the stop location"
                                                            className="form-input"
                                                        />
                                                        <small className="helper-text">Complete address of the stop location</small>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {(stopEditForm.isManualStop || isManualStop) && (
                                            <>
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <label>Distance from Previous Stop (km) *</label>
                                                        <input
                                                            type="number"
                                                            value={newRoute.stopDistFromPrev}
                                                            onChange={(e) => setNewRoute(prev => ({ ...prev, stopDistFromPrev: e.target.value }))}
                                                            placeholder="e.g., 50"
                                                            className="form-input"
                                                            min="0"
                                                            step="0.1"
                                                        />
                                                        <small className="helper-text">Required for manual stops</small>
                                                    </div>
                                                </div>

                                                {(() => {
                                                    const stops = getActiveStops();
                                                    const currentIndex = editingStopIndex !== null ? editingStopIndex :
                                                        (insertIndex !== null ? insertIndex : stops.length);
                                                    const nextStop = stops[currentIndex];
                                                    const isNextAuto = nextStop && nextStop.coordinates &&
                                                        (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
                                                    if (isNextAuto) {
                                                        return (
                                                            <div className="form-row">
                                                                <div className="form-group full-width">
                                                                    <label>Distance to Next Stop ({nextStop.city}) (km)</label>
                                                                    <input
                                                                        type="number"
                                                                        value={newRoute.stopDistToNext}
                                                                        onChange={(e) => setNewRoute(prev => ({ ...prev, stopDistToNext: e.target.value }))}
                                                                        placeholder={`Distance to ${nextStop.city}`}
                                                                        className="form-input"
                                                                        min="0"
                                                                        step="0.1"
                                                                    />
                                                                    <small className="helper-text">
                                                                        Optional - helps with distance calculation accuracy
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })()}
                                            </>
                                        )}

                                        <div className="form-row">
                                            <div className="form-group">
                                                <label>State</label>
                                                <input
                                                    type="text"
                                                    value={newRoute.stopState}
                                                    onChange={(e) => setNewRoute(prev => ({ ...prev, stopState: e.target.value }))}
                                                    placeholder="State"
                                                    className="form-input"
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Terminal</label>
                                                <input
                                                    type="text"
                                                    value={newRoute.stopTerminal}
                                                    onChange={(e) =>
                                                        setNewRoute(prev => ({
                                                            ...prev,
                                                            stopTerminal: toTitleCase(e.target.value),
                                                        }))
                                                    }
                                                    placeholder="Terminal name"
                                                    className="form-input"
                                                />
                                            </div>
                                        </div>

                                        {isMultiTrip ? (
                                            <StopTimingManager
                                                stop={{
                                                    sequence: editingStopIndex !== null ? editingStopIndex + 1 :
                                                        (insertIndex !== null ? insertIndex + 1 : getActiveStops().length + 1),
                                                    timings: newRoute.stopTimings || []
                                                }}
                                                timeSlots={timeSlots}
                                                onTimingUpdate={(stopSequence, timings) => {
                                                    setNewRoute(prev => ({ ...prev, stopTimings: timings }));
                                                }}
                                                disabled={false}
                                            />
                                        ) : (
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>Arrival Time *</label>
                                                    <TimePicker
                                                        value={newRoute.stopArrivalTime}
                                                        onChange={(value) => setNewRoute(prev => ({ ...prev, stopArrivalTime: value }))}
                                                        placeholder="Select time"
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Departure Time (Opt)</label>
                                                    <TimePicker
                                                        value={newRoute.stopDepartureTime}
                                                        onChange={(value) => setNewRoute(prev => ({ ...prev, stopDepartureTime: value }))}
                                                        placeholder="Select time"
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <div className="form-row checkbox-row">
                                            <Checkbox
                                                label="Boarding Point"
                                                checked={newRoute.isBoarding}
                                                onChange={() => setNewRoute(prev => ({ ...prev, isBoarding: !prev.isBoarding }))}
                                            />
                                            <Checkbox
                                                label="Dropping Point"
                                                checked={newRoute.isDropping}
                                                onChange={() => setNewRoute(prev => ({ ...prev, isDropping: !prev.isDropping }))}
                                            />
                                        </div>

                                        <button
                                            className="btn btn-secondary add-stop-btn"
                                            onClick={() => addIntermediateStop(activeRouteTab === 'UP' ? 'up' : 'down')}
                                            disabled={
                                                !newRoute.stopCity ||
                                                ((!isMultiTrip && !newRoute.stopArrivalTime) ||
                                                    (isMultiTrip && (!newRoute.stopTimings || newRoute.stopTimings.length === 0))) ||
                                                ((isManualStop || !newRoute.stopCoords) && (!newRoute.stopDistFromPrev || parseFloat(newRoute.stopDistFromPrev) <= 0))
                                            }
                                        >
                                            {editingStopIndex !== null ? 'Save Changes' :
                                                insertIndex !== null ? 'Confirm Insertion' :
                                                    '+ Append Stop'}
                                        </button>
                                    </div>
                                </div>
                                {/* Route Summary Section */}
                                <div className="form-section">
                                    <h4>{activeRouteTab} Summary</h4>

                                    <button
                                        className="btn btn-success calculate-btn"
                                        onClick={handleCalculateDistances}
                                        disabled={isCalculatingDistances}
                                    >
                                        {isCalculatingDistances ? 'Calculating...' : `Auto-Calculate Distances (${activeRouteTab})`}
                                    </button>

                                    {isLastStopManual() && (
                                        <div className="form-row" style={{ marginTop: '10px' }}>
                                            <div className="form-group full-width">
                                                <label>Distance from Last Stop to Destination (KM) *</label>
                                                <input
                                                    type="number"
                                                    value={activeRouteTab === 'UP' ? newRoute.upManualFinalLeg : newRoute.downManualFinalLeg}
                                                    onChange={(e) => setNewRoute(prev => ({
                                                        ...prev,
                                                        [activeRouteTab === 'UP' ? 'upManualFinalLeg' : 'downManualFinalLeg']: e.target.value
                                                    }))}
                                                    placeholder="Required because last stop is manual"
                                                    className="form-input"
                                                    min="0"
                                                    step="0.1"
                                                    style={{ borderColor: '#dc3545', backgroundColor: '#fff5f5' }}
                                                />
                                                <small className="helper-text" style={{ color: '#dc3545' }}>
                                                    ⚠️ The last stop is manual, so you must provide the distance to destination
                                                </small>
                                            </div>
                                        </div>
                                    )}

                                    <div className="form-row summary-fields">
                                        <div className="form-group">
                                            <label>Total Distance (KM)</label>
                                            <input
                                                type="number"
                                                value={activeRouteTab === 'UP' ? newRoute.upTotalDistance : newRoute.downTotalDistance}
                                                onChange={(e) => setNewRoute(prev => ({
                                                    ...prev,
                                                    [activeRouteTab === 'UP' ? 'upTotalDistance' : 'downTotalDistance']: e.target.value
                                                }))}
                                                className="form-input"
                                                min="0"
                                                step="0.1"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Est. Duration</label>
                                            <div className="duration-inputs">
                                                <input
                                                    type="number"
                                                    value={activeRouteTab === 'UP' ? newRoute.upDurationHours : newRoute.downDurationHours}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setNewRoute(prev => ({
                                                            ...prev,
                                                            [activeRouteTab === 'UP' ? 'upDurationHours' : 'downDurationHours']: value
                                                        }));
                                                    }}
                                                    className="form-input"
                                                    placeholder="Hours"
                                                    min="0"
                                                />
                                                <span>h</span>
                                                <input
                                                    type="number"
                                                    value={activeRouteTab === 'UP' ? newRoute.upDurationMinutes : newRoute.downDurationMinutes}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        let minutes = Math.min(59, Math.max(0, parseInt(value) || 0));
                                                        setNewRoute(prev => ({
                                                            ...prev,
                                                            [activeRouteTab === 'UP' ? 'upDurationMinutes' : 'downDurationMinutes']: minutes.toString()
                                                        }));
                                                    }}
                                                    className="form-input"
                                                    placeholder="Minutes"
                                                    min="0"
                                                    max="59"
                                                />
                                                <span>m</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div className="form-actions">
                                <button
                                    className="btn btn-primary save-route-btn"
                                    onClick={handleSaveRoute}
                                    disabled={
                                        isCreatingRoute ||
                                        !selectedMasterRouteFromDropdown ||
                                        !isDistanceCalculated.up ||
                                        (isRoundTrip && !isDistanceCalculated.down)
                                    }
                                >
                                    {isCreatingRoute ? 'Creating Route...' : 'Add Route'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* View Route Modal */}
            {viewingRoute && (
                <div className="modal-overlay" onClick={() => setViewingRoute(null)}>
                    <div className="modal-content1 view-route-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Route Details: {viewingRoute.routeName}</h3>
                            <button className="modal-close-btn" onClick={() => setViewingRoute(null)}>×</button>
                        </div>

                        <div className="modal-body view-modal-body">
                            <div className="route-details">
                                <div className="detail-row">
                                    <label>Route Name:</label>
                                    <span>{viewingRoute.routeName}</span>
                                </div>
                                <div className="detail-row">
                                    <label>Local Route Name:</label>
                                    <span>{viewingRoute.localRouteName || '—'}</span>
                                </div>
                                <div className="detail-row">
                                    <label>Route Type:</label>
                                    <span className={`route-type-badge ${viewingRoute.isRoundTrip ? 'roundtrip' : 'oneway'}`}>
                                        {viewingRoute.isRoundTrip ? 'Round Trip' : 'One Way'}
                                    </span>
                                </div>
                                <div className="detail-row">
                                    <label>Multi-Trip:</label>
                                    <span>{viewingRoute.isMultiTrip ? `Yes (${viewingRoute.numberOfTrips || viewingRoute.origin?.timings?.length || 1} trips per day)` : 'No'}</span>
                                </div>

                                <div className="detail-section">
                                    <h4>Origin</h4>
                                    <div className="detail-row"><label>City:</label><span>{viewingRoute.origin?.city}</span></div>
                                    <div className="detail-row"><label>State:</label><span>{viewingRoute.origin?.state}</span></div>
                                    <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.origin?.terminal}</span></div>

                                    {viewingRoute.origin?.timings && viewingRoute.origin.timings.length > 0 ? (
                                        <div className="detail-row">
                                            <label>Departure Times:</label>
                                            <div className="multi-trip-times">
                                                {viewingRoute.origin.timings.map((timing, idx) => (
                                                    <span key={idx} className="time-badge">
                                                        Trip {timing.timeSlotSequence}: {formatTime(timing.departureTime)}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="detail-row"><label>Departure Time:</label><span>{formatTime(viewingRoute.origin?.departureTime)}</span></div>
                                    )}

                                    {viewingRoute.origin?.address && (
                                        <div className="detail-row"><label>Address:</label><span className="address-text">{viewingRoute.origin.address}</span></div>
                                    )}
                                </div>

                                <div className="detail-section">
                                    <h4>Destination</h4>
                                    <div className="detail-row"><label>City:</label><span>{viewingRoute.destination?.city}</span></div>
                                    <div className="detail-row"><label>State:</label><span>{viewingRoute.destination?.state}</span></div>
                                    <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.destination?.terminal}</span></div>

                                    {viewingRoute.destination?.timings && viewingRoute.destination.timings.length > 0 ? (
                                        <div className="detail-row">
                                            <label>Arrival Times:</label>
                                            <div className="multi-trip-times">
                                                {viewingRoute.destination.timings.map((timing, idx) => (
                                                    <span key={idx} className="time-badge">
                                                        Trip {timing.timeSlotSequence}: {formatTime(timing.arrivalTime)}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="detail-row"><label>Arrival Time:</label><span>{formatTime(viewingRoute.destination?.arrivalTime)}</span></div>
                                    )}

                                    {viewingRoute.destination?.address && (
                                        <div className="detail-row"><label>Address:</label><span className="address-text">{viewingRoute.destination.address}</span></div>
                                    )}
                                </div>

                                {viewingRoute.intermediateStops && viewingRoute.intermediateStops.length > 0 && (
                                    <div className="detail-section">
                                        <h4>Intermediate Stops ({viewingRoute.intermediateStops.length})</h4>
                                        <div className="stops-list-container">
                                            {viewingRoute.intermediateStops.map((stop, index) => (
                                                <div key={index} className="stop-card">
                                                    <div className="stop-header">
                                                        <span className="stop-sequence">#{stop.sequence}</span>
                                                        <span className="stop-city">{stop.city}</span>
                                                        <span className={`stop-type-badge ${stop.stopType}`}>
                                                            {stop.stopType === 'both' ? 'Boarding & Dropping' :
                                                                stop.stopType === 'boarding' ? 'Boarding' :
                                                                    stop.stopType === 'dropping' ? 'Dropping' : 'Stop'}
                                                        </span>
                                                    </div>
                                                    <div className="stop-details">
                                                        <div className="stop-info"><span className="info-label">Distance:</span><span className="stop-distance">
                                                            ({typeof stop.distanceFromOrigin === 'number'
                                                                ? stop.distanceFromOrigin.toFixed(2)
                                                                : parseFloat(stop.distanceFromOrigin || 0).toFixed(2)} km)
                                                        </span></div>
                                                        <div className="stop-info"><span className="info-label">Terminal:</span><span>{stop.terminal}</span></div>

                                                        {stop.timings && stop.timings.length > 0 ? (
                                                            <div className="stop-info full-width">
                                                                <span className="info-label">Timings:</span>
                                                                <div className="multi-trip-times">
                                                                    {stop.timings.map((timing, idx) => (
                                                                        <div key={idx} className="timing-entry">
                                                                            <span className="time-badge">Trip {timing.timeSlotSequence}:</span>
                                                                            <span className="time-badge">Arr {formatTime(timing.arrivalTime)}</span>
                                                                            <span className="time-badge">Dep {formatTime(timing.departureTime)}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <>
                                                                <div className="stop-info"><span className="info-label">Arrival:</span><span className="time-badge">{formatTime(stop.arrivalTime)}</span></div>
                                                                <div className="stop-info"><span className="info-label">Departure:</span><span className="time-badge">{formatTime(stop.departureTime)}</span></div>
                                                            </>
                                                        )}

                                                        <div className="stop-info"><span className="info-label">State:</span><span>{stop.state}</span></div>
                                                        {stop.manualDistToNext && (
                                                            <div className="stop-info"><span className="info-label">To Next:</span><span>{stop.manualDistToNext} km</span></div>
                                                        )}
                                                        {stop.address && (
                                                            <div className="stop-info full-width"><span className="info-label">Address:</span><span className="address-text">{stop.address}</span></div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {viewingRoute.isRoundTrip && viewingRoute.returnJourney && (
                                    <div className="detail-section return-journey">
                                        <h4>Return Journey</h4>

                                        <div className="return-subsection">
                                            <h5>Return Origin</h5>
                                            <div className="detail-row"><label>City:</label><span>{viewingRoute.returnJourney.origin?.city}</span></div>
                                            <div className="detail-row"><label>State:</label><span>{viewingRoute.returnJourney.origin?.state}</span></div>
                                            <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.returnJourney.origin?.terminal}</span></div>

                                            {viewingRoute.returnJourney.origin?.timings && viewingRoute.returnJourney.origin.timings.length > 0 ? (
                                                <div className="detail-row">
                                                    <label>Departure Times:</label>
                                                    <div className="multi-trip-times">
                                                        {viewingRoute.returnJourney.origin.timings.map((timing, idx) => (
                                                            <span key={idx} className="time-badge">
                                                                Trip {timing.timeSlotSequence}: {formatTime(timing.departureTime)}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="detail-row"><label>Departure Time:</label><span>{formatTime(viewingRoute.returnJourney.origin?.departureTime)}</span></div>
                                            )}
                                        </div>

                                        <div className="return-subsection">
                                            <h5>Return Destination</h5>
                                            <div className="detail-row"><label>City:</label><span>{viewingRoute.returnJourney.destination?.city}</span></div>
                                            <div className="detail-row"><label>State:</label><span>{viewingRoute.returnJourney.destination?.state}</span></div>
                                            <div className="detail-row"><label>Terminal:</label><span>{viewingRoute.returnJourney.destination?.terminal}</span></div>

                                            {viewingRoute.returnJourney.destination?.timings && viewingRoute.returnJourney.destination.timings.length > 0 ? (
                                                <div className="detail-row">
                                                    <label>Arrival Times:</label>
                                                    <div className="multi-trip-times">
                                                        {viewingRoute.returnJourney.destination.timings.map((timing, idx) => (
                                                            <span key={idx} className="time-badge">
                                                                Trip {timing.timeSlotSequence}: {formatTime(timing.arrivalTime)}
                                                            </span>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="detail-row"><label>Arrival Time:</label><span>{formatTime(viewingRoute.returnJourney.destination?.arrivalTime)}</span></div>
                                            )}

                                            <div className="detail-row"><label>Distance:</label><span>{viewingRoute.returnJourney.routeDetails?.totalDistance} km</span></div>
                                        </div>

                                        {viewingRoute.returnJourney.intermediateStops?.length > 0 && (
                                            <div className="return-subsection">
                                                <h5>Return Stops ({viewingRoute.returnJourney.intermediateStops.length})</h5>
                                                <div className="stops-list-container">
                                                    {viewingRoute.returnJourney.intermediateStops.map((stop, index) => (
                                                        <div key={index} className="stop-card">
                                                            <div className="stop-header">
                                                                <span className="stop-sequence">#{stop.sequence}</span>
                                                                <span className="stop-city">{stop.city}</span>
                                                                <span className={`stop-type-badge ${stop.stopType}`}>
                                                                    {stop.stopType === 'both' ? 'Boarding & Dropping' :
                                                                        stop.stopType === 'boarding' ? 'Boarding' :
                                                                            stop.stopType === 'dropping' ? 'Dropping' : 'Stop'}
                                                                </span>
                                                            </div>
                                                            <div className="stop-details">
                                                                <div className="stop-info"><span className="info-label">Distance:</span><span className="stop-distance">
                                                                    ({typeof stop.distanceFromOrigin === 'number'
                                                                        ? stop.distanceFromOrigin.toFixed(2)
                                                                        : parseFloat(stop.distanceFromOrigin || 0).toFixed(2)} km)
                                                                </span></div>

                                                                {stop.timings && stop.timings.length > 0 ? (
                                                                    <div className="stop-info full-width">
                                                                        <span className="info-label">Timings:</span>
                                                                        <div className="multi-trip-times">
                                                                            {stop.timings.map((timing, idx) => (
                                                                                <div key={idx} className="timing-entry">
                                                                                    <span className="time-badge">Trip {timing.timeSlotSequence}:</span>
                                                                                    <span className="time-badge">Arr {formatTime(timing.arrivalTime)}</span>
                                                                                    <span className="time-badge">Dep {formatTime(timing.departureTime)}</span>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <>
                                                                        <div className="stop-info"><span className="info-label">Arrival:</span><span className="time-badge">{formatTime(stop.arrivalTime)}</span></div>
                                                                        <div className="stop-info"><span className="info-label">Departure:</span><span className="time-badge">{formatTime(stop.departureTime)}</span></div>
                                                                    </>
                                                                )}

                                                                <div className="stop-info"><span className="info-label">State:</span><span>{stop.state}</span></div>
                                                                {stop.address && (
                                                                    <div className="stop-info full-width"><span className="info-label">Address:</span><span className="address-text">{stop.address}</span></div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="detail-section">
                                    <h4>Route Details</h4>
                                    <div className="detail-row"><label>Total Distance:</label><span>{viewingRoute.routeDetails?.totalDistance} km</span></div>
                                    <div className="detail-row">
                                        <label>Estimated Duration:</label>
                                        <span>{viewingRoute.routeDetails?.estimatedDuration?.hours || 0}h {viewingRoute.routeDetails?.estimatedDuration?.minutes || 0}m</span>
                                    </div>
                                </div>

                                <div className="detail-section">
                                    <h4>Status Information</h4>
                                    <div className="detail-row">
                                        <label>Status:</label>
                                        <span className={`status-badge ${viewingRoute.isActive ? 'active' : 'inactive'}`}>
                                            {viewingRoute.isActive ? 'Active' : 'Inactive'}
                                        </span>
                                    </div>
                                    <div className="detail-row"><label>Created By:</label><span>{viewingRoute.creatorName} ({viewingRoute.creatorType})</span></div>
                                    <div className="detail-row"><label>Created At:</label><span>{new Date(viewingRoute.createdAt).toLocaleString()}</span></div>
                                    <div className="detail-row"><label>Updated At:</label><span>{new Date(viewingRoute.updatedAt).toLocaleString()}</span></div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="modal-close-btn secondary" onClick={() => setViewingRoute(null)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Modal with Trip Management */}
            {showEditModal && editingRoute && (
                <div className="modal-overlay edit-route-modal" onClick={() => setShowEditModal(false)}>
                    <div className="modal-content edit-route-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Edit Route: {editingRoute.routeName}</h3>
                            <button className="modal-close-btn" onClick={() => setShowEditModal(false)}>×</button>
                        </div>

                        <div className="modal-body">
                            {/* Round Trip Toggle - FIXED FOR EDIT MODAL */}
                            {/* Round Trip Toggle - FIXED FOR EDIT MODAL */}
                            <div className="round-trip-toggle">
                                <label className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        checked={editForm.isRoundTrip || false}
                                        onChange={(e) => {
                                            const newVal = e.target.checked;
                                            handleEditRoundTripToggle(newVal);
                                        }}
                                        className="checkbox-input"
                                    />
                                    <span className="checkbox-label">Round Trip (Main + Return Routes)</span>
                                </label>
                                {editForm.isRoundTrip && (editForm.isMultiTrip || editIsMultiTrip) && (
                                    <div style={{
                                        marginTop: '8px',
                                        padding: '8px 12px',
                                        backgroundColor: '#e3f2fd',
                                        borderRadius: '6px',
                                        fontSize: '12px',
                                        color: '#0d47a1',
                                        border: '1px solid #90caf9'
                                    }}>
                                        ℹ️ Multi-trip mode is enabled. Each return stop will have {editForm.numberOfTrips || 1} trip timings.
                                        Please set the timings for each trip in the DOWN route section below.
                                    </div>
                                )}
                            </div>
                            {editForm.isRoundTrip && (
                                <div className="route-tabs">
                                    <button
                                        className={`route-tab ${activeRouteTab === 'UP' ? 'active' : ''}`}
                                        onClick={() => setActiveRouteTab('UP')}
                                    >
                                        UP (Main) Route
                                    </button>
                                    <button
                                        className={`route-tab ${activeRouteTab === 'DOWN' ? 'active' : ''}`}
                                        onClick={() => setActiveRouteTab('DOWN')}
                                    >
                                        DOWN (Return) Route
                                    </button>
                                </div>
                            )}

                            {/* Multi-Trip Toggle in Edit Modal */}
                            <div className="form-row" style={{ marginBottom: '16px' }}>
                                <Checkbox
                                    label="Multi-Trip Route (Multiple trips per day)"
                                    checked={editForm.isMultiTrip || false}
                                    onChange={(e) => {
                                        const isMulti = e.target.checked;
                                        setEditForm(prev => ({ ...prev, isMultiTrip: isMulti }));
                                        setEditIsMultiTrip(isMulti);

                                        if (isMulti) {
                                            // ========== ENABLE MULTI-TRIP ==========
                                            // For UP route origin
                                            if (!editForm.originTimings || editForm.originTimings.length === 0) {
                                                setEditForm(prev => ({
                                                    ...prev,
                                                    originTimings: [{ timeSlotSequence: 1, departureTime: prev.originDepTime || '', arrivalTime: '' }],
                                                    destTimings: [{ timeSlotSequence: 1, arrivalTime: prev.destArrTime || '', departureTime: '' }],
                                                    numberOfTrips: 1
                                                }));
                                                setEditNumberOfTrips(1);
                                            }

                                            // ========== FIX: FOR RETURN ROUTE (DOWN) WHEN ROUND TRIP IS ENABLED ==========
                                            if (editForm.isRoundTrip || isRoundTrip) {
                                                // Create return origin timings
                                                const returnOriginTimings = editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0
                                                    ? editForm.returnOriginTimings
                                                    : [{
                                                        timeSlotSequence: 1,
                                                        departureTime: editForm.returnOriginDepTime || '',
                                                        arrivalTime: ''
                                                    }];

                                                // Create return destination timings
                                                const returnDestTimings = editForm.returnDestTimings && editForm.returnDestTimings.length > 0
                                                    ? editForm.returnDestTimings
                                                    : [{
                                                        timeSlotSequence: 1,
                                                        arrivalTime: editForm.returnDestArrTime || '',
                                                        departureTime: ''
                                                    }];

                                                setEditForm(prev => ({
                                                    ...prev,
                                                    returnOriginTimings: returnOriginTimings,
                                                    returnDestTimings: returnDestTimings,
                                                    numberOfTrips: 1
                                                }));

                                                setEditNumberOfTrips(1);

                                                // Also update return stops with timings
                                                if (downStops.length > 0) {
                                                    const updatedDownStops = downStops.map(stop => {
                                                        // Check if stop already has timings
                                                        if (stop.timings && stop.timings.length > 0) {
                                                            return stop;
                                                        }
                                                        // Create a single timing for this stop
                                                        return {
                                                            ...stop,
                                                            timings: [{
                                                                timeSlotSequence: 1,
                                                                arrivalTime: stop.arrivalTime || '',
                                                                departureTime: stop.departureTime || ''
                                                            }]
                                                        };
                                                    });
                                                    setDownStops(updatedDownStops);
                                                }

                                                toast.info('Multi-trip enabled for return route. Please set timings for each trip.');
                                            }
                                        } else {
                                            // ========== DISABLE MULTI-TRIP ==========
                                            const firstOriginTiming = editForm.originTimings?.[0];
                                            const firstDestTiming = editForm.destTimings?.[0];

                                            // For UP route
                                            setEditForm(prev => ({
                                                ...prev,
                                                originDepTime: firstOriginTiming?.departureTime || '',
                                                destArrTime: firstDestTiming?.arrivalTime || '',
                                                originTimings: [],
                                                destTimings: [],
                                                numberOfTrips: 1
                                            }));
                                            setEditNumberOfTrips(1);

                                            // ========== FIX: FOR RETURN ROUTE (DOWN) ==========
                                            if (editForm.isRoundTrip || isRoundTrip) {
                                                const firstReturnOriginTiming = editForm.returnOriginTimings?.[0];
                                                const firstReturnDestTiming = editForm.returnDestTimings?.[0];

                                                setEditForm(prev => ({
                                                    ...prev,
                                                    returnOriginDepTime: firstReturnOriginTiming?.departureTime || '',
                                                    returnDestArrTime: firstReturnDestTiming?.arrivalTime || '',
                                                    returnOriginTimings: [],
                                                    returnDestTimings: []
                                                }));

                                                // Also clear timings from return stops
                                                if (downStops.length > 0) {
                                                    const updatedDownStops = downStops.map(stop => {
                                                        const firstTiming = stop.timings?.[0];
                                                        return {
                                                            ...stop,
                                                            arrivalTime: firstTiming?.arrivalTime || stop.arrivalTime || '',
                                                            departureTime: firstTiming?.departureTime || stop.departureTime || '',
                                                            timings: []
                                                        };
                                                    });
                                                    setDownStops(updatedDownStops);
                                                }
                                            }
                                        }
                                    }}
                                />
                            </div>

                            {(editForm.isMultiTrip || editIsMultiTrip) && (
                                <div style={{
                                    marginBottom: '16px',
                                    padding: '12px 16px',
                                    backgroundColor: '#e3f2fd',
                                    borderRadius: '8px',
                                    border: '1px solid #90caf9',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    flexWrap: 'wrap',
                                    gap: '10px'
                                }}>
                                    <div>
                                        <span style={{ fontSize: '13px', fontWeight: '500', color: '#0d47a1' }}>
                                            🚍 Number of Trips per Day ({activeRouteTab} Route):
                                        </span>
                                        <span style={{
                                            marginLeft: '8px',
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            color: '#1565c0',
                                            backgroundColor: '#bbdefb',
                                            padding: '4px 12px',
                                            borderRadius: '20px',
                                            display: 'inline-block'
                                        }}>
                                            {editForm.numberOfTrips || editNumberOfTrips || 1} trip{editForm.numberOfTrips !== 1 ? 's' : ''}
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const numTrips = editForm.numberOfTrips || editNumberOfTrips || 1;
                                            if (window.confirm(`This will set default timings for all stops. Continue?`)) {
                                                const currentStops = getActiveStops();
                                                const updatedStops = currentStops.map(stop => ({
                                                    ...stop,
                                                    timings: Array.from({ length: numTrips }, (_, i) => ({
                                                        timeSlotSequence: i + 1,
                                                        arrivalTime: '',
                                                        departureTime: ''
                                                    }))
                                                }));
                                                setActiveStops(updatedStops);
                                                toast.info(`Timings initialized for all ${currentStops.length} stops`);
                                            }
                                        }}
                                        style={{
                                            padding: '4px 12px',
                                            fontSize: '11px',
                                            backgroundColor: '#1565c0',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Initialize All Stops
                                    </button>
                                </div>
                            )}

                            <div className="form-sections">
                                <div className="form-section">
                                    <h4>Route Identity</h4>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Route Name *</label>
                                            <input
                                                type="text"
                                                value={editForm.routeName}
                                                onChange={(e) => setEditForm(prev => ({ ...prev, routeName: e.target.value }))}
                                                placeholder="Route name"
                                                className="form-input"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Local Route Name (Optional)</label>
                                            <input
                                                type="text"
                                                value={editForm.localRouteName || ''}
                                                onChange={(e) => setEditForm(prev => ({ ...prev, localRouteName: e.target.value }))}
                                                placeholder="Enter local/regional name for this route"
                                                className="form-input"
                                            />
                                            <small className="helper-text">This name will be displayed to passengers as the local route identifier</small>
                                        </div>
                                    </div>
                                </div>

                                {/* Origin Section with Trip Management */}
                                <div className="form-section">
                                    <h4>{activeRouteTab === 'UP' ? 'Origin' : 'Return Origin'}</h4>
                                    {activeRouteTab === 'UP' ? (
                                        <React.Fragment>
                                            <div className="form-row">
                                                <div className="form-group full-width">
                                                    <label>Search Location</label>
                                                    <LocationInput
                                                        value={editForm.originCity}
                                                        onChange={(value) => setEditForm(prev => ({ ...prev, originCity: value }))}
                                                        onLocationSelect={handleEditOriginSelect}
                                                        placeholder="Search origin city or address..."
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>Address</label>
                                                    <input type="text" value={editForm.originAddress} onChange={(e) => setEditForm(prev => ({ ...prev, originAddress: e.target.value }))} placeholder="Full address" className="form-input" />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>State</label>
                                                    <input type="text" value={editForm.originState} onChange={(e) => setEditForm(prev => ({ ...prev, originState: e.target.value }))} placeholder="State" className="form-input" />
                                                </div>
                                                <div className="form-group">
                                                    <label>Terminal</label>
                                                    <input type="text" value={editForm.originTerminal} onChange={(e) => setEditForm(prev => ({ ...prev, originTerminal: e.target.value }))} placeholder="Terminal name" className="form-input" />
                                                </div>
                                            </div>

                                            {/* Origin Timings with Add/Remove Trip */}
                                            {editForm.isMultiTrip && editForm.originTimings && editForm.originTimings.length > 0 ? (
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                            <label>Departure Times (Multi-Trip)</label>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-add-timing"
                                                                onClick={addEditOriginTrip}
                                                                style={{
                                                                    padding: '4px 14px',
                                                                    fontSize: '12px',
                                                                    background: '#28a745',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                + Add Trip
                                                            </button>
                                                        </div>
                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
                                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                                                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
                                                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
                                                                        <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {editForm.originTimings.map((timing, idx) => (
                                                                        <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.originTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                                                                            <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
                                                                                Trip #{timing.timeSlotSequence || idx + 1}
                                                                            </td>
                                                                            <td style={{ padding: '10px' }}>
                                                                                <TimePicker
                                                                                    value={timing.departureTime}
                                                                                    onChange={(value) => {
                                                                                        const updatedTimings = [...(editForm.originTimings || [])];
                                                                                        updatedTimings[idx] = { ...timing, departureTime: value };
                                                                                        setEditForm(prev => ({ ...prev, originTimings: updatedTimings }));
                                                                                    }}
                                                                                    placeholder="--:--"
                                                                                />
                                                                            </td>
                                                                            <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                                {editForm.originTimings.length > 1 && (
                                                                                    <button
                                                                                        onClick={() => removeEditOriginTrip(idx)}
                                                                                        style={{
                                                                                            padding: '2px 8px',
                                                                                            fontSize: '12px',
                                                                                            background: '#dc3545',
                                                                                            color: 'white',
                                                                                            border: 'none',
                                                                                            borderRadius: '4px',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    >
                                                                                        ✕
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <small className="helper-text">Add multiple departure times for different trips per day</small>
                                                    </div>
                                                </div>
                                            ) : !editForm.isMultiTrip && (
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Departure Time *</label>
                                                        <TimePicker
                                                            value={editForm.originDepTime}
                                                            // onChange={(value) => {
                                                            //     setEditForm(prev => ({ ...prev, originDepTime: value }));
                                                            //     const dur = getDuration(value, editForm.destArrTime);
                                                            //     setEditForm(prev => ({ ...prev, durationHours: dur.hours, durationMinutes: dur.minutes }));
                                                            // }}
                                                            onChange={(value) => {
                                                                setEditForm(prev => ({ ...prev, originDepTime: value }));
                                                                // The useEffect will handle the duration calculation automatically
                                                            }}
                                                            placeholder="Select time"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <div className="form-row">
                                                <div className="form-group full-width">
                                                    <input type="text" value={editForm.returnOriginCity || ''} onChange={(e) => setEditForm(prev => ({ ...prev, returnOriginCity: e.target.value }))} placeholder="Return Origin City" className="form-input" />
                                                </div>
                                            </div>

                                            {editForm.isMultiTrip && editForm.returnOriginTimings && editForm.returnOriginTimings.length > 0 && (
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                            <label>Return Departure Times (Multi-Trip)</label>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-add-timing"
                                                                onClick={addEditReturnOriginTrip}
                                                                style={{
                                                                    padding: '4px 14px',
                                                                    fontSize: '12px',
                                                                    background: '#28a745',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                + Add Trip
                                                            </button>
                                                        </div>
                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
                                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                                                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
                                                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
                                                                        <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {editForm.returnOriginTimings.map((timing, idx) => (
                                                                        <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.returnOriginTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                                                                            <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
                                                                                Trip #{timing.timeSlotSequence || idx + 1}
                                                                            </td>
                                                                            <td style={{ padding: '10px' }}>
                                                                                <TimePicker
                                                                                    value={timing.departureTime}
                                                                                    onChange={(value) => {
                                                                                        const updatedTimings = [...(editForm.returnOriginTimings || [])];
                                                                                        updatedTimings[idx] = { ...timing, departureTime: value };
                                                                                        setEditForm(prev => ({ ...prev, returnOriginTimings: updatedTimings }));
                                                                                    }}
                                                                                    placeholder="--:--"
                                                                                />
                                                                            </td>
                                                                            <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                                {editForm.returnOriginTimings.length > 1 && (
                                                                                    <button
                                                                                        onClick={() => removeEditReturnOriginTrip(idx)}
                                                                                        style={{
                                                                                            padding: '2px 8px',
                                                                                            fontSize: '12px',
                                                                                            background: '#dc3545',
                                                                                            color: 'white',
                                                                                            border: 'none',
                                                                                            borderRadius: '4px',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    >
                                                                                        ✕
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <small className="helper-text">Add multiple departure times for different trips per day</small>
                                                    </div>
                                                </div>
                                            )}
                                            {!editForm.isMultiTrip && (
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Return Departure Time *</label>
                                                        <TimePicker
                                                            value={editForm.returnOriginDepTime}
                                                            // onChange={(value) => {
                                                            //     setEditForm(prev => ({ ...prev, returnOriginDepTime: value }));
                                                            //     const dur = getDuration(value, editForm.returnDestArrTime);
                                                            //     setEditForm(prev => ({ ...prev, returnDurationHours: dur.hours, returnDurationMinutes: dur.minutes }));
                                                            // }}
                                                            onChange={(value) => {
                                                                setEditForm(prev => ({ ...prev, returnOriginDepTime: value }));
                                                                // The useEffect will handle the duration calculation automatically
                                                            }}
                                                            placeholder="Select time"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>

                                {/* Destination Section with Trip Management */}
                                <div className="form-section">
                                    <h4>{activeRouteTab === 'UP' ? 'Destination' : 'Return Destination'}</h4>
                                    {activeRouteTab === 'UP' ? (
                                        <React.Fragment>
                                            <div className="form-row">
                                                <div className="form-group full-width">
                                                    <label>Search Location</label>
                                                    <LocationInput
                                                        value={editForm.destCity}
                                                        onChange={(value) => setEditForm(prev => ({ ...prev, destCity: value }))}
                                                        onLocationSelect={handleEditDestSelect}
                                                        placeholder="Search destination city or address..."
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>Address</label>
                                                    <input type="text" value={editForm.destAddress} onChange={(e) => setEditForm(prev => ({ ...prev, destAddress: e.target.value }))} placeholder="Full address" className="form-input" />
                                                </div>
                                            </div>
                                            <div className="form-row">
                                                <div className="form-group">
                                                    <label>State</label>
                                                    <input type="text" value={editForm.destState} onChange={(e) => setEditForm(prev => ({ ...prev, destState: e.target.value }))} placeholder="State" className="form-input" />
                                                </div>
                                                <div className="form-group">
                                                    <label>Terminal</label>
                                                    <input type="text" value={editForm.destTerminal} onChange={(e) => setEditForm(prev => ({ ...prev, destTerminal: e.target.value }))} placeholder="Terminal name" className="form-input" />
                                                </div>
                                            </div>

                                            {/* Destination Timings with Add/Remove Trip */}
                                            {editForm.isMultiTrip && editForm.destTimings && editForm.destTimings.length > 0 ? (
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                            <label>Arrival Times (Multi-Trip)</label>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-add-timing"
                                                                onClick={addEditDestinationTrip}
                                                                style={{
                                                                    padding: '4px 14px',
                                                                    fontSize: '12px',
                                                                    background: '#28a745',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                + Add Trip
                                                            </button>
                                                        </div>
                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
                                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                                                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
                                                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
                                                                        <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {editForm.destTimings.map((timing, idx) => (
                                                                        <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.destTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                                                                            <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
                                                                                Trip #{timing.timeSlotSequence || idx + 1}
                                                                            </td>
                                                                            <td style={{ padding: '10px' }}>
                                                                                <TimePicker
                                                                                    value={timing.arrivalTime}
                                                                                    onChange={(value) => {
                                                                                        const updatedTimings = [...(editForm.destTimings || [])];
                                                                                        updatedTimings[idx] = { ...timing, arrivalTime: value };
                                                                                        setEditForm(prev => ({ ...prev, destTimings: updatedTimings }));
                                                                                    }}
                                                                                    placeholder="--:--"
                                                                                />
                                                                            </td>
                                                                            <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                                {editForm.destTimings.length > 1 && (
                                                                                    <button
                                                                                        onClick={() => removeEditDestinationTrip(idx)}
                                                                                        style={{
                                                                                            padding: '2px 8px',
                                                                                            fontSize: '12px',
                                                                                            background: '#dc3545',
                                                                                            color: 'white',
                                                                                            border: 'none',
                                                                                            borderRadius: '4px',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    >
                                                                                        ✕
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <small className="helper-text">Add multiple arrival times for different trips per day</small>
                                                    </div>
                                                </div>
                                            ) : !editForm.isMultiTrip && (
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Arrival Time *</label>
                                                        <TimePicker
                                                            value={editForm.destArrTime}
                                                            // onChange={(value) => {
                                                            //     setEditForm(prev => ({ ...prev, destArrTime: value }));
                                                            //     const dur = getDuration(editForm.originDepTime, value);
                                                            //     setEditForm(prev => ({ ...prev, durationHours: dur.hours, durationMinutes: dur.minutes }));
                                                            // }}
                                                            onChange={(value) => {
                                                                setEditForm(prev => ({ ...prev, destArrTime: value }));
                                                                // The useEffect will handle the duration calculation automatically
                                                            }}
                                                            placeholder="Select time"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            <div className="form-row">
                                                <div className="form-group full-width">
                                                    <input type="text" value={editForm.returnDestCity || ''} onChange={(e) => setEditForm(prev => ({ ...prev, returnDestCity: e.target.value }))} placeholder="Return Destination City" className="form-input" />
                                                </div>
                                            </div>

                                            {editForm.isMultiTrip && editForm.returnDestTimings && editForm.returnDestTimings.length > 0 && (
                                                <div className="form-row">
                                                    <div className="form-group full-width">
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                            <label>Return Arrival Times (Multi-Trip)</label>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-add-timing"
                                                                onClick={addEditReturnDestinationTrip}
                                                                style={{
                                                                    padding: '4px 14px',
                                                                    fontSize: '12px',
                                                                    background: '#28a745',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                + Add Trip
                                                            </button>
                                                        </div>
                                                        <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', marginTop: '8px' }}>
                                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                                <thead>
                                                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                                                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
                                                                        <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
                                                                        <th style={{ padding: '10px', textAlign: 'center', fontSize: '13px', width: '50px' }}>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {editForm.returnDestTimings.map((timing, idx) => (
                                                                        <tr key={timing.timeSlotSequence || idx} style={{ borderBottom: idx < editForm.returnDestTimings.length - 1 ? '1px solid #f0f0f0' : 'none' }}>
                                                                            <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
                                                                                Trip #{timing.timeSlotSequence || idx + 1}
                                                                            </td>
                                                                            <td style={{ padding: '10px' }}>
                                                                                <TimePicker
                                                                                    value={timing.arrivalTime}
                                                                                    onChange={(value) => {
                                                                                        const updatedTimings = [...(editForm.returnDestTimings || [])];
                                                                                        updatedTimings[idx] = { ...timing, arrivalTime: value };
                                                                                        setEditForm(prev => ({ ...prev, returnDestTimings: updatedTimings }));
                                                                                    }}
                                                                                    placeholder="--:--"
                                                                                />
                                                                            </td>
                                                                            <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                                {editForm.returnDestTimings.length > 1 && (
                                                                                    <button
                                                                                        onClick={() => removeEditReturnDestinationTrip(idx)}
                                                                                        style={{
                                                                                            padding: '2px 8px',
                                                                                            fontSize: '12px',
                                                                                            background: '#dc3545',
                                                                                            color: 'white',
                                                                                            border: 'none',
                                                                                            borderRadius: '4px',
                                                                                            cursor: 'pointer'
                                                                                        }}
                                                                                    >
                                                                                        ✕
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <small className="helper-text">Add multiple arrival times for different trips per day</small>
                                                    </div>
                                                </div>
                                            )}
                                            {!editForm.isMultiTrip && (
                                                <div className="form-row">
                                                    <div className="form-group">
                                                        <label>Return Arrival Time *</label>
                                                        <TimePicker
                                                            value={editForm.returnDestArrTime}
                                                            // onChange={(value) => {
                                                            //     setEditForm(prev => ({ ...prev, returnDestArrTime: value }));
                                                            //     const dur = getDuration(editForm.returnOriginDepTime, value);
                                                            //     setEditForm(prev => ({ ...prev, returnDurationHours: dur.hours, returnDurationMinutes: dur.minutes }));
                                                            // }}
                                                            onChange={(value) => {
                                                                setEditForm(prev => ({ ...prev, returnDestArrTime: value }));
                                                                // The useEffect will handle the duration calculation automatically
                                                            }}
                                                            placeholder="Select time"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </React.Fragment>
                                    )}
                                </div>

                                {/* Intermediate Stops Section */}
                                <div className="form-section stops-section">
                                    <h4>Intermediate Stops ({activeRouteTab})</h4>

                                    {activeRouteTab === 'DOWN' && editForm.isRoundTrip && (
                                        <button
                                            className="sync-btn"
                                            onClick={() => syncDownStopsWithUpStops(true)}
                                            style={{
                                                padding: '8px 16px',
                                                backgroundColor: '#17a2b8',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                marginBottom: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#138496'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#17a2b8'}
                                        >
                                            🔄 Auto-Fill / Sync Reversed Stops from UP Route
                                            {editForm.isMultiTrip && (
                                                <span style={{
                                                    fontSize: '10px',
                                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                                    padding: '2px 8px',
                                                    borderRadius: '10px',
                                                    marginLeft: '4px'
                                                }}>
                                                    {editForm.numberOfTrips || 1} trips
                                                </span>
                                            )}
                                        </button>
                                    )}

                                    <div className="stops-list">
                                        {getActiveStops().length > 0 && renderInsertButton(0, activeRouteTab === 'UP' ? 'up' : 'down')}
                                        {getActiveStops().map((stop, index) => {
                                            // Calculate distance display
                                            const displayManualDist = calculateManualDistFromPrev(getActiveStops(), index);
                                            const distanceDisplay = displayManualDist ||
                                                (typeof stop.distanceFromOrigin === 'number'
                                                    ? stop.distanceFromOrigin.toFixed(2)
                                                    : parseFloat(stop.distanceFromOrigin || 0).toFixed(2));

                                            const hasMultiTimings = stop.timings && stop.timings.length > 0;
                                            const sortedTimings = hasMultiTimings ? sortTimings(stop.timings) : [];

                                            return (
                                                <React.Fragment key={index}>
                                                    <div className={`stop-list-item ${(activeRouteTab === 'UP' ? editUpIndex : editDownIndex) === index ? 'editing-highlight' : ''}`}>
                                                        <div className="stop-info">
                                                            <div className="stop-name">
                                                                {index + 1}. {stop.city}
                                                                <span className="stop-distance">
                                                                    ({distanceDisplay} km)
                                                                </span>
                                                            </div>

                                                            {hasMultiTimings && sortedTimings.length > 0 ? (
                                                                <div className="stop-multi-times" style={{ marginTop: '8px', marginBottom: '8px' }}>
                                                                    {sortedTimings.map((timing, idx) => (
                                                                        <div key={timing.timeSlotSequence || idx} style={{
                                                                            display: 'inline-flex', alignItems: 'center', gap: '8px',
                                                                            backgroundColor: '#e9ecef', padding: '4px 10px',
                                                                            borderRadius: '16px', margin: '2px 4px', fontSize: '11px'
                                                                        }}>
                                                                            <span style={{ fontWeight: '500' }}>Trip {timing.timeSlotSequence || idx + 1}:</span>
                                                                            <span>Arr {TimeDisplay({ time: timing.arrivalTime })}</span>
                                                                            <span>→</span>
                                                                            <span>Dep {TimeDisplay({ time: timing.departureTime })}</span>
                                                                        </div>
                                                                    ))}
                                                                    {stop.stopType && stop.stopType !== 'none' && (
                                                                        <span style={{
                                                                            display: 'inline-flex', alignItems: 'center',
                                                                            marginLeft: '8px', fontSize: '11px', fontWeight: '500',
                                                                            padding: '2px 8px', borderRadius: '12px',
                                                                            backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
                                                                                : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
                                                                            color: stop.stopType === 'boarding' ? '#1565c0'
                                                                                : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
                                                                            border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
                                                                                : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
                                                                        }}>
                                                                            {stop.stopType === 'boarding' ? '🟢 Boarding'
                                                                                : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="stop-times" style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                                                    <span>Arr: {stop.arrivalTime || 'TBD'} • Dep: {stop.departureTime || 'N/A'}</span>
                                                                    {stop.stopType && stop.stopType !== 'none' && (
                                                                        <span style={{
                                                                            fontSize: '11px', fontWeight: '500',
                                                                            padding: '2px 8px', borderRadius: '12px',
                                                                            backgroundColor: stop.stopType === 'boarding' ? '#e3f2fd'
                                                                                : stop.stopType === 'dropping' ? '#fce4ec' : '#e8f5e9',
                                                                            color: stop.stopType === 'boarding' ? '#1565c0'
                                                                                : stop.stopType === 'dropping' ? '#c62828' : '#2e7d32',
                                                                            border: `1px solid ${stop.stopType === 'boarding' ? '#90caf9'
                                                                                : stop.stopType === 'dropping' ? '#f48fb1' : '#a5d6a7'}`
                                                                        }}>
                                                                            {stop.stopType === 'boarding' ? '🟢 Boarding'
                                                                                : stop.stopType === 'dropping' ? '🔴 Dropping' : '🟡 Both'}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="stop-actions">
                                                            <button className="stop-action-btn edit" onClick={() => {
                                                                setEditingStopIndex(index);
                                                                handleEditStop(index, activeRouteTab === 'UP' ? 'up' : 'down');
                                                            }}>Edit</button>
                                                            <button className="stop-action-btn delete" onClick={() => handleDeleteStop(index)}>Delete</button>
                                                        </div>
                                                    </div>
                                                    {renderInsertButton(index + 1, activeRouteTab === 'UP' ? 'up' : 'down')}
                                                </React.Fragment>
                                            );
                                        })}
                                    </div>
                                </div>

                                <div className="form-section">
                                    <h4>{activeRouteTab} Summary</h4>

                                    <button
                                        className="btn btn-success calculate-btn"
                                        onClick={() => handleEditCalculateDistances(activeRouteTab === 'UP' ? 'up' : 'down')}
                                        disabled={isCalculatingDistances}
                                    >
                                        {isCalculatingDistances ? 'Calculating...' : `Auto-Calculate Distances (${activeRouteTab})`}
                                    </button>

                                    {(() => {
                                        const stops = activeRouteTab === 'UP' ? upStops : downStops;
                                        const lastStop = stops.length > 0 ? stops[stops.length - 1] : null;

                                        const isLastManual = lastStop?.isManualStop === true ||
                                            (lastStop && (!lastStop.coordinates || (lastStop.coordinates.lat === 0 && lastStop.coordinates.lng === 0)));

                                        const shouldShow = (activeRouteTab === 'DOWN' && stops.length > 0) ||
                                            (activeRouteTab === 'UP' && isLastManual);

                                        if (!shouldShow) return null;

                                        const fieldValue = activeRouteTab === 'UP'
                                            ? (editForm.upManualFinalLeg || '')
                                            : (editForm.returnManualFinalLeg || '');

                                        return (
                                            <div className="form-row" style={{ marginTop: '10px' }}>
                                                <div className="form-group full-width">
                                                    <label>Distance from Last Stop to Destination (KM) *</label>
                                                    <input
                                                        type="number"
                                                        value={fieldValue}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (activeRouteTab === 'UP') {
                                                                setEditForm(prev => ({ ...prev, upManualFinalLeg: value }));
                                                                const lastStopDist = stops.length > 0 ? (stops[stops.length - 1].distanceFromOrigin || 0) : 0;
                                                                const newTotal = lastStopDist + (parseFloat(value) || 0);
                                                                if (newTotal > 0) {
                                                                    setEditForm(prev => ({ ...prev, totalDistance: newTotal.toFixed(1) }));
                                                                }
                                                            } else {
                                                                setEditForm(prev => ({ ...prev, returnManualFinalLeg: value }));
                                                                const lastStopDist = stops.length > 0 ? (stops[stops.length - 1].distanceFromOrigin || 0) : 0;
                                                                const newTotal = lastStopDist + (parseFloat(value) || 0);
                                                                if (newTotal > 0) {
                                                                    setEditForm(prev => ({ ...prev, returnTotalDistance: newTotal.toFixed(1) }));
                                                                }
                                                            }
                                                        }}
                                                        placeholder="Distance from last stop to destination"
                                                        className="form-input"
                                                        min="0"
                                                        step="0.1"
                                                        style={{ borderColor: '#dc3545', backgroundColor: '#fff5f5' }}
                                                    />
                                                    <small className="helper-text" style={{ color: '#dc3545' }}>
                                                        ⚠️ Required because the last stop is manual. This distance will be added to the total.
                                                    </small>
                                                </div>
                                            </div>
                                        );
                                    })()}

                                    <div className="form-row summary-fields">
                                        <div className="form-group">
                                            <label>Total Distance (KM)</label>
                                            <input
                                                type="number"
                                                value={activeRouteTab === 'UP' ? (editForm.totalDistance || '') : (editForm.returnTotalDistance || '')}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (activeRouteTab === 'UP') {
                                                        setEditForm(prev => ({ ...prev, totalDistance: value }));
                                                    } else {
                                                        setEditForm(prev => ({ ...prev, returnTotalDistance: value }));
                                                    }
                                                }}
                                                className="form-input"
                                                min="0"
                                                step="0.1"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Est. Duration</label>
                                            <div className="duration-inputs">
                                                <input
                                                    type="number"
                                                    value={activeRouteTab === 'UP' ? (editForm.durationHours || '') : (editForm.returnDurationHours || '')}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (activeRouteTab === 'UP') {
                                                            setEditForm(prev => ({ ...prev, durationHours: value }));
                                                        } else {
                                                            setEditForm(prev => ({ ...prev, returnDurationHours: value }));
                                                        }
                                                    }}
                                                    className="form-input"
                                                    placeholder="Hours"
                                                    min="0"
                                                />
                                                <span>h</span>
                                                <input
                                                    type="number"
                                                    value={activeRouteTab === 'UP' ? (editForm.durationMinutes || '') : (editForm.returnDurationMinutes || '')}
                                                    onChange={(e) => {
                                                        let value = e.target.value;
                                                        let minutes = Math.min(59, Math.max(0, parseInt(value) || 0));
                                                        if (activeRouteTab === 'UP') {
                                                            setEditForm(prev => ({ ...prev, durationMinutes: minutes.toString() }));
                                                        } else {
                                                            setEditForm(prev => ({ ...prev, returnDurationMinutes: minutes.toString() }));
                                                        }
                                                    }}
                                                    className="form-input"
                                                    placeholder="Minutes"
                                                    min="0"
                                                    max="59"
                                                />
                                                <span>m</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Status Section */}
                                <div className="form-section">
                                    <h4>Status</h4>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label className="checkbox-container">
                                                <input type="checkbox" checked={editForm.isActive} onChange={(e) => setEditForm(prev => ({ ...prev, isActive: e.target.checked }))} />
                                                <span>Route is Active</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div className="form-actions">
                                <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                                <button className="btn btn-primary save-route-btn" onClick={handleUpdateRoute} disabled={isUpdatingRoute}>
                                    {isUpdatingRoute ? 'Updating...' : 'Update Route'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showStopEditModal && stopBeingEdited && (
                <div className="modal-overlay" onClick={() => setShowStopEditModal(false)}>
                    <div className="modal-content edit-stop-modal" onClick={(e) => e.stopPropagation()}
                        style={{ maxWidth: '1200px', width: '90%' }}>
                        <div className="modal-header">
                            <h3>
                                Edit Stop #{stopBeingEdited.index + 1}
                                <span style={{ fontWeight: 'normal', color: '#666', fontSize: '14px' }}>
                                    {' '}— {stopBeingEdited.originalStop.city}
                                </span>
                            </h3>
                            <button className="modal-close-btn" onClick={() => setShowStopEditModal(false)}>×</button>
                        </div>

                        <div className="modal-body">
                            <div className="form-row" style={{ marginBottom: '12px' }}>
                                <Checkbox
                                    label="Manually Typed Stop (No Map Suggestions)"
                                    checked={stopEditForm.isManualStop}
                                    onChange={() => setStopEditForm(prev => ({
                                        ...prev,
                                        isManualStop: !prev.isManualStop,
                                        manualDistFromPrev: !prev.isManualStop ? prev.manualDistFromPrev : ''
                                    }))}
                                />
                            </div>

                            {!stopEditForm.isManualStop ? (
                                <>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Search Location *</label>
                                            <LocationInput
                                                value={stopEditForm.city}
                                                onChange={(value) => setStopEditForm(prev => ({ ...prev, city: value }))}
                                                onLocationSelect={(location) => setStopEditForm(prev => ({
                                                    ...prev,
                                                    city: location.city || location.name || '',
                                                    state: location.state || prev.state,
                                                    address: location.address || '',
                                                }))}
                                                placeholder="Search city or address..."
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Address</label>
                                            <input type="text" value={stopEditForm.address}
                                                onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
                                                placeholder="Full address" className="form-input" />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Search City *</label>
                                            <div className="city-search-container" style={{ position: 'relative' }}>
                                                <input
                                                    type="text"
                                                    value={stopEditForm.city}
                                                    onChange={async (e) => {
                                                        const value = toTitleCase(e.target.value);
                                                        setNewRoute(prev => ({ ...prev, stopCity: value }));

                                                        if (value !== stopEditForm.city) {
                                                            setStopEditForm(prev => ({
                                                                ...prev,
                                                                address: '',
                                                                state: '',
                                                                terminal: ''
                                                            }));
                                                        }

                                                        if (value.length >= 2) {
                                                            try {
                                                                const response = await searchRouteIntermediateStops(token, value);
                                                                if (response.success && response.cities && response.cities.length > 0) {
                                                                    setEditCitySuggestions(response.cities);
                                                                    setShowEditCityDropdown(true);
                                                                } else {
                                                                    setEditCitySuggestions([]);
                                                                    setShowEditCityDropdown(false);
                                                                }
                                                            } catch (error) {
                                                                console.error('Error searching cities:', error);
                                                                setEditCitySuggestions([]);
                                                                setShowEditCityDropdown(false);
                                                            }
                                                        } else {
                                                            setEditCitySuggestions([]);
                                                            setShowEditCityDropdown(false);
                                                        }
                                                    }}
                                                    onFocus={() => {
                                                        if (editCitySuggestions.length > 0) {
                                                            setShowEditCityDropdown(true);
                                                        }
                                                    }}
                                                    onBlur={() => {
                                                        setTimeout(() => setShowEditCityDropdown(false), 200);
                                                    }}
                                                    placeholder="Type city name (min 2 characters)..."
                                                    className="form-input"
                                                />
                                                {showEditCityDropdown && editCitySuggestions.length > 0 && (
                                                    <div className="city-suggestions-dropdown" style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 0,
                                                        right: 0,
                                                        backgroundColor: 'white',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '4px',
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        zIndex: 10000,
                                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                                    }}>
                                                        {editCitySuggestions.map((city, idx) => (
                                                            <div
                                                                key={city.id || idx}
                                                                onClick={() => {
                                                                    setStopEditForm(prev => ({
                                                                        ...prev,
                                                                        city: city.name,
                                                                        address: city.address || city.name,
                                                                        state: city.state || '',
                                                                        terminal: city.terminal || `${city.name} Bus Stand`
                                                                    }));
                                                                    setShowEditCityDropdown(false);
                                                                    toast.success(`Auto-filled details for ${city.name}`);
                                                                }}
                                                                style={{
                                                                    padding: '10px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #f0f0f0'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                                            >
                                                                <div style={{ fontWeight: '500' }}>{city.name}</div>
                                                                <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                                                    {city.state}
                                                                    {city.terminal && ` • ${city.terminal}`}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            <small className="helper-text">Type at least 2 characters to search for cities from existing routes</small>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Address</label>
                                            <input type="text" value={stopEditForm.address}
                                                onChange={(e) => setStopEditForm(prev => ({ ...prev, address: e.target.value }))}
                                                placeholder="Full address (e.g., NH-19, Near Bus Stand)" className="form-input" />
                                            <small className="helper-text">Complete address of the stop location</small>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="form-row">
                                <div className="form-group">
                                    <label>State</label>
                                    <input type="text" value={stopEditForm.state}
                                        onChange={(e) => setStopEditForm(prev => ({ ...prev, state: e.target.value }))}
                                        placeholder="State" className="form-input" />
                                </div>
                                <div className="form-group">
                                    <label>Terminal</label>
                                    <input type="text" value={stopEditForm.terminal}
                                        onChange={(e) => setStopEditForm(prev => ({ ...prev, terminal: e.target.value }))}
                                        placeholder="Terminal name" className="form-input" />
                                </div>
                            </div>

                            {/* In the edit stop modal body, replace the timings section */}
                            {/* {(editForm.isMultiTrip || isMultiTrip) ? (
                                <>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label style={{ marginBottom: '12px', display: 'block' }}>
                                                Timings for each trip: {editForm.numberOfTrips || numberOfTrips || 1} {editForm.numberOfTrips !== 1 ? 'trips' : 'trip'} per day
                                            </label>
                                            <div style={{
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                marginTop: '8px'
                                            }}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                                                            <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
                                                            <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
                                                            <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.from({ length: editForm.numberOfTrips || numberOfTrips || 1 }, (_, i) => {
                                                            const tripNumber = i + 1;
                                                            // Find timing for this trip
                                                            const timing = stopEditForm.timings?.find(t => t.timeSlotSequence === tripNumber) ||
                                                                { timeSlotSequence: tripNumber, arrivalTime: '', departureTime: '' };

                                                            return (
                                                                <tr key={tripNumber} style={{ borderBottom: i < (editForm.numberOfTrips || numberOfTrips || 1) - 1 ? '1px solid #f0f0f0' : 'none' }}>
                                                                    <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
                                                                        Trip #{tripNumber}
                                                                    </td>
                                                                    <td style={{ padding: '10px' }}>
                                                                        <TimePicker
                                                                            value={timing.arrivalTime}
                                                                            onChange={(value) => {
                                                                                const updatedTimings = [...(stopEditForm.timings || [])];
                                                                                const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === tripNumber);
                                                                                const timingData = {
                                                                                    timeSlotSequence: tripNumber,
                                                                                    arrivalTime: value,
                                                                                    departureTime: timing.departureTime || ''
                                                                                };
                                                                                if (existingIndex >= 0) {
                                                                                    updatedTimings[existingIndex] = timingData;
                                                                                } else {
                                                                                    updatedTimings.push(timingData);
                                                                                }
                                                                                setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
                                                                            }}
                                                                            placeholder="--:--"
                                                                        />
                                                                    </td>
                                                                    <td style={{ padding: '10px' }}>
                                                                        <TimePicker
                                                                            value={timing.departureTime}
                                                                            onChange={(value) => {
                                                                                const updatedTimings = [...(stopEditForm.timings || [])];
                                                                                const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === tripNumber);
                                                                                const timingData = {
                                                                                    timeSlotSequence: tripNumber,
                                                                                    arrivalTime: timing.arrivalTime || '',
                                                                                    departureTime: value
                                                                                };
                                                                                if (existingIndex >= 0) {
                                                                                    updatedTimings[existingIndex] = timingData;
                                                                                } else {
                                                                                    updatedTimings.push(timingData);
                                                                                }
                                                                                setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
                                                                            }}
                                                                            placeholder="--:--"
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <small className="helper-text" style={{ display: 'block', marginTop: '8px', color: '#666' }}>
                                                Tip: Set arrival and departure times for each trip separately
                                            </small>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                // Single trip mode - show arrival and departure time
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Arrival Time *</label>
                                        <TimePicker
                                            value={stopEditForm.arrivalTime}
                                            onChange={(value) => setStopEditForm(prev => ({ ...prev, arrivalTime: value }))}
                                            placeholder="Select time"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Departure Time (Opt)</label>
                                        <TimePicker
                                            value={stopEditForm.departureTime}
                                            onChange={(value) => setStopEditForm(prev => ({ ...prev, departureTime: value }))}
                                            placeholder="Select time"
                                        />
                                    </div>
                                </div>
                            )} */}

                            {/* In the edit stop modal body, replace the timings section */}
{/* In the edit stop modal body - TIMINGS SECTION */}
{(editForm.isMultiTrip || editIsMultiTrip || (stopEditForm.timings && stopEditForm.timings.length > 0)) ? (
    <>
        <div className="form-row">
            <div className="form-group full-width">
                <label style={{ marginBottom: '12px', display: 'block' }}>
                    Timings for each trip: {stopEditForm.timings?.length || editForm.numberOfTrips || 1} {stopEditForm.timings?.length !== 1 ? 'trips' : 'trip'} per day
                </label>
                <div style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    marginTop: '8px'
                }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #e0e0e0' }}>
                                <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Trip</th>
                                <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Arrival Time</th>
                                <th style={{ padding: '10px', textAlign: 'left', fontSize: '13px' }}>Departure Time</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* ALWAYS show ALL timings - never filter */}
                            {stopEditForm.timings && stopEditForm.timings.length > 0 ? (
                                stopEditForm.timings.map((timing, index) => {
                                    const tripNumber = timing.timeSlotSequence || index + 1;
                                    return (
                                        <tr key={tripNumber} style={{ 
                                            borderBottom: index < stopEditForm.timings.length - 1 ? '1px solid #f0f0f0' : 'none',
                                            backgroundColor: timing.arrivalTime || timing.departureTime ? 'transparent' : '#fafafa'
                                        }}>
                                            <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
                                                Trip #{tripNumber}
                                            </td>
                                            <td style={{ padding: '10px' }}>
                                                <TimePicker
                                                    value={timing.arrivalTime}
                                                    onChange={(value) => {
                                                        const updatedTimings = [...(stopEditForm.timings || [])];
                                                        updatedTimings[index] = {
                                                            ...updatedTimings[index],
                                                            arrivalTime: value
                                                        };
                                                        setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
                                                    }}
                                                    placeholder="--:--"
                                                />
                                            </td>
                                            <td style={{ padding: '10px' }}>
                                                <TimePicker
                                                    value={timing.departureTime}
                                                    onChange={(value) => {
                                                        const updatedTimings = [...(stopEditForm.timings || [])];
                                                        updatedTimings[index] = {
                                                            ...updatedTimings[index],
                                                            departureTime: value
                                                        };
                                                        setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
                                                    }}
                                                    placeholder="--:--"
                                                />
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                // Fallback: create timings from numberOfTrips
                                Array.from({ length: editForm.numberOfTrips || editNumberOfTrips || 1 }, (_, i) => {
                                    const tripNumber = i + 1;
                                    return (
                                        <tr key={tripNumber} style={{ borderBottom: i < (editForm.numberOfTrips || 1) - 1 ? '1px solid #f0f0f0' : 'none' }}>
                                            <td style={{ padding: '10px', fontSize: '13px', fontWeight: '500' }}>
                                                Trip #{tripNumber}
                                            </td>
                                            <td style={{ padding: '10px' }}>
                                                <TimePicker
                                                    value=""
                                                    onChange={(value) => {
                                                        const updatedTimings = [...(stopEditForm.timings || [])];
                                                        const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === tripNumber);
                                                        const timingData = {
                                                            timeSlotSequence: tripNumber,
                                                            arrivalTime: value,
                                                            departureTime: ''
                                                        };
                                                        if (existingIndex >= 0) {
                                                            updatedTimings[existingIndex] = timingData;
                                                        } else {
                                                            updatedTimings.push(timingData);
                                                        }
                                                        setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
                                                    }}
                                                    placeholder="--:--"
                                                />
                                            </td>
                                            <td style={{ padding: '10px' }}>
                                                <TimePicker
                                                    value=""
                                                    onChange={(value) => {
                                                        const updatedTimings = [...(stopEditForm.timings || [])];
                                                        const existingIndex = updatedTimings.findIndex(t => t.timeSlotSequence === tripNumber);
                                                        const timingData = {
                                                            timeSlotSequence: tripNumber,
                                                            arrivalTime: '',
                                                            departureTime: value
                                                        };
                                                        if (existingIndex >= 0) {
                                                            updatedTimings[existingIndex] = timingData;
                                                        } else {
                                                            updatedTimings.push(timingData);
                                                        }
                                                        setStopEditForm(prev => ({ ...prev, timings: updatedTimings }));
                                                    }}
                                                    placeholder="--:--"
                                                />
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
                <small className="helper-text" style={{ display: 'block', marginTop: '8px', color: '#666' }}>
                    Tip: Set arrival and departure times for each trip separately
                </small>
            </div>
        </div>
    </>
) : (
    // Single trip mode
    <div className="form-row">
        <div className="form-group">
            <label>Arrival Time *</label>
            <TimePicker
                value={stopEditForm.arrivalTime}
                onChange={(value) => setStopEditForm(prev => ({ ...prev, arrivalTime: value }))}
                placeholder="Select time"
            />
        </div>
        <div className="form-group">
            <label>Departure Time (Opt)</label>
            <TimePicker
                value={stopEditForm.departureTime}
                onChange={(value) => setStopEditForm(prev => ({ ...prev, departureTime: value }))}
                placeholder="Select time"
            />
        </div>
    </div>
)}

                            {stopEditForm.isManualStop && (
                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <label>Distance from Previous Stop (km) *</label>
                                        <input type="number" value={stopEditForm.manualDistFromPrev}
                                            onChange={(e) => setStopEditForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
                                            placeholder="e.g., 50" className="form-input" min="0" step="0.1" />
                                    </div>
                                </div>
                            )}

                            {stopEditForm.isManualStop && (() => {
                                const stops = stopBeingEdited.type === 'up' ? upStops : downStops;
                                const nextStop = stops[stopBeingEdited.index + 1];
                                const isNextAuto = nextStop?.coordinates &&
                                    (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
                                if (isNextAuto) return (
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Distance to Next Stop ({nextStop.city}) (km) *</label>
                                            <input type="number" value={stopEditForm.manualDistToNext}
                                                onChange={(e) => setStopEditForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
                                                placeholder={`Distance to ${nextStop.city}`}
                                                className="form-input" min="0" step="0.1" />
                                            <small style={{ color: '#dc3545' }}>
                                                ⚠️ Required because next stop has GPS coordinates
                                            </small>
                                        </div>
                                    </div>
                                );
                                return null;
                            })()}

                            <div className="form-row checkbox-row">
                                <Checkbox label="Boarding Point" checked={stopEditForm.isBoarding}
                                    onChange={() => setStopEditForm(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
                                <Checkbox label="Dropping Point" checked={stopEditForm.isDropping}
                                    onChange={() => setStopEditForm(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
                            </div>
                        </div>

                        <div className="modal-footer" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', padding: '16px' }}>
                            <button className="btn btn-secondary" onClick={() => setShowStopEditModal(false)}>
                                Cancel
                            </button>
                            <button className="btn btn-primary" onClick={saveEditedStop}>
                                Save Changes
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showStopInsertModal && (
                <div className="modal-overlay" onClick={() => setShowStopInsertModal(false)}>
                    <div className="modal-content edit-stop-modal" onClick={(e) => e.stopPropagation()}
                        style={{ width: '90%' }}>
                        <div className="modal-header">
                            <h3>Insert Stop at Position #{pendingInsertIndex + 1}</h3>
                            <button className="modal-close-btn" onClick={() => setShowStopInsertModal(false)}>×</button>
                        </div>

                        <div className="modal-body">
                            <div className="form-row" style={{ marginBottom: '12px' }}>
                                <Checkbox
                                    label="Manually Typed Stop (No Map Suggestions)"
                                    checked={insertStopForm.isManualStop}
                                    onChange={() => setInsertStopForm(prev => ({
                                        ...prev,
                                        isManualStop: !prev.isManualStop,
                                        city: '', address: '', state: '', terminal: '',
                                        manualDistFromPrev: ''
                                    }))}
                                />
                            </div>

                            {!insertStopForm.isManualStop ? (
                                <>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Search Location *</label>
                                            <LocationInput
                                                value={insertStopForm.city}
                                                onChange={(value) => setInsertStopForm(prev => ({ ...prev, city: value }))}
                                                onLocationSelect={(location) => setInsertStopForm(prev => ({
                                                    ...prev,
                                                    city: location.city || location.name || '',
                                                    state: location.state || prev.state,
                                                    address: location.address || '',
                                                }))}
                                                placeholder="Search city or address..."
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Address</label>
                                            <input type="text" value={insertStopForm.address}
                                                onChange={(e) => setInsertStopForm(prev => ({ ...prev, address: e.target.value }))}
                                                placeholder="Full address" className="form-input" />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Search City *</label>
                                            <div style={{ position: 'relative' }}>
                                                <input
                                                    type="text"
                                                    value={insertStopForm.city}
                                                    onChange={async (e) => {
                                                        const value = e.target.value;
                                                        setInsertStopForm(prev => ({ ...prev, city: value, address: '', state: '', terminal: '' }));
                                                        if (value.length >= 2) {
                                                            try {
                                                                const response = await searchRouteIntermediateStops(token, value);
                                                                if (response.success && response.cities?.length > 0) {
                                                                    normalizeAndDeduplicateSuggestions(response.cities);
                                                                    setShowInsertCityDropdown(true);
                                                                } else {
                                                                    setInsertCitySuggestions([]);
                                                                    setShowInsertCityDropdown(false);
                                                                }
                                                            } catch { setInsertCitySuggestions([]); setShowInsertCityDropdown(false); }
                                                        } else {
                                                            setInsertCitySuggestions([]);
                                                            setShowInsertCityDropdown(false);
                                                        }
                                                    }}
                                                    onFocus={() => insertCitySuggestions.length > 0 && setShowInsertCityDropdown(true)}
                                                    onBlur={() => setTimeout(() => setShowInsertCityDropdown(false), 200)}
                                                    placeholder="Type city name (min 2 characters)..."
                                                    className="form-input"
                                                />
                                                {showInsertCityDropdown && insertCitySuggestions.length > 0 && (
                                                    <div style={{
                                                        position: 'absolute', top: '100%', left: 0, right: 0,
                                                        backgroundColor: 'white', border: '1px solid #ddd',
                                                        borderRadius: '4px', maxHeight: '200px', overflowY: 'auto',
                                                        zIndex: 10000, boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                                    }}>
                                                        {insertCitySuggestions.map((city, idx) => (
                                                            <div key={city.id || idx}
                                                                onMouseDown={() => {
                                                                    setInsertStopForm(prev => ({
                                                                        ...prev,
                                                                        city: city.name,
                                                                        address: city.address || city.name,
                                                                        state: city.state || '',
                                                                        terminal: city.terminal || `${city.name} Bus Stand`,
                                                                    }));
                                                                    setShowInsertCityDropdown(false);
                                                                    setInsertCitySuggestions([]);
                                                                    toast.success(`Auto-filled details for ${city.name}`);
                                                                }}
                                                                style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                                                                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f7ff'}
                                                                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'white'}
                                                            >
                                                                <div style={{ fontWeight: '500' }}>{city.name}</div>
                                                                <div style={{ fontSize: '12px', color: '#6c757d' }}>
                                                                    {city.state}{city.terminal ? ` • ${city.terminal}` : ''}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                            <small className="helper-text">Type at least 2 characters to search cities</small>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Address</label>
                                            <input type="text" value={insertStopForm.address}
                                                onChange={(e) => setInsertStopForm(prev => ({ ...prev, address: e.target.value }))}
                                                placeholder="Full address" className="form-input" />
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="form-row">
                                <div className="form-group">
                                    <label>State</label>
                                    <input type="text" value={insertStopForm.state}
                                        onChange={(e) => setInsertStopForm(prev => ({ ...prev, state: e.target.value }))}
                                        placeholder="State" className="form-input" />
                                </div>
                                <div className="form-group">
                                    <label>Terminal</label>
                                    <input type="text" value={insertStopForm.terminal}
                                        onChange={(e) => setInsertStopForm(prev => ({ ...prev, terminal: e.target.value }))}
                                        placeholder="Terminal name" className="form-input" />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label>Arrival Time *</label>
                                    <TimePicker value={insertStopForm.arrivalTime}
                                        onChange={(value) => setInsertStopForm(prev => ({ ...prev, arrivalTime: value }))}
                                        placeholder="Select time" />
                                </div>
                                <div className="form-group">
                                    <label>Departure Time (Opt)</label>
                                    <TimePicker value={insertStopForm.departureTime}
                                        onChange={(value) => setInsertStopForm(prev => ({ ...prev, departureTime: value }))}
                                        placeholder="Select time" />
                                </div>
                            </div>

                            {insertStopForm.isManualStop && (
                                <div className="form-row">
                                    <div className="form-group full-width">
                                        <label>Distance from Previous Stop (km) *</label>
                                        <input type="number" value={insertStopForm.manualDistFromPrev}
                                            onChange={(e) => setInsertStopForm(prev => ({ ...prev, manualDistFromPrev: e.target.value }))}
                                            placeholder="e.g., 50" className="form-input" min="0" step="0.1" />
                                        <small className="helper-text">Required for manual stops</small>
                                    </div>
                                </div>
                            )}

                            {insertStopForm.isManualStop && (() => {
                                const stops = activeRouteTab === 'UP' ? upStops : downStops;
                                const nextStop = stops[pendingInsertIndex];
                                const isNextAuto = nextStop?.coordinates &&
                                    (nextStop.coordinates.lat !== 0 || nextStop.coordinates.lng !== 0);
                                if (isNextAuto) return (
                                    <div className="form-row">
                                        <div className="form-group full-width">
                                            <label>Distance to Next Stop ({nextStop.city}) (km)</label>
                                            <input type="number" value={insertStopForm.manualDistToNext}
                                                onChange={(e) => setInsertStopForm(prev => ({ ...prev, manualDistToNext: e.target.value }))}
                                                placeholder={`Distance to ${nextStop.city}`}
                                                className="form-input" min="0" step="0.1" />
                                            <small style={{ color: '#dc3545' }}>⚠️ Next stop has GPS coordinates</small>
                                        </div>
                                    </div>
                                );
                                return null;
                            })()}

                            <div className="form-row checkbox-row">
                                <Checkbox label="Boarding Point" checked={insertStopForm.isBoarding}
                                    onChange={() => setInsertStopForm(prev => ({ ...prev, isBoarding: !prev.isBoarding }))} />
                                <Checkbox label="Dropping Point" checked={insertStopForm.isDropping}
                                    onChange={() => setInsertStopForm(prev => ({ ...prev, isDropping: !prev.isDropping }))} />
                            </div>
                        </div>

                        <div className="modal-footer" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', padding: '16px' }}>
                            <button className="btn btn-secondary" onClick={() => setShowStopInsertModal(false)}>Cancel</button>
                            <button className="btn btn-primary" onClick={saveInsertedStop}
                                disabled={!insertStopForm.city || !insertStopForm.arrivalTime || !insertStopForm.state  || !insertStopForm.address || !insertStopForm.terminal }>
                                Insert Stop
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showPlatformFeeModal && selectedBusForActivation && (
                <PlatformFeeModal
                    bus={selectedBusForActivation}
                    onClose={() => {
                        setShowPlatformFeeModal(false);
                        setSelectedBusForActivation(null);
                    }}
                    onActivated={() => {
                        fetchRoutes();
                        toast.success('Bus activated successfully!');
                    }}
                />
            )}
        </div>
    );
};

export default RouteManage;